/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @default "EVENT_TYPE_UNSPECIFIED" */
export enum WebhooksV1EventType {
  EVENT_TYPE_UNSPECIFIED = "EVENT_TYPE_UNSPECIFIED",
  EVENT_TYPE_AFFILIATE_CREATED = "EVENT_TYPE_AFFILIATE_CREATED",
  EVENT_TYPE_AFFILIATE_STATUS_CHANGED = "EVENT_TYPE_AFFILIATE_STATUS_CHANGED",
  EVENT_TYPE_AFFILIATE_TIER_CHANGED = "EVENT_TYPE_AFFILIATE_TIER_CHANGED",
  EVENT_TYPE_CLICK_CREATED = "EVENT_TYPE_CLICK_CREATED",
  EVENT_TYPE_CONVERSION_CREATED = "EVENT_TYPE_CONVERSION_CREATED",
  EVENT_TYPE_COUPON_CREATED = "EVENT_TYPE_COUPON_CREATED",
  EVENT_TYPE_CONVERSION_STATUS_CHANGED = "EVENT_TYPE_CONVERSION_STATUS_CHANGED",
  EVENT_TYPE_SETTLEMENT_CREATED = "EVENT_TYPE_SETTLEMENT_CREATED",
}

/** @default "SET_PASSWORD_ERROR_CODE_UNSPECIFIED" */
export enum UsersV1SetPasswordErrorCode {
  SET_PASSWORD_ERROR_CODE_UNSPECIFIED = "SET_PASSWORD_ERROR_CODE_UNSPECIFIED",
  SET_PASSWORD_ERROR_CODE_USER_WITH_PASSWORD = "SET_PASSWORD_ERROR_CODE_USER_WITH_PASSWORD",
}

/** @default "REGISTRATION_ERROR_CODE_UNSPECIFIED" */
export enum UsersV1RegistrationErrorCode {
  REGISTRATION_ERROR_CODE_UNSPECIFIED = "REGISTRATION_ERROR_CODE_UNSPECIFIED",
  REGISTRATION_ERROR_CODE_INVALID_RECAPTCHA_TOKEN = "REGISTRATION_ERROR_CODE_INVALID_RECAPTCHA_TOKEN",
  REGISTRATION_ERROR_CODE_NON_BUSINESS_EMAIL = "REGISTRATION_ERROR_CODE_NON_BUSINESS_EMAIL",
  REGISTRATION_ERROR_CODE_USER_ALREADY_REGISTERED = "REGISTRATION_ERROR_CODE_USER_ALREADY_REGISTERED",
}

/** @default "EMAIL_SIGN_IN_LINK_ERROR_CODE_UNSPECIFIED" */
export enum UsersV1EmailSignInLinkErrorCode {
  EMAIL_SIGN_IN_LINK_ERROR_CODE_UNSPECIFIED = "EMAIL_SIGN_IN_LINK_ERROR_CODE_UNSPECIFIED",
  EMAIL_SIGN_IN_LINK_ERROR_CODE_INVALID_OOB_CODE = "EMAIL_SIGN_IN_LINK_ERROR_CODE_INVALID_OOB_CODE",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum TrackingBlockingV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_CLICK_RULES_WITHOUT_CONDITIONS_NOT_ALLOWED = "ERROR_CODE_CLICK_RULES_WITHOUT_CONDITIONS_NOT_ALLOWED",
  ERROR_CODE_CONVERSION_RULES_WITHOUT_CONDITIONS_NOT_ALLOWED = "ERROR_CODE_CONVERSION_RULES_WITHOUT_CONDITIONS_NOT_ALLOWED",
}

/** @default "CONVERSION_SOURCE_ERROR_CODE_UNSPECIFIED" */
export enum TrackingV1ConversionSourceErrorCode {
  CONVERSION_SOURCE_ERROR_CODE_UNSPECIFIED = "CONVERSION_SOURCE_ERROR_CODE_UNSPECIFIED",
  CONVERSION_SOURCE_ERROR_CODE_CONVERSION_SOURCE_NOT_EXISTS = "CONVERSION_SOURCE_ERROR_CODE_CONVERSION_SOURCE_NOT_EXISTS",
  CONVERSION_SOURCE_ERROR_CODE_REVENUE_ORIGIN_NOT_EXISTS = "CONVERSION_SOURCE_ERROR_CODE_REVENUE_ORIGIN_NOT_EXISTS",
}

/** @default "CONVERSION_ERROR_CODE_UNSPECIFIED" */
export enum TrackingV1ConversionErrorCode {
  CONVERSION_ERROR_CODE_UNSPECIFIED = "CONVERSION_ERROR_CODE_UNSPECIFIED",
  CONVERSION_ERROR_CODE_CONVERSION_SETTLED = "CONVERSION_ERROR_CODE_CONVERSION_SETTLED",
  CONVERSION_ERROR_CODE_COUPON_CODES_WITHOUT_REVENUE_ORIGIN = "CONVERSION_ERROR_CODE_COUPON_CODES_WITHOUT_REVENUE_ORIGIN",
  CONVERSION_ERROR_CODE_DUPLICATE_EXTERNAL_ID = "CONVERSION_ERROR_CODE_DUPLICATE_EXTERNAL_ID",
  CONVERSION_ERROR_CODE_EXTERNAL_CID_WITHOUT_REVENUE_ORIGIN = "CONVERSION_ERROR_CODE_EXTERNAL_CID_WITHOUT_REVENUE_ORIGIN",
  CONVERSION_ERROR_CODE_LESS_REVENUE_THAN_COST = "CONVERSION_ERROR_CODE_LESS_REVENUE_THAN_COST",
  CONVERSION_ERROR_CODE_MISSING_CID = "CONVERSION_ERROR_CODE_MISSING_CID",
  CONVERSION_ERROR_CODE_MULTIPLE_CID = "CONVERSION_ERROR_CODE_MULTIPLE_CID",
}

/** @default "CLICK_ERROR_CODE_UNSPECIFIED" */
export enum TrackingV1ClickErrorCode {
  CLICK_ERROR_CODE_UNSPECIFIED = "CLICK_ERROR_CODE_UNSPECIFIED",
  CLICK_ERROR_CODE_GEOLOCATION_NOT_FOUND = "CLICK_ERROR_CODE_GEOLOCATION_NOT_FOUND",
  CLICK_ERROR_CODE_LINK_NOT_EXISTS = "CLICK_ERROR_CODE_LINK_NOT_EXISTS",
  CLICK_ERROR_CODE_MISSING_FORWARDED_FOR = "CLICK_ERROR_CODE_MISSING_FORWARDED_FOR",
  CLICK_ERROR_CODE_SOURCE_DISABLED = "CLICK_ERROR_CODE_SOURCE_DISABLED",
  CLICK_ERROR_CODE_SOURCE_NOT_EXISTS = "CLICK_ERROR_CODE_SOURCE_NOT_EXISTS",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum TipaltiV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_TIPALTI_INTEGRATION_WAS_NOT_SET_UP = "ERROR_CODE_TIPALTI_INTEGRATION_WAS_NOT_SET_UP",
  ERROR_CODE_NO_SETTLEMENTS_WITH_TIPALTI = "ERROR_CODE_NO_SETTLEMENTS_WITH_TIPALTI",
  ERROR_CODE_NO_UNPAID_SETTLEMENTS_WITH_TIPALTI = "ERROR_CODE_NO_UNPAID_SETTLEMENTS_WITH_TIPALTI",
  ERROR_CODE_NO_PAYABLE_SETTLEMENTS_WITH_TIPALTI = "ERROR_CODE_NO_PAYABLE_SETTLEMENTS_WITH_TIPALTI",
  ERROR_CODE_TOO_SOON_TO_INSPECT_PAYMENTS = "ERROR_CODE_TOO_SOON_TO_INSPECT_PAYMENTS",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum TiersV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_INVALID_DEFAULT_RATE_FORMAT = "ERROR_CODE_INVALID_DEFAULT_RATE_FORMAT",
  ERROR_CODE_INVALID_DEFAULT_RATE_VALUE = "ERROR_CODE_INVALID_DEFAULT_RATE_VALUE",
  ERROR_CODE_PROTECTED_DEFAULT_TIER = "ERROR_CODE_PROTECTED_DEFAULT_TIER",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum TierTransitionAutomationV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_TRANSITIONS_DISABLED = "ERROR_CODE_TRANSITIONS_DISABLED",
  ERROR_CODE_TRANSITION_LOOP_NOT_ALLOWED = "ERROR_CODE_TRANSITION_LOOP_NOT_ALLOWED",
  ERROR_CODE_THRESHOLD_VALUE_OUT_OF_BOUNDS = "ERROR_CODE_THRESHOLD_VALUE_OUT_OF_BOUNDS",
}

/** @default "REGISTRATION_ERROR_CODE_UNSPECIFIED" */
export enum TenantsV1RegistrationErrorCode {
  REGISTRATION_ERROR_CODE_UNSPECIFIED = "REGISTRATION_ERROR_CODE_UNSPECIFIED",
  REGISTRATION_ERROR_CODE_STRIPE_CUSTOMER_NOT_EXISTS = "REGISTRATION_ERROR_CODE_STRIPE_CUSTOMER_NOT_EXISTS",
  REGISTRATION_ERROR_CODE_STRIPE_CUSTOMER_NOT_VERIFIED = "REGISTRATION_ERROR_CODE_STRIPE_CUSTOMER_NOT_VERIFIED",
}

/** @default "FACTORY_ERROR_CODE_UNSPECIFIED" */
export enum TenantsV1FactoryErrorCode {
  FACTORY_ERROR_CODE_UNSPECIFIED = "FACTORY_ERROR_CODE_UNSPECIFIED",
  FACTORY_ERROR_CODE_CURRENCY_NOT_SUPPORTED = "FACTORY_ERROR_CODE_CURRENCY_NOT_SUPPORTED",
  FACTORY_ERROR_CODE_TENANT_NOT_BELONGS_TO_USER = "FACTORY_ERROR_CODE_TENANT_NOT_BELONGS_TO_USER",
}

/** @default "DELETION_ERROR_CODE_UNSPECIFIED" */
export enum TenantsV1DeletionErrorCode {
  DELETION_ERROR_CODE_UNSPECIFIED = "DELETION_ERROR_CODE_UNSPECIFIED",
  DELETION_ERROR_CODE_TOO_LATE_LATEST_ADMIN_LOGIN_AT = "DELETION_ERROR_CODE_TOO_LATE_LATEST_ADMIN_LOGIN_AT",
}

/** @default "PERIOD_UNSPECIFIED" */
export enum TenantStatisticsV1Period {
  PERIOD_UNSPECIFIED = "PERIOD_UNSPECIFIED",
  PERIOD_HOURLY = "PERIOD_HOURLY",
  PERIOD_DAILY = "PERIOD_DAILY",
  PERIOD_MONTHLY = "PERIOD_MONTHLY",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum TenantStatisticsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_TOO_LATE_LATEST_ADMIN_LOGIN_AT = "ERROR_CODE_TOO_LATE_LATEST_ADMIN_LOGIN_AT",
}

/** @default "SOURCE_STATUS_UNSPECIFIED" */
export enum SourcesV1SourceStatus {
  SOURCE_STATUS_UNSPECIFIED = "SOURCE_STATUS_UNSPECIFIED",
  SOURCE_STATUS_DISABLED = "SOURCE_STATUS_DISABLED",
  SOURCE_STATUS_ENABLED = "SOURCE_STATUS_ENABLED",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum SourcesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ACCOUNT_NOT_EXISTS = "ERROR_CODE_ACCOUNT_NOT_EXISTS",
  ERROR_CODE_TIER_NOT_EXISTS = "ERROR_CODE_TIER_NOT_EXISTS",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum ShopifyV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_DUPLICATE_REVENUE_ORIGIN = "ERROR_CODE_DUPLICATE_REVENUE_ORIGIN",
  ERROR_CODE_ORDER_RECEIVED_CONVERSION_TYPE_NOT_EXISTS = "ERROR_CODE_ORDER_RECEIVED_CONVERSION_TYPE_NOT_EXISTS",
  ERROR_CODE_REVENUE_ORIGIN_NOT_EXISTS = "ERROR_CODE_REVENUE_ORIGIN_NOT_EXISTS",
  ERROR_CODE_SHOPIFY_INTEGRATION_APP_ALREADY_INSTALLED = "ERROR_CODE_SHOPIFY_INTEGRATION_APP_ALREADY_INSTALLED",
  ERROR_CODE_SHOPIFY_INTEGRATION_UNAUTHORIZED = "ERROR_CODE_SHOPIFY_INTEGRATION_UNAUTHORIZED",
  ERROR_CODE_SHOPIFY_SHOP_ASSIGNED_TO_ANOTHER_TENANT = "ERROR_CODE_SHOPIFY_SHOP_ASSIGNED_TO_ANOTHER_TENANT",
}

/** @default "TENANT_TYPE_UNSPECIFIED" */
export enum SettingsV1TenantType {
  TENANT_TYPE_UNSPECIFIED = "TENANT_TYPE_UNSPECIFIED",
  TENANT_TYPE_ECOMMERCE = "TENANT_TYPE_ECOMMERCE",
  TENANT_TYPE_NETWORK = "TENANT_TYPE_NETWORK",
}

/** @default "ONBOARDING_STATUS_UNSPECIFIED" */
export enum SettingsV1OnboardingStatus {
  ONBOARDING_STATUS_UNSPECIFIED = "ONBOARDING_STATUS_UNSPECIFIED",
  ONBOARDING_STATUS_ASSISTED_IMPLEMENTATION = "ONBOARDING_STATUS_ASSISTED_IMPLEMENTATION",
  ONBOARDING_STATUS_ENTERPRISE = "ONBOARDING_STATUS_ENTERPRISE",
  ONBOARDING_STATUS_FINISHED = "ONBOARDING_STATUS_FINISHED",
  ONBOARDING_STATUS_INITIAL = "ONBOARDING_STATUS_INITIAL",
  ONBOARDING_STATUS_SELF_IMPLEMENTATION_APP_LOCKED = "ONBOARDING_STATUS_SELF_IMPLEMENTATION_APP_LOCKED",
  ONBOARDING_STATUS_SELF_IMPLEMENTATION_APP_UNLOCKED = "ONBOARDING_STATUS_SELF_IMPLEMENTATION_APP_UNLOCKED",
  ONBOARDING_STATUS_WELCOMED = "ONBOARDING_STATUS_WELCOMED",
}

/** @default "MEMBERSHIP_BILLING_CYCLE_UNSPECIFIED" */
export enum SettingsV1MembershipBillingCycle {
  MEMBERSHIP_BILLING_CYCLE_UNSPECIFIED = "MEMBERSHIP_BILLING_CYCLE_UNSPECIFIED",
  MEMBERSHIP_BILLING_CYCLE_ANNUAL = "MEMBERSHIP_BILLING_CYCLE_ANNUAL",
  MEMBERSHIP_BILLING_CYCLE_MONTHLY = "MEMBERSHIP_BILLING_CYCLE_MONTHLY",
  MEMBERSHIP_BILLING_CYCLE_NONE = "MEMBERSHIP_BILLING_CYCLE_NONE",
}

/** @default "EMAIL_TYPE_UNSPECIFIED" */
export enum SettingsV1EmailType {
  EMAIL_TYPE_UNSPECIFIED = "EMAIL_TYPE_UNSPECIFIED",
  EMAIL_TYPE_ADVERTISER_WELCOME_APPROVED = "EMAIL_TYPE_ADVERTISER_WELCOME_APPROVED",
  EMAIL_TYPE_ADVERTISER_WELCOME_PENDING = "EMAIL_TYPE_ADVERTISER_WELCOME_PENDING",
  EMAIL_TYPE_AFFILIATE_WELCOME_APPROVED = "EMAIL_TYPE_AFFILIATE_WELCOME_APPROVED",
  EMAIL_TYPE_AFFILIATE_WELCOME_PENDING = "EMAIL_TYPE_AFFILIATE_WELCOME_PENDING",
  EMAIL_TYPE_INVITE_USER = "EMAIL_TYPE_INVITE_USER",
}

/** @default "ADMIN_ACCESS_STATUS_UNSPECIFIED" */
export enum SettingsV1AdminAccessStatus {
  ADMIN_ACCESS_STATUS_UNSPECIFIED = "ADMIN_ACCESS_STATUS_UNSPECIFIED",
  ADMIN_ACCESS_STATUS_ALLOWED_PERMANENTLY = "ADMIN_ACCESS_STATUS_ALLOWED_PERMANENTLY",
  ADMIN_ACCESS_STATUS_ALLOWED_TILL_NEXT_REVENUE_CHECK = "ADMIN_ACCESS_STATUS_ALLOWED_TILL_NEXT_REVENUE_CHECK",
  ADMIN_ACCESS_STATUS_BLOCKED_DUE_TO_REVENUE_TILL_UPGRADE = "ADMIN_ACCESS_STATUS_BLOCKED_DUE_TO_REVENUE_TILL_UPGRADE",
  ADMIN_ACCESS_STATUS_BLOCKED_PERMANENTLY = "ADMIN_ACCESS_STATUS_BLOCKED_PERMANENTLY",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum RolesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ONE_OR_MORE_PERMISSIONS_NOT_EXIST = "ERROR_CODE_ONE_OR_MORE_PERMISSIONS_NOT_EXIST",
  ERROR_CODE_ROLE_PROTECTED = "ERROR_CODE_ROLE_PROTECTED",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum RevenueOriginsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_QUALITY_CONTROL_DUPLICATE_CONVERSION_TYPE_RULE = "ERROR_CODE_QUALITY_CONTROL_DUPLICATE_CONVERSION_TYPE_RULE",
  ERROR_CODE_QUALITY_CONTROL_DUPLICATE_ITEM_WITHOUT_RULES = "ERROR_CODE_QUALITY_CONTROL_DUPLICATE_ITEM_WITHOUT_RULES",
  ERROR_CODE_QUALITY_CONTROL_MAX_ACTIVATION_RATE_LIMIT_EXCEEDED = "ERROR_CODE_QUALITY_CONTROL_MAX_ACTIVATION_RATE_LIMIT_EXCEEDED",
  ERROR_CODE_QUALITY_CONTROL_MIN_ACTIVATION_RATE_LIMIT_EXCEEDED = "ERROR_CODE_QUALITY_CONTROL_MIN_ACTIVATION_RATE_LIMIT_EXCEEDED",
  ERROR_CODE_INCORRECT_ENDPOINT_TO_UPDATE_REVENUE_ORIGIN_WITH_ACCOUNT = "ERROR_CODE_INCORRECT_ENDPOINT_TO_UPDATE_REVENUE_ORIGIN_WITH_ACCOUNT",
  ERROR_CODE_REVENUE_ORIGIN_WITH_EMAIL_ALREADY_EXISTS = "ERROR_CODE_REVENUE_ORIGIN_WITH_EMAIL_ALREADY_EXISTS",
}

/** @default "CLAIM_ERROR_CODE_UNSPECIFIED" */
export enum RevenueOriginBillingV1ClaimErrorCode {
  CLAIM_ERROR_CODE_UNSPECIFIED = "CLAIM_ERROR_CODE_UNSPECIFIED",
  CLAIM_ERROR_CODE_BILLING_DETAIL_NOT_SET = "CLAIM_ERROR_CODE_BILLING_DETAIL_NOT_SET",
  CLAIM_ERROR_CODE_NO_REVENUE_ORIGIN_OPEN_BALANCES = "CLAIM_ERROR_CODE_NO_REVENUE_ORIGIN_OPEN_BALANCES",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum ReportsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_INVALID_FROM = "ERROR_CODE_INVALID_FROM",
  ERROR_CODE_INVALID_TIME_RANGE = "ERROR_CODE_INVALID_TIME_RANGE",
  ERROR_CODE_INVALID_TIMEZONE = "ERROR_CODE_INVALID_TIMEZONE",
  ERROR_CODE_INVALID_TO = "ERROR_CODE_INVALID_TO",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum PricingV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_SUPER_GROUP_NOT_FOUND_FOR_PRICING = "ERROR_CODE_SUPER_GROUP_NOT_FOUND_FOR_PRICING",
}

/** @default "POSTBACK_STATUS_UNSPECIFIED" */
export enum PostbacksV1PostbackStatus {
  POSTBACK_STATUS_UNSPECIFIED = "POSTBACK_STATUS_UNSPECIFIED",
  POSTBACK_STATUS_ERROR = "POSTBACK_STATUS_ERROR",
  POSTBACK_STATUS_ERROR_RETRYING = "POSTBACK_STATUS_ERROR_RETRYING",
  POSTBACK_STATUS_SCHEDULED = "POSTBACK_STATUS_SCHEDULED",
  POSTBACK_STATUS_SUCCESS = "POSTBACK_STATUS_SUCCESS",
}

/** @default "POSTBACK_TEMPLATE_TYPE_UNSPECIFIED" */
export enum PostbackTemplatesV1PostbackTemplateType {
  POSTBACK_TEMPLATE_TYPE_UNSPECIFIED = "POSTBACK_TEMPLATE_TYPE_UNSPECIFIED",
  POSTBACK_TEMPLATE_TYPE_HTTP_GET = "POSTBACK_TEMPLATE_TYPE_HTTP_GET",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum PostbackTemplatesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_CONVERSION_TYPE_NOT_EXISTS = "ERROR_CODE_CONVERSION_TYPE_NOT_EXISTS",
  ERROR_CODE_DUPLICATE_CONVERSION_STATUS = "ERROR_CODE_DUPLICATE_CONVERSION_STATUS",
  ERROR_CODE_EMPTY_CONVERSION_STATUSES = "ERROR_CODE_EMPTY_CONVERSION_STATUSES",
  ERROR_CODE_EMPTY_WHITELISTED_OFFERS = "ERROR_CODE_EMPTY_WHITELISTED_OFFERS",
  ERROR_CODE_INVALID_PARAMS_FOR_POSTBACK_TYPE = "ERROR_CODE_INVALID_PARAMS_FOR_POSTBACK_TYPE",
  ERROR_CODE_OFFER_NOT_EXISTS = "ERROR_CODE_OFFER_NOT_EXISTS",
  ERROR_CODE_SOURCE_NOT_EXISTS = "ERROR_CODE_SOURCE_NOT_EXISTS",
  ERROR_CODE_INVALID_POSTBACK_URL = "ERROR_CODE_INVALID_POSTBACK_URL",
}

/** @default "PAYMENT_METHOD_TYPE_UNSPECIFIED" */
export enum PaymentMethodsV1PaymentMethodType {
  PAYMENT_METHOD_TYPE_UNSPECIFIED = "PAYMENT_METHOD_TYPE_UNSPECIFIED",
  PAYMENT_METHOD_TYPE_BANK_TRANSFER = "PAYMENT_METHOD_TYPE_BANK_TRANSFER",
  PAYMENT_METHOD_TYPE_BITCOIN = "PAYMENT_METHOD_TYPE_BITCOIN",
  PAYMENT_METHOD_TYPE_CREDIT_STORE = "PAYMENT_METHOD_TYPE_CREDIT_STORE",
  PAYMENT_METHOD_TYPE_DIRECT_DEPOSIT = "PAYMENT_METHOD_TYPE_DIRECT_DEPOSIT",
  PAYMENT_METHOD_TYPE_ETHER = "PAYMENT_METHOD_TYPE_ETHER",
  PAYMENT_METHOD_TYPE_GIFT_CARD = "PAYMENT_METHOD_TYPE_GIFT_CARD",
  PAYMENT_METHOD_TYPE_MERCADO_PAGO = "PAYMENT_METHOD_TYPE_MERCADO_PAGO",
  PAYMENT_METHOD_TYPE_NETELLER = "PAYMENT_METHOD_TYPE_NETELLER",
  PAYMENT_METHOD_TYPE_PAYONEER = "PAYMENT_METHOD_TYPE_PAYONEER",
  PAYMENT_METHOD_TYPE_PAY_PAL = "PAYMENT_METHOD_TYPE_PAY_PAL",
  PAYMENT_METHOD_TYPE_REVOLUT = "PAYMENT_METHOD_TYPE_REVOLUT",
  PAYMENT_METHOD_TYPE_SEPA = "PAYMENT_METHOD_TYPE_SEPA",
  PAYMENT_METHOD_TYPE_SKRILL = "PAYMENT_METHOD_TYPE_SKRILL",
  PAYMENT_METHOD_TYPE_TIPALTI = "PAYMENT_METHOD_TYPE_TIPALTI",
  PAYMENT_METHOD_TYPE_USDC = "PAYMENT_METHOD_TYPE_USDC",
  PAYMENT_METHOD_TYPE_USDT = "PAYMENT_METHOD_TYPE_USDT",
  PAYMENT_METHOD_TYPE_WISE = "PAYMENT_METHOD_TYPE_WISE",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum PaymentMethodsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ACCOUNT_NOT_EXIST = "ERROR_CODE_ACCOUNT_NOT_EXIST",
  ERROR_CODE_CURRENCY_NOT_EXIST = "ERROR_CODE_CURRENCY_NOT_EXIST",
  ERROR_CODE_INVALID_DATA_FOR_PAYMENT_METHOD_TYPE = "ERROR_CODE_INVALID_DATA_FOR_PAYMENT_METHOD_TYPE",
  ERROR_CODE_PAYMENT_METHOD_NOT_AVAILABLE = "ERROR_CODE_PAYMENT_METHOD_NOT_AVAILABLE",
  ERROR_CODE_PROTECTED_DEFAULT_PAYMENT_METHOD = "ERROR_CODE_PROTECTED_DEFAULT_PAYMENT_METHOD",
}

/** @default "AVAILABLE_ERROR_CODE_UNSPECIFIED" */
export enum PaymentMethodsV1AvailableErrorCode {
  AVAILABLE_ERROR_CODE_UNSPECIFIED = "AVAILABLE_ERROR_CODE_UNSPECIFIED",
  AVAILABLE_ERROR_CODE_CURRENCY_NOT_EXIST = "AVAILABLE_ERROR_CODE_CURRENCY_NOT_EXIST",
  AVAILABLE_ERROR_CODE_PAYMENT_METHOD_TYPE_NOT_SUPPORTED_FOR_CURRENCY = "AVAILABLE_ERROR_CODE_PAYMENT_METHOD_TYPE_NOT_SUPPORTED_FOR_CURRENCY",
}

/** @default "VISIBILITY_UNSPECIFIED" */
export enum OffersV1Visibility {
  VISIBILITY_UNSPECIFIED = "VISIBILITY_UNSPECIFIED",
  VISIBILITY_PUBLIC = "VISIBILITY_PUBLIC",
  VISIBILITY_PRIVATE = "VISIBILITY_PRIVATE",
  VISIBILITY_APPLY_TO_RUN = "VISIBILITY_APPLY_TO_RUN",
}

/** @default "TRAFFIC_SOURCE_UNSPECIFIED" */
export enum OffersV1TrafficSource {
  TRAFFIC_SOURCE_UNSPECIFIED = "TRAFFIC_SOURCE_UNSPECIFIED",
  TRAFFIC_SOURCE_APP_INSTALLS = "TRAFFIC_SOURCE_APP_INSTALLS",
  TRAFFIC_SOURCE_CONTEXTUAL = "TRAFFIC_SOURCE_CONTEXTUAL",
  TRAFFIC_SOURCE_DISPLAY = "TRAFFIC_SOURCE_DISPLAY",
  TRAFFIC_SOURCE_EMAIL = "TRAFFIC_SOURCE_EMAIL",
  TRAFFIC_SOURCE_POP = "TRAFFIC_SOURCE_POP",
  TRAFFIC_SOURCE_PUSH = "TRAFFIC_SOURCE_PUSH",
  TRAFFIC_SOURCE_SEARCH = "TRAFFIC_SOURCE_SEARCH",
  TRAFFIC_SOURCE_SMS = "TRAFFIC_SOURCE_SMS",
  TRAFFIC_SOURCE_SOCIAL = "TRAFFIC_SOURCE_SOCIAL",
  TRAFFIC_SOURCE_SURVEY = "TRAFFIC_SOURCE_SURVEY",
}

/** @default "TRACKING_TYPE_UNSPECIFIED" */
export enum OffersV1TrackingType {
  TRACKING_TYPE_UNSPECIFIED = "TRACKING_TYPE_UNSPECIFIED",
  TRACKING_TYPE_DIRECT = "TRACKING_TYPE_DIRECT",
  TRACKING_TYPE_REDIRECT = "TRACKING_TYPE_REDIRECT",
}

/** @default "STATUS_UNSPECIFIED" */
export enum OffersV1Status {
  STATUS_UNSPECIFIED = "STATUS_UNSPECIFIED",
  STATUS_DRAFT = "STATUS_DRAFT",
  STATUS_ACTIVE = "STATUS_ACTIVE",
  STATUS_INACTIVE = "STATUS_INACTIVE",
}

/** @default "SOURCE_ERROR_CODE_UNSPECIFIED" */
export enum OffersV1SourceErrorCode {
  SOURCE_ERROR_CODE_UNSPECIFIED = "SOURCE_ERROR_CODE_UNSPECIFIED",
  SOURCE_ERROR_CODE_OFFER_NOT_EXISTS = "SOURCE_ERROR_CODE_OFFER_NOT_EXISTS",
  SOURCE_ERROR_CODE_ONE_OR_MORE_SOURCES_ALREADY_ASSIGNED = "SOURCE_ERROR_CODE_ONE_OR_MORE_SOURCES_ALREADY_ASSIGNED",
  SOURCE_ERROR_CODE_ONE_OR_MORE_SOURCES_NOT_EXIST = "SOURCE_ERROR_CODE_ONE_OR_MORE_SOURCES_NOT_EXIST",
  SOURCE_ERROR_CODE_APPLICATION_ACCESS_NOT_PENDING = "SOURCE_ERROR_CODE_APPLICATION_ACCESS_NOT_PENDING",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum OffersV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_CATEGORY_NOT_EXISTS = "ERROR_CODE_CATEGORY_NOT_EXISTS",
  ERROR_CODE_DEFAULT_REVENUE_ORIGIN_NOT_EXISTS = "ERROR_CODE_DEFAULT_REVENUE_ORIGIN_NOT_EXISTS",
  ERROR_CODE_OFFER_OWNER_NOT_EXISTS = "ERROR_CODE_OFFER_OWNER_NOT_EXISTS",
  ERROR_CODE_STATUS_NOT_ALLOWED = "ERROR_CODE_STATUS_NOT_ALLOWED",
  ERROR_CODE_TAG_NOT_EXISTS = "ERROR_CODE_TAG_NOT_EXISTS",
  ERROR_CODE_OFFER_NOT_ACTIVE = "ERROR_CODE_OFFER_NOT_ACTIVE",
  ERROR_CODE_OFFER_DEACTIVATION_TOO_FAR_IN_FUTURE = "ERROR_CODE_OFFER_DEACTIVATION_TOO_FAR_IN_FUTURE",
  ERROR_CODE_INVALID_OFFER_TRACKING_TYPE = "ERROR_CODE_INVALID_OFFER_TRACKING_TYPE",
  ERROR_CODE_QUALITY_CONTROL_DUPLICATE_CONVERSION_TYPE_RULE = "ERROR_CODE_QUALITY_CONTROL_DUPLICATE_CONVERSION_TYPE_RULE",
  ERROR_CODE_QUALITY_CONTROL_DUPLICATE_ITEM_WITHOUT_RULES = "ERROR_CODE_QUALITY_CONTROL_DUPLICATE_ITEM_WITHOUT_RULES",
  ERROR_CODE_QUALITY_CONTROL_MAX_ACTIVATION_RATE_LIMIT_EXCEEDED = "ERROR_CODE_QUALITY_CONTROL_MAX_ACTIVATION_RATE_LIMIT_EXCEEDED",
  ERROR_CODE_QUALITY_CONTROL_MIN_ACTIVATION_RATE_LIMIT_EXCEEDED = "ERROR_CODE_QUALITY_CONTROL_MIN_ACTIVATION_RATE_LIMIT_EXCEEDED",
}

/** @default "ACCESS_UNSPECIFIED" */
export enum OffersV1Access {
  ACCESS_UNSPECIFIED = "ACCESS_UNSPECIFIED",
  ACCESS_ALLOWED = "ACCESS_ALLOWED",
  ACCESS_FORBIDDEN = "ACCESS_FORBIDDEN",
  ACCESS_PENDING = "ACCESS_PENDING",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum MetadataV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_STRIPE_CUSTOMER_NOT_EXISTS = "ERROR_CODE_STRIPE_CUSTOMER_NOT_EXISTS",
  ERROR_CODE_STRIPE_CUSTOMER_NOT_VERIFIED = "ERROR_CODE_STRIPE_CUSTOMER_NOT_VERIFIED",
}

/** @default "STATUS_UNSPECIFIED" */
export enum MembershipsV1Status {
  STATUS_UNSPECIFIED = "STATUS_UNSPECIFIED",
  STATUS_ACTIVE = "STATUS_ACTIVE",
  STATUS_INACTIVE = "STATUS_INACTIVE",
  STATUS_TRIALING = "STATUS_TRIALING",
}

/** @default "PLATFORM_ID_UNSPECIFIED" */
export enum MembershipsV1PlatformId {
  PLATFORM_ID_UNSPECIFIED = "PLATFORM_ID_UNSPECIFIED",
  PLATFORM_ID_SHOPIFY = "PLATFORM_ID_SHOPIFY",
  PLATFORM_ID_STRIPE = "PLATFORM_ID_STRIPE",
}

/** @default "PLAN_ID_UNSPECIFIED" */
export enum MembershipsV1PlanId {
  PLAN_ID_UNSPECIFIED = "PLAN_ID_UNSPECIFIED",
  PLAN_ID_BUSINESS = "PLAN_ID_BUSINESS",
  PLAN_ID_ENTERPRISE = "PLAN_ID_ENTERPRISE",
  PLAN_ID_ENTERPRISE_PLUS = "PLAN_ID_ENTERPRISE_PLUS",
  PLAN_ID_FREEMIUM = "PLAN_ID_FREEMIUM",
  PLAN_ID_STARTER = "PLAN_ID_STARTER",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum MembershipsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ALLOWED_IN_FREEMIUM_ONLY = "ERROR_CODE_ALLOWED_IN_FREEMIUM_ONLY",
  ERROR_CODE_FREE_TRIAL_ACTIVE_IN_THE_PAST = "ERROR_CODE_FREE_TRIAL_ACTIVE_IN_THE_PAST",
  ERROR_CODE_FREE_TRIAL_ALREADY_ACTIVE = "ERROR_CODE_FREE_TRIAL_ALREADY_ACTIVE",
  ERROR_CODE_INCORRECT_MEMBERSHIP_PLATFORM = "ERROR_CODE_INCORRECT_MEMBERSHIP_PLATFORM",
  ERROR_CODE_MEMBERSHIP_ALREADY_ACTIVE = "ERROR_CODE_MEMBERSHIP_ALREADY_ACTIVE",
  ERROR_CODE_NO_ACTIVE_MEMBERSHIP = "ERROR_CODE_NO_ACTIVE_MEMBERSHIP",
  ERROR_CODE_SHOPIFY_APP_NOT_INSTALLED = "ERROR_CODE_SHOPIFY_APP_NOT_INSTALLED",
  ERROR_CODE_SHOPIFY_INTEGRATION_NOT_EXISTS = "ERROR_CODE_SHOPIFY_INTEGRATION_NOT_EXISTS",
  ERROR_CODE_STRIPE_CUSTOMER_NOT_EXISTS = "ERROR_CODE_STRIPE_CUSTOMER_NOT_EXISTS",
  ERROR_CODE_STRIPE_CUSTOMER_NOT_VERIFIED = "ERROR_CODE_STRIPE_CUSTOMER_NOT_VERIFIED",
}

/** @default "CURRENCY_UNSPECIFIED" */
export enum MembershipsV1Currency {
  CURRENCY_UNSPECIFIED = "CURRENCY_UNSPECIFIED",
  CURRENCY_EUR = "CURRENCY_EUR",
  CURRENCY_USD = "CURRENCY_USD",
}

/** @default "BILLING_CYCLE_UNSPECIFIED" */
export enum MembershipsV1BillingCycle {
  BILLING_CYCLE_UNSPECIFIED = "BILLING_CYCLE_UNSPECIFIED",
  BILLING_CYCLE_ANNUAL = "BILLING_CYCLE_ANNUAL",
  BILLING_CYCLE_MONTHLY = "BILLING_CYCLE_MONTHLY",
}

/** @default "LANDING_PAGE_STATUS_UNSPECIFIED" */
export enum LandingPagesV1LandingPageStatus {
  LANDING_PAGE_STATUS_UNSPECIFIED = "LANDING_PAGE_STATUS_UNSPECIFIED",
  LANDING_PAGE_STATUS_ENABLED = "LANDING_PAGE_STATUS_ENABLED",
  LANDING_PAGE_STATUS_HIDDEN = "LANDING_PAGE_STATUS_HIDDEN",
  LANDING_PAGE_STATUS_DISABLED = "LANDING_PAGE_STATUS_DISABLED",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum LandingPagesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ALREADY_USED = "ERROR_CODE_ALREADY_USED",
  ERROR_CODE_OFFER_NOT_EXISTS = "ERROR_CODE_OFFER_NOT_EXISTS",
  ERROR_CODE_OFFER_STATUS_NOT_DRAFT = "ERROR_CODE_OFFER_STATUS_NOT_DRAFT",
  ERROR_CODE_AT_LEAST_ONE_LANDING_PAGE_MUST_BE_ENABLED = "ERROR_CODE_AT_LEAST_ONE_LANDING_PAGE_MUST_BE_ENABLED",
  ERROR_CODE_INVALID_TRACKING_TYPE = "ERROR_CODE_INVALID_TRACKING_TYPE",
  ERROR_CODE_REDIRECT_LINK_INVALID_URL = "ERROR_CODE_REDIRECT_LINK_INVALID_URL",
  ERROR_CODE_REDIRECT_LINK_MISSING_CID = "ERROR_CODE_REDIRECT_LINK_MISSING_CID",
  ERROR_CODE_LANDING_PAGE_NOT_FOUND_FOR_GIVEN_OFFER = "ERROR_CODE_LANDING_PAGE_NOT_FOUND_FOR_GIVEN_OFFER",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum InvitationsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_INVITATION_ALREADY_EXISTS = "ERROR_CODE_INVITATION_ALREADY_EXISTS",
  ERROR_CODE_INVITATION_ALREADY_ACCEPTED = "ERROR_CODE_INVITATION_ALREADY_ACCEPTED",
  ERROR_CODE_INVITATION_EXPIRED = "ERROR_CODE_INVITATION_EXPIRED",
  ERROR_CODE_INVITATION_TOKEN_MISMATCH = "ERROR_CODE_INVITATION_TOKEN_MISMATCH",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum IntraMessagesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ACCOUNT_NOT_MEETS_CONDITIONS = "ERROR_CODE_ACCOUNT_NOT_MEETS_CONDITIONS",
  ERROR_CODE_NO_RECIPIENTS_MEET_TARGET_GROUP_CRITERIA = "ERROR_CODE_NO_RECIPIENTS_MEET_TARGET_GROUP_CRITERIA",
  ERROR_CODE_REVENUE_ORIGIN_NOT_MEETS_CONDITIONS = "ERROR_CODE_REVENUE_ORIGIN_NOT_MEETS_CONDITIONS",
  ERROR_CODE_HTML_CONTENT_NOT_VALID = "ERROR_CODE_HTML_CONTENT_NOT_VALID",
  ERROR_CODE_UNMANAGED_ACCOUNT = "ERROR_CODE_UNMANAGED_ACCOUNT",
  ERROR_CODE_NUMBER_OF_RECIPIENTS_LIMIT_EXCEEDED = "ERROR_CODE_NUMBER_OF_RECIPIENTS_LIMIT_EXCEEDED",
}

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 *
 *  - NULL_VALUE: Null value.
 * @default "NULL_VALUE"
 */
export enum GoogleProtobufNullValue {
  NULL_VALUE = "NULL_VALUE",
}

/** @default "LINE_ENDINGS_UNSPECIFIED" */
export enum ExportV1LineEndings {
  LINE_ENDINGS_UNSPECIFIED = "LINE_ENDINGS_UNSPECIFIED",
  LINE_ENDINGS_WINDOWS = "LINE_ENDINGS_WINDOWS",
  LINE_ENDINGS_UNIX = "LINE_ENDINGS_UNIX",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum ExportV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_UNSUPPORTED_MIME_TYPE = "ERROR_CODE_UNSUPPORTED_MIME_TYPE",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum ErrorsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_INVALID_TIME_RANGE = "ERROR_CODE_INVALID_TIME_RANGE",
  ERROR_CODE_VIOLATION = "ERROR_CODE_VIOLATION",
}

/** @default "WEEKDAY_UNSPECIFIED" */
export enum EnumsV1Weekday {
  WEEKDAY_UNSPECIFIED = "WEEKDAY_UNSPECIFIED",
  WEEKDAY_MONDAY = "WEEKDAY_MONDAY",
  WEEKDAY_TUESDAY = "WEEKDAY_TUESDAY",
  WEEKDAY_WEDNESDAY = "WEEKDAY_WEDNESDAY",
  WEEKDAY_THURSDAY = "WEEKDAY_THURSDAY",
  WEEKDAY_FRIDAY = "WEEKDAY_FRIDAY",
  WEEKDAY_SATURDAY = "WEEKDAY_SATURDAY",
  WEEKDAY_SUNDAY = "WEEKDAY_SUNDAY",
}

/** @default "TIER_TRANSITION_TYPE_UNSPECIFIED" */
export enum EnumsV1TierTransitionType {
  TIER_TRANSITION_TYPE_UNSPECIFIED = "TIER_TRANSITION_TYPE_UNSPECIFIED",
  TIER_TRANSITION_TYPE_LIFETIME = "TIER_TRANSITION_TYPE_LIFETIME",
  TIER_TRANSITION_TYPE_PERIODICAL = "TIER_TRANSITION_TYPE_PERIODICAL",
}

/** @default "TIER_TRANSITION_PERIOD_UNSPECIFIED" */
export enum EnumsV1TierTransitionPeriod {
  TIER_TRANSITION_PERIOD_UNSPECIFIED = "TIER_TRANSITION_PERIOD_UNSPECIFIED",
  TIER_TRANSITION_PERIOD_DAILY = "TIER_TRANSITION_PERIOD_DAILY",
  TIER_TRANSITION_PERIOD_WEEKLY = "TIER_TRANSITION_PERIOD_WEEKLY",
  TIER_TRANSITION_PERIOD_MONTHLY = "TIER_TRANSITION_PERIOD_MONTHLY",
}

/** @default "TIER_TRANSITION_METRIC_UNSPECIFIED" */
export enum EnumsV1TierTransitionMetric {
  TIER_TRANSITION_METRIC_UNSPECIFIED = "TIER_TRANSITION_METRIC_UNSPECIFIED",
  TIER_TRANSITION_METRIC_REVENUE = "TIER_TRANSITION_METRIC_REVENUE",
  TIER_TRANSITION_METRIC_COST = "TIER_TRANSITION_METRIC_COST",
  TIER_TRANSITION_METRIC_CONVERSION_COUNT = "TIER_TRANSITION_METRIC_CONVERSION_COUNT",
}

/** @default "THEME_UNSPECIFIED" */
export enum EnumsV1Theme {
  THEME_UNSPECIFIED = "THEME_UNSPECIFIED",
  THEME_DARK = "THEME_DARK",
  THEME_LIGHT = "THEME_LIGHT",
  THEME_SYSTEM = "THEME_SYSTEM",
}

/** @default "SMART_LINK_STATUS_UNSPECIFIED" */
export enum EnumsV1SmartLinkStatus {
  SMART_LINK_STATUS_UNSPECIFIED = "SMART_LINK_STATUS_UNSPECIFIED",
  SMART_LINK_STATUS_ENABLED = "SMART_LINK_STATUS_ENABLED",
  SMART_LINK_STATUS_DISABLED = "SMART_LINK_STATUS_DISABLED",
}

/** @default "SMART_LINK_METRIC_UNSPECIFIED" */
export enum EnumsV1SmartLinkMetric {
  SMART_LINK_METRIC_UNSPECIFIED = "SMART_LINK_METRIC_UNSPECIFIED",
  SMART_LINK_METRIC_EQUAL = "SMART_LINK_METRIC_EQUAL",
  SMART_LINK_METRIC_EPC = "SMART_LINK_METRIC_EPC",
  SMART_LINK_METRIC_MANUAL = "SMART_LINK_METRIC_MANUAL",
}

/** @default "REVENUE_ORIGIN_STATUS_UNSPECIFIED" */
export enum EnumsV1RevenueOriginStatus {
  REVENUE_ORIGIN_STATUS_UNSPECIFIED = "REVENUE_ORIGIN_STATUS_UNSPECIFIED",
  REVENUE_ORIGIN_STATUS_ACTIVE = "REVENUE_ORIGIN_STATUS_ACTIVE",
  REVENUE_ORIGIN_STATUS_INACTIVE = "REVENUE_ORIGIN_STATUS_INACTIVE",
}

/** @default "REPORT_GROUPING_UNSPECIFIED" */
export enum EnumsV1ReportGrouping {
  REPORT_GROUPING_UNSPECIFIED = "REPORT_GROUPING_UNSPECIFIED",
  REPORT_GROUPING_ACCOUNT = "REPORT_GROUPING_ACCOUNT",
  REPORT_GROUPING_AFFILIATE_MANAGER_ACCOUNT = "REPORT_GROUPING_AFFILIATE_MANAGER_ACCOUNT",
  REPORT_GROUPING_CATEGORY = "REPORT_GROUPING_CATEGORY",
  REPORT_GROUPING_COUNTRY_CODE = "REPORT_GROUPING_COUNTRY_CODE",
  REPORT_GROUPING_COUPON = "REPORT_GROUPING_COUPON",
  REPORT_GROUPING_DAY = "REPORT_GROUPING_DAY",
  REPORT_GROUPING_HOUR = "REPORT_GROUPING_HOUR",
  REPORT_GROUPING_LANDING_PAGE = "REPORT_GROUPING_LANDING_PAGE",
  REPORT_GROUPING_MONTH = "REPORT_GROUPING_MONTH",
  REPORT_GROUPING_OFFER = "REPORT_GROUPING_OFFER",
  REPORT_GROUPING_REVENUE_ORIGIN = "REPORT_GROUPING_REVENUE_ORIGIN",
  REPORT_GROUPING_SMART_LINK = "REPORT_GROUPING_SMART_LINK",
  REPORT_GROUPING_SOURCE = "REPORT_GROUPING_SOURCE",
  REPORT_GROUPING_TIER = "REPORT_GROUPING_TIER",
  REPORT_GROUPING_WEEK = "REPORT_GROUPING_WEEK",
  REPORT_GROUPING_YEAR = "REPORT_GROUPING_YEAR",
}

/** @default "REDIRECT_DOMAINS_TYPE_UNSPECIFIED" */
export enum EnumsV1RedirectDomainsType {
  REDIRECT_DOMAINS_TYPE_UNSPECIFIED = "REDIRECT_DOMAINS_TYPE_UNSPECIFIED",
  REDIRECT_DOMAINS_TYPE_SYSTEM_DOMAINS = "REDIRECT_DOMAINS_TYPE_SYSTEM_DOMAINS",
  REDIRECT_DOMAINS_TYPE_GOOGLE_CERTIFIED = "REDIRECT_DOMAINS_TYPE_GOOGLE_CERTIFIED",
  REDIRECT_DOMAINS_TYPE_BOTH = "REDIRECT_DOMAINS_TYPE_BOTH",
  REDIRECT_DOMAINS_TYPE_OFFER_DEFAULT = "REDIRECT_DOMAINS_TYPE_OFFER_DEFAULT",
}

/** @default "QUESTION_VISIBILITY_UNSPECIFIED" */
export enum EnumsV1QuestionVisibility {
  QUESTION_VISIBILITY_UNSPECIFIED = "QUESTION_VISIBILITY_UNSPECIFIED",
  QUESTION_VISIBILITY_REQUIRED = "QUESTION_VISIBILITY_REQUIRED",
  QUESTION_VISIBILITY_OPTIONAL = "QUESTION_VISIBILITY_OPTIONAL",
  QUESTION_VISIBILITY_HIDDEN = "QUESTION_VISIBILITY_HIDDEN",
}

/** @default "PRICING_ADJUSTMENT_STATUS_UNSPECIFIED" */
export enum EnumsV1PricingAdjustmentStatus {
  PRICING_ADJUSTMENT_STATUS_UNSPECIFIED = "PRICING_ADJUSTMENT_STATUS_UNSPECIFIED",
  PRICING_ADJUSTMENT_STATUS_OK = "PRICING_ADJUSTMENT_STATUS_OK",
  PRICING_ADJUSTMENT_STATUS_ACTIVE = "PRICING_ADJUSTMENT_STATUS_ACTIVE",
  PRICING_ADJUSTMENT_STATUS_INACTIVE = "PRICING_ADJUSTMENT_STATUS_INACTIVE",
}

/** @default "PERMISSION_UNSPECIFIED" */
export enum EnumsV1Permission {
  PERMISSION_UNSPECIFIED = "PERMISSION_UNSPECIFIED",
  PERMISSION_ACCOUNT_CREATE = "PERMISSION_ACCOUNT_CREATE",
  PERMISSION_ACCOUNT_DELETE = "PERMISSION_ACCOUNT_DELETE",
  PERMISSION_ACCOUNT_DETAIL = "PERMISSION_ACCOUNT_DETAIL",
  PERMISSION_ACCOUNT_LIST = "PERMISSION_ACCOUNT_LIST",
  PERMISSION_ACCOUNT_NOTE_CREATE = "PERMISSION_ACCOUNT_NOTE_CREATE",
  PERMISSION_ACCOUNT_NOTE_DELETE = "PERMISSION_ACCOUNT_NOTE_DELETE",
  PERMISSION_ACCOUNT_NOTE_LIST_FOR_ACCOUNT = "PERMISSION_ACCOUNT_NOTE_LIST_FOR_ACCOUNT",
  PERMISSION_ACCOUNT_PRIMARY_SET = "PERMISSION_ACCOUNT_PRIMARY_SET",
  PERMISSION_ACCOUNT_UPDATE = "PERMISSION_ACCOUNT_UPDATE",
  PERMISSION_ACTIVITY_LOG_DETAIL = "PERMISSION_ACTIVITY_LOG_DETAIL",
  PERMISSION_ACTIVITY_LOG_LIST = "PERMISSION_ACTIVITY_LOG_LIST",
  PERMISSION_ADVERTISER_DELETE = "PERMISSION_ADVERTISER_DELETE",
  PERMISSION_ADVERTISER_DETAIL = "PERMISSION_ADVERTISER_DETAIL",
  PERMISSION_ADVERTISER_DETAIL_OWN_ONLY = "PERMISSION_ADVERTISER_DETAIL_OWN_ONLY",
  PERMISSION_ADVERTISER_INTRA_MESSAGE_HISTORY = "PERMISSION_ADVERTISER_INTRA_MESSAGE_HISTORY",
  PERMISSION_ADVERTISER_INTRA_MESSAGE_SEND = "PERMISSION_ADVERTISER_INTRA_MESSAGE_SEND",
  PERMISSION_ADVERTISER_LIST = "PERMISSION_ADVERTISER_LIST",
  PERMISSION_ADVERTISER_REGISTER_WITH_EXISTING_REVENUE_ORIGIN = "PERMISSION_ADVERTISER_REGISTER_WITH_EXISTING_REVENUE_ORIGIN",
  PERMISSION_ADVERTISER_REGISTER_WITH_USER = "PERMISSION_ADVERTISER_REGISTER_WITH_USER",
  PERMISSION_ADVERTISER_UPDATE = "PERMISSION_ADVERTISER_UPDATE",
  PERMISSION_AFFILIATE_BULK_UPDATE = "PERMISSION_AFFILIATE_BULK_UPDATE",
  PERMISSION_AFFILIATE_BULK_UPDATE_MANAGED_ONLY = "PERMISSION_AFFILIATE_BULK_UPDATE_MANAGED_ONLY",
  PERMISSION_AFFILIATE_CONVERSION_VISIBILITY_APPLIED = "PERMISSION_AFFILIATE_CONVERSION_VISIBILITY_APPLIED",
  PERMISSION_AFFILIATE_DEFAULT_REDIRECT_DOMAIN_UPDATE = "PERMISSION_AFFILIATE_DEFAULT_REDIRECT_DOMAIN_UPDATE",
  PERMISSION_AFFILIATE_DELETE = "PERMISSION_AFFILIATE_DELETE",
  PERMISSION_AFFILIATE_DELETE_MANAGED_ONLY = "PERMISSION_AFFILIATE_DELETE_MANAGED_ONLY",
  PERMISSION_AFFILIATE_DETAIL = "PERMISSION_AFFILIATE_DETAIL",
  PERMISSION_AFFILIATE_DETAIL_MANAGED_ONLY = "PERMISSION_AFFILIATE_DETAIL_MANAGED_ONLY",
  PERMISSION_AFFILIATE_DETAIL_OWN_ONLY = "PERMISSION_AFFILIATE_DETAIL_OWN_ONLY",
  PERMISSION_AFFILIATE_INTRA_MESSAGE_HISTORY = "PERMISSION_AFFILIATE_INTRA_MESSAGE_HISTORY",
  PERMISSION_AFFILIATE_INTRA_MESSAGE_HISTORY_MANAGED_AFFILIATE_ONLY = "PERMISSION_AFFILIATE_INTRA_MESSAGE_HISTORY_MANAGED_AFFILIATE_ONLY",
  PERMISSION_AFFILIATE_INTRA_MESSAGE_SEND = "PERMISSION_AFFILIATE_INTRA_MESSAGE_SEND",
  PERMISSION_AFFILIATE_INTRA_MESSAGE_SEND_MANAGED_AFFILIATE_ONLY = "PERMISSION_AFFILIATE_INTRA_MESSAGE_SEND_MANAGED_AFFILIATE_ONLY",
  PERMISSION_AFFILIATE_LIST = "PERMISSION_AFFILIATE_LIST",
  PERMISSION_AFFILIATE_LIST_MANAGED_ONLY = "PERMISSION_AFFILIATE_LIST_MANAGED_ONLY",
  PERMISSION_AFFILIATE_MANAGER_AFFILIATE_ASSIGN = "PERMISSION_AFFILIATE_MANAGER_AFFILIATE_ASSIGN",
  PERMISSION_AFFILIATE_MANAGER_AFFILIATE_UNASSIGN = "PERMISSION_AFFILIATE_MANAGER_AFFILIATE_UNASSIGN",
  PERMISSION_AFFILIATE_MANAGER_ASSIGNED_AFFILIATE_LIST = "PERMISSION_AFFILIATE_MANAGER_ASSIGNED_AFFILIATE_LIST",
  PERMISSION_AFFILIATE_MANAGER_ASSIGNED_AFFILIATE_LIST_OWN_ONLY = "PERMISSION_AFFILIATE_MANAGER_ASSIGNED_AFFILIATE_LIST_OWN_ONLY",
  PERMISSION_AFFILIATE_MANAGER_BULK_UPDATE = "PERMISSION_AFFILIATE_MANAGER_BULK_UPDATE",
  PERMISSION_AFFILIATE_MANAGER_DETAIL = "PERMISSION_AFFILIATE_MANAGER_DETAIL",
  PERMISSION_AFFILIATE_MANAGER_LIST = "PERMISSION_AFFILIATE_MANAGER_LIST",
  PERMISSION_AFFILIATE_MANAGER_REGISTER_WITH_USER = "PERMISSION_AFFILIATE_MANAGER_REGISTER_WITH_USER",
  PERMISSION_AFFILIATE_REFERRAL_ACCOUNT = "PERMISSION_AFFILIATE_REFERRAL_ACCOUNT",
  PERMISSION_AFFILIATE_REFERRAL_ACCOUNT_UPDATE = "PERMISSION_AFFILIATE_REFERRAL_ACCOUNT_UPDATE",
  PERMISSION_AFFILIATE_REFERRAL_ACCOUNT_UPDATE_MANAGED_ONLY = "PERMISSION_AFFILIATE_REFERRAL_ACCOUNT_UPDATE_MANAGED_ONLY",
  PERMISSION_AFFILIATE_REGISTER_WITH_USER = "PERMISSION_AFFILIATE_REGISTER_WITH_USER",
  PERMISSION_AFFILIATE_REGISTER_WITH_USER_MANAGED_ONLY = "PERMISSION_AFFILIATE_REGISTER_WITH_USER_MANAGED_ONLY",
  PERMISSION_AFFILIATE_REGISTRATION_DATA_GET = "PERMISSION_AFFILIATE_REGISTRATION_DATA_GET",
  PERMISSION_AFFILIATE_REGISTRATION_DATA_GET_MANAGED_ONLY = "PERMISSION_AFFILIATE_REGISTRATION_DATA_GET_MANAGED_ONLY",
  PERMISSION_AFFILIATE_REGISTRATION_FORM_SETTINGS_GET = "PERMISSION_AFFILIATE_REGISTRATION_FORM_SETTINGS_GET",
  PERMISSION_AFFILIATE_REGISTRATION_FORM_SETTINGS_UPDATE = "PERMISSION_AFFILIATE_REGISTRATION_FORM_SETTINGS_UPDATE",
  PERMISSION_AFFILIATE_STATUS_UPDATE = "PERMISSION_AFFILIATE_STATUS_UPDATE",
  PERMISSION_AFFILIATE_STATUS_UPDATE_MANAGED_ONLY = "PERMISSION_AFFILIATE_STATUS_UPDATE_MANAGED_ONLY",
  PERMISSION_AFFILIATE_TIER_UPDATE = "PERMISSION_AFFILIATE_TIER_UPDATE",
  PERMISSION_AFFILIATE_TIER_UPDATE_MANAGED_ONLY = "PERMISSION_AFFILIATE_TIER_UPDATE_MANAGED_ONLY",
  PERMISSION_AFFILIATE_UPDATE = "PERMISSION_AFFILIATE_UPDATE",
  PERMISSION_AFFILIATE_UPDATE_MANAGED_ONLY = "PERMISSION_AFFILIATE_UPDATE_MANAGED_ONLY",
  PERMISSION_ALBATO_INTEGRATIONS_RETRIEVE_SESSION_TOKEN = "PERMISSION_ALBATO_INTEGRATIONS_RETRIEVE_SESSION_TOKEN",
  PERMISSION_AVAILABLE_PAYMENT_METHOD_CREATE = "PERMISSION_AVAILABLE_PAYMENT_METHOD_CREATE",
  PERMISSION_AVAILABLE_PAYMENT_METHOD_DELETE = "PERMISSION_AVAILABLE_PAYMENT_METHOD_DELETE",
  PERMISSION_AVAILABLE_PAYMENT_METHOD_DETAIL = "PERMISSION_AVAILABLE_PAYMENT_METHOD_DETAIL",
  PERMISSION_AVAILABLE_PAYMENT_METHOD_LIST = "PERMISSION_AVAILABLE_PAYMENT_METHOD_LIST",
  PERMISSION_BALANCES_ACCOUNT_GET = "PERMISSION_BALANCES_ACCOUNT_GET",
  PERMISSION_BALANCES_ACCOUNT_GET_MANAGED_AFFILIATE_ONLY = "PERMISSION_BALANCES_ACCOUNT_GET_MANAGED_AFFILIATE_ONLY",
  PERMISSION_BALANCES_ACCOUNT_GET_OWN_ONLY = "PERMISSION_BALANCES_ACCOUNT_GET_OWN_ONLY",
  PERMISSION_BALANCES_OPEN_LIST = "PERMISSION_BALANCES_OPEN_LIST",
  PERMISSION_BILLING_DETAIL_DETAIL = "PERMISSION_BILLING_DETAIL_DETAIL",
  PERMISSION_BILLING_DETAIL_DETAIL_MANAGED_AFFILIATE_ONLY = "PERMISSION_BILLING_DETAIL_DETAIL_MANAGED_AFFILIATE_ONLY",
  PERMISSION_BILLING_DETAIL_DETAIL_OWN_ONLY = "PERMISSION_BILLING_DETAIL_DETAIL_OWN_ONLY",
  PERMISSION_BILLING_DETAIL_SET = "PERMISSION_BILLING_DETAIL_SET",
  PERMISSION_BILLING_DETAIL_SET_MANAGED_AFFILIATE_ONLY = "PERMISSION_BILLING_DETAIL_SET_MANAGED_AFFILIATE_ONLY",
  PERMISSION_BILLING_DETAIL_SET_OWN_ONLY = "PERMISSION_BILLING_DETAIL_SET_OWN_ONLY",
  PERMISSION_CATEGORY_CREATE = "PERMISSION_CATEGORY_CREATE",
  PERMISSION_CATEGORY_DELETE = "PERMISSION_CATEGORY_DELETE",
  PERMISSION_CATEGORY_LIST = "PERMISSION_CATEGORY_LIST",
  PERMISSION_CATEGORY_UPDATE = "PERMISSION_CATEGORY_UPDATE",
  PERMISSION_CLAIM_BALANCES = "PERMISSION_CLAIM_BALANCES",
  PERMISSION_CLAIM_DELETE = "PERMISSION_CLAIM_DELETE",
  PERMISSION_CLAIM_GET = "PERMISSION_CLAIM_GET",
  PERMISSION_CLAIM_LIST = "PERMISSION_CLAIM_LIST",
  PERMISSION_CLAIM_LIST_OWN_ONLY = "PERMISSION_CLAIM_LIST_OWN_ONLY",
  PERMISSION_CLICK_CREATE = "PERMISSION_CLICK_CREATE",
  PERMISSION_CLICK_LIST = "PERMISSION_CLICK_LIST",
  PERMISSION_CONTACT_EMAIL = "PERMISSION_CONTACT_EMAIL",
  PERMISSION_CONVERSION_AMOUNTS_SET = "PERMISSION_CONVERSION_AMOUNTS_SET",
  PERMISSION_CONVERSION_CREATE = "PERMISSION_CONVERSION_CREATE",
  PERMISSION_CONVERSION_CREATE_CUSTOM_PAYOUTS = "PERMISSION_CONVERSION_CREATE_CUSTOM_PAYOUTS",
  PERMISSION_CONVERSION_CREATE_OWN_REVENUE_ORIGIN_ONLY = "PERMISSION_CONVERSION_CREATE_OWN_REVENUE_ORIGIN_ONLY",
  PERMISSION_CONVERSION_DETAIL = "PERMISSION_CONVERSION_DETAIL",
  PERMISSION_CONVERSION_LIST = "PERMISSION_CONVERSION_LIST",
  PERMISSION_CONVERSION_REQUEST_LIST = "PERMISSION_CONVERSION_REQUEST_LIST",
  PERMISSION_CONVERSION_SOURCE_EXTERNAL_IDENTIFIER_CREATE = "PERMISSION_CONVERSION_SOURCE_EXTERNAL_IDENTIFIER_CREATE",
  PERMISSION_CONVERSION_SOURCE_EXTERNAL_IDENTIFIER_DELETE = "PERMISSION_CONVERSION_SOURCE_EXTERNAL_IDENTIFIER_DELETE",
  PERMISSION_CONVERSION_SOURCE_EXTERNAL_IDENTIFIER_UPDATE = "PERMISSION_CONVERSION_SOURCE_EXTERNAL_IDENTIFIER_UPDATE",
  PERMISSION_CONVERSION_STATUS_SET = "PERMISSION_CONVERSION_STATUS_SET",
  PERMISSION_CONVERSION_TYPE_CREATE = "PERMISSION_CONVERSION_TYPE_CREATE",
  PERMISSION_CONVERSION_TYPE_DELETE = "PERMISSION_CONVERSION_TYPE_DELETE",
  PERMISSION_CONVERSION_TYPE_DETAIL = "PERMISSION_CONVERSION_TYPE_DETAIL",
  PERMISSION_CONVERSION_TYPE_LIST = "PERMISSION_CONVERSION_TYPE_LIST",
  PERMISSION_CONVERSION_TYPE_UPDATE = "PERMISSION_CONVERSION_TYPE_UPDATE",
  PERMISSION_CONVERSION_UPDATE = "PERMISSION_CONVERSION_UPDATE",
  PERMISSION_COUPON_CREATE = "PERMISSION_COUPON_CREATE",
  PERMISSION_COUPON_DELETE = "PERMISSION_COUPON_DELETE",
  PERMISSION_COUPON_DETAIL = "PERMISSION_COUPON_DETAIL",
  PERMISSION_COUPON_LIST = "PERMISSION_COUPON_LIST",
  PERMISSION_COUPON_LIST_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_COUPON_LIST_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_COUPON_LIST_OWN_SOURCES_ONLY = "PERMISSION_COUPON_LIST_OWN_SOURCES_ONLY",
  PERMISSION_COUPON_UPDATE = "PERMISSION_COUPON_UPDATE",
  PERMISSION_CURRENCY_CREATE = "PERMISSION_CURRENCY_CREATE",
  PERMISSION_CURRENCY_DELETE = "PERMISSION_CURRENCY_DELETE",
  PERMISSION_CURRENCY_DETAIL = "PERMISSION_CURRENCY_DETAIL",
  PERMISSION_CURRENCY_LIST = "PERMISSION_CURRENCY_LIST",
  PERMISSION_CURRENCY_PRIMARY_DETAIL = "PERMISSION_CURRENCY_PRIMARY_DETAIL",
  PERMISSION_CURRENCY_SET_DEFAULT = "PERMISSION_CURRENCY_SET_DEFAULT",
  PERMISSION_CUSTOM_DOMAIN_CREATE = "PERMISSION_CUSTOM_DOMAIN_CREATE",
  PERMISSION_CUSTOM_DOMAIN_DELETE = "PERMISSION_CUSTOM_DOMAIN_DELETE",
  PERMISSION_CUSTOM_DOMAIN_LIST = "PERMISSION_CUSTOM_DOMAIN_LIST",
  PERMISSION_CUSTOM_INTERNAL_PAGE_CREATE = "PERMISSION_CUSTOM_INTERNAL_PAGE_CREATE",
  PERMISSION_CUSTOM_INTERNAL_PAGE_DELETE = "PERMISSION_CUSTOM_INTERNAL_PAGE_DELETE",
  PERMISSION_CUSTOM_INTERNAL_PAGE_DETAIL = "PERMISSION_CUSTOM_INTERNAL_PAGE_DETAIL",
  PERMISSION_CUSTOM_INTERNAL_PAGE_LIST = "PERMISSION_CUSTOM_INTERNAL_PAGE_LIST",
  PERMISSION_CUSTOM_INTERNAL_PAGE_UPDATE = "PERMISSION_CUSTOM_INTERNAL_PAGE_UPDATE",
  PERMISSION_CUSTOM_MENU_ITEM_CREATE = "PERMISSION_CUSTOM_MENU_ITEM_CREATE",
  PERMISSION_CUSTOM_MENU_ITEM_DELETE = "PERMISSION_CUSTOM_MENU_ITEM_DELETE",
  PERMISSION_CUSTOM_MENU_ITEM_LIST = "PERMISSION_CUSTOM_MENU_ITEM_LIST",
  PERMISSION_CUSTOM_MENU_ITEM_LIST_FOR_ROLE = "PERMISSION_CUSTOM_MENU_ITEM_LIST_FOR_ROLE",
  PERMISSION_CUSTOM_MENU_ITEM_UPDATE = "PERMISSION_CUSTOM_MENU_ITEM_UPDATE",
  PERMISSION_INVITATION_CREATE = "PERMISSION_INVITATION_CREATE",
  PERMISSION_INVITATION_LIST = "PERMISSION_INVITATION_LIST",
  PERMISSION_LANDING_PAGE_CREATE = "PERMISSION_LANDING_PAGE_CREATE",
  PERMISSION_LANDING_PAGE_DELETE = "PERMISSION_LANDING_PAGE_DELETE",
  PERMISSION_LANDING_PAGE_DETAIL = "PERMISSION_LANDING_PAGE_DETAIL",
  PERMISSION_LANDING_PAGE_LIST = "PERMISSION_LANDING_PAGE_LIST",
  PERMISSION_LANDING_PAGE_LIST_ENABLED = "PERMISSION_LANDING_PAGE_LIST_ENABLED",
  PERMISSION_LANDING_PAGE_UPDATE = "PERMISSION_LANDING_PAGE_UPDATE",
  PERMISSION_LOCATION_SYSTEM_LIST = "PERMISSION_LOCATION_SYSTEM_LIST",
  PERMISSION_MEMBERSHIP_CURRENCY_GET = "PERMISSION_MEMBERSHIP_CURRENCY_GET",
  PERMISSION_MEMBERSHIP_FREE_TRIAL_START = "PERMISSION_MEMBERSHIP_FREE_TRIAL_START",
  PERMISSION_MEMBERSHIP_GET = "PERMISSION_MEMBERSHIP_GET",
  PERMISSION_MEMBERSHIP_PLAN_USAGE = "PERMISSION_MEMBERSHIP_PLAN_USAGE",
  PERMISSION_MEMBERSHIP_RENEW = "PERMISSION_MEMBERSHIP_RENEW",
  PERMISSION_MEMBERSHIP_SHOPIFY_CANCEL = "PERMISSION_MEMBERSHIP_SHOPIFY_CANCEL",
  PERMISSION_MEMBERSHIP_SHOPIFY_CREATE = "PERMISSION_MEMBERSHIP_SHOPIFY_CREATE",
  PERMISSION_METADATA_SET = "PERMISSION_METADATA_SET",
  PERMISSION_NOTIFICATION_ACCOUNT_SETTINGS_DETAIL = "PERMISSION_NOTIFICATION_ACCOUNT_SETTINGS_DETAIL",
  PERMISSION_NOTIFICATION_ACCOUNT_SETTINGS_UPDATE = "PERMISSION_NOTIFICATION_ACCOUNT_SETTINGS_UPDATE",
  PERMISSION_NOTIFICATION_CUSTOM_EVENT_CREATE = "PERMISSION_NOTIFICATION_CUSTOM_EVENT_CREATE",
  PERMISSION_NOTIFICATION_CUSTOM_EVENT_DELETE = "PERMISSION_NOTIFICATION_CUSTOM_EVENT_DELETE",
  PERMISSION_NOTIFICATION_CUSTOM_EVENT_LIST = "PERMISSION_NOTIFICATION_CUSTOM_EVENT_LIST",
  PERMISSION_NOTIFICATION_CUSTOM_EVENT_UPDATE = "PERMISSION_NOTIFICATION_CUSTOM_EVENT_UPDATE",
  PERMISSION_NOTIFICATION_CUSTOM_EVENT_UPDATE_PAUSED = "PERMISSION_NOTIFICATION_CUSTOM_EVENT_UPDATE_PAUSED",
  PERMISSION_NOTIFICATION_DEFAULTS_DETAIL = "PERMISSION_NOTIFICATION_DEFAULTS_DETAIL",
  PERMISSION_NOTIFICATION_DEFAULTS_UPDATE = "PERMISSION_NOTIFICATION_DEFAULTS_UPDATE",
  PERMISSION_NOTIFICATION_LIST = "PERMISSION_NOTIFICATION_LIST",
  PERMISSION_NOTIFICATION_READ_UPDATE = "PERMISSION_NOTIFICATION_READ_UPDATE",
  PERMISSION_OFFER_ANURA_ENABLED_UPDATE = "PERMISSION_OFFER_ANURA_ENABLED_UPDATE",
  PERMISSION_OFFER_CAP_CREATE = "PERMISSION_OFFER_CAP_CREATE",
  PERMISSION_OFFER_CAP_DELETE = "PERMISSION_OFFER_CAP_DELETE",
  PERMISSION_OFFER_CAP_LIST = "PERMISSION_OFFER_CAP_LIST",
  PERMISSION_OFFER_CAP_LIST_OWN_ONLY = "PERMISSION_OFFER_CAP_LIST_OWN_ONLY",
  PERMISSION_OFFER_CAP_LIST_SOURCE = "PERMISSION_OFFER_CAP_LIST_SOURCE",
  PERMISSION_OFFER_CAP_SOURCE_LIMIT_ADD = "PERMISSION_OFFER_CAP_SOURCE_LIMIT_ADD",
  PERMISSION_OFFER_CAP_SOURCE_LIMIT_REMOVE = "PERMISSION_OFFER_CAP_SOURCE_LIMIT_REMOVE",
  PERMISSION_OFFER_CLONE = "PERMISSION_OFFER_CLONE",
  PERMISSION_OFFER_CREATE = "PERMISSION_OFFER_CREATE",
  PERMISSION_OFFER_CREATIVE_UPLOAD = "PERMISSION_OFFER_CREATIVE_UPLOAD",
  PERMISSION_OFFER_CREATIVES_DETAIL = "PERMISSION_OFFER_CREATIVES_DETAIL",
  PERMISSION_OFFER_CREATIVES_DETAIL_FOR_ACTIVE_OFFER_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_OFFER_CREATIVES_DETAIL_FOR_ACTIVE_OFFER_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_OFFER_CREATIVES_DETAIL_FOR_ACTIVE_PUBLIC_OR_PRIVATE_SELF_ASSIGNED_OFFER = "PERMISSION_OFFER_CREATIVES_DETAIL_FOR_ACTIVE_PUBLIC_OR_PRIVATE_SELF_ASSIGNED_OFFER",
  PERMISSION_OFFER_CREATIVES_SET = "PERMISSION_OFFER_CREATIVES_SET",
  PERMISSION_OFFER_DEFAULT_REDIRECT_DOMAIN_UPDATE = "PERMISSION_OFFER_DEFAULT_REDIRECT_DOMAIN_UPDATE",
  PERMISSION_OFFER_DELETE = "PERMISSION_OFFER_DELETE",
  PERMISSION_OFFER_DETAIL = "PERMISSION_OFFER_DETAIL",
  PERMISSION_OFFER_DETAIL_ACTIVE = "PERMISSION_OFFER_DETAIL_ACTIVE",
  PERMISSION_OFFER_DETAIL_ACTIVE_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_OFFER_DETAIL_ACTIVE_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_OFFER_DETAIL_ACTIVE_PUBLIC_OR_PRIVATE_SELF_ASSIGNED = "PERMISSION_OFFER_DETAIL_ACTIVE_PUBLIC_OR_PRIVATE_SELF_ASSIGNED",
  PERMISSION_OFFER_INTERNAL_NOTE = "PERMISSION_OFFER_INTERNAL_NOTE",
  PERMISSION_OFFER_LIST_ACTIVE = "PERMISSION_OFFER_LIST_ACTIVE",
  PERMISSION_OFFER_LIST_ACTIVE_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_OFFER_LIST_ACTIVE_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_OFFER_LIST_ACTIVE_PUBLIC_OR_PRIVATE_SELF_ASSIGNED = "PERMISSION_OFFER_LIST_ACTIVE_PUBLIC_OR_PRIVATE_SELF_ASSIGNED",
  PERMISSION_OFFER_LIST_ALL = "PERMISSION_OFFER_LIST_ALL",
  PERMISSION_OFFER_OWNER_LIST = "PERMISSION_OFFER_OWNER_LIST",
  PERMISSION_OFFER_PINNED_UPDATE = "PERMISSION_OFFER_PINNED_UPDATE",
  PERMISSION_OFFER_REDIRECT_DOMAINS_TYPE_DETAIL = "PERMISSION_OFFER_REDIRECT_DOMAINS_TYPE_DETAIL",
  PERMISSION_OFFER_REDIRECT_DOMAINS_TYPE_UPDATE = "PERMISSION_OFFER_REDIRECT_DOMAINS_TYPE_UPDATE",
  PERMISSION_OFFER_REVENUE_ORIGIN_LIST = "PERMISSION_OFFER_REVENUE_ORIGIN_LIST",
  PERMISSION_OFFER_SCHEDULE_DEACTIVATION = "PERMISSION_OFFER_SCHEDULE_DEACTIVATION",
  PERMISSION_OFFER_SOURCE_ACCESS_SET = "PERMISSION_OFFER_SOURCE_ACCESS_SET",
  PERMISSION_OFFER_SOURCE_ACCESS_SET_MANAGED_AFFILIATE_ONLY = "PERMISSION_OFFER_SOURCE_ACCESS_SET_MANAGED_AFFILIATE_ONLY",
  PERMISSION_OFFER_SOURCE_APPLICATION_LIST = "PERMISSION_OFFER_SOURCE_APPLICATION_LIST",
  PERMISSION_OFFER_SOURCE_APPLICATION_LIST_MANAGED_AFFILIATE_ONLY = "PERMISSION_OFFER_SOURCE_APPLICATION_LIST_MANAGED_AFFILIATE_ONLY",
  PERMISSION_OFFER_SOURCE_APPLICATION_RESOLVE = "PERMISSION_OFFER_SOURCE_APPLICATION_RESOLVE",
  PERMISSION_OFFER_SOURCE_APPLICATION_RESOLVE_MANAGED_AFFILIATE_ONLY = "PERMISSION_OFFER_SOURCE_APPLICATION_RESOLVE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_OFFER_SOURCE_APPLY = "PERMISSION_OFFER_SOURCE_APPLY",
  PERMISSION_OFFER_SOURCE_ASSIGN = "PERMISSION_OFFER_SOURCE_ASSIGN",
  PERMISSION_OFFER_SOURCE_ASSIGN_MANAGED_AFFILIATE_ONLY = "PERMISSION_OFFER_SOURCE_ASSIGN_MANAGED_AFFILIATE_ONLY",
  PERMISSION_OFFER_SOURCE_LIST = "PERMISSION_OFFER_SOURCE_LIST",
  PERMISSION_OFFER_SOURCE_LIST_MANAGED_AFFILIATE_ONLY = "PERMISSION_OFFER_SOURCE_LIST_MANAGED_AFFILIATE_ONLY",
  PERMISSION_OFFER_SOURCE_UNASSIGN = "PERMISSION_OFFER_SOURCE_UNASSIGN",
  PERMISSION_OFFER_SOURCE_UNASSIGN_MANAGED_AFFILIATE_ONLY = "PERMISSION_OFFER_SOURCE_UNASSIGN_MANAGED_AFFILIATE_ONLY",
  PERMISSION_OFFER_STATUS_UPDATE = "PERMISSION_OFFER_STATUS_UPDATE",
  PERMISSION_OFFER_THUMBNAIL_UPLOAD = "PERMISSION_OFFER_THUMBNAIL_UPLOAD",
  PERMISSION_OFFER_TRACKING_API_AUTHORIZATION_DETAIL = "PERMISSION_OFFER_TRACKING_API_AUTHORIZATION_DETAIL",
  PERMISSION_OFFER_TRACKING_API_AUTHORIZATION_UPDATE = "PERMISSION_OFFER_TRACKING_API_AUTHORIZATION_UPDATE",
  PERMISSION_OFFER_TRACKING_QUALITY_CONTROL_DETAIL = "PERMISSION_OFFER_TRACKING_QUALITY_CONTROL_DETAIL",
  PERMISSION_OFFER_TRACKING_QUALITY_CONTROL_UPDATE = "PERMISSION_OFFER_TRACKING_QUALITY_CONTROL_UPDATE",
  PERMISSION_OFFER_UPDATE = "PERMISSION_OFFER_UPDATE",
  PERMISSION_PARTNERSHIP_ACCESS_APP = "PERMISSION_PARTNERSHIP_ACCESS_APP",
  PERMISSION_PAYMENT_METHOD_ACCOUNT_DEFAULT_UPDATE = "PERMISSION_PAYMENT_METHOD_ACCOUNT_DEFAULT_UPDATE",
  PERMISSION_PAYMENT_METHOD_ACCOUNT_DEFAULT_UPDATE_MANAGED_AFFILIATE_ONLY = "PERMISSION_PAYMENT_METHOD_ACCOUNT_DEFAULT_UPDATE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_PAYMENT_METHOD_ACCOUNT_DEFAULT_UPDATE_OWN_ONLY = "PERMISSION_PAYMENT_METHOD_ACCOUNT_DEFAULT_UPDATE_OWN_ONLY",
  PERMISSION_PAYMENT_METHOD_CREATE = "PERMISSION_PAYMENT_METHOD_CREATE",
  PERMISSION_PAYMENT_METHOD_CREATE_MANAGED_AFFILIATE_ONLY = "PERMISSION_PAYMENT_METHOD_CREATE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_PAYMENT_METHOD_CREATE_OWN_ONLY = "PERMISSION_PAYMENT_METHOD_CREATE_OWN_ONLY",
  PERMISSION_PAYMENT_METHOD_DELETE = "PERMISSION_PAYMENT_METHOD_DELETE",
  PERMISSION_PAYMENT_METHOD_DELETE_MANAGED_AFFILIATE_ONLY = "PERMISSION_PAYMENT_METHOD_DELETE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_PAYMENT_METHOD_DELETE_OWN_ONLY = "PERMISSION_PAYMENT_METHOD_DELETE_OWN_ONLY",
  PERMISSION_PAYMENT_METHOD_DETAIL = "PERMISSION_PAYMENT_METHOD_DETAIL",
  PERMISSION_PAYMENT_METHOD_DETAIL_MANAGED_AFFILIATE_ONLY = "PERMISSION_PAYMENT_METHOD_DETAIL_MANAGED_AFFILIATE_ONLY",
  PERMISSION_PAYMENT_METHOD_DETAIL_OWN_ONLY = "PERMISSION_PAYMENT_METHOD_DETAIL_OWN_ONLY",
  PERMISSION_PAYMENT_METHOD_LIST = "PERMISSION_PAYMENT_METHOD_LIST",
  PERMISSION_PAYMENT_METHOD_LIST_MANAGED_AFFILIATE_ONLY = "PERMISSION_PAYMENT_METHOD_LIST_MANAGED_AFFILIATE_ONLY",
  PERMISSION_PAYMENT_METHOD_LIST_OWN_ONLY = "PERMISSION_PAYMENT_METHOD_LIST_OWN_ONLY",
  PERMISSION_PAYMENT_METHOD_TYPES_LIST_SUPPORTED = "PERMISSION_PAYMENT_METHOD_TYPES_LIST_SUPPORTED",
  PERMISSION_PAYMENT_METHOD_UPDATE = "PERMISSION_PAYMENT_METHOD_UPDATE",
  PERMISSION_PAYMENT_METHOD_UPDATE_MANAGED_AFFILIATE_ONLY = "PERMISSION_PAYMENT_METHOD_UPDATE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_PAYMENT_METHOD_UPDATE_OWN_ONLY = "PERMISSION_PAYMENT_METHOD_UPDATE_OWN_ONLY",
  PERMISSION_PERSONAL_ACCESS_TOKEN_CREATE = "PERMISSION_PERSONAL_ACCESS_TOKEN_CREATE",
  PERMISSION_PERSONAL_ACCESS_TOKEN_DELETE = "PERMISSION_PERSONAL_ACCESS_TOKEN_DELETE",
  PERMISSION_PERSONAL_ACCESS_TOKEN_LIST = "PERMISSION_PERSONAL_ACCESS_TOKEN_LIST",
  PERMISSION_POSTBACK_DETAIL = "PERMISSION_POSTBACK_DETAIL",
  PERMISSION_POSTBACK_DETAIL_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_DETAIL_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_DETAIL_OWN_ONLY = "PERMISSION_POSTBACK_DETAIL_OWN_ONLY",
  PERMISSION_POSTBACK_LIST = "PERMISSION_POSTBACK_LIST",
  PERMISSION_POSTBACK_LIST_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_LIST_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_LIST_OWN_ONLY = "PERMISSION_POSTBACK_LIST_OWN_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_CREATE = "PERMISSION_POSTBACK_TEMPLATE_CREATE",
  PERMISSION_POSTBACK_TEMPLATE_CREATE_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_TEMPLATE_CREATE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_CREATE_OWN_ONLY = "PERMISSION_POSTBACK_TEMPLATE_CREATE_OWN_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_DELETE = "PERMISSION_POSTBACK_TEMPLATE_DELETE",
  PERMISSION_POSTBACK_TEMPLATE_DELETE_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_TEMPLATE_DELETE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_DELETE_OWN_ONLY = "PERMISSION_POSTBACK_TEMPLATE_DELETE_OWN_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_DETAIL = "PERMISSION_POSTBACK_TEMPLATE_DETAIL",
  PERMISSION_POSTBACK_TEMPLATE_DETAIL_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_TEMPLATE_DETAIL_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_DETAIL_OWN_ONLY = "PERMISSION_POSTBACK_TEMPLATE_DETAIL_OWN_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_LIST = "PERMISSION_POSTBACK_TEMPLATE_LIST",
  PERMISSION_POSTBACK_TEMPLATE_LIST_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_TEMPLATE_LIST_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_LIST_OWN_ONLY = "PERMISSION_POSTBACK_TEMPLATE_LIST_OWN_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_UPDATE = "PERMISSION_POSTBACK_TEMPLATE_UPDATE",
  PERMISSION_POSTBACK_TEMPLATE_UPDATE_MANAGED_AFFILIATE_ONLY = "PERMISSION_POSTBACK_TEMPLATE_UPDATE_MANAGED_AFFILIATE_ONLY",
  PERMISSION_POSTBACK_TEMPLATE_UPDATE_OWN_ONLY = "PERMISSION_POSTBACK_TEMPLATE_UPDATE_OWN_ONLY",
  PERMISSION_PRICING_ADJUSTMENT_CREATE = "PERMISSION_PRICING_ADJUSTMENT_CREATE",
  PERMISSION_PRICING_ADJUSTMENT_DELETE = "PERMISSION_PRICING_ADJUSTMENT_DELETE",
  PERMISSION_PRICING_ADJUSTMENT_DETAIL = "PERMISSION_PRICING_ADJUSTMENT_DETAIL",
  PERMISSION_PRICING_ADJUSTMENT_LIST = "PERMISSION_PRICING_ADJUSTMENT_LIST",
  PERMISSION_PRICING_ADJUSTMENT_UPDATE = "PERMISSION_PRICING_ADJUSTMENT_UPDATE",
  PERMISSION_PRICING_CREATE = "PERMISSION_PRICING_CREATE",
  PERMISSION_PRICING_GET = "PERMISSION_PRICING_GET",
  PERMISSION_PRICING_GET_OWN_ONLY = "PERMISSION_PRICING_GET_OWN_ONLY",
  PERMISSION_PRICING_GET_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_PRICING_GET_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_PRICING_UPDATE = "PERMISSION_PRICING_UPDATE",
  PERMISSION_REFERRAL_ACCOUNT_SETTING_CREATE = "PERMISSION_REFERRAL_ACCOUNT_SETTING_CREATE",
  PERMISSION_REFERRAL_ACCOUNT_SETTING_DELETE = "PERMISSION_REFERRAL_ACCOUNT_SETTING_DELETE",
  PERMISSION_REFERRAL_ACCOUNT_SETTING_DETAIL = "PERMISSION_REFERRAL_ACCOUNT_SETTING_DETAIL",
  PERMISSION_REFERRAL_ACCOUNT_SETTING_LIST = "PERMISSION_REFERRAL_ACCOUNT_SETTING_LIST",
  PERMISSION_REFERRAL_ACCOUNT_SETTING_UPDATE = "PERMISSION_REFERRAL_ACCOUNT_SETTING_UPDATE",
  PERMISSION_REFERRAL_CHILD_ACCOUNTS_COUNT_OWN_ONLY = "PERMISSION_REFERRAL_CHILD_ACCOUNTS_COUNT_OWN_ONLY",
  PERMISSION_REFERRAL_SUB_AFFILIATE_LIST = "PERMISSION_REFERRAL_SUB_AFFILIATE_LIST",
  PERMISSION_REPORT_PRESETS_CREATE = "PERMISSION_REPORT_PRESETS_CREATE",
  PERMISSION_REPORT_PRESETS_DELETE = "PERMISSION_REPORT_PRESETS_DELETE",
  PERMISSION_REPORT_PRESETS_DETAIL = "PERMISSION_REPORT_PRESETS_DETAIL",
  PERMISSION_REPORT_PRESETS_UPDATE = "PERMISSION_REPORT_PRESETS_UPDATE",
  PERMISSION_REPORTS_AFFILIATE_OVERVIEW = "PERMISSION_REPORTS_AFFILIATE_OVERVIEW",
  PERMISSION_REPORTS_AFFILIATE_OVERVIEW_MANAGED_ONLY = "PERMISSION_REPORTS_AFFILIATE_OVERVIEW_MANAGED_ONLY",
  PERMISSION_REPORTS_CLICK = "PERMISSION_REPORTS_CLICK",
  PERMISSION_REPORTS_CLICK_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_REPORTS_CLICK_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_REPORTS_CLICK_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_CLICK_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_CLICK_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_CLICK_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_CLICK_REVENUE_ORIGIN = "PERMISSION_REPORTS_CLICK_REVENUE_ORIGIN",
  PERMISSION_REPORTS_CLICK_SOURCE = "PERMISSION_REPORTS_CLICK_SOURCE",
  PERMISSION_REPORTS_COMMISSION = "PERMISSION_REPORTS_COMMISSION",
  PERMISSION_REPORTS_COMMISSION_MANAGED_ONLY = "PERMISSION_REPORTS_COMMISSION_MANAGED_ONLY",
  PERMISSION_REPORTS_COMMISSION_OWN_ONLY = "PERMISSION_REPORTS_COMMISSION_OWN_ONLY",
  PERMISSION_REPORTS_COMMISSION_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_COMMISSION_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_CONVERSION = "PERMISSION_REPORTS_CONVERSION",
  PERMISSION_REPORTS_CONVERSION_CLAIM = "PERMISSION_REPORTS_CONVERSION_CLAIM",
  PERMISSION_REPORTS_CONVERSION_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_REPORTS_CONVERSION_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_REPORTS_CONVERSION_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_CONVERSION_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_CONVERSION_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_CONVERSION_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_CONVERSION_REVENUE_ORIGIN = "PERMISSION_REPORTS_CONVERSION_REVENUE_ORIGIN",
  PERMISSION_REPORTS_CONVERSION_SETTLEMENT = "PERMISSION_REPORTS_CONVERSION_SETTLEMENT",
  PERMISSION_REPORTS_CONVERSION_SOURCE = "PERMISSION_REPORTS_CONVERSION_SOURCE",
  PERMISSION_REPORTS_COST = "PERMISSION_REPORTS_COST",
  PERMISSION_REPORTS_COUNTRY_OVERVIEW = "PERMISSION_REPORTS_COUNTRY_OVERVIEW",
  PERMISSION_REPORTS_COUNTRY_OVERVIEW_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_REPORTS_COUNTRY_OVERVIEW_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_REPORTS_COUNTRY_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_COUNTRY_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_COUNTRY_OVERVIEW_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_COUNTRY_OVERVIEW_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_COUPON_REDEMPTION = "PERMISSION_REPORTS_COUPON_REDEMPTION",
  PERMISSION_REPORTS_COUPON_REDEMPTION_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_REPORTS_COUPON_REDEMPTION_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_REPORTS_COUPON_REDEMPTION_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_COUPON_REDEMPTION_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_COUPON_REDEMPTION_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_COUPON_REDEMPTION_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_COUPON_REDEMPTION_REVENUE_ORIGIN = "PERMISSION_REPORTS_COUPON_REDEMPTION_REVENUE_ORIGIN",
  PERMISSION_REPORTS_COUPON_REDEMPTION_SOURCE = "PERMISSION_REPORTS_COUPON_REDEMPTION_SOURCE",
  PERMISSION_REPORTS_DAILY_OVERVIEW = "PERMISSION_REPORTS_DAILY_OVERVIEW",
  PERMISSION_REPORTS_DAILY_OVERVIEW_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_REPORTS_DAILY_OVERVIEW_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_REPORTS_DAILY_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_DAILY_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_DAILY_OVERVIEW_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_DAILY_OVERVIEW_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_GENERAL_OVERVIEW = "PERMISSION_REPORTS_GENERAL_OVERVIEW",
  PERMISSION_REPORTS_GENERAL_OVERVIEW_MANAGED_AFFILIATES_SOURCE_ONLY = "PERMISSION_REPORTS_GENERAL_OVERVIEW_MANAGED_AFFILIATES_SOURCE_ONLY",
  PERMISSION_REPORTS_GENERAL_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_GENERAL_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_GENERAL_OVERVIEW_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_GENERAL_OVERVIEW_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_OFFER_OVERVIEW = "PERMISSION_REPORTS_OFFER_OVERVIEW",
  PERMISSION_REPORTS_OFFER_OVERVIEW_MANAGED_AFFILIATE_SOURCES_ONLY = "PERMISSION_REPORTS_OFFER_OVERVIEW_MANAGED_AFFILIATE_SOURCES_ONLY",
  PERMISSION_REPORTS_OFFER_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY = "PERMISSION_REPORTS_OFFER_OVERVIEW_OWN_REVENUE_ORIGINS_ONLY",
  PERMISSION_REPORTS_OFFER_OVERVIEW_OWN_SOURCES_ONLY = "PERMISSION_REPORTS_OFFER_OVERVIEW_OWN_SOURCES_ONLY",
  PERMISSION_REPORTS_OVERVIEW_COMMISSION = "PERMISSION_REPORTS_OVERVIEW_COMMISSION",
  PERMISSION_REPORTS_OVERVIEW_ORDER_BY_REVENUE = "PERMISSION_REPORTS_OVERVIEW_ORDER_BY_REVENUE",
  PERMISSION_REVENUE_ORIGIN_BALANCE_GET = "PERMISSION_REVENUE_ORIGIN_BALANCE_GET",
  PERMISSION_REVENUE_ORIGIN_BALANCES_OPEN_LIST = "PERMISSION_REVENUE_ORIGIN_BALANCES_OPEN_LIST",
  PERMISSION_REVENUE_ORIGIN_CREATE = "PERMISSION_REVENUE_ORIGIN_CREATE",
  PERMISSION_REVENUE_ORIGIN_DEFAULT_DETAIL = "PERMISSION_REVENUE_ORIGIN_DEFAULT_DETAIL",
  PERMISSION_REVENUE_ORIGIN_GROUP_LIST = "PERMISSION_REVENUE_ORIGIN_GROUP_LIST",
  PERMISSION_REVENUE_ORIGIN_LIST = "PERMISSION_REVENUE_ORIGIN_LIST",
  PERMISSION_REVENUE_ORIGIN_TRACKING_API_AUTHORIZATION_DETAIL = "PERMISSION_REVENUE_ORIGIN_TRACKING_API_AUTHORIZATION_DETAIL",
  PERMISSION_REVENUE_ORIGIN_TRACKING_API_AUTHORIZATION_UPDATE = "PERMISSION_REVENUE_ORIGIN_TRACKING_API_AUTHORIZATION_UPDATE",
  PERMISSION_REVENUE_ORIGIN_TRACKING_QUALITY_CONTROL_DETAIL = "PERMISSION_REVENUE_ORIGIN_TRACKING_QUALITY_CONTROL_DETAIL",
  PERMISSION_REVENUE_ORIGIN_TRACKING_QUALITY_CONTROL_UPDATE = "PERMISSION_REVENUE_ORIGIN_TRACKING_QUALITY_CONTROL_UPDATE",
  PERMISSION_REVENUE_ORIGIN_UPDATE = "PERMISSION_REVENUE_ORIGIN_UPDATE",
  PERMISSION_ROLE_CREATE = "PERMISSION_ROLE_CREATE",
  PERMISSION_ROLE_DELETE = "PERMISSION_ROLE_DELETE",
  PERMISSION_ROLE_DETAIL = "PERMISSION_ROLE_DETAIL",
  PERMISSION_ROLE_LIST = "PERMISSION_ROLE_LIST",
  PERMISSION_ROLE_PERMISSION_LIST = "PERMISSION_ROLE_PERMISSION_LIST",
  PERMISSION_ROLE_PERMISSION_SET = "PERMISSION_ROLE_PERMISSION_SET",
  PERMISSION_ROLE_UPDATE = "PERMISSION_ROLE_UPDATE",
  PERMISSION_SETTING_ADVERTISER_DASHBOARD_NOTE_DETAIL = "PERMISSION_SETTING_ADVERTISER_DASHBOARD_NOTE_DETAIL",
  PERMISSION_SETTING_ADVERTISER_DASHBOARD_NOTE_UPDATE = "PERMISSION_SETTING_ADVERTISER_DASHBOARD_NOTE_UPDATE",
  PERMISSION_SETTING_ADVERTISER_PARAMS_VISIBILITY_DETAIL = "PERMISSION_SETTING_ADVERTISER_PARAMS_VISIBILITY_DETAIL",
  PERMISSION_SETTING_ADVERTISER_PARAMS_VISIBILITY_IGNORED = "PERMISSION_SETTING_ADVERTISER_PARAMS_VISIBILITY_IGNORED",
  PERMISSION_SETTING_ADVERTISER_PARAMS_VISIBILITY_UPDATE = "PERMISSION_SETTING_ADVERTISER_PARAMS_VISIBILITY_UPDATE",
  PERMISSION_SETTING_ADVERTISER_PENDING_REGISTRATION_NOTE_UPDATE = "PERMISSION_SETTING_ADVERTISER_PENDING_REGISTRATION_NOTE_UPDATE",
  PERMISSION_SETTING_ADVERTISER_REGISTRATION_PAGE_NOTE_UPDATE = "PERMISSION_SETTING_ADVERTISER_REGISTRATION_PAGE_NOTE_UPDATE",
  PERMISSION_SETTING_ADVERTISER_VAT_REQUIRED_UPDATE = "PERMISSION_SETTING_ADVERTISER_VAT_REQUIRED_UPDATE",
  PERMISSION_SETTING_AFFILIATE_CONVERSION_VISIBILITY_DETAIL = "PERMISSION_SETTING_AFFILIATE_CONVERSION_VISIBILITY_DETAIL",
  PERMISSION_SETTING_AFFILIATE_CONVERSION_VISIBILITY_UPDATE = "PERMISSION_SETTING_AFFILIATE_CONVERSION_VISIBILITY_UPDATE",
  PERMISSION_SETTING_AFFILIATE_PENDING_REGISTRATION_NOTE_UPDATE = "PERMISSION_SETTING_AFFILIATE_PENDING_REGISTRATION_NOTE_UPDATE",
  PERMISSION_SETTING_AFFILIATE_POSTBACK_CONVERSION_AMOUNT_AND_REVENUE_ENABLED_UPDATE = "PERMISSION_SETTING_AFFILIATE_POSTBACK_CONVERSION_AMOUNT_AND_REVENUE_ENABLED_UPDATE",
  PERMISSION_SETTING_AFFILIATE_RATE_COST_BASE_UPDATE = "PERMISSION_SETTING_AFFILIATE_RATE_COST_BASE_UPDATE",
  PERMISSION_SETTING_AFFILIATE_REGISTRATION_CUSTOMIZATION_UPDATE = "PERMISSION_SETTING_AFFILIATE_REGISTRATION_CUSTOMIZATION_UPDATE",
  PERMISSION_SETTING_AFFILIATE_TRACKING_LINK_SETTINGS_DETAIL = "PERMISSION_SETTING_AFFILIATE_TRACKING_LINK_SETTINGS_DETAIL",
  PERMISSION_SETTING_AFFILIATE_TRACKING_LINK_SETTINGS_UPDATE = "PERMISSION_SETTING_AFFILIATE_TRACKING_LINK_SETTINGS_UPDATE",
  PERMISSION_SETTING_AFFILIATES_VAT_REQUIRED_UPDATE = "PERMISSION_SETTING_AFFILIATES_VAT_REQUIRED_UPDATE",
  PERMISSION_SETTING_ANURA_INSTANCE_DETAIL = "PERMISSION_SETTING_ANURA_INSTANCE_DETAIL",
  PERMISSION_SETTING_ANURA_INSTANCE_UPDATE = "PERMISSION_SETTING_ANURA_INSTANCE_UPDATE",
  PERMISSION_SETTING_BILLING_DETAIL_DETAIL = "PERMISSION_SETTING_BILLING_DETAIL_DETAIL",
  PERMISSION_SETTING_BILLING_DETAIL_UPDATE = "PERMISSION_SETTING_BILLING_DETAIL_UPDATE",
  PERMISSION_SETTING_CLAIM_GENERATING_DETAIL = "PERMISSION_SETTING_CLAIM_GENERATING_DETAIL",
  PERMISSION_SETTING_CLAIM_GENERATING_UPDATE = "PERMISSION_SETTING_CLAIM_GENERATING_UPDATE",
  PERMISSION_SETTING_CLICK_TRACKING_SETTINGS_DETAIL = "PERMISSION_SETTING_CLICK_TRACKING_SETTINGS_DETAIL",
  PERMISSION_SETTING_CLICK_TRACKING_SETTINGS_UPDATE = "PERMISSION_SETTING_CLICK_TRACKING_SETTINGS_UPDATE",
  PERMISSION_SETTING_COLOR_THEME_UPDATE = "PERMISSION_SETTING_COLOR_THEME_UPDATE",
  PERMISSION_SETTING_CONTACT_FOR_ADVERTISERS_DETAIL = "PERMISSION_SETTING_CONTACT_FOR_ADVERTISERS_DETAIL",
  PERMISSION_SETTING_CONTACT_FOR_ADVERTISERS_UPDATE = "PERMISSION_SETTING_CONTACT_FOR_ADVERTISERS_UPDATE",
  PERMISSION_SETTING_CONTACT_FOR_AFFILIATES_DETAIL = "PERMISSION_SETTING_CONTACT_FOR_AFFILIATES_DETAIL",
  PERMISSION_SETTING_CONTACT_FOR_AFFILIATES_UPDATE = "PERMISSION_SETTING_CONTACT_FOR_AFFILIATES_UPDATE",
  PERMISSION_SETTING_CONVERSION_AMOUNT_VISIBLE_IGNORED = "PERMISSION_SETTING_CONVERSION_AMOUNT_VISIBLE_IGNORED",
  PERMISSION_SETTING_CONVERSION_AMOUNT_VISIBLE_UPDATE = "PERMISSION_SETTING_CONVERSION_AMOUNT_VISIBLE_UPDATE",
  PERMISSION_SETTING_DASHBOARD_NOTE_DETAIL = "PERMISSION_SETTING_DASHBOARD_NOTE_DETAIL",
  PERMISSION_SETTING_DASHBOARD_NOTE_UPDATE = "PERMISSION_SETTING_DASHBOARD_NOTE_UPDATE",
  PERMISSION_SETTING_DASHBOARD_PROMOS_VISIBILITY_DETAIL = "PERMISSION_SETTING_DASHBOARD_PROMOS_VISIBILITY_DETAIL",
  PERMISSION_SETTING_DASHBOARD_PROMOS_VISIBILITY_UPDATE = "PERMISSION_SETTING_DASHBOARD_PROMOS_VISIBILITY_UPDATE",
  PERMISSION_SETTING_DATA_VISIBILITY_FOR_ADVERTISERS_APPLIED = "PERMISSION_SETTING_DATA_VISIBILITY_FOR_ADVERTISERS_APPLIED",
  PERMISSION_SETTING_DATA_VISIBILITY_FOR_ADVERTISERS_DETAIL = "PERMISSION_SETTING_DATA_VISIBILITY_FOR_ADVERTISERS_DETAIL",
  PERMISSION_SETTING_DATA_VISIBILITY_FOR_ADVERTISERS_UPDATE = "PERMISSION_SETTING_DATA_VISIBILITY_FOR_ADVERTISERS_UPDATE",
  PERMISSION_SETTING_DEFAULT_LANGUAGE_UPDATE = "PERMISSION_SETTING_DEFAULT_LANGUAGE_UPDATE",
  PERMISSION_SETTING_DEFAULT_REDIRECT_DOMAIN_DETAIL = "PERMISSION_SETTING_DEFAULT_REDIRECT_DOMAIN_DETAIL",
  PERMISSION_SETTING_DEFAULT_REDIRECT_DOMAIN_UPDATE = "PERMISSION_SETTING_DEFAULT_REDIRECT_DOMAIN_UPDATE",
  PERMISSION_SETTING_DEFAULT_REGISTERED_ADVERTISER_ACCOUNT_STATUS_DETAIL = "PERMISSION_SETTING_DEFAULT_REGISTERED_ADVERTISER_ACCOUNT_STATUS_DETAIL",
  PERMISSION_SETTING_DEFAULT_REGISTERED_ADVERTISER_ACCOUNT_STATUS_UPDATE = "PERMISSION_SETTING_DEFAULT_REGISTERED_ADVERTISER_ACCOUNT_STATUS_UPDATE",
  PERMISSION_SETTING_DEFAULT_REPORT_FILTERING_DETAIL = "PERMISSION_SETTING_DEFAULT_REPORT_FILTERING_DETAIL",
  PERMISSION_SETTING_DEFAULT_REPORT_FILTERING_UPDATE = "PERMISSION_SETTING_DEFAULT_REPORT_FILTERING_UPDATE",
  PERMISSION_SETTING_DEFAULT_THEME_UPDATE = "PERMISSION_SETTING_DEFAULT_THEME_UPDATE",
  PERMISSION_SETTING_EMAIL_CUSTOMIZATION_DETAIL = "PERMISSION_SETTING_EMAIL_CUSTOMIZATION_DETAIL",
  PERMISSION_SETTING_EMAIL_CUSTOMIZATION_PREVIEW = "PERMISSION_SETTING_EMAIL_CUSTOMIZATION_PREVIEW",
  PERMISSION_SETTING_EMAIL_CUSTOMIZATION_UPDATE = "PERMISSION_SETTING_EMAIL_CUSTOMIZATION_UPDATE",
  PERMISSION_SETTING_FRAUD_SUSPICIONS_VISIBLE_UPDATE = "PERMISSION_SETTING_FRAUD_SUSPICIONS_VISIBLE_UPDATE",
  PERMISSION_SETTING_GENERAL_DETAIL = "PERMISSION_SETTING_GENERAL_DETAIL",
  PERMISSION_SETTING_GENERAL_UPDATE = "PERMISSION_SETTING_GENERAL_UPDATE",
  PERMISSION_SETTING_GLOBAL_REDIRECT_DOMAINS_VISIBLE_DETAIL = "PERMISSION_SETTING_GLOBAL_REDIRECT_DOMAINS_VISIBLE_DETAIL",
  PERMISSION_SETTING_GLOBAL_REDIRECT_DOMAINS_VISIBLE_UPDATE = "PERMISSION_SETTING_GLOBAL_REDIRECT_DOMAINS_VISIBLE_UPDATE",
  PERMISSION_SETTING_IMAGE_UPLOAD = "PERMISSION_SETTING_IMAGE_UPLOAD",
  PERMISSION_SETTING_ONBOARDING_STATUS_UPDATE = "PERMISSION_SETTING_ONBOARDING_STATUS_UPDATE",
  PERMISSION_SETTING_PAYMENT_METHOD_FOR_ADVERTISERS_DETAIL = "PERMISSION_SETTING_PAYMENT_METHOD_FOR_ADVERTISERS_DETAIL",
  PERMISSION_SETTING_PAYMENT_METHOD_FOR_ADVERTISERS_UPDATE = "PERMISSION_SETTING_PAYMENT_METHOD_FOR_ADVERTISERS_UPDATE",
  PERMISSION_SETTING_QUICK_SETUP = "PERMISSION_SETTING_QUICK_SETUP",
  PERMISSION_SETTING_REDIRECT_DOMAINS_TYPE_DETAIL = "PERMISSION_SETTING_REDIRECT_DOMAINS_TYPE_DETAIL",
  PERMISSION_SETTING_REDIRECT_DOMAINS_TYPE_UPDATE = "PERMISSION_SETTING_REDIRECT_DOMAINS_TYPE_UPDATE",
  PERMISSION_SETTING_REFERRAL_ACCOUNT_WHITELIST_IGNORED = "PERMISSION_SETTING_REFERRAL_ACCOUNT_WHITELIST_IGNORED",
  PERMISSION_SETTING_REFERRAL_CONVERSION_SOURCE_ACCOUNT_VISIBLE_IGNORED = "PERMISSION_SETTING_REFERRAL_CONVERSION_SOURCE_ACCOUNT_VISIBLE_IGNORED",
  PERMISSION_SETTING_REFERRAL_DETAIL = "PERMISSION_SETTING_REFERRAL_DETAIL",
  PERMISSION_SETTING_REFERRAL_UPDATE = "PERMISSION_SETTING_REFERRAL_UPDATE",
  PERMISSION_SETTING_REVENUE_VISIBLE_IGNORED = "PERMISSION_SETTING_REVENUE_VISIBLE_IGNORED",
  PERMISSION_SETTING_REVENUE_VISIBLE_UPDATE = "PERMISSION_SETTING_REVENUE_VISIBLE_UPDATE",
  PERMISSION_SETTING_SMART_LINKS_UPDATE = "PERMISSION_SETTING_SMART_LINKS_UPDATE",
  PERMISSION_SETTING_STRIPE_BILLING_DETAIL_DETAIL = "PERMISSION_SETTING_STRIPE_BILLING_DETAIL_DETAIL",
  PERMISSION_SETTING_TENANT_PRIVATE_DETAIL = "PERMISSION_SETTING_TENANT_PRIVATE_DETAIL",
  PERMISSION_SETTING_TERMS_AND_CONDITIONS_TEXT_UPDATE = "PERMISSION_SETTING_TERMS_AND_CONDITIONS_TEXT_UPDATE",
  PERMISSION_SETTING_TRACKING_API_AUTHORIZATION_DETAIL = "PERMISSION_SETTING_TRACKING_API_AUTHORIZATION_DETAIL",
  PERMISSION_SETTING_TRACKING_API_AUTHORIZATION_UPDATE = "PERMISSION_SETTING_TRACKING_API_AUTHORIZATION_UPDATE",
  PERMISSION_SETTING_TRACKING_BLOCKING_GET = "PERMISSION_SETTING_TRACKING_BLOCKING_GET",
  PERMISSION_SETTING_TRACKING_BLOCKING_SET = "PERMISSION_SETTING_TRACKING_BLOCKING_SET",
  PERMISSION_SETTING_TRACKING_QUALITY_CONTROL_DETAIL = "PERMISSION_SETTING_TRACKING_QUALITY_CONTROL_DETAIL",
  PERMISSION_SETTING_TRACKING_QUALITY_CONTROL_UPDATE = "PERMISSION_SETTING_TRACKING_QUALITY_CONTROL_UPDATE",
  PERMISSION_SETTLE_BALANCES = "PERMISSION_SETTLE_BALANCES",
  PERMISSION_SETTLEMENT_ACCOUNT_DELETE = "PERMISSION_SETTLEMENT_ACCOUNT_DELETE",
  PERMISSION_SETTLEMENT_ACCOUNT_LIST = "PERMISSION_SETTLEMENT_ACCOUNT_LIST",
  PERMISSION_SETTLEMENT_ACCOUNT_LIST_MANAGED_AFFILIATE_ONLY = "PERMISSION_SETTLEMENT_ACCOUNT_LIST_MANAGED_AFFILIATE_ONLY",
  PERMISSION_SETTLEMENT_ACCOUNT_LIST_OWN = "PERMISSION_SETTLEMENT_ACCOUNT_LIST_OWN",
  PERMISSION_SETTLEMENT_DELETE = "PERMISSION_SETTLEMENT_DELETE",
  PERMISSION_SETTLEMENT_GET = "PERMISSION_SETTLEMENT_GET",
  PERMISSION_SETTLEMENT_LIST = "PERMISSION_SETTLEMENT_LIST",
  PERMISSION_SHOPIFY_INTEGRATION_ACTIVATE = "PERMISSION_SHOPIFY_INTEGRATION_ACTIVATE",
  PERMISSION_SHOPIFY_INTEGRATION_AUTHENTICATE = "PERMISSION_SHOPIFY_INTEGRATION_AUTHENTICATE",
  PERMISSION_SHOPIFY_INTEGRATION_CREATE = "PERMISSION_SHOPIFY_INTEGRATION_CREATE",
  PERMISSION_SHOPIFY_INTEGRATION_DEACTIVATE = "PERMISSION_SHOPIFY_INTEGRATION_DEACTIVATE",
  PERMISSION_SHOPIFY_INTEGRATION_DELETE = "PERMISSION_SHOPIFY_INTEGRATION_DELETE",
  PERMISSION_SHOPIFY_INTEGRATION_DETAIL = "PERMISSION_SHOPIFY_INTEGRATION_DETAIL",
  PERMISSION_SHOPIFY_INTEGRATION_LIST = "PERMISSION_SHOPIFY_INTEGRATION_LIST",
  PERMISSION_SHORT_LINK_CREATE = "PERMISSION_SHORT_LINK_CREATE",
  PERMISSION_SHORT_LINK_DELETE = "PERMISSION_SHORT_LINK_DELETE",
  PERMISSION_SHORT_LINK_LIST = "PERMISSION_SHORT_LINK_LIST",
  PERMISSION_SHORT_LINK_LIST_OWN_ONLY = "PERMISSION_SHORT_LINK_LIST_OWN_ONLY",
  PERMISSION_SMART_LINK_CREATE = "PERMISSION_SMART_LINK_CREATE",
  PERMISSION_SMART_LINK_DELETE = "PERMISSION_SMART_LINK_DELETE",
  PERMISSION_SMART_LINK_DETAIL = "PERMISSION_SMART_LINK_DETAIL",
  PERMISSION_SMART_LINK_LIST = "PERMISSION_SMART_LINK_LIST",
  PERMISSION_SMART_LINK_RESET = "PERMISSION_SMART_LINK_RESET",
  PERMISSION_SMART_LINK_UPDATE = "PERMISSION_SMART_LINK_UPDATE",
  PERMISSION_SOURCE_CREATE = "PERMISSION_SOURCE_CREATE",
  PERMISSION_SOURCE_DELETE = "PERMISSION_SOURCE_DELETE",
  PERMISSION_SOURCE_DETAIL = "PERMISSION_SOURCE_DETAIL",
  PERMISSION_SOURCE_LIST = "PERMISSION_SOURCE_LIST",
  PERMISSION_SOURCE_LIST_MANAGED_ONLY = "PERMISSION_SOURCE_LIST_MANAGED_ONLY",
  PERMISSION_SOURCE_LIST_OWN_ONLY = "PERMISSION_SOURCE_LIST_OWN_ONLY",
  PERMISSION_SOURCE_UPDATE = "PERMISSION_SOURCE_UPDATE",
  PERMISSION_STRIPE_CUSTOMER_PORTAL = "PERMISSION_STRIPE_CUSTOMER_PORTAL",
  PERMISSION_STRIPE_INTEGRATION_API_VERSION = "PERMISSION_STRIPE_INTEGRATION_API_VERSION",
  PERMISSION_STRIPE_INTEGRATION_COUPONS_TRACKING_SWITCH = "PERMISSION_STRIPE_INTEGRATION_COUPONS_TRACKING_SWITCH",
  PERMISSION_STRIPE_INTEGRATION_CREATE = "PERMISSION_STRIPE_INTEGRATION_CREATE",
  PERMISSION_STRIPE_INTEGRATION_CUSTOMER_DETAIL = "PERMISSION_STRIPE_INTEGRATION_CUSTOMER_DETAIL",
  PERMISSION_STRIPE_INTEGRATION_DELETE = "PERMISSION_STRIPE_INTEGRATION_DELETE",
  PERMISSION_STRIPE_INTEGRATION_DETAIL = "PERMISSION_STRIPE_INTEGRATION_DETAIL",
  PERMISSION_STRIPE_INTEGRATION_SYNC = "PERMISSION_STRIPE_INTEGRATION_SYNC",
  PERMISSION_TAG_CREATE = "PERMISSION_TAG_CREATE",
  PERMISSION_TAG_DELETE = "PERMISSION_TAG_DELETE",
  PERMISSION_TAG_DETAIL = "PERMISSION_TAG_DETAIL",
  PERMISSION_TAG_LIST = "PERMISSION_TAG_LIST",
  PERMISSION_TAG_UPDATE = "PERMISSION_TAG_UPDATE",
  PERMISSION_TIER_CREATE = "PERMISSION_TIER_CREATE",
  PERMISSION_TIER_DELETE = "PERMISSION_TIER_DELETE",
  PERMISSION_TIER_DETAIL = "PERMISSION_TIER_DETAIL",
  PERMISSION_TIER_LIST = "PERMISSION_TIER_LIST",
  PERMISSION_TIER_TRANSITION_AUTOMATION_SETTINGS_GET = "PERMISSION_TIER_TRANSITION_AUTOMATION_SETTINGS_GET",
  PERMISSION_TIER_TRANSITION_AUTOMATION_SETTINGS_SET = "PERMISSION_TIER_TRANSITION_AUTOMATION_SETTINGS_SET",
  PERMISSION_TIER_TRANSITION_CREATE = "PERMISSION_TIER_TRANSITION_CREATE",
  PERMISSION_TIER_TRANSITION_DELETE = "PERMISSION_TIER_TRANSITION_DELETE",
  PERMISSION_TIER_TRANSITION_LIST = "PERMISSION_TIER_TRANSITION_LIST",
  PERMISSION_TIER_TRANSITION_UPDATE = "PERMISSION_TIER_TRANSITION_UPDATE",
  PERMISSION_TIER_UPDATE = "PERMISSION_TIER_UPDATE",
  PERMISSION_TIPALTI_INTEGRATION_CREATE = "PERMISSION_TIPALTI_INTEGRATION_CREATE",
  PERMISSION_TIPALTI_INTEGRATION_GET = "PERMISSION_TIPALTI_INTEGRATION_GET",
  PERMISSION_TIPALTI_PAYEE_DASHBOARD_GET = "PERMISSION_TIPALTI_PAYEE_DASHBOARD_GET",
  PERMISSION_TIPALTI_PAYEE_DASHBOARD_GET_MANAGED_AFFILIATE_ONLY = "PERMISSION_TIPALTI_PAYEE_DASHBOARD_GET_MANAGED_AFFILIATE_ONLY",
  PERMISSION_TIPALTI_PAYEE_DASHBOARD_GET_OWN_ONLY = "PERMISSION_TIPALTI_PAYEE_DASHBOARD_GET_OWN_ONLY",
  PERMISSION_TIPALTI_PAYEE_ID_GET = "PERMISSION_TIPALTI_PAYEE_ID_GET",
  PERMISSION_TIPALTI_PAYEE_ID_GET_MANAGED_AFFILIATE_ONLY = "PERMISSION_TIPALTI_PAYEE_ID_GET_MANAGED_AFFILIATE_ONLY",
  PERMISSION_TIPALTI_PAYEE_ID_GET_OWN_ONLY = "PERMISSION_TIPALTI_PAYEE_ID_GET_OWN_ONLY",
  PERMISSION_TIPALTI_PAYMENT_BATCH_CREATE = "PERMISSION_TIPALTI_PAYMENT_BATCH_CREATE",
  PERMISSION_TIPALTI_PAYMENT_BATCH_STATUS = "PERMISSION_TIPALTI_PAYMENT_BATCH_STATUS",
  PERMISSION_TIPALTI_PAYMENT_INFO = "PERMISSION_TIPALTI_PAYMENT_INFO",
  PERMISSION_VIEW_ADVERTISER_DASHBOARD_NOTE = "PERMISSION_VIEW_ADVERTISER_DASHBOARD_NOTE",
  PERMISSION_VIEW_DASHBOARD_NOTE = "PERMISSION_VIEW_DASHBOARD_NOTE",
  PERMISSION_VIEW_GETTING_STARTED = "PERMISSION_VIEW_GETTING_STARTED",
  PERMISSION_VIEW_HUBSPOT = "PERMISSION_VIEW_HUBSPOT",
  PERMISSION_VIEW_INTERCOM = "PERMISSION_VIEW_INTERCOM",
  PERMISSION_VIEW_MY_ACCOUNT_LINK = "PERMISSION_VIEW_MY_ACCOUNT_LINK",
  PERMISSION_WEBHOOK_AFFILIATE_CREATED_CREATE = "PERMISSION_WEBHOOK_AFFILIATE_CREATED_CREATE",
  PERMISSION_WEBHOOK_AFFILIATE_CREATED_DELETE = "PERMISSION_WEBHOOK_AFFILIATE_CREATED_DELETE",
  PERMISSION_WEBHOOK_AFFILIATE_CREATED_SEND = "PERMISSION_WEBHOOK_AFFILIATE_CREATED_SEND",
  PERMISSION_WEBHOOK_AFFILIATE_STATUS_CHANGED_CREATE = "PERMISSION_WEBHOOK_AFFILIATE_STATUS_CHANGED_CREATE",
  PERMISSION_WEBHOOK_AFFILIATE_STATUS_CHANGED_DELETE = "PERMISSION_WEBHOOK_AFFILIATE_STATUS_CHANGED_DELETE",
  PERMISSION_WEBHOOK_AFFILIATE_STATUS_CHANGED_SEND = "PERMISSION_WEBHOOK_AFFILIATE_STATUS_CHANGED_SEND",
  PERMISSION_WEBHOOK_AFFILIATE_TIER_CHANGED_CREATE = "PERMISSION_WEBHOOK_AFFILIATE_TIER_CHANGED_CREATE",
  PERMISSION_WEBHOOK_AFFILIATE_TIER_CHANGED_DELETE = "PERMISSION_WEBHOOK_AFFILIATE_TIER_CHANGED_DELETE",
  PERMISSION_WEBHOOK_AFFILIATE_TIER_CHANGED_SEND = "PERMISSION_WEBHOOK_AFFILIATE_TIER_CHANGED_SEND",
  PERMISSION_WEBHOOK_CLICK_CREATED_CREATE = "PERMISSION_WEBHOOK_CLICK_CREATED_CREATE",
  PERMISSION_WEBHOOK_CLICK_CREATED_CREATE_OWN_ONLY = "PERMISSION_WEBHOOK_CLICK_CREATED_CREATE_OWN_ONLY",
  PERMISSION_WEBHOOK_CLICK_CREATED_DELETE = "PERMISSION_WEBHOOK_CLICK_CREATED_DELETE",
  PERMISSION_WEBHOOK_CLICK_CREATED_DELETE_OWN_ONLY = "PERMISSION_WEBHOOK_CLICK_CREATED_DELETE_OWN_ONLY",
  PERMISSION_WEBHOOK_CLICK_CREATED_SEND = "PERMISSION_WEBHOOK_CLICK_CREATED_SEND",
  PERMISSION_WEBHOOK_CLICK_CREATED_SEND_OWN_ONLY = "PERMISSION_WEBHOOK_CLICK_CREATED_SEND_OWN_ONLY",
  PERMISSION_WEBHOOK_CONVERSION_CREATED_CREATE = "PERMISSION_WEBHOOK_CONVERSION_CREATED_CREATE",
  PERMISSION_WEBHOOK_CONVERSION_CREATED_CREATE_OWN_ONLY = "PERMISSION_WEBHOOK_CONVERSION_CREATED_CREATE_OWN_ONLY",
  PERMISSION_WEBHOOK_CONVERSION_CREATED_DELETE = "PERMISSION_WEBHOOK_CONVERSION_CREATED_DELETE",
  PERMISSION_WEBHOOK_CONVERSION_CREATED_DELETE_OWN_ONLY = "PERMISSION_WEBHOOK_CONVERSION_CREATED_DELETE_OWN_ONLY",
  PERMISSION_WEBHOOK_CONVERSION_CREATED_SEND = "PERMISSION_WEBHOOK_CONVERSION_CREATED_SEND",
  PERMISSION_WEBHOOK_CONVERSION_CREATED_SEND_OWN_ONLY = "PERMISSION_WEBHOOK_CONVERSION_CREATED_SEND_OWN_ONLY",
  PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_CREATE = "PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_CREATE",
  PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_CREATE_OWN_ONLY = "PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_CREATE_OWN_ONLY",
  PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_DELETE = "PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_DELETE",
  PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_DELETE_OWN_ONLY = "PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_DELETE_OWN_ONLY",
  PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_SEND = "PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_SEND",
  PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_SEND_OWN_ONLY = "PERMISSION_WEBHOOK_CONVERSION_STATUS_CHANGED_SEND_OWN_ONLY",
  PERMISSION_WEBHOOK_COUPON_CREATED_CREATE = "PERMISSION_WEBHOOK_COUPON_CREATED_CREATE",
  PERMISSION_WEBHOOK_COUPON_CREATED_CREATE_OWN_ONLY = "PERMISSION_WEBHOOK_COUPON_CREATED_CREATE_OWN_ONLY",
  PERMISSION_WEBHOOK_COUPON_CREATED_DELETE = "PERMISSION_WEBHOOK_COUPON_CREATED_DELETE",
  PERMISSION_WEBHOOK_COUPON_CREATED_DELETE_OWN_ONLY = "PERMISSION_WEBHOOK_COUPON_CREATED_DELETE_OWN_ONLY",
  PERMISSION_WEBHOOK_LIST = "PERMISSION_WEBHOOK_LIST",
  PERMISSION_WEBHOOK_LIST_OWN_ONLY = "PERMISSION_WEBHOOK_LIST_OWN_ONLY",
  PERMISSION_WEBHOOK_SETTLEMENT_CREATED_CREATE = "PERMISSION_WEBHOOK_SETTLEMENT_CREATED_CREATE",
  PERMISSION_WEBHOOK_SETTLEMENT_CREATED_CREATE_OWN_ONLY = "PERMISSION_WEBHOOK_SETTLEMENT_CREATED_CREATE_OWN_ONLY",
  PERMISSION_WEBHOOK_SETTLEMENT_CREATED_DELETE = "PERMISSION_WEBHOOK_SETTLEMENT_CREATED_DELETE",
  PERMISSION_WEBHOOK_SETTLEMENT_CREATED_DELETE_OWN_ONLY = "PERMISSION_WEBHOOK_SETTLEMENT_CREATED_DELETE_OWN_ONLY",
  PERMISSION_WEBHOOK_SETTLEMENT_CREATED_SEND = "PERMISSION_WEBHOOK_SETTLEMENT_CREATED_SEND",
  PERMISSION_WEBHOOK_SETTLEMENT_CREATED_SEND_OWN_ONLY = "PERMISSION_WEBHOOK_SETTLEMENT_CREATED_SEND_OWN_ONLY",
}

/** @default "OPERATING_SYSTEM_UNSPECIFIED" */
export enum EnumsV1OperatingSystem {
  OPERATING_SYSTEM_UNSPECIFIED = "OPERATING_SYSTEM_UNSPECIFIED",
  OPERATING_SYSTEM_ANDROID = "OPERATING_SYSTEM_ANDROID",
  OPERATING_SYSTEM_CHROME_OS = "OPERATING_SYSTEM_CHROME_OS",
  OPERATING_SYSTEM_I_OS = "OPERATING_SYSTEM_I_OS",
  OPERATING_SYSTEM_LINUX = "OPERATING_SYSTEM_LINUX",
  OPERATING_SYSTEM_MAC_OS = "OPERATING_SYSTEM_MAC_OS",
  OPERATING_SYSTEM_WINDOWS = "OPERATING_SYSTEM_WINDOWS",
}

/** @default "OFFER_CAP_CALCULATION_METHOD_UNSPECIFIED" */
export enum EnumsV1OfferCapCalculationMethod {
  OFFER_CAP_CALCULATION_METHOD_UNSPECIFIED = "OFFER_CAP_CALCULATION_METHOD_UNSPECIFIED",
  OFFER_CAP_CALCULATION_METHOD_NUMBER_OF_CONVERSIONS = "OFFER_CAP_CALCULATION_METHOD_NUMBER_OF_CONVERSIONS",
  OFFER_CAP_CALCULATION_METHOD_SUM_OF_REVENUE = "OFFER_CAP_CALCULATION_METHOD_SUM_OF_REVENUE",
}

/** @default "NOTIFICATION_EVENT_UNSPECIFIED" */
export enum EnumsV1NotificationEvent {
  NOTIFICATION_EVENT_UNSPECIFIED = "NOTIFICATION_EVENT_UNSPECIFIED",
  NOTIFICATION_EVENT_EXAMPLE = "NOTIFICATION_EVENT_EXAMPLE",
  NOTIFICATION_EVENT_AFFILIATE_MISSING_BILLING_DETAILS = "NOTIFICATION_EVENT_AFFILIATE_MISSING_BILLING_DETAILS",
  NOTIFICATION_EVENT_AFFILIATE_MISSING_PAYMENT_METHOD = "NOTIFICATION_EVENT_AFFILIATE_MISSING_PAYMENT_METHOD",
  NOTIFICATION_EVENT_AFFILIATE_REGISTERED = "NOTIFICATION_EVENT_AFFILIATE_REGISTERED",
  NOTIFICATION_EVENT_AFFILIATE_REGISTRATION_PENDING = "NOTIFICATION_EVENT_AFFILIATE_REGISTRATION_PENDING",
  NOTIFICATION_EVENT_APPLY_TO_RUN_REQUESTED = "NOTIFICATION_EVENT_APPLY_TO_RUN_REQUESTED",
  NOTIFICATION_EVENT_CONVERSION_ERROR_DETECTED = "NOTIFICATION_EVENT_CONVERSION_ERROR_DETECTED",
  NOTIFICATION_EVENT_CONVERSION_FRAUD_DETECTED = "NOTIFICATION_EVENT_CONVERSION_FRAUD_DETECTED",
  NOTIFICATION_EVENT_CONVERSION_PENDING_DETECTED = "NOTIFICATION_EVENT_CONVERSION_PENDING_DETECTED",
  NOTIFICATION_EVENT_CUSTOM = "NOTIFICATION_EVENT_CUSTOM",
  NOTIFICATION_EVENT_OFFER_DRAFT = "NOTIFICATION_EVENT_OFFER_DRAFT",
  NOTIFICATION_EVENT_OFFER_NOT_INTEGRATED = "NOTIFICATION_EVENT_OFFER_NOT_INTEGRATED",
  NOTIFICATION_EVENT_TIER_AUTOMATION_TIER_CHANGED = "NOTIFICATION_EVENT_TIER_AUTOMATION_TIER_CHANGED",
}

/** @default "NOTIFICATION_CHANNEL_UNSPECIFIED" */
export enum EnumsV1NotificationChannel {
  NOTIFICATION_CHANNEL_UNSPECIFIED = "NOTIFICATION_CHANNEL_UNSPECIFIED",
  NOTIFICATION_CHANNEL_IN_APP = "NOTIFICATION_CHANNEL_IN_APP",
  NOTIFICATION_CHANNEL_EMAIL = "NOTIFICATION_CHANNEL_EMAIL",
}

/** @default "FRAUD_SUSPICION_CAUSE_UNSPECIFIED" */
export enum EnumsV1FraudSuspicionCause {
  FRAUD_SUSPICION_CAUSE_UNSPECIFIED = "FRAUD_SUSPICION_CAUSE_UNSPECIFIED",
  FRAUD_SUSPICION_CAUSE_IP_ADDRESS_FREQUENCY = "FRAUD_SUSPICION_CAUSE_IP_ADDRESS_FREQUENCY",
  FRAUD_SUSPICION_CAUSE_SAME_BILLING_DETAILS = "FRAUD_SUSPICION_CAUSE_SAME_BILLING_DETAILS",
  FRAUD_SUSPICION_CAUSE_SAME_IP_ADDRESS = "FRAUD_SUSPICION_CAUSE_SAME_IP_ADDRESS",
  FRAUD_SUSPICION_CAUSE_SUSPICIOUS_CLICK = "FRAUD_SUSPICION_CAUSE_SUSPICIOUS_CLICK",
  FRAUD_SUSPICION_CAUSE_TIME_AFTER_CONVERSION_SOURCE = "FRAUD_SUSPICION_CAUSE_TIME_AFTER_CONVERSION_SOURCE",
}

/** @default "FEATURE_ID_UNSPECIFIED" */
export enum EnumsV1FeatureId {
  FEATURE_ID_UNSPECIFIED = "FEATURE_ID_UNSPECIFIED",
  FEATURE_ID_ACTIVE_OFFERS = "FEATURE_ID_ACTIVE_OFFERS",
  FEATURE_ID_ACTIVITY_LOGS = "FEATURE_ID_ACTIVITY_LOGS",
  FEATURE_ID_ADVERTISERS = "FEATURE_ID_ADVERTISERS",
  FEATURE_ID_ADVERTISER_EMAIL_PLATFORM = "FEATURE_ID_ADVERTISER_EMAIL_PLATFORM",
  FEATURE_ID_AFFILIATE_CONVERSION_VISIBILITY = "FEATURE_ID_AFFILIATE_CONVERSION_VISIBILITY",
  FEATURE_ID_AFFILIATE_EMAIL_PLATFORM = "FEATURE_ID_AFFILIATE_EMAIL_PLATFORM",
  FEATURE_ID_AFFILIATE_MANAGERS = "FEATURE_ID_AFFILIATE_MANAGERS",
  FEATURE_ID_AFFILIATES_BULK_UPDATE = "FEATURE_ID_AFFILIATES_BULK_UPDATE",
  FEATURE_ID_AFFILIATES_EXPORT = "FEATURE_ID_AFFILIATES_EXPORT",
  FEATURE_ID_AFFILIATES_IMPORT = "FEATURE_ID_AFFILIATES_IMPORT",
  FEATURE_ID_ANURA = "FEATURE_ID_ANURA",
  FEATURE_ID_APPLY_TO_RUN_OFFERS = "FEATURE_ID_APPLY_TO_RUN_OFFERS",
  FEATURE_ID_AVAILABLE_PAYMENT_METHODS = "FEATURE_ID_AVAILABLE_PAYMENT_METHODS",
  FEATURE_ID_CLAIM_GENERATING = "FEATURE_ID_CLAIM_GENERATING",
  FEATURE_ID_COLOR_THEME = "FEATURE_ID_COLOR_THEME",
  FEATURE_ID_CONVERSION_AMOUNT_MODIFICATION = "FEATURE_ID_CONVERSION_AMOUNT_MODIFICATION",
  FEATURE_ID_CONVERSION_AMOUNT_VISIBILITY = "FEATURE_ID_CONVERSION_AMOUNT_VISIBILITY",
  FEATURE_ID_CONVERSIONS_IMPORT = "FEATURE_ID_CONVERSIONS_IMPORT",
  FEATURE_ID_CONVERSIONS_UPDATE_CSV = "FEATURE_ID_CONVERSIONS_UPDATE_CSV",
  FEATURE_ID_COUPONS = "FEATURE_ID_COUPONS",
  FEATURE_ID_CUSTOM_AFFILIATE_FORM = "FEATURE_ID_CUSTOM_AFFILIATE_FORM",
  FEATURE_ID_CUSTOM_AFFILIATE_REGISTRATION = "FEATURE_ID_CUSTOM_AFFILIATE_REGISTRATION",
  FEATURE_ID_CUSTOM_CONVERSION_TYPES = "FEATURE_ID_CUSTOM_CONVERSION_TYPES",
  FEATURE_ID_CUSTOM_DOMAINS = "FEATURE_ID_CUSTOM_DOMAINS",
  FEATURE_ID_CUSTOM_INTERNAL_PAGES = "FEATURE_ID_CUSTOM_INTERNAL_PAGES",
  FEATURE_ID_CUSTOM_REVENUE_ORIGINS = "FEATURE_ID_CUSTOM_REVENUE_ORIGINS",
  FEATURE_ID_CUSTOM_REVENUE_VISIBILITY = "FEATURE_ID_CUSTOM_REVENUE_VISIBILITY",
  FEATURE_ID_CUSTOM_TERMS_AND_CONDITIONS = "FEATURE_ID_CUSTOM_TERMS_AND_CONDITIONS",
  FEATURE_ID_CUSTOM_TIER_TRANSITION_AUTOMATION = "FEATURE_ID_CUSTOM_TIER_TRANSITION_AUTOMATION",
  FEATURE_ID_CUSTOM_TIERS = "FEATURE_ID_CUSTOM_TIERS",
  FEATURE_ID_DASHBOARD_PROMOS_VISIBILITY = "FEATURE_ID_DASHBOARD_PROMOS_VISIBILITY",
  FEATURE_ID_DEFAULT_THEME = "FEATURE_ID_DEFAULT_THEME",
  FEATURE_ID_DEFAULT_REPORT_FILTERING = "FEATURE_ID_DEFAULT_REPORT_FILTERING",
  FEATURE_ID_EMAIL_CUSTOMIZATION = "FEATURE_ID_EMAIL_CUSTOMIZATION",
  FEATURE_ID_ENABLED_INTERNAL_USERS = "FEATURE_ID_ENABLED_INTERNAL_USERS",
  FEATURE_ID_EXPORT_REPORTS = "FEATURE_ID_EXPORT_REPORTS",
  FEATURE_ID_FRAUD_DETECTION = "FEATURE_ID_FRAUD_DETECTION",
  FEATURE_ID_FREE_TRIAL_START = "FEATURE_ID_FREE_TRIAL_START",
  FEATURE_ID_FULL_WHITE_LABEL = "FEATURE_ID_FULL_WHITE_LABEL",
  FEATURE_ID_LIVE_CHAT_INTERCOM_SUPPORT = "FEATURE_ID_LIVE_CHAT_INTERCOM_SUPPORT",
  FEATURE_ID_MULTI_CURRENCY = "FEATURE_ID_MULTI_CURRENCY",
  FEATURE_ID_MULTI_FACTOR_AUTHENTICATION = "FEATURE_ID_MULTI_FACTOR_AUTHENTICATION",
  FEATURE_ID_NOTIFICATION_CUSTOM_EVENTS = "FEATURE_ID_NOTIFICATION_CUSTOM_EVENTS",
  FEATURE_ID_NOTIFICATIONS = "FEATURE_ID_NOTIFICATIONS",
  FEATURE_ID_OFFER_CAPS = "FEATURE_ID_OFFER_CAPS",
  FEATURE_ID_ON_HOLD = "FEATURE_ID_ON_HOLD",
  FEATURE_ID_PARTNERSHIP_MARKETPLACE = "FEATURE_ID_PARTNERSHIP_MARKETPLACE",
  FEATURE_ID_PAYOUT_AUTOMATION = "FEATURE_ID_PAYOUT_AUTOMATION",
  FEATURE_ID_PRICING_ADJUSTMENTS = "FEATURE_ID_PRICING_ADJUSTMENTS",
  FEATURE_ID_PRICING_SUPER_GROUP_RULES = "FEATURE_ID_PRICING_SUPER_GROUP_RULES",
  FEATURE_ID_PRIVATE_OFFERS = "FEATURE_ID_PRIVATE_OFFERS",
  FEATURE_ID_PUBLIC_API = "FEATURE_ID_PUBLIC_API",
  FEATURE_ID_PUBLIC_API_CLAIMS = "FEATURE_ID_PUBLIC_API_CLAIMS",
  FEATURE_ID_PUBLIC_API_PAYMENTS = "FEATURE_ID_PUBLIC_API_PAYMENTS",
  FEATURE_ID_PUBLIC_API_SETTLEMENTS = "FEATURE_ID_PUBLIC_API_SETTLEMENTS",
  FEATURE_ID_REDIRECT = "FEATURE_ID_REDIRECT",
  FEATURE_ID_REDIRECT_DOMAINS_TYPE = "FEATURE_ID_REDIRECT_DOMAINS_TYPE",
  FEATURE_ID_REFERRALS = "FEATURE_ID_REFERRALS",
  FEATURE_ID_REPORT_BUILDER_ADVANCED = "FEATURE_ID_REPORT_BUILDER_ADVANCED",
  FEATURE_ID_SHORT_LINKS = "FEATURE_ID_SHORT_LINKS",
  FEATURE_ID_SMART_LINKS = "FEATURE_ID_SMART_LINKS",
  FEATURE_ID_TRACKING_API_AUTHORIZATION = "FEATURE_ID_TRACKING_API_AUTHORIZATION",
  FEATURE_ID_TRACKING_BLOCKING = "FEATURE_ID_TRACKING_BLOCKING",
  FEATURE_ID_TRACKING_QUALITY_CONTROL = "FEATURE_ID_TRACKING_QUALITY_CONTROL",
  FEATURE_ID_UI_TRANSLATIONS = "FEATURE_ID_UI_TRANSLATIONS",
}

/** @default "DEVICE_UNSPECIFIED" */
export enum EnumsV1Device {
  DEVICE_UNSPECIFIED = "DEVICE_UNSPECIFIED",
  DEVICE_DESKTOP = "DEVICE_DESKTOP",
  DEVICE_MOBILE = "DEVICE_MOBILE",
  DEVICE_TABLET = "DEVICE_TABLET",
}

/** @default "CUSTOMER_TAX_ID_TYPE_UNSPECIFIED" */
export enum EnumsV1CustomerTaxIdType {
  CUSTOMER_TAX_ID_TYPE_UNSPECIFIED = "CUSTOMER_TAX_ID_TYPE_UNSPECIFIED",
  CUSTOMER_TAX_ID_TYPE_AETRN = "CUSTOMER_TAX_ID_TYPE_AETRN",
  CUSTOMER_TAX_ID_TYPE_AUABN = "CUSTOMER_TAX_ID_TYPE_AUABN",
  CUSTOMER_TAX_ID_TYPE_AUARN = "CUSTOMER_TAX_ID_TYPE_AUARN",
  CUSTOMER_TAX_ID_TYPE_BGUIC = "CUSTOMER_TAX_ID_TYPE_BGUIC",
  CUSTOMER_TAX_ID_TYPE_BRCNPJ = "CUSTOMER_TAX_ID_TYPE_BRCNPJ",
  CUSTOMER_TAX_ID_TYPE_BRCPF = "CUSTOMER_TAX_ID_TYPE_BRCPF",
  CUSTOMER_TAX_ID_TYPE_CABN = "CUSTOMER_TAX_ID_TYPE_CABN",
  CUSTOMER_TAX_ID_TYPE_CAGSTHST = "CUSTOMER_TAX_ID_TYPE_CAGSTHST",
  CUSTOMER_TAX_ID_TYPE_CAPSTBC = "CUSTOMER_TAX_ID_TYPE_CAPSTBC",
  CUSTOMER_TAX_ID_TYPE_CAPSTMB = "CUSTOMER_TAX_ID_TYPE_CAPSTMB",
  CUSTOMER_TAX_ID_TYPE_CAPSTSK = "CUSTOMER_TAX_ID_TYPE_CAPSTSK",
  CUSTOMER_TAX_ID_TYPE_CAQST = "CUSTOMER_TAX_ID_TYPE_CAQST",
  CUSTOMER_TAX_ID_TYPE_CHVAT = "CUSTOMER_TAX_ID_TYPE_CHVAT",
  CUSTOMER_TAX_ID_TYPE_CLTIN = "CUSTOMER_TAX_ID_TYPE_CLTIN",
  CUSTOMER_TAX_ID_TYPE_ESCIF = "CUSTOMER_TAX_ID_TYPE_ESCIF",
  CUSTOMER_TAX_ID_TYPE_EUOSSVAT = "CUSTOMER_TAX_ID_TYPE_EUOSSVAT",
  CUSTOMER_TAX_ID_TYPE_EUVAT = "CUSTOMER_TAX_ID_TYPE_EUVAT",
  CUSTOMER_TAX_ID_TYPE_GBVAT = "CUSTOMER_TAX_ID_TYPE_GBVAT",
  CUSTOMER_TAX_ID_TYPE_GEVAT = "CUSTOMER_TAX_ID_TYPE_GEVAT",
  CUSTOMER_TAX_ID_TYPE_HKBR = "CUSTOMER_TAX_ID_TYPE_HKBR",
  CUSTOMER_TAX_ID_TYPE_HUTIN = "CUSTOMER_TAX_ID_TYPE_HUTIN",
  CUSTOMER_TAX_ID_TYPE_IDNPWP = "CUSTOMER_TAX_ID_TYPE_IDNPWP",
  CUSTOMER_TAX_ID_TYPE_ILVAT = "CUSTOMER_TAX_ID_TYPE_ILVAT",
  CUSTOMER_TAX_ID_TYPE_INGST = "CUSTOMER_TAX_ID_TYPE_INGST",
  CUSTOMER_TAX_ID_TYPE_ISVAT = "CUSTOMER_TAX_ID_TYPE_ISVAT",
  CUSTOMER_TAX_ID_TYPE_JPCN = "CUSTOMER_TAX_ID_TYPE_JPCN",
  CUSTOMER_TAX_ID_TYPE_JPRN = "CUSTOMER_TAX_ID_TYPE_JPRN",
  CUSTOMER_TAX_ID_TYPE_KRBRN = "CUSTOMER_TAX_ID_TYPE_KRBRN",
  CUSTOMER_TAX_ID_TYPE_LIUID = "CUSTOMER_TAX_ID_TYPE_LIUID",
  CUSTOMER_TAX_ID_TYPE_MXRFC = "CUSTOMER_TAX_ID_TYPE_MXRFC",
  CUSTOMER_TAX_ID_TYPE_MYFRP = "CUSTOMER_TAX_ID_TYPE_MYFRP",
  CUSTOMER_TAX_ID_TYPE_MYITN = "CUSTOMER_TAX_ID_TYPE_MYITN",
  CUSTOMER_TAX_ID_TYPE_MYSST = "CUSTOMER_TAX_ID_TYPE_MYSST",
  CUSTOMER_TAX_ID_TYPE_NOVAT = "CUSTOMER_TAX_ID_TYPE_NOVAT",
  CUSTOMER_TAX_ID_TYPE_NZGST = "CUSTOMER_TAX_ID_TYPE_NZGST",
  CUSTOMER_TAX_ID_TYPE_RUINN = "CUSTOMER_TAX_ID_TYPE_RUINN",
  CUSTOMER_TAX_ID_TYPE_RUKPP = "CUSTOMER_TAX_ID_TYPE_RUKPP",
  CUSTOMER_TAX_ID_TYPE_SAVAT = "CUSTOMER_TAX_ID_TYPE_SAVAT",
  CUSTOMER_TAX_ID_TYPE_SGGST = "CUSTOMER_TAX_ID_TYPE_SGGST",
  CUSTOMER_TAX_ID_TYPE_SGUEN = "CUSTOMER_TAX_ID_TYPE_SGUEN",
  CUSTOMER_TAX_ID_TYPE_SITIN = "CUSTOMER_TAX_ID_TYPE_SITIN",
  CUSTOMER_TAX_ID_TYPE_THVAT = "CUSTOMER_TAX_ID_TYPE_THVAT",
  CUSTOMER_TAX_ID_TYPE_TWVAT = "CUSTOMER_TAX_ID_TYPE_TWVAT",
  CUSTOMER_TAX_ID_TYPE_UAVAT = "CUSTOMER_TAX_ID_TYPE_UAVAT",
  CUSTOMER_TAX_ID_TYPE_USEIN = "CUSTOMER_TAX_ID_TYPE_USEIN",
  CUSTOMER_TAX_ID_TYPE_ZAVAT = "CUSTOMER_TAX_ID_TYPE_ZAVAT",
}

/** @default "CUSTOMER_TAX_EXEMPT_UNSPECIFIED" */
export enum EnumsV1CustomerTaxExempt {
  CUSTOMER_TAX_EXEMPT_UNSPECIFIED = "CUSTOMER_TAX_EXEMPT_UNSPECIFIED",
  CUSTOMER_TAX_EXEMPT_EXEMPT = "CUSTOMER_TAX_EXEMPT_EXEMPT",
  CUSTOMER_TAX_EXEMPT_REVERSE = "CUSTOMER_TAX_EXEMPT_REVERSE",
  CUSTOMER_TAX_EXEMPT_NONE = "CUSTOMER_TAX_EXEMPT_NONE",
}

/** @default "CUSTOM_NOTIFICATION_EVENT_TOPIC_UNSPECIFIED" */
export enum EnumsV1CustomNotificationEventTopic {
  CUSTOM_NOTIFICATION_EVENT_TOPIC_UNSPECIFIED = "CUSTOM_NOTIFICATION_EVENT_TOPIC_UNSPECIFIED",
  CUSTOM_NOTIFICATION_EVENT_TOPIC_AFFILIATE = "CUSTOM_NOTIFICATION_EVENT_TOPIC_AFFILIATE",
  CUSTOM_NOTIFICATION_EVENT_TOPIC_ADVERTISER = "CUSTOM_NOTIFICATION_EVENT_TOPIC_ADVERTISER",
  CUSTOM_NOTIFICATION_EVENT_TOPIC_OFFER = "CUSTOM_NOTIFICATION_EVENT_TOPIC_OFFER",
}

/** @default "CUSTOM_NOTIFICATION_EVENT_OPERATION_UNSPECIFIED" */
export enum EnumsV1CustomNotificationEventOperation {
  CUSTOM_NOTIFICATION_EVENT_OPERATION_UNSPECIFIED = "CUSTOM_NOTIFICATION_EVENT_OPERATION_UNSPECIFIED",
  CUSTOM_NOTIFICATION_EVENT_OPERATION_GREATER_THAN = "CUSTOM_NOTIFICATION_EVENT_OPERATION_GREATER_THAN",
  CUSTOM_NOTIFICATION_EVENT_OPERATION_LESS_THAN = "CUSTOM_NOTIFICATION_EVENT_OPERATION_LESS_THAN",
}

/** @default "CUSTOM_NOTIFICATION_EVENT_CRITERIA_UNSPECIFIED" */
export enum EnumsV1CustomNotificationEventCriteria {
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_UNSPECIFIED = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_UNSPECIFIED",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_CLICKS = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_CLICKS",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_CONVERSIONS = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_CONVERSIONS",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_REVENUE = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_REVENUE",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_COST = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_COST",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_COMMISSIONS = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_COMMISSIONS",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_PROFIT = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_PROFIT",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_CONVERSION_PER_CLICK_RATE = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_CONVERSION_PER_CLICK_RATE",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_AVERAGE_REVENUE = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_AVERAGE_REVENUE",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_AVERAGE_COST = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_AVERAGE_COST",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_REVENUE_PER_CLICK = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_REVENUE_PER_CLICK",
  CUSTOM_NOTIFICATION_EVENT_CRITERIA_COST_PER_CLICK = "CUSTOM_NOTIFICATION_EVENT_CRITERIA_COST_PER_CLICK",
}

/** @default "CREATIVE_TYPE_UNSPECIFIED" */
export enum EnumsV1CreativeType {
  CREATIVE_TYPE_UNSPECIFIED = "CREATIVE_TYPE_UNSPECIFIED",
  CREATIVE_TYPE_IMAGE_BANNER = "CREATIVE_TYPE_IMAGE_BANNER",
  CREATIVETYPEHTML5BANNER = "CREATIVE_TYPE_HTML5_BANNER",
  CREATIVE_TYPE_TEXT_LINK = "CREATIVE_TYPE_TEXT_LINK",
  CREATIVE_TYPE_YOUTUBE_VIDEO = "CREATIVE_TYPE_YOUTUBE_VIDEO",
  CREATIVE_TYPE_VIMEO_VIDEO = "CREATIVE_TYPE_VIMEO_VIDEO",
  CREATIVE_TYPE_FACEBOOK_POST = "CREATIVE_TYPE_FACEBOOK_POST",
  CREATIVE_TYPE_TWITTER_POST = "CREATIVE_TYPE_TWITTER_POST",
  CREATIVE_TYPE_PRODUCT_FEED = "CREATIVE_TYPE_PRODUCT_FEED",
  CREATIVE_TYPE_ZIP = "CREATIVE_TYPE_ZIP",
}

/** @default "CONVERSION_VALUE_TYPE_UNSPECIFIED" */
export enum EnumsV1ConversionValueType {
  CONVERSION_VALUE_TYPE_UNSPECIFIED = "CONVERSION_VALUE_TYPE_UNSPECIFIED",
  CONVERSION_VALUE_TYPE_AMOUNT = "CONVERSION_VALUE_TYPE_AMOUNT",
  CONVERSION_VALUE_TYPE_NO_REVENUE = "CONVERSION_VALUE_TYPE_NO_REVENUE",
  CONVERSION_VALUE_TYPE_RATE = "CONVERSION_VALUE_TYPE_RATE",
  CONVERSION_VALUE_TYPE_REVENUE_RATE_AND_COST_AMOUNT = "CONVERSION_VALUE_TYPE_REVENUE_RATE_AND_COST_AMOUNT",
}

/** @default "CONVERSION_ATTRIBUTION_TYPE_UNSPECIFIED" */
export enum EnumsV1ConversionAttributionType {
  CONVERSION_ATTRIBUTION_TYPE_UNSPECIFIED = "CONVERSION_ATTRIBUTION_TYPE_UNSPECIFIED",
  CONVERSION_ATTRIBUTION_TYPE_FIRST_TOUCH = "CONVERSION_ATTRIBUTION_TYPE_FIRST_TOUCH",
  CONVERSION_ATTRIBUTION_TYPE_LAST_TOUCH = "CONVERSION_ATTRIBUTION_TYPE_LAST_TOUCH",
}

/** @default "COMMISSION_SOURCE_AMOUNT_TYPE_UNSPECIFIED" */
export enum EnumsV1CommissionSourceAmountType {
  COMMISSION_SOURCE_AMOUNT_TYPE_UNSPECIFIED = "COMMISSION_SOURCE_AMOUNT_TYPE_UNSPECIFIED",
  COMMISSION_SOURCE_AMOUNT_TYPE_COST = "COMMISSION_SOURCE_AMOUNT_TYPE_COST",
  COMMISSION_SOURCE_AMOUNT_TYPE_REVENUE = "COMMISSION_SOURCE_AMOUNT_TYPE_REVENUE",
}

/** @default "CLICK_TYPE_UNSPECIFIED" */
export enum EnumsV1ClickType {
  CLICK_TYPE_UNSPECIFIED = "CLICK_TYPE_UNSPECIFIED",
  CLICK_TYPE_DIRECT = "CLICK_TYPE_DIRECT",
  CLICK_TYPE_REDIRECT = "CLICK_TYPE_REDIRECT",
  CLICK_TYPE_SMART_LINK = "CLICK_TYPE_SMART_LINK",
  CLICK_TYPE_REDIRECT_LANDING_PAGE = "CLICK_TYPE_REDIRECT_LANDING_PAGE",
}

/** @default "CLICK_STATUS_UNSPECIFIED" */
export enum EnumsV1ClickStatus {
  CLICK_STATUS_UNSPECIFIED = "CLICK_STATUS_UNSPECIFIED",
  CLICK_STATUS_OK = "CLICK_STATUS_OK",
  CLICK_STATUS_NOT_ALLOWED = "CLICK_STATUS_NOT_ALLOWED",
  CLICK_STATUS_BLOCKED = "CLICK_STATUS_BLOCKED",
}

/** @default "ANURA_SCORE_UNSPECIFIED" */
export enum EnumsV1AnuraScore {
  ANURA_SCORE_UNSPECIFIED = "ANURA_SCORE_UNSPECIFIED",
  ANURA_SCORE_GOOD = "ANURA_SCORE_GOOD",
  ANURA_SCORE_WARNING = "ANURA_SCORE_WARNING",
  ANURA_SCORE_BAD = "ANURA_SCORE_BAD",
}

/** @default "ANSWER_TYPE_UNSPECIFIED" */
export enum EnumsV1AnswerType {
  ANSWER_TYPE_UNSPECIFIED = "ANSWER_TYPE_UNSPECIFIED",
  ANSWER_TYPE_TEXT = "ANSWER_TYPE_TEXT",
  ANSWER_TYPE_CHECKBOX = "ANSWER_TYPE_CHECKBOX",
  ANSWER_TYPE_SELECT_OPTION = "ANSWER_TYPE_SELECT_OPTION",
}

/** @default "AFFILIATE_REGISTRATION_PAGE_STYLE_UNSPECIFIED" */
export enum EnumsV1AffiliateRegistrationPageStyle {
  AFFILIATE_REGISTRATION_PAGE_STYLE_UNSPECIFIED = "AFFILIATE_REGISTRATION_PAGE_STYLE_UNSPECIFIED",
  AFFILIATE_REGISTRATION_PAGE_STYLE_STANDARD = "AFFILIATE_REGISTRATION_PAGE_STYLE_STANDARD",
  AFFILIATE_REGISTRATION_PAGE_STYLE_MINIMALIST = "AFFILIATE_REGISTRATION_PAGE_STYLE_MINIMALIST",
}

/** @default "ACTIVITY_UNSPECIFIED" */
export enum EnumsV1Activity {
  ACTIVITY_UNSPECIFIED = "ACTIVITY_UNSPECIFIED",
  ACTIVITY_ADVERTISER_MANUALLY_CREATED = "ACTIVITY_ADVERTISER_MANUALLY_CREATED",
  ACTIVITY_AFFILIATE_BILLING_DETAIL_CHANGED = "ACTIVITY_AFFILIATE_BILLING_DETAIL_CHANGED",
  ACTIVITY_AFFILIATE_BILLING_DETAIL_CREATED = "ACTIVITY_AFFILIATE_BILLING_DETAIL_CREATED",
  ACTIVITY_AFFILIATE_MANUALLY_CREATED = "ACTIVITY_AFFILIATE_MANUALLY_CREATED",
  ACTIVITY_AFFILIATE_NOTE_CREATED = "ACTIVITY_AFFILIATE_NOTE_CREATED",
  ACTIVITY_AFFILIATE_NOTE_DELETED = "ACTIVITY_AFFILIATE_NOTE_DELETED",
  ACTIVITY_AFFILIATE_PAYMENT_METHOD_CHANGED = "ACTIVITY_AFFILIATE_PAYMENT_METHOD_CHANGED",
  ACTIVITY_AFFILIATE_PAYMENT_METHOD_CREATED = "ACTIVITY_AFFILIATE_PAYMENT_METHOD_CREATED",
  ACTIVITY_AFFILIATE_PAYMENT_METHOD_DELETED = "ACTIVITY_AFFILIATE_PAYMENT_METHOD_DELETED",
  ACTIVITY_CONVERSION_AMOUNT_CHANGED = "ACTIVITY_CONVERSION_AMOUNT_CHANGED",
  ACTIVITY_CONVERSION_CHANGED = "ACTIVITY_CONVERSION_CHANGED",
  ACTIVITY_CONVERSION_STATUS_CHANGED = "ACTIVITY_CONVERSION_STATUS_CHANGED",
  ACTIVITY_COUPON_CREATED = "ACTIVITY_COUPON_CREATED",
  ACTIVITY_COUPON_DELETED = "ACTIVITY_COUPON_DELETED",
  ACTIVITY_COUPON_STATUS_CHANGED = "ACTIVITY_COUPON_STATUS_CHANGED",
  ACTIVITY_DIRECT_LANDING_PAGE_CHANGED = "ACTIVITY_DIRECT_LANDING_PAGE_CHANGED",
  ACTIVITY_DIRECT_LANDING_PAGE_CREATED = "ACTIVITY_DIRECT_LANDING_PAGE_CREATED",
  ACTIVITY_DIRECT_LANDING_PAGE_DELETED = "ACTIVITY_DIRECT_LANDING_PAGE_DELETED",
  ACTIVITY_OFFER_CREATED = "ACTIVITY_OFFER_CREATED",
  ACTIVITY_OFFER_PRICING_CHANGED = "ACTIVITY_OFFER_PRICING_CHANGED",
  ACTIVITY_OFFER_STATUS_CHANGED = "ACTIVITY_OFFER_STATUS_CHANGED",
  ACTIVITY_OFFER_TRACKING_QUALITY_CONTROL_CHANGED = "ACTIVITY_OFFER_TRACKING_QUALITY_CONTROL_CHANGED",
  ACTIVITY_POSTBACK_TEMPLATE_CHANGED = "ACTIVITY_POSTBACK_TEMPLATE_CHANGED",
  ACTIVITY_POSTBACK_TEMPLATE_CREATED = "ACTIVITY_POSTBACK_TEMPLATE_CREATED",
  ACTIVITY_POSTBACK_TEMPLATE_DELETED = "ACTIVITY_POSTBACK_TEMPLATE_DELETED",
  ACTIVITY_REDIRECT_LANDING_PAGE_CHANGED = "ACTIVITY_REDIRECT_LANDING_PAGE_CHANGED",
  ACTIVITY_REDIRECT_LANDING_PAGE_CREATED = "ACTIVITY_REDIRECT_LANDING_PAGE_CREATED",
  ACTIVITY_REDIRECT_LANDING_PAGE_DELETED = "ACTIVITY_REDIRECT_LANDING_PAGE_DELETED",
  ACTIVITY_REVENUE_ORIGIN_TRACKING_QUALITY_CONTROL_CHANGED = "ACTIVITY_REVENUE_ORIGIN_TRACKING_QUALITY_CONTROL_CHANGED",
  ACTIVITY_SETTINGS_AFFILIATE_REGISTRATION_CUSTOMIZATION_CHANGED = "ACTIVITY_SETTINGS_AFFILIATE_REGISTRATION_CUSTOMIZATION_CHANGED",
  ACTIVITY_SETTINGS_AFFILIATE_REGISTRATION_PAGE_NOTE_CHANGED = "ACTIVITY_SETTINGS_AFFILIATE_REGISTRATION_PAGE_NOTE_CHANGED",
  ACTIVITY_SETTINGS_AFFILIATE_TRACKING_LINK_SETTINGS_CHANGED = "ACTIVITY_SETTINGS_AFFILIATE_TRACKING_LINK_SETTINGS_CHANGED",
  ACTIVITY_SETTINGS_CLAIM_GENERATING_CHANGED = "ACTIVITY_SETTINGS_CLAIM_GENERATING_CHANGED",
  ACTIVITY_SETTINGS_CLICK_TRACKING_SETTINGS_CHANGED = "ACTIVITY_SETTINGS_CLICK_TRACKING_SETTINGS_CHANGED",
  ACTIVITY_SETTINGS_CONVERSION_AMOUNT_VISIBLE_CHANGED = "ACTIVITY_SETTINGS_CONVERSION_AMOUNT_VISIBLE_CHANGED",
  ACTIVITY_SETTINGS_DASHBOARD_NOTE_CHANGED = "ACTIVITY_SETTINGS_DASHBOARD_NOTE_CHANGED",
  ACTIVITY_SETTINGS_DEFAULT_REGISTERED_ACCOUNT_STATUS_CHANGED = "ACTIVITY_SETTINGS_DEFAULT_REGISTERED_ACCOUNT_STATUS_CHANGED",
  ACTIVITY_SETTINGS_DEFAULT_REGISTERED_ADVERTISER_ACCOUNT_STATUS_CHANGED = "ACTIVITY_SETTINGS_DEFAULT_REGISTERED_ADVERTISER_ACCOUNT_STATUS_CHANGED",
  ACTIVITY_SETTINGS_DEFAULT_REPORT_FILTERING_CHANGED = "ACTIVITY_SETTINGS_DEFAULT_REPORT_FILTERING_CHANGED",
  ACTIVITY_SETTINGS_PAYMENT_METHOD_FOR_ADVERTISERS_CHANGED = "ACTIVITY_SETTINGS_PAYMENT_METHOD_FOR_ADVERTISERS_CHANGED",
  ACTIVITY_SETTINGS_REFERRAL_CHANGED = "ACTIVITY_SETTINGS_REFERRAL_CHANGED",
  ACTIVITY_SETTINGS_REVENUE_VISIBLE_CHANGED = "ACTIVITY_SETTINGS_REVENUE_VISIBLE_CHANGED",
  ACTIVITY_SETTINGS_TERMS_AND_CONDITIONS_CHANGED = "ACTIVITY_SETTINGS_TERMS_AND_CONDITIONS_CHANGED",
  ACTIVITY_SETTINGS_TRACKING_QUALITY_CONTROL_CHANGED = "ACTIVITY_SETTINGS_TRACKING_QUALITY_CONTROL_CHANGED",
  ACTIVITY_SETTLEMENT_ACCOUNT_DELETED = "ACTIVITY_SETTLEMENT_ACCOUNT_DELETED",
  ACTIVITY_SETTLEMENT_CREATED = "ACTIVITY_SETTLEMENT_CREATED",
  ACTIVITY_SETTLEMENT_DELETED = "ACTIVITY_SETTLEMENT_DELETED",
  ACTIVITY_WEBHOOK_CREATED = "ACTIVITY_WEBHOOK_CREATED",
  ACTIVITY_WEBHOOK_DELETED = "ACTIVITY_WEBHOOK_DELETED",
}

/** @default "ACCOUNT_STATUS_UNSPECIFIED" */
export enum EnumsV1AccountStatus {
  ACCOUNT_STATUS_UNSPECIFIED = "ACCOUNT_STATUS_UNSPECIFIED",
  ACCOUNT_STATUS_DISABLED = "ACCOUNT_STATUS_DISABLED",
  ACCOUNT_STATUS_ENABLED = "ACCOUNT_STATUS_ENABLED",
  ACCOUNT_STATUS_PENDING = "ACCOUNT_STATUS_PENDING",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum CustomInternalPagesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_SLUG_NOT_UNIQUE = "ERROR_CODE_SLUG_NOT_UNIQUE",
  ERROR_CODE_PAGE_ALREADY_USED = "ERROR_CODE_PAGE_ALREADY_USED",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum CurrenciesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ALREADY_USED = "ERROR_CODE_ALREADY_USED",
  ERROR_CODE_PROTECTED_PRIMARY_CURRENCY = "ERROR_CODE_PROTECTED_PRIMARY_CURRENCY",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum CouponsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_DUPLICATE_COUPON_CODE = "ERROR_CODE_DUPLICATE_COUPON_CODE",
  ERROR_CODE_OFFER_NOT_EXISTS = "ERROR_CODE_OFFER_NOT_EXISTS",
  ERROR_CODE_REVENUE_ORIGIN_NOT_EXISTS = "ERROR_CODE_REVENUE_ORIGIN_NOT_EXISTS",
  ERROR_CODE_SOURCE_NOT_EXISTS = "ERROR_CODE_SOURCE_NOT_EXISTS",
}

/** @default "COUPON_STATUS_UNSPECIFIED" */
export enum CouponsV1CouponStatus {
  COUPON_STATUS_UNSPECIFIED = "COUPON_STATUS_UNSPECIFIED",
  COUPON_STATUS_ACTIVE = "COUPON_STATUS_ACTIVE",
  COUPON_STATUS_INACTIVE = "COUPON_STATUS_INACTIVE",
  COUPON_STATUS_REMOVED = "COUPON_STATUS_REMOVED",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum ConversionsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_CONVERSION_COUNT_LIMIT_REACHED = "ERROR_CODE_CONVERSION_COUNT_LIMIT_REACHED",
  ERROR_CODE_CONVERSION_SETTLED = "ERROR_CODE_CONVERSION_SETTLED",
  ERROR_CODE_CONVERSION_SOURCE_NOT_FOUND = "ERROR_CODE_CONVERSION_SOURCE_NOT_FOUND",
  ERROR_CODE_CONVERSION_TYPE_NOT_CONFIGURED = "ERROR_CODE_CONVERSION_TYPE_NOT_CONFIGURED",
  ERROR_CODE_CONVERSION_TYPE_NOT_FOUND = "ERROR_CODE_CONVERSION_TYPE_NOT_FOUND",
  ERROR_CODE_CONVERSION_CURRENCY_NOT_SUPPORTED = "ERROR_CODE_CONVERSION_CURRENCY_NOT_SUPPORTED",
  ERROR_CODE_COUPON_CODE_NOT_FOUND = "ERROR_CODE_COUPON_CODE_NOT_FOUND",
  ERROR_CODE_NO_MATCHING_SUPER_GROUP = "ERROR_CODE_NO_MATCHING_SUPER_GROUP",
  ERROR_CODE_LESS_REVENUE_THAN_COST = "ERROR_CODE_LESS_REVENUE_THAN_COST",
  ERROR_CODE_MISSING_CONVERSION_AMOUNT = "ERROR_CODE_MISSING_CONVERSION_AMOUNT",
  ERROR_CODE_OFFER_NOT_ACTIVE = "ERROR_CODE_OFFER_NOT_ACTIVE",
  ERROR_CODE_REVENUE_ORIGIN_NOT_FOUND = "ERROR_CODE_REVENUE_ORIGIN_NOT_FOUND",
  ERROR_CODE_STATUS_NOT_DIFFERS = "ERROR_CODE_STATUS_NOT_DIFFERS",
  ERROR_CODE_EXTERNAL_CID_WITHOUT_REVENUE_ORIGIN = "ERROR_CODE_EXTERNAL_CID_WITHOUT_REVENUE_ORIGIN",
  ERROR_CODE_MISSING_CID = "ERROR_CODE_MISSING_CID",
  ERROR_CODE_MULTIPLE_CID = "ERROR_CODE_MULTIPLE_CID",
  ERROR_CODE_SOURCE_DISABLED = "ERROR_CODE_SOURCE_DISABLED",
  ERROR_CODE_DUPLICATE_EXTERNAL_ID = "ERROR_CODE_DUPLICATE_EXTERNAL_ID",
  ERROR_CODE_GROUP_WITH_CURRENCY_NOT_CONFIGURED = "ERROR_CODE_GROUP_WITH_CURRENCY_NOT_CONFIGURED",
}

/**
 * Check all validations on any index update.
 * @default "CONVERSION_STATUS_UNSPECIFIED"
 */
export enum ConversionsV1ConversionStatus {
  CONVERSION_STATUS_UNSPECIFIED = "CONVERSION_STATUS_UNSPECIFIED",
  CONVERSION_STATUS_APPROVED = "CONVERSION_STATUS_APPROVED",
  CONVERSION_STATUS_FRAUD = "CONVERSION_STATUS_FRAUD",
  CONVERSION_STATUS_NOT_ALLOWED = "CONVERSION_STATUS_NOT_ALLOWED",
  CONVERSION_STATUS_BLOCKED = "CONVERSION_STATUS_BLOCKED",
  CONVERSION_STATUS_ON_HOLD = "CONVERSION_STATUS_ON_HOLD",
  CONVERSION_STATUS_PENDING = "CONVERSION_STATUS_PENDING",
  CONVERSION_STATUS_REFUNDED = "CONVERSION_STATUS_REFUNDED",
  CONVERSION_STATUS_REJECTED = "CONVERSION_STATUS_REJECTED",
  CONVERSION_STATUS_TEST = "CONVERSION_STATUS_TEST",
  CONVERSION_STATUS_QUALITY_CONTROL = "CONVERSION_STATUS_QUALITY_CONTROL",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum ConversionTypesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ALREADY_USED = "ERROR_CODE_ALREADY_USED",
}

/** @default "CONVERSION_SOURCE_TYPE_UNSPECIFIED" */
export enum ConversionSourcesV1ConversionSourceType {
  CONVERSION_SOURCE_TYPE_UNSPECIFIED = "CONVERSION_SOURCE_TYPE_UNSPECIFIED",
  CONVERSION_SOURCE_TYPE_CLICK = "CONVERSION_SOURCE_TYPE_CLICK",
  CONVERSION_SOURCE_TYPE_COUPON = "CONVERSION_SOURCE_TYPE_COUPON",
}

/** @default "CONVERSION_REQUEST_STATUS_UNSPECIFIED" */
export enum ConversionRequestsV1ConversionRequestStatus {
  CONVERSION_REQUEST_STATUS_UNSPECIFIED = "CONVERSION_REQUEST_STATUS_UNSPECIFIED",
  CONVERSION_REQUEST_STATUS_CLIENT_ERROR = "CONVERSION_REQUEST_STATUS_CLIENT_ERROR",
  CONVERSION_REQUEST_STATUS_IN_PROGRESS = "CONVERSION_REQUEST_STATUS_IN_PROGRESS",
  CONVERSION_REQUEST_STATUS_OK = "CONVERSION_REQUEST_STATUS_OK",
  CONVERSION_REQUEST_STATUS_SYSTEM_ERROR = "CONVERSION_REQUEST_STATUS_SYSTEM_ERROR",
}

/** @default "EARNING_TYPE_UNSPECIFIED" */
export enum BillingV1EarningType {
  EARNING_TYPE_UNSPECIFIED = "EARNING_TYPE_UNSPECIFIED",
  EARNING_TYPE_COMMISSION = "EARNING_TYPE_COMMISSION",
  EARNING_TYPE_CONVERSION = "EARNING_TYPE_CONVERSION",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum AuthenticationV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_DISABLED_ACCOUNT = "ERROR_CODE_DISABLED_ACCOUNT",
  ERROR_CODE_PENDING_ACCOUNT = "ERROR_CODE_PENDING_ACCOUNT",
  ERROR_CODE_ACCOUNT_NOT_FOUND = "ERROR_CODE_ACCOUNT_NOT_FOUND",
  ERROR_CODE_PENDING_ACCOUNT_ADVERTISER = "ERROR_CODE_PENDING_ACCOUNT_ADVERTISER",
}

/** @default "REGISTRATION_ERROR_CODE_UNSPECIFIED" */
export enum AffiliatesV1RegistrationErrorCode {
  REGISTRATION_ERROR_CODE_UNSPECIFIED = "REGISTRATION_ERROR_CODE_UNSPECIFIED",
  REGISTRATION_ERROR_CODE_MANAGER_NOT_FOUND = "REGISTRATION_ERROR_CODE_MANAGER_NOT_FOUND",
  REGISTRATION_ERROR_CODE_PUBLIC_ID_ALREADY_USED = "REGISTRATION_ERROR_CODE_PUBLIC_ID_ALREADY_USED",
  REGISTRATION_ERROR_CODE_USER_ALREADY_REGISTERED = "REGISTRATION_ERROR_CODE_USER_ALREADY_REGISTERED",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum AffiliatesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_CYCLIC_ACCOUNT_REFERRING = "ERROR_CODE_CYCLIC_ACCOUNT_REFERRING",
  ERROR_CODE_PUBLIC_ID_ALREADY_USED = "ERROR_CODE_PUBLIC_ID_ALREADY_USED",
  ERROR_CODE_REFERRAL_ACCOUNT_NOT_FOUND = "ERROR_CODE_REFERRAL_ACCOUNT_NOT_FOUND",
  ERROR_CODE_SELF_ACCOUNT_REFERRING = "ERROR_CODE_SELF_ACCOUNT_REFERRING",
  ERROR_CODE_TIER_NOT_FOUND = "ERROR_CODE_TIER_NOT_FOUND",
  ERROR_CODE_USER_ALREADY_REGISTERED = "ERROR_CODE_USER_ALREADY_REGISTERED",
  ERROR_CODE_NON_AFFILIATE_ACCOUNT = "ERROR_CODE_NON_AFFILIATE_ACCOUNT",
  ERROR_CODE_SOURCE_NOT_FOUND = "ERROR_CODE_SOURCE_NOT_FOUND",
  ERROR_CODE_NON_AFFILIATE_MANAGER_ACCOUNT = "ERROR_CODE_NON_AFFILIATE_MANAGER_ACCOUNT",
  ERROR_CODE_AFFILIATE_ACCOUNT_NOT_FOUND = "ERROR_CODE_AFFILIATE_ACCOUNT_NOT_FOUND",
  ERROR_CODE_AFFILIATE_MANAGER_ACCOUNT_NOT_FOUND = "ERROR_CODE_AFFILIATE_MANAGER_ACCOUNT_NOT_FOUND",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum AccountsV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_UPDATE_OWN_ACCOUNT_STATUS = "ERROR_CODE_UPDATE_OWN_ACCOUNT_STATUS",
  ERROR_CODE_DELETE_OWN_ACCOUNT = "ERROR_CODE_DELETE_OWN_ACCOUNT",
}

/** @default "ERROR_CODE_UNSPECIFIED" */
export enum AccountNotesV1ErrorCode {
  ERROR_CODE_UNSPECIFIED = "ERROR_CODE_UNSPECIFIED",
  ERROR_CODE_ACCOUNT_NOT_FOUND = "ERROR_CODE_ACCOUNT_NOT_FOUND",
}

export interface AccountNotesV1CreateAccountNoteRequest {
  accountId?: string;
  note?: string;
}

export type AccountNotesV1CreateAccountNoteResponse = object;

export type AccountNotesV1DeleteAccountNoteResponse = object;

export interface AccountNotesV1ListAccountNotesForAccountResponse {
  accountNotes?: AccountNotesV1ListAccountNotesForAccountResponseAccountNote[];
}

export interface AccountNotesV1ListAccountNotesForAccountResponseAccountNote {
  id?: string;
  author?: AccountNotesV1ListAccountNotesForAccountResponseAuthor;
  note?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface AccountNotesV1ListAccountNotesForAccountResponseAuthor {
  accountId?: string;
  name?: string;
}

export interface AccountStatusesV1ListAccountStatusesResponse {
  accountStatuses?: EnumsV1AccountStatus[];
}

export interface AccountsV1Account {
  id?: string;
  roleId?: string;
  status?: EnumsV1AccountStatus;
  email?: string;
  name?: string;
  registrationCountryCode?: string;
  /** @format date-time */
  createdAt?: string;
  primary?: boolean;
  firebaseId?: string;
}

export interface AccountsV1AccountServiceUpdateAccountBody {
  name?: string;
  status?: EnumsV1AccountStatus;
}

export type AccountsV1DeleteAccountResponse = object;

export interface AccountsV1GetAccountResponse {
  account?: AccountsV1Account;
}

export interface AccountsV1GetContactEmailResponse {
  email?: string;
  name?: string;
}

export interface AccountsV1ListAccountsResponse {
  accounts?: AccountsV1Account[];
}

export interface AccountsV1ListAccountsWithSourceResponse {
  accounts?: AccountsV1Account[];
}

export type AccountsV1SetPrimaryAccountResponse = object;

export interface AccountsV1UpdateAccountResponse {
  account?: AccountsV1Account;
}

export interface ActivityLogsV1Account {
  id: string;
  name: string;
}

export interface ActivityLogsV1AdvertiserManuallyCreatedDetail {
  email: string;
  name: string;
}

export interface ActivityLogsV1AffiliateBillingDetailChangedDetail {
  id: string;
  account: ActivityLogsV1Account;
  old: ActivityLogsV1AffiliateBillingDetailChangedDetailEditable;
  new: ActivityLogsV1AffiliateBillingDetailChangedDetailEditable;
}

export interface ActivityLogsV1AffiliateBillingDetailChangedDetailEditable {
  name: string;
  addressLine1: string;
  city: string;
  countryCode: string;
  postalCode: string;
  addressLine2?: string;
  invoicingEmail?: string;
  vat?: string;
}

export interface ActivityLogsV1AffiliateBillingDetailCreatedDetail {
  id: string;
  account: ActivityLogsV1Account;
  name: string;
  addressLine1: string;
  city: string;
  countryCode: string;
  postalCode: string;
  addressLine2?: string;
  invoicingEmail?: string;
  vat?: string;
}

export interface ActivityLogsV1AffiliateManuallyCreatedDetail {
  sourcePublicId: string;
  name: string;
}

export interface ActivityLogsV1AffiliateNoteCreatedDetail {
  id: string;
  account: ActivityLogsV1Account;
  authorAccount: ActivityLogsV1Account;
  note: string;
}

export interface ActivityLogsV1AffiliateNoteDeletedDetail {
  id: string;
  account: ActivityLogsV1Account;
  authorAccount: ActivityLogsV1Account;
  note: string;
}

export interface ActivityLogsV1AffiliatePaymentMethodChangedDetail {
  id: string;
  account: ActivityLogsV1Account;
  old: ActivityLogsV1AffiliatePaymentMethodChangedDetailEditable;
  new: ActivityLogsV1AffiliatePaymentMethodChangedDetailEditable;
}

export interface ActivityLogsV1AffiliatePaymentMethodChangedDetailEditable {
  type: PaymentMethodsV1PaymentMethodType;
  currencyCode: string;
  data: PaymentMethodsV1PaymentMethodData;
}

export interface ActivityLogsV1AffiliatePaymentMethodCreatedDetail {
  id: string;
  account: ActivityLogsV1Account;
  type: PaymentMethodsV1PaymentMethodType;
  currencyCode: string;
  data: PaymentMethodsV1PaymentMethodData;
}

export interface ActivityLogsV1AffiliatePaymentMethodDeletedDetail {
  id: string;
  account: ActivityLogsV1Account;
  type: PaymentMethodsV1PaymentMethodType;
  currencyCode: string;
  data: PaymentMethodsV1PaymentMethodData;
}

export interface ActivityLogsV1ChangedDetail {
  old?: object;
  new?: object;
}

export interface ActivityLogsV1ConversionAmountChangedDetail {
  id: string;
  old: ActivityLogsV1ConversionAmountChangedDetailEditable;
  new: ActivityLogsV1ConversionAmountChangedDetailEditable;
}

export interface ActivityLogsV1ConversionAmountChangedDetailEditable {
  revenue: TypesV1Decimal;
  cost: TypesV1Decimal;
}

export interface ActivityLogsV1ConversionChangedDetail {
  id: string;
  old: object;
  new: object;
}

export interface ActivityLogsV1ConversionStatusChangedDetail {
  id: string;
  old: ActivityLogsV1ConversionStatusChangedDetailEditable;
  new: ActivityLogsV1ConversionStatusChangedDetailEditable;
}

export interface ActivityLogsV1ConversionStatusChangedDetailEditable {
  /** Check all validations on any index update. */
  status: ConversionsV1ConversionStatus;
}

export interface ActivityLogsV1ConversionType {
  id: string;
  name: string;
}

export interface ActivityLogsV1CouponCreatedDetail {
  id: string;
  code: string;
  revenueOriginId: string;
}

export interface ActivityLogsV1CouponDeletedDetail {
  id: string;
  code: string;
  revenueOriginId: string;
}

export interface ActivityLogsV1CouponStatusChangedDetail {
  id: string;
  code: string;
  revenueOriginId: string;
  old: ActivityLogsV1CouponStatusChangedDetailEditable;
  new: ActivityLogsV1CouponStatusChangedDetailEditable;
}

export interface ActivityLogsV1CouponStatusChangedDetailEditable {
  status: CouponsV1CouponStatus;
}

export interface ActivityLogsV1Detail {
  advertiserManuallyCreated?: ActivityLogsV1AdvertiserManuallyCreatedDetail;
  affiliateBillingDetailChanged?: ActivityLogsV1AffiliateBillingDetailChangedDetail;
  affiliateBillingDetailCreated?: ActivityLogsV1AffiliateBillingDetailCreatedDetail;
  affiliateManuallyCreated?: ActivityLogsV1AffiliateManuallyCreatedDetail;
  affiliateNoteCreated?: ActivityLogsV1AffiliateNoteCreatedDetail;
  affiliateNoteDeletedDetail?: ActivityLogsV1AffiliateNoteDeletedDetail;
  affiliatePaymentMethodChanged?: ActivityLogsV1AffiliatePaymentMethodChangedDetail;
  affiliatePaymentMethodCreated?: ActivityLogsV1AffiliatePaymentMethodCreatedDetail;
  affiliatePaymentMethodDeleted?: ActivityLogsV1AffiliatePaymentMethodDeletedDetail;
  conversionAmountChanged?: ActivityLogsV1ConversionAmountChangedDetail;
  conversionChanged?: ActivityLogsV1ConversionChangedDetail;
  conversionStatusChanged?: ActivityLogsV1ConversionStatusChangedDetail;
  couponCreated?: ActivityLogsV1CouponCreatedDetail;
  couponDeleted?: ActivityLogsV1CouponDeletedDetail;
  couponStatusChanged?: ActivityLogsV1CouponStatusChangedDetail;
  directLandingPageChanged?: ActivityLogsV1DirectLandingPageChangedDetail;
  directLandingPageCreated?: ActivityLogsV1DirectLandingPageCreatedDetail;
  directLandingPageDeleted?: ActivityLogsV1DirectLandingPageDeletedDetail;
  offerCreated?: ActivityLogsV1OfferCreatedDetail;
  offerPricingChanged?: ActivityLogsV1ChangedDetail;
  offerStatusChanged?: ActivityLogsV1OfferStatusChangedDetail;
  offerTrackingQualityControlChanged?: ActivityLogsV1OfferTrackingQualityControlChangedDetail;
  postbackTemplateChanged?: ActivityLogsV1PostbackTemplateChangedDetail;
  postbackTemplateCreated?: ActivityLogsV1PostbackTemplateCreatedDetail;
  postbackTemplateDeleted?: ActivityLogsV1PostbackTemplateDeletedDetail;
  redirectLandingPageChanged?: ActivityLogsV1RedirectLandingPageChangedDetail;
  redirectLandingPageCreated?: object;
  redirectLandingPageDeleted?: object;
  revenueOriginTrackingQualityControlChanged?: ActivityLogsV1RevenueOriginTrackingQualityControlChangedDetail;
  settingsAffiliateRegistrationPageNoteChanged?: ActivityLogsV1SettingsAffiliateRegistrationPageNoteChangedDetail;
  settingsAffiliateRegistrationCustomizationChanged?: ActivityLogsV1ChangedDetail;
  settingsAffiliateTrackingLinkSettingsChanged?: ActivityLogsV1ChangedDetail;
  settingsClaimGeneratingChanged?: ActivityLogsV1SettingsClaimGeneratingChangedDetail;
  settingsConversionAmountVisibleChanged?: ActivityLogsV1SettingsConversionAmountVisibleChanged;
  settingsClickTrackingSettingsChanged?: ActivityLogsV1ChangedDetail;
  settingsDashboardNoteChanged?: ActivityLogsV1SettingsDashboardNoteChangedDetail;
  settingsDefaultRegisteredAccountStatusChanged?: ActivityLogsV1SettingsDefaultRegisteredAccountStatusChangedDetail;
  settingsDefaultRegisteredAdvertiserAccountStatusChanged?: ActivityLogsV1ChangedDetail;
  settingsDefaultReportFilteringChanged?: ActivityLogsV1ChangedDetail;
  settingsPaymentMethodForAdvertisersChanged?: ActivityLogsV1SettingsPaymentMethodForAdvertisersChangedDetail;
  settingsReferralChanged?: ActivityLogsV1SettingsReferralChangedDetail;
  settingsRevenueVisibleChanged?: ActivityLogsV1SettingsRevenueVisibleChangedDetail;
  settingsTermsAndConditionsChanged?: ActivityLogsV1SettingsTermsAndConditionsChangedDetail;
  settingsTrackingQualityControlChanged?: ActivityLogsV1ChangedDetail;
  settlementAccountDeleted?: ActivityLogsV1SettlementAccountDeletedDetail;
  settlementCreated?: ActivityLogsV1SettlementCreatedDetail;
  settlementDeleted?: ActivityLogsV1SettlementDeletedDetail;
  webhookCreated?: ActivityLogsV1WebhookCreatedDetail;
  webhookDeleted?: ActivityLogsV1WebhookDeletedDetail;
}

export interface ActivityLogsV1DirectLandingPageChangedDetail {
  id: string;
  publicId: string;
  offer: ActivityLogsV1Offer;
  old: ActivityLogsV1DirectLandingPageChangedDetailEditable;
  new: ActivityLogsV1DirectLandingPageChangedDetailEditable;
}

export interface ActivityLogsV1DirectLandingPageChangedDetailEditable {
  name: string;
  url: string;
  status: LandingPagesV1LandingPageStatus;
}

export interface ActivityLogsV1DirectLandingPageCreatedDetail {
  id: string;
  publicId: string;
  offer: ActivityLogsV1Offer;
  name: string;
  url: string;
  status: LandingPagesV1LandingPageStatus;
}

export interface ActivityLogsV1DirectLandingPageDeletedDetail {
  id: string;
  publicId: string;
  offer: ActivityLogsV1Offer;
  name: string;
  url: string;
  status: LandingPagesV1LandingPageStatus;
}

export interface ActivityLogsV1GetActivityLogResponse {
  activityLog: ActivityLogsV1GetActivityLogResponseActivityLog;
}

export interface ActivityLogsV1GetActivityLogResponseActivityLog {
  id: string;
  activity: EnumsV1Activity;
  account: ActivityLogsV1Account;
  impersonatedAccount?: ActivityLogsV1Account;
  detail: ActivityLogsV1Detail;
  /** @format date-time */
  createdAt: string;
}

export interface ActivityLogsV1ListActivityLogsRequest {
  pagination: TypesV1PaginationRequest;
  timeRange: TypesV1TimeRange;
  activities?: EnumsV1Activity[];
  accountIds?: string[];
}

export interface ActivityLogsV1ListActivityLogsResponse {
  activityLogs: ActivityLogsV1ListActivityLogsResponseActivityLog[];
  pagination: TypesV1PaginationResponse;
}

export interface ActivityLogsV1ListActivityLogsResponseActivityLog {
  id: string;
  activity: EnumsV1Activity;
  account: ActivityLogsV1Account;
  impersonatedAccount?: ActivityLogsV1Account;
  /** @format date-time */
  createdAt: string;
}

export interface ActivityLogsV1Offer {
  id: string;
  name: string;
}

export interface ActivityLogsV1OfferCreatedDetail {
  id: string;
  name: string;
}

export interface ActivityLogsV1OfferStatusChangedDetail {
  id: string;
  name: string;
  old: ActivityLogsV1OfferStatusChangedDetailEditable;
  new: ActivityLogsV1OfferStatusChangedDetailEditable;
}

export interface ActivityLogsV1OfferStatusChangedDetailEditable {
  status: OffersV1Status;
}

export interface ActivityLogsV1OfferTrackingQualityControlChangedDetail {
  id: string;
  name: string;
  old?: object;
  new?: object;
}

export interface ActivityLogsV1PostbackTemplateChangedDetail {
  id: string;
  old: ActivityLogsV1PostbackTemplateChangedDetailEditable;
  new: ActivityLogsV1PostbackTemplateChangedDetailEditable;
}

export interface ActivityLogsV1PostbackTemplateChangedDetailEditable {
  source: ActivityLogsV1Source;
  offersBlacklisted: boolean;
  type: PostbackTemplatesV1PostbackTemplateType;
  conversionStatues: ConversionsV1ConversionStatus[];
  conversionTypes: ActivityLogsV1ConversionType[];
  offers: ActivityLogsV1Offer[];
  params: PostbackTemplatesV1PostbackTemplateParams;
}

export interface ActivityLogsV1PostbackTemplateCreatedDetail {
  id: string;
  source: ActivityLogsV1Source;
  offersBlacklisted: boolean;
  type: PostbackTemplatesV1PostbackTemplateType;
  conversionStatues: ConversionsV1ConversionStatus[];
  conversionTypes: ActivityLogsV1ConversionType[];
  offers: ActivityLogsV1Offer[];
  params: PostbackTemplatesV1PostbackTemplateParams;
}

export interface ActivityLogsV1PostbackTemplateDeletedDetail {
  id: string;
  source: ActivityLogsV1Source;
  offersBlacklisted: boolean;
  type: PostbackTemplatesV1PostbackTemplateType;
  conversionStatues: ConversionsV1ConversionStatus[];
  conversionTypes: ActivityLogsV1ConversionType[];
  offers: ActivityLogsV1Offer[];
  params: PostbackTemplatesV1PostbackTemplateParams;
}

export interface ActivityLogsV1RedirectLandingPageChangedDetail {
  id: string;
  offer: ActivityLogsV1Offer;
  old: object;
  new: object;
}

export interface ActivityLogsV1RevenueOriginTrackingQualityControlChangedDetail {
  id: string;
  name: string;
  old?: object;
  new?: object;
}

export interface ActivityLogsV1SettingsAffiliateRegistrationPageNoteChangedDetail {
  old: ActivityLogsV1SettingsAffiliateRegistrationPageNoteChangedDetailEditable;
  new: ActivityLogsV1SettingsAffiliateRegistrationPageNoteChangedDetailEditable;
}

export interface ActivityLogsV1SettingsAffiliateRegistrationPageNoteChangedDetailEditable {
  note?: string;
}

export interface ActivityLogsV1SettingsClaimGeneratingChangedDetail {
  old: ActivityLogsV1SettingsClaimGeneratingChangedDetailEditable;
  new: ActivityLogsV1SettingsClaimGeneratingChangedDetailEditable;
}

export interface ActivityLogsV1SettingsClaimGeneratingChangedDetailEditable {
  claimGenerating: SettingsV1ClaimGenerating;
}

export interface ActivityLogsV1SettingsConversionAmountVisibleChanged {
  old: ActivityLogsV1SettingsConversionAmountVisibleChangedEditable;
  new: ActivityLogsV1SettingsConversionAmountVisibleChangedEditable;
}

export interface ActivityLogsV1SettingsConversionAmountVisibleChangedEditable {
  visible: boolean;
}

export interface ActivityLogsV1SettingsDashboardNoteChangedDetail {
  old: ActivityLogsV1SettingsDashboardNoteChangedDetailEditable;
  new: ActivityLogsV1SettingsDashboardNoteChangedDetailEditable;
}

export interface ActivityLogsV1SettingsDashboardNoteChangedDetailEditable {
  note?: string;
}

export interface ActivityLogsV1SettingsDefaultRegisteredAccountStatusChangedDetail {
  old: ActivityLogsV1SettingsDefaultRegisteredAccountStatusChangedDetailEditable;
  new: ActivityLogsV1SettingsDefaultRegisteredAccountStatusChangedDetailEditable;
}

export interface ActivityLogsV1SettingsDefaultRegisteredAccountStatusChangedDetailEditable {
  status: EnumsV1AccountStatus;
}

export interface ActivityLogsV1SettingsPaymentMethodForAdvertisersChangedDetail {
  old: ActivityLogsV1SettingsPaymentMethodForAdvertisersChangedDetailEditable;
  new: ActivityLogsV1SettingsPaymentMethodForAdvertisersChangedDetailEditable;
}

export interface ActivityLogsV1SettingsPaymentMethodForAdvertisersChangedDetailEditable {
  paymentMethod?: string;
}

export interface ActivityLogsV1SettingsReferralChangedDetail {
  old: ActivityLogsV1SettingsReferralChangedDetailEditable;
  new: ActivityLogsV1SettingsReferralChangedDetailEditable;
}

export interface ActivityLogsV1SettingsReferralChangedDetailEditable {
  enabled: boolean;
  commissionRates: TypesV1Decimal[];
}

export interface ActivityLogsV1SettingsRevenueVisibleChangedDetail {
  old: ActivityLogsV1SettingsRevenueVisibleChangedDetailEditable;
  new: ActivityLogsV1SettingsRevenueVisibleChangedDetailEditable;
}

export interface ActivityLogsV1SettingsRevenueVisibleChangedDetailEditable {
  visible: boolean;
}

export interface ActivityLogsV1SettingsTermsAndConditionsChangedDetail {
  old: ActivityLogsV1SettingsTermsAndConditionsChangedDetailEditable;
  new: ActivityLogsV1SettingsTermsAndConditionsChangedDetailEditable;
}

export interface ActivityLogsV1SettingsTermsAndConditionsChangedDetailEditable {
  text?: string;
}

export interface ActivityLogsV1SettlementAccountDeletedDetail {
  id: string;
  settlementId: string;
  account: ActivityLogsV1Account;
}

export interface ActivityLogsV1SettlementCreatedDetail {
  id: string;
  accounts: ActivityLogsV1Account[];
  note: string;
}

export interface ActivityLogsV1SettlementDeletedDetail {
  id: string;
  accounts: ActivityLogsV1Account[];
  note: string;
}

export interface ActivityLogsV1Source {
  id: string;
  publicId: string;
}

export interface ActivityLogsV1WebhookCreatedDetail {
  id: string;
  url: string;
  eventTypes: WebhooksV1EventType[];
}

export interface ActivityLogsV1WebhookDeletedDetail {
  id: string;
  url: string;
  eventTypes: WebhooksV1EventType[];
}

export interface AdvertisersV1Advertiser {
  /** @format date-time */
  registeredAt: string;
  accountId: string;
  revenueOriginId: string;
  email: string;
  name: string;
  status: EnumsV1AccountStatus;
  revenueOriginStatus: EnumsV1RevenueOriginStatus;
  /** Billing details of the advertiser. */
  billingDetail: RevenueOriginsV1RevenueOriginBillingDetail;
  adminNote: string;
  registrationCountryCode?: string;
  ipAddress?: string;
}

export interface AdvertisersV1AdvertiserServiceUpdateAdvertiserBody {
  name: string;
  status: EnumsV1AccountStatus;
  revenueOriginStatus: EnumsV1RevenueOriginStatus;
  /** Billing details of the advertiser. */
  billingDetail: RevenueOriginsV1RevenueOriginBillingDetail;
  adminNote?: string;
}

export interface AdvertisersV1AdvertisersFilters {
  /** @format date-time */
  registeredFrom?: string;
  /** @format date-time */
  registeredTo?: string;
  revenueOriginIds?: string[];
  emails?: string[];
  name?: string;
  statuses?: EnumsV1AccountStatus[];
  revenueOriginStatuses?: EnumsV1RevenueOriginStatus[];
  registrationCountryCodes?: string[];
  accountIds?: string[];
}

export type AdvertisersV1DeleteAdvertiserResponse = object;

export interface AdvertisersV1GetAdvertiserResponse {
  advertiser: AdvertisersV1Advertiser;
}

export interface AdvertisersV1ListAdvertisersRequest {
  pagination?: TypesV1OptionalPaginationRequest;
  filters?: AdvertisersV1AdvertisersFilters;
}

export interface AdvertisersV1ListAdvertisersResponse {
  advertisers: AdvertisersV1Advertiser[];
  pagination: TypesV1PaginationResponse;
}

export interface AdvertisersV1RegisterAdvertiserRequest {
  name: string;
  /** Billing details of the advertiser. */
  billingDetail: RevenueOriginsV1RevenueOriginBillingDetail;
}

export type AdvertisersV1RegisterAdvertiserResponse = object;

export interface AdvertisersV1RegisterAdvertiserWithExistingRevenueOriginRequest {
  email: string;
  password?: string;
  name: string;
  status: EnumsV1AccountStatus;
  revenueOriginId: string;
  shouldSendWelcomeEmail?: boolean;
}

export type AdvertisersV1RegisterAdvertiserWithExistingRevenueOriginResponse =
  object;

export interface AdvertisersV1RegisterAdvertiserWithUserRequest {
  email: string;
  password?: string;
  name: string;
  status: EnumsV1AccountStatus;
  /** Billing details of the advertiser. */
  billingDetail: RevenueOriginsV1RevenueOriginBillingDetail;
  shouldSendWelcomeEmail?: boolean;
}

export type AdvertisersV1RegisterAdvertiserWithUserResponse = object;

export interface AdvertisersV1UpdateAdvertiserResponse {
  advertiser: AdvertisersV1Advertiser;
}

export interface AffiliateManagersV1AffiliateManager {
  /** @format date-time */
  registeredAt: string;
  email: string;
  name: string;
  status: EnumsV1AccountStatus;
  accountId: string;
  isSuperManager?: boolean;
}

export interface AffiliateManagersV1AffiliateManagerServiceAssignAffiliatesBody {
  affiliateAccountIds?: string[];
}

export interface AffiliateManagersV1AffiliateManagerServiceUnassignAffiliateBody {
  affiliateAccountId?: string;
}

export type AffiliateManagersV1AssignAffiliatesResponse = object;

export interface AffiliateManagersV1BulkUpdateAffiliateManagersRequest {
  accountIds?: string[];
  status?: EnumsV1AccountStatus;
}

export type AffiliateManagersV1BulkUpdateAffiliateManagersResponse = object;

export interface AffiliateManagersV1CreateAffiliateManagerWithUserRequest {
  email?: string;
  password?: string;
  name?: string;
  status?: EnumsV1AccountStatus;
  isSuperManager?: boolean;
}

export type AffiliateManagersV1CreateAffiliateManagerWithUserResponse = object;

export interface AffiliateManagersV1GetAffiliateManagerResponse {
  affiliateManager: AffiliateManagersV1AffiliateManager;
}

export interface AffiliateManagersV1ListAffiliateManagersRequest {
  /** optional */
  pagination?: TypesV1OptionalPaginationRequest;
  /** optional */
  filters?: AffiliateManagersV1ListAffiliateManagersRequestFilters;
}

export interface AffiliateManagersV1ListAffiliateManagersRequestFilters {
  registeredTimeRange?: TypesV1TimeRange;
  emails?: string[];
  name?: string;
  statuses?: EnumsV1AccountStatus[];
  isSuperManager?: boolean;
}

export interface AffiliateManagersV1ListAffiliateManagersResponse {
  affiliateManagers: AffiliateManagersV1AffiliateManager[];
  pagination: TypesV1PaginationResponse;
}

export interface AffiliateManagersV1ListAssignedAffiliatesResponse {
  affiliates: AffiliateManagersV1ListAssignedAffiliatesResponseAffiliate[];
}

export interface AffiliateManagersV1ListAssignedAffiliatesResponseAffiliate {
  accountId: string;
  name: string;
  /** @format date-time */
  assignedAt: string;
}

export type AffiliateManagersV1UnassignAffiliateResponse = object;

/** Affiliate */
export interface AffiliatesV1Affiliate {
  /**
   * Timestamp of the date of affiliate's registration.
   * @format date-time
   */
  registeredAt?: string;
  /** Public ID of the affiliate. */
  publicId?: string;
  /** Email of the affiliate. */
  email?: string;
  /** Full name of the affiliate. */
  name?: string;
  /** Status of the affiliate. */
  status?: EnumsV1AccountStatus;
  /** Identifier of the current tier to which the affiliate is assigned. */
  tierId?: string;
  /** Name of the tier to which the affiliate is assigned. */
  tierName?: string;
  /** Country from which the original affiliate registration came in. Uses ISO-3166 three letter format. */
  registrationCountryCode?: string;
  /** Identifier of the account of the affiliate, useful for getting information about billing details and other information. */
  accountId?: string;
  /** Traffic source ID. */
  sourceId?: string;
  /** Traffic source status. */
  sourceStatus?: SourcesV1SourceStatus;
  /** Designates if the affiliate is currently flagged by the fraud suspicion system. */
  fraudSuspicion?: TypesV1FraudSuspicion;
  /** IP address from which the original registration came through. */
  ipAddress?: string;
  /** Parent affiliate (for MLM). */
  referralAccount?: AffiliatesV1AffiliateReferralAccount;
  /** Default redirect domain for affiliate. */
  defaultRedirectDomain?: string;
  /** Manager account. */
  managerAccount?: AffiliatesV1AffiliateManagerAccount;
}

export interface AffiliatesV1AffiliateManagerAccount {
  /** Unique ID of the manager. */
  id?: string;
  /** Full name of the manager. */
  name?: string;
  /**
   * Timestamp of the date when the affiliate was assigned to the manager.
   * @format date-time
   */
  assignedAt?: string;
}

/** Referral account is the affiliate's unique identifier used throughout the system. */
export interface AffiliatesV1AffiliateReferralAccount {
  /** Unique ID of the affiliate. */
  id?: string;
  /** Full name of the affiliate. */
  name?: string;
}

export interface AffiliatesV1AffiliateRegistrationData {
  telephone?: string;
  /** optional */
  messenger?: TypesV1Messenger;
  websiteUrl?: string;
  promotionChannels?: string;
  audience?: string;
  currentTraffic?: string;
  expectedTraffic?: string;
  affiliateType?: string;
  previousExperience?: string;
  customQuestionAnswers?: TypesV1CustomQuestionAnswer[];
}

export interface AffiliatesV1AffiliateRegistrationFormSettings {
  billingDetails?: boolean;
  telephone?: EnumsV1QuestionVisibility;
  messenger?: EnumsV1QuestionVisibility;
  websiteUrl?: EnumsV1QuestionVisibility;
  promotionChannels?: EnumsV1QuestionVisibility;
  audience?: EnumsV1QuestionVisibility;
  currentTraffic?: EnumsV1QuestionVisibility;
  expectedTraffic?: EnumsV1QuestionVisibility;
  affiliateType?: EnumsV1QuestionVisibility;
  previousExperience?: EnumsV1QuestionVisibility;
  customQuestions?: TypesV1CustomQuestionSettings[];
}

export interface AffiliatesV1AffiliateServiceSetAffiliateDefaultRedirectDomainBody {
  defaultRedirectDomain?: string;
}

export interface AffiliatesV1AffiliateServiceSetAffiliateReferralAccountBody {
  referralAccountId?: string;
}

/** Set affiliate status. */
export interface AffiliatesV1AffiliateServiceSetAffiliateStatusBody {
  /**
   * Traffic source public ID.
   * Traffic source public ID.
   */
  sourcePublicId: object;
  /** New status to be set for the affiliate. */
  status: EnumsV1AccountStatus;
}

/** Set affiliate tier. */
export interface AffiliatesV1AffiliateServiceSetAffiliateTierBody {
  /**
   * Public ID of affiliate to be updated.
   * Public ID of affiliate to be updated.
   */
  sourcePublicId: object;
  /** Identifier of the new tier to be applied to the affiliate. */
  tierId: string;
}

/** Update affiliate */
export interface AffiliatesV1AffiliateServiceUpdateAffiliateBody {
  /** Full name of the affiliate. */
  name?: string;
  /** Status of the affiliate. */
  status?: EnumsV1AccountStatus;
  /** Traffic source tier ID of the affiliate. */
  tierId?: string;
  /** Traffic source status of the affiliate. */
  sourceStatus?: SourcesV1SourceStatus;
}

/** Filters available for affiliates. */
export interface AffiliatesV1AffiliatesFilters {
  /**
   * Timestamp of the date of affiliate's registration, start date of filtered results.
   * @format date-time
   */
  registeredFrom?: string;
  /**
   * Timestamp of the date of affiliate's registration, end date of filtered results.
   * @format date-time
   */
  registeredTo?: string;
  /** Public ID's of affiliates to be filtered. */
  publicIds?: string[];
  /** Emails of the affiliates to be filtered. */
  emails?: string[];
  /** Name of affiliates to be filtered. */
  name?: string;
  /** Specific affiliate statuses to be filtered. */
  statuses?: EnumsV1AccountStatus[];
  /** Specific tiers in which affiliates are present. */
  tierIds?: string[];
  /** Country codes of affiliates to be filtered. Uses ISO-3166, three letter formatting. */
  registrationCountryCodes?: string[];
  /** Traffic source status. */
  sourceStatuses?: SourcesV1SourceStatus[];
  /** Parent affiliate. */
  referralAccountIds?: string[];
  /** Filters affiliates who are flagged by the fraud detection system. */
  fraudSuspicion?: TypesV1FraudSuspicionFilter;
  /** Filters affiliates assigned to specific managers. */
  managerAccountIds?: string[];
  /** Filters affiliates assigned to any manager. */
  assignedToManager?: boolean;
  /** Filters affiliates by specific account IDs. */
  accountIds?: string[];
}

/** Bulk update affiliates. */
export interface AffiliatesV1BulkUpdateAffiliatesRequest {
  /** Optional: Update accounts in bulk. */
  account?: AffiliatesV1BulkUpdateAffiliatesRequestAccount;
  /** Optional: Update traffic sources in bulk. */
  source?: AffiliatesV1BulkUpdateAffiliatesRequestSource;
  /** Optional: Update affiliate manager in bulk. */
  affiliateManager?: AffiliatesV1BulkUpdateAffiliatesRequestAffiliateManager;
}

/** Account */
export interface AffiliatesV1BulkUpdateAffiliatesRequestAccount {
  /** Status of the account. */
  status?: EnumsV1AccountStatus;
  /** Filter for specified account IDs. Only accounts with specified ID will be altered. */
  accountIds?: string[];
}

/** Affiliate manager */
export interface AffiliatesV1BulkUpdateAffiliatesRequestAffiliateManager {
  /** Account of the affiliate manager. */
  affiliateManagerAccountId?: string;
  /** Filter for specified affiliate account IDs. Only accounts with specified ID will be altered. */
  affiliateAccountIds: string[];
}

/** Traffic source */
export interface AffiliatesV1BulkUpdateAffiliatesRequestSource {
  /** Status of the traffic source. */
  status?: SourcesV1SourceStatus;
  /** Tier of the traffic source. */
  tierId?: string;
  /** Filter for specified source IDs. Only sources with specified ID will be altered. */
  sourceIds?: string[];
}

/** Feedback message for the updated affiliates. */
export type AffiliatesV1BulkUpdateAffiliatesResponse = object;

/** Deletion request response. */
export type AffiliatesV1DeleteAffiliateResponse = object;

/** Export affiliate's data */
export interface AffiliatesV1ExportAffiliatesRequest {
  /** Filters to be applied to get specific affiliates. */
  filters?: AffiliatesV1AffiliatesFilters;
  /** Affiliate export configuration. */
  config?: ExportV1Export;
  /** Affiliate export scope. */
  scope?: ExportV1Scope;
}

/** Export of the affiliate's data per request specification. */
export interface AffiliatesV1ExportAffiliatesResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

/** Registration data of requested affiliate. */
export interface AffiliatesV1GetAffiliateRegistrationDataResponse {
  data?: AffiliatesV1AffiliateRegistrationData;
}

export interface AffiliatesV1GetAffiliateRegistrationFormResponse {
  form?: AffiliatesV1AffiliateRegistrationFormSettings;
}

/** Details of the requested affiliate. */
export interface AffiliatesV1GetAffiliateResponse {
  affiliate?: AffiliatesV1Affiliate;
}

/** List affiliates in the system */
export interface AffiliatesV1ListAffiliatesRequest {
  /** Pagination offset of the listed affiliates. */
  pagination?: TypesV1OptionalPaginationRequest;
  /** Additional filters to be applied. */
  filters?: AffiliatesV1AffiliatesFilters;
}

/** List of affiliates matching the pagination and filters */
export interface AffiliatesV1ListAffiliatesResponse {
  affiliates?: AffiliatesV1Affiliate[];
  pagination: TypesV1PaginationResponse;
}

export interface AffiliatesV1ListSubAffiliatesRequest {
  /** Pagination offset of the listed affiliates. */
  pagination?: TypesV1OptionalPaginationRequest;
}

/** List of sub-affiliates */
export interface AffiliatesV1ListSubAffiliatesResponse {
  affiliates?: AffiliatesV1ListSubAffiliatesResponseSubAffiliate[];
  pagination: TypesV1PaginationResponse;
}

/** Sub-affiliate */
export interface AffiliatesV1ListSubAffiliatesResponseSubAffiliate {
  /**
   * Timestamp of the date of affiliate's registration.
   * @format date-time
   */
  registeredAt?: string;
  /** Public ID of the affiliate. */
  publicId?: string;
  /** Email of the affiliate. */
  email?: string;
  /** Full name of the affiliate. */
  name?: string;
  /** Status of the affiliate. */
  status?: EnumsV1AccountStatus;
  /** Country from which the original affiliate registration came in. Uses ISO-3166 three letter format. */
  registrationCountryCode?: string;
  /** Traffic source status. */
  sourceStatus?: SourcesV1SourceStatus;
}

export interface AffiliatesV1RegisterAffiliateRequest {
  name?: string;
  /** Only lowercase alphanumeric characters allowed. */
  publicId?: TypesV1SourcePublicId;
  billingDetail?: BillingDetailsV1BillingDetail;
  data?: AffiliatesV1AffiliateRegistrationData;
  referralAccountId?: string;
  managerAccountId?: string;
}

export type AffiliatesV1RegisterAffiliateResponse = object;

/** Create new affiliate */
export interface AffiliatesV1RegisterAffiliateWithUserRequest {
  /** Affiliate's email */
  email?: string;
  /** Password to be set for the affiliate by default. */
  password?: string;
  /** Full name of the affiliate. */
  name?: string;
  /** Creates a unique public identifier for the affiliate. */
  publicId?: TypesV1SourcePublicId;
  /** Status of the affiliate. Designates if the system counts incoming traffic from the affiliate see [this article](https://help.trackdesk.com/en/articles/6495339-affiliate-statuses) for more details. */
  status?: EnumsV1AccountStatus;
  /** Creates a unique referral identifier for the affiliate. This parameter cannot be changed later on. */
  referralAccountId?: string;
  /** Designates if a welcome mail with login link should be sent to the affiliate on creation. */
  shouldSendWelcomeEmail?: boolean;
}

/** Feedback message about the creation of a new affiliate. */
export type AffiliatesV1RegisterAffiliateWithUserResponse = object;

export type AffiliatesV1SetAffiliateDefaultRedirectDomainResponse = object;

export interface AffiliatesV1SetAffiliateReferralAccountResponse {
  referralAccountId?: string;
}

/** Feedback message about new status assignment. */
export interface AffiliatesV1SetAffiliateStatusResponse {
  status: EnumsV1AccountStatus;
}

/** Feedback message about assigning of a different affiliate tier. */
export interface AffiliatesV1SetAffiliateTierResponse {
  tierId?: string;
}

export interface AffiliatesV1UpdateAffiliateRegistrationFormSettingsRequest {
  settings: AffiliatesV1AffiliateRegistrationFormSettings;
}

export interface AffiliatesV1UpdateAffiliateRegistrationFormSettingsResponse {
  settings: AffiliatesV1AffiliateRegistrationFormSettings;
}

/** Details of the updated affiliate. */
export interface AffiliatesV1UpdateAffiliateResponse {
  affiliate?: AffiliatesV1Affiliate;
}

export interface AlbatoIntegrationsV1RetrieveAlbatoIntegrationsSessionTokenResponse {
  token: string;
}

export type AnuraV1ProcessAnuraScriptClickIdResponse = object;

export interface AuthenticationV1Account {
  id?: string;
  name?: string;
  role?: AuthenticationV1AccountRole;
  hasOwnSources?: boolean;
  referralEnabled?: boolean;
}

export interface AuthenticationV1AccountRole {
  id?: string;
  name?: string;
  permissions?: EnumsV1Permission[];
}

export interface AuthenticationV1GetAccountResponse {
  account?: AuthenticationV1Account;
  quickSetupDone?: boolean;
}

export interface AuthenticationV1GetImpersonableAccountsResponse {
  accounts?: AuthenticationV1ImpersonableAccount[];
}

export interface AuthenticationV1ImpersonableAccount {
  id?: string;
  email?: string;
  role?: AuthenticationV1ImpersonableAccountRole;
}

export interface AuthenticationV1ImpersonableAccountRole {
  id?: string;
  name?: string;
}

export interface BillingV1AccountSettlement {
  /** Unique ID of the account settlement. */
  id?: string;
  /** Unique ID of an account associated with the settlement. */
  accountId?: string;
  /** Settlement amount. */
  amount?: TypesV1Decimal;
  /** Currency of the settlement. */
  currency?: TypesV1Currency;
  /** Name of the account. */
  accountName?: string;
  /** Billing details for the settlement. */
  billingDetail?: BillingV1AccountSettlementBillingDetail;
  /** Payment method used for the settlement. */
  paymentMethod?: BillingV1AccountSettlementPaymentMethod;
  /**
   * Creation timestamp.
   * @format date-time
   */
  createdAt?: string;
  /** List of amounts in original currencies. */
  originalCurrencyAmounts?: BillingV1AccountSettlementAmount[];
  /** Billing details for the tenant. */
  tenantBillingDetail?: SettingsV1BillingDetail;
  /**
   * Time until which all yet unsettled items were included into the settlement.
   * @format date-time
   */
  settledUntil?: string;
  /** Payment data associated with the settlement. */
  paymentData?: BillingV1AccountSettlementPaymentData;
}

/** Amount contains details about the settlement amount. */
export interface BillingV1AccountSettlementAmount {
  /** Amount value. */
  amount?: TypesV1Decimal;
  /** Currency of the amount. */
  currency?: TypesV1Currency;
  /** Exchange rate applied. */
  exchangeRate?: TypesV1Decimal;
  /** Earning type associated with the amount. */
  earningType?: BillingV1EarningType;
}

/** BillingDetail contains billing-related information. */
export interface BillingV1AccountSettlementBillingDetail {
  /** Name associated with the billing detail. */
  name?: string;
  /** First line of the address. */
  addressLine1?: string;
  /** City of the address. */
  city?: string;
  /** Country code of the address. */
  countryCode?: string;
  /** Postal code of the address. */
  postalCode?: string;
  /** Second line of the address (optional). */
  addressLine2?: string;
  /** Invoicing email (optional). */
  invoicingEmail?: string;
  /** VAT number (optional). */
  vat?: string;
}

/** PaymentData contains payment-related information. */
export interface BillingV1AccountSettlementPaymentData {
  /** Tipalti payment data. */
  tipalti?: BillingV1AccountSettlementPaymentDataTipaltiPaymentData;
}

/** TipaltiPaymentData holds details specific to Tipalti payments. */
export interface BillingV1AccountSettlementPaymentDataTipaltiPaymentData {
  /**
   * List of payment instructions.
   *
   * Each instruction represents a payment attempt made by Tipalti system.
   * For more information about the containing data you can check the Tipalti documentation: https://documentation.tipalti.com/reference/get_api-v1-payment-batches-id-instructions
   */
  paymentInstructions?: BillingV1AccountSettlementPaymentDataTipaltiPaymentDataPaymentInstruction[];
}

export interface BillingV1AccountSettlementPaymentDataTipaltiPaymentDataPaymentInstruction {
  /** Unique identifier for the payment batch. */
  paymentBatchId?: string;
  /** Indicates if the payee is payable. */
  payeeIsPayable?: boolean;
  /** Status of the instruction. */
  instructionStatus?: string;
  /** Status of the payment. */
  paymentStatus?: string;
  /**
   * List of errors in the payment instruction.
   *
   * Provides details on errors within a payment instruction as received from Tipalti.
   * For more information you can check Tipalti documentation: https://documentation.tipalti.com/reference/http-status-codes#api-error-object
   */
  errors?: BillingV1AccountSettlementPaymentDataTipaltiPaymentDataPaymentInstructionError[];
}

export interface BillingV1AccountSettlementPaymentDataTipaltiPaymentDataPaymentInstructionError {
  /** Error code. */
  code?: string;
  /** Error message. */
  message?: string;
  /** Documentation URL. */
  docUrl?: string;
  /** Type of error. */
  type?: string;
}

/** PaymentMethod contains payment method details. */
export interface BillingV1AccountSettlementPaymentMethod {
  /** Type of the payment method. */
  type?: PaymentMethodsV1PaymentMethodType;
  /** Currency code for the payment method. */
  currencyCode?: string;
  /** Data associated with the payment method. */
  data?: PaymentMethodsV1PaymentMethodData;
}

export type BillingV1DeleteAccountSettlementResponse = object;

export type BillingV1DeleteSettlementResponse = object;

export interface BillingV1ExportSettlementForMassPaymentResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

export interface BillingV1ExportSettlementResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

export interface BillingV1GetBalancesForAccountResponse {
  /** Total balance generated from approved conversions. */
  conversionOpenBalance: TypesV1Decimal;
  /** Total balance generated from on-hold conversions. */
  conversionOnHoldBalance: TypesV1Decimal;
  /** Total balance generated from approved MLM commissions. */
  commissionOpenBalance: TypesV1Decimal;
  /** Total balance generated from on-hold MLM commissions. */
  commissionOnHoldBalance: TypesV1Decimal;
  /** Sum of balance generated from approved conversions and MLM commissions. */
  openBalance: TypesV1Decimal;
  /** Sum of balance generated from on-hold conversions and MLM commissions. */
  onHoldBalance: TypesV1Decimal;
  /** Total settled balance. */
  settledBalance: TypesV1Decimal;
}

/** Details of the requested settlement */
export interface BillingV1GetSettlementResponse {
  /** Details of the settlement */
  settlement?: BillingV1Settlement;
  /** Details of account settlements of affiliates */
  accountSettlements?: BillingV1AccountSettlement[];
}

export interface BillingV1ListAccountSettlementsResponse {
  /** Individual affiliate settlements. */
  accountSettlements?: BillingV1AccountSettlement[];
  /** Pagination. */
  pagination: TypesV1PaginationResponse;
}

export interface BillingV1ListOpenBalancesRequest {
  pagination?: TypesV1PaginationRequest;
  filter?: BillingV1OpenBalanceFilter;
}

export interface BillingV1ListOpenBalancesResponse {
  balances: BillingV1ListOpenBalancesResponseBalance[];
  pagination: TypesV1PaginationResponse;
}

export interface BillingV1ListOpenBalancesResponseBalance {
  /** ID of the affiliate to whom the open balnce is credited. */
  accountId: string;
  /** Name of the affiliate to whom the open balance is credited. */
  name: string;
  /** Total amount of payout sourced from approved conversions. */
  conversionOpenBalance: TypesV1Decimal;
  /** Total amount of payout sourced from on-hold conversions. */
  conversionOnHoldBalance: TypesV1Decimal;
  /** Total amount of payout sourced from approved MLM commissions. */
  commissionOpenBalance: TypesV1Decimal;
  /** Total amount of payout sourced from on-hold MLM commissions. */
  commissionOnHoldBalance: TypesV1Decimal;
  /** Total amount of payout sourced from approved conversions and MLM commissions. */
  openBalance: TypesV1Decimal;
  /** Total amount of payout sourced from on-hold conversions and MLM commissions. */
  onHoldBalance: TypesV1Decimal;
  /** Payment menthod affiliate has selected as default. */
  defaultPaymentMethodType: PaymentMethodsV1PaymentMethodType;
  /** Denotes if affiliate has filled their billing details. */
  hasBillingDetails: boolean;
}

export interface BillingV1ListSettlementsResponse {
  /** List all existing settlements. */
  settlements?: BillingV1Settlement[];
  /** Pagination. */
  pagination: TypesV1PaginationResponse;
}

export interface BillingV1OpenBalanceFilter {
  /**
   * Day until which the settlement is settled.
   * @format date-time
   */
  until?: string;
  /** Minimium amount of open balance required for generation of affiliate settlement. */
  minAmount?: TypesV1Decimal;
  /** Payment methods used for the settlement. */
  defaultPaymentMethodTypes?: PaymentMethodsV1PaymentMethodType[];
}

export interface BillingV1SettleBalancesRequest {
  /** Filter the open balance that shloud be used to create settlement. */
  filter?: BillingV1OpenBalanceFilter;
  /** Affiliate IDs for which to create settlement. */
  accountIds?: string[];
  /** Optional note for created settlement. */
  note?: string;
}

export interface BillingV1SettleBalancesResponse {
  /** ID of the settlement as a whole. */
  id?: string;
  /** Total amount payable for the entire settlement. */
  amount?: TypesV1Decimal;
  /** Currency used in the settlement. */
  currency?: TypesV1Currency;
  /**
   * Settled until day.
   * @format date-time
   */
  until?: string;
  /** Optional note for the settlements. */
  note?: string;
  /** Individual affiliate settlements generated within the entire settlement. */
  accountSettlements?: BillingV1SettleBalancesResponseAccountSettlement[];
  /** Error messages for individual affiliate settlements. */
  errors?: BillingV1SettleBalancesResponseAccountSettlementError[];
}

export interface BillingV1SettleBalancesResponseAccountSettlement {
  /** ID of the settlement created for specific affiliate. */
  id?: string;
  /** ID of the affiliate for whom the settlement was created. */
  accountId?: string;
  /** Total payout created in the settlement. */
  amount?: TypesV1Decimal;
  /** Currency used for the settlement. */
  currency?: TypesV1Currency;
}

export interface BillingV1SettleBalancesResponseAccountSettlementError {
  /** ID of the affiliate. */
  accountId?: string;
  /** Error message generated by the system. */
  error?: string;
}

export interface BillingV1Settlement {
  /** Unique identifier for the settlement. */
  id?: string;
  /** Settlement amount. */
  amount?: TypesV1Decimal;
  /** Currency of the settlement. */
  currency?: TypesV1Currency;
  /**
   * Expiration time of the settlement.
   * @format date-time
   */
  until?: string;
  /** Additional notes. */
  note?: string;
  /**
   * Creation timestamp.
   * @format date-time
   */
  createdAt?: string;
  /**
   * Count of account settlements.
   * @format int64
   */
  accountSettlementsCount?: number;
  /** Billing details for the tenant. */
  tenantBillingDetail?: SettingsV1BillingDetail;
  /** Payment data associated with the settlement. */
  paymentData?: BillingV1SettlementPaymentData;
}

/** Payment data associated with the settlement. */
export interface BillingV1SettlementPaymentData {
  /** Tipalti payment data holds details specific to Tipalti payments. */
  tipalti?: BillingV1SettlementPaymentDataTipaltiPaymentData;
}

/** Tipalti payment data holds details specific to Tipalti payments. */
export interface BillingV1SettlementPaymentDataTipaltiPaymentData {
  /**
   * List of payment batches.
   *
   * PaymentBatch represents a batch of payments sent to Tipalti system.
   * For more information about the containing data you can check the Tipalti documentation: https://documentation.tipalti.com/reference/get_api-v1-payment-batches-id
   */
  paymentBatches?: BillingV1SettlementPaymentDataTipaltiPaymentDataPaymentBatch[];
}

export interface BillingV1SettlementPaymentDataTipaltiPaymentDataPaymentBatch {
  /** Unique identifier for the payment batch. */
  paymentBatchId?: string;
  /** Name of the payment batch. */
  name?: string;
  /** Status of the payment batch. */
  status?: string;
  /** Indicates if the batch is valid for submission. */
  isValidForSubmission?: boolean;
  /** Time of submission. */
  submissionTime?: string;
  /**
   * List of errors in the payment batch.
   *
   * Error provides details on errors within a payment batch as received from Tipalti.
   * For more information you can check Tipalti documentation: https://documentation.tipalti.com/reference/http-status-codes#api-error-object
   */
  errors?: BillingV1SettlementPaymentDataTipaltiPaymentDataPaymentBatchError[];
  /**
   * Time after which inspection is possible.
   * @format date-time
   */
  inspectionPossibleAfter?: string;
}

export interface BillingV1SettlementPaymentDataTipaltiPaymentDataPaymentBatchError {
  /** Error code. */
  code?: string;
  /** Error message. */
  message?: string;
  /** Documentation URL. */
  docUrl?: string;
  /** Parameter causing the error. */
  parameter?: string;
}

export interface BillingV1SettlementServiceExportSettlementBody {
  config?: ExportV1Export;
  paymentMethodTypes?: PaymentMethodsV1PaymentMethodType[];
}

export interface BillingV1SettlementServiceExportSettlementForMassPaymentBody {
  paymentMethodType?: PaymentMethodsV1PaymentMethodType;
}

export interface BillingV1SummarizeOpenBalancesByPaymentMethodRequest {
  filter?: BillingV1OpenBalanceFilter;
}

export interface BillingV1SummarizeOpenBalancesByPaymentMethodResponse {
  balances: BillingV1SummarizeOpenBalancesByPaymentMethodResponseBalance[];
}

export interface BillingV1SummarizeOpenBalancesByPaymentMethodResponseBalance {
  defaultPaymentMethodType: PaymentMethodsV1PaymentMethodType;
  openBalance: TypesV1Decimal;
  onHoldBalance: TypesV1Decimal;
}

/** Billing detail */
export interface BillingDetailsV1BillingDetail {
  /** Unique identifier of the billing detail */
  id?: string;
  /** Account for which the billing details are set. Commonly used for identifying details of affiliates. */
  accountId?: string;
  /** Full name present on the billing details */
  name?: string;
  /** First line of the address */
  addressLine1?: string;
  /** City of the address */
  city?: string;
  /** Country code for the address. Uses ISO-3166, two letter formatting. */
  countryCode?: string;
  /** Subdivision code for the address. Uses ISO 3166-2, two letter formatting. */
  subdivisionCode?: string;
  /** Postal code of the address */
  postalCode?: string;
  /** Second line of the address */
  addressLine2?: string;
  /** Email used for invoicing */
  invoicingEmail?: string;
  /** VAT information */
  vat?: string;
}

/** Billing details of associated account */
export interface BillingDetailsV1GetBillingDetailByAccountResponse {
  billingDetail?: BillingDetailsV1BillingDetail;
}

/** Details of the requested billing detail */
export interface BillingDetailsV1GetBillingDetailResponse {
  billingDetail?: BillingDetailsV1BillingDetail;
}

/** Set billing details */
export interface BillingDetailsV1SetBillingDetailRequest {
  /** Identifier of the account */
  accountId?: string;
  /** Full name on the billing details */
  name?: string;
  /** First line of the address */
  addressLine1?: string;
  /** City of the address */
  city?: string;
  /** Country code for the address. Uses ISO-3166, two letter formatting. */
  countryCode?: string;
  /** Subdivision code for the address. Uses ISO-3166-2, two letter formatting. */
  subdivisionCode?: string;
  /** Postal code of the address */
  postalCode?: string;
  /** Second line of the address */
  addressLine2?: string;
  /** Email used for invoicing */
  invoicingEmail?: string;
  /** VAT information */
  vat?: string;
}

/** Feedback message for update of billing details. */
export interface BillingDetailsV1SetBillingDetailResponse {
  billingDetail?: BillingDetailsV1BillingDetail;
}

export interface CategoriesV1CategoriesServiceUpdateCategoryBody {
  name: string;
}

export interface CategoriesV1Category {
  id: string;
  name: string;
}

export interface CategoriesV1CreateCategoryRequest {
  name: string;
}

export interface CategoriesV1CreateCategoryResponse {
  category: CategoriesV1Category;
}

export type CategoriesV1DeleteCategoryResponse = object;

export interface CategoriesV1ListCategoriesResponse {
  categories?: CategoriesV1Category[];
}

export interface CategoriesV1UpdateCategoryResponse {
  category: CategoriesV1Category;
}

/** Click */
export interface ClicksV1Click {
  /** Internal identifer of a click. */
  id?: string;
  /** Unique identifer of a click. This parameter is used when creating new conversions. */
  cid?: string;
  /**
   * Timestamp of click's creation date.
   * @format date-time
   */
  createdAt?: string;
  /** URL of the origin of the incoming click. */
  requestUrl?: string;
  /** Browser, OS and device. */
  userAgent?: string;
  /** IP address from which the click was registered. */
  ipAddress?: string;
  /** Affiliate who gets credited with the incoming click. */
  referer?: string;
  /** Code of the country from where the click originated. Uses ISO-3166 three letter format. */
  countryCode?: string;
  /** Subdivision of the country of origin. Uses ISO-3166-2 format. */
  subdivisionCode?: string;
  /** City from where the click originated. */
  city?: string;
  /** GPS coordinates of the click's origin. */
  cityLatLong?: string;
  /** Custom aff S1 parameter. */
  affS1?: string;
  /** Custom aff S2 parameter. */
  affS2?: string;
  /** Custom aff S3 parameter. */
  affS3?: string;
  /** Custom aff S4 parameter. */
  affS4?: string;
  /** Custom aff S5 parameter. */
  affS5?: string;
  /** Affiliate public ID. */
  sourcePublicId?: string;
}

/** Create a new click */
export interface ClicksV1CreateClickRequest {
  /** ID of the link to which the click is assigned. */
  linkId: string;
  /** Traffic source ID. */
  sourceId: string;
  /** IP address from where the click originated. */
  ipAddress: string;
  /** Browser, OS and device. */
  userAgent: string;
  /** Code of the country from where the click originated. Uses ISO-3166 three letter format. */
  countryCode: string;
  /** Subdivision of the country of origin. Uses ISO-3166-2 format. */
  subdivisionCode?: string;
  /** City from where the click originated. */
  city?: string;
  /** GPS coordinates of the click's origin. */
  cityLatLong?: GoogleTypeLatLng;
  /** URL of the origin of the incoming click. */
  requestUrl?: string;
  /** Affiliate who gets credited with the incoming click. */
  referer?: string;
  /** Custom aff S1 parameter. */
  affS1?: string;
  /** Custom aff S2 parameter. */
  affS2?: string;
  /** Custom aff S3 parameter. */
  affS3?: string;
  /** Custom aff S4 parameter. */
  affS4?: string;
  /** Custom aff S5 parameter. */
  affS5?: string;
  /**
   * Timestamp when the click was registered.
   * @format date-time
   */
  createdAt?: string;
}

/** Feedback message for click creation status. */
export interface ClicksV1CreateClickResponse {
  click?: ClicksV1Click;
}

export interface ClicksV1CreateRedirectClickRequest {
  offerId: string;
  /** Only lowercase alphanumeric characters allowed. */
  sourcePublicId: TypesV1SourcePublicId;
  ipAddress: string;
  userAgent: string;
  requestUrl?: string;
  referer?: string;
  acceptLanguage?: string;
  affS1?: string;
  affS2?: string;
  affS3?: string;
  affS4?: string;
  affS5?: string;
}

export interface ClicksV1CreateRedirectClickResponse {
  redirectUrl?: string;
}

export interface ClicksV1CreateRedirectLandingPageClickRequest {
  landingPageId: string;
  sourceId: string;
  ipAddress: string;
  userAgent: string;
  requestUrl?: string;
  referer?: string;
  affS1?: string;
  affS2?: string;
  affS3?: string;
  affS4?: string;
  affS5?: string;
}

export interface ClicksV1CreateRedirectLandingPageClickResponse {
  redirectUrl: string;
}

export interface ClicksV1CreateRedirectSmartLinkClickRequest {
  smartLinkId: string;
  /** Only lowercase alphanumeric characters allowed. */
  sourcePublicId: TypesV1SourcePublicId;
  ipAddress: string;
  userAgent: string;
  requestUrl?: string;
  referer?: string;
  acceptLanguage?: string;
  affS1?: string;
  affS2?: string;
  affS3?: string;
  affS4?: string;
  affS5?: string;
}

export interface ClicksV1CreateRedirectSmartLinkClickResponse {
  redirectUrl?: string;
}

/** List of clicks per pagination. */
export interface ClicksV1ListClicksResponse {
  clicks?: ClicksV1Click[];
}

export interface ControlPanelV1GetControlPanelSettingsResponse {
  membershipPlanId?: MembershipsV1PlanId;
  lastAutomaticMembershipPlanId?: MembershipsV1PlanId;
  loginAvailable?: boolean;
  trafficAvailable?: boolean;
  adminAccessStatus?: SettingsV1AdminAccessStatus;
  superadminNote?: string;
  tenantType?: SettingsV1TenantType;
  freeTrialActive?: boolean;
  membershipBillingCycle?: SettingsV1MembershipBillingCycle;
  marketplaceAccessOverridden?: boolean;
  /** @format date-time */
  membershipEndAt?: string;
  customFreemiumRevenueLimit?: TypesV1Decimal;
  customFeatureLimits?: SettingsV1FeatureLimit[];
}

export type ControlPanelV1RegulateUsageResponse = object;

export type ControlPanelV1ResetFreeTrialResponse = object;

export interface ControlPanelV1SetFreeTrialRequest {
  planId?: MembershipsV1PlanId;
  /** @format date-time */
  endAt?: string;
}

export type ControlPanelV1SetFreeTrialResponse = object;

export type ControlPanelV1SyncSubscriptionsResponse = object;

export interface ControlPanelV1UpdateAdminAccessRequest {
  status?: SettingsV1AdminAccessStatus;
}

export type ControlPanelV1UpdateAdminAccessResponse = object;

export interface ControlPanelV1UpdateCustomFeatureLimitsRequest {
  limits?: SettingsV1FeatureLimit[];
}

export interface ControlPanelV1UpdateCustomFeatureLimitsResponse {
  limits?: SettingsV1FeatureLimit[];
}

export interface ControlPanelV1UpdateCustomFreemiumRevenueLimitRequest {
  /** optional */
  limit?: TypesV1Decimal;
}

export interface ControlPanelV1UpdateCustomFreemiumRevenueLimitResponse {
  limit?: TypesV1Decimal;
}

export interface ControlPanelV1UpdateLoginEnabledRequest {
  loginEnabled?: boolean;
}

export type ControlPanelV1UpdateLoginEnabledResponse = object;

export interface ControlPanelV1UpdateMarketplaceAccessOverriddenRequest {
  accessOverridden?: boolean;
}

export interface ControlPanelV1UpdateMarketplaceAccessOverriddenResponse {
  accessOverridden?: boolean;
}

export interface ControlPanelV1UpdateMembershipPlanRequest {
  id?: MembershipsV1PlanId;
}

export type ControlPanelV1UpdateMembershipPlanResponse = object;

export interface ControlPanelV1UpdateSuperadminNoteRequest {
  note?: string;
}

export interface ControlPanelV1UpdateSuperadminNoteResponse {
  note?: string;
}

export interface ControlPanelV1UpdateTrafficEnabledRequest {
  trafficEnabled?: boolean;
}

export type ControlPanelV1UpdateTrafficEnabledResponse = object;

export type ControlPanelV1UpgradeToNetworkResponse = object;

export interface ConversionRequestsV1ErrorConversionRequest {
  /** @format date-time */
  createdAt?: string;
  id?: string;
  status?: ConversionRequestsV1ConversionRequestStatus;
  message?: string;
  cid?: string;
  externalCid?: string;
  params?: string;
}

export interface ConversionRequestsV1ListErrorConversionRequestsResponse {
  requests?: ConversionRequestsV1ErrorConversionRequest[];
}

export interface ConversionSourcesV1ConversionSourceExternalIdentifiersServiceUpdateConversionSourceExternalIdentifierBody {
  externalCid: string;
}

export interface ConversionSourcesV1CreateConversionSourceExternalIdentifierRequest {
  externalCid: string;
  revenueOriginId: string;
  cid: string;
}

export type ConversionSourcesV1CreateConversionSourceExternalIdentifierResponse =
  object;

export type ConversionSourcesV1DeleteConversionSourceExternalIdentifierResponse =
  object;

export type ConversionSourcesV1UpdateConversionSourceExternalIdentifierResponse =
  object;

export interface ConversionStatusesV1ListConversionStatusesResponse {
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

/** Conversion type */
export interface ConversionTypesV1ConversionType {
  /** Unique identifier of the conversion type. */
  id?: string;
  /** Code of the conversion type. */
  code?: string;
  /** Name of the conversion type (in human readable format) */
  name?: string;
}

/** Change exisitng conversion type. */
export interface ConversionTypesV1ConversionTypesServiceUpdateConversionTypeBody {
  /** Name of the conversion type (in human readable format). */
  name?: string;
}

/** Create a new coversion type */
export interface ConversionTypesV1CreateConversionTypeRequest {
  /** Code of the conversion type. */
  code?: string;
  /** Name of the conversion type (in human readable format). */
  name?: string;
}

/** Feedback message for new conversion type creation. */
export interface ConversionTypesV1CreateConversionTypeResponse {
  conversionType?: ConversionTypesV1ConversionType;
}

/** Feedback message for conversion type deletion. */
export type ConversionTypesV1DeleteConversionTypeResponse = object;

/** Detailed information about the requested conversion type. */
export interface ConversionTypesV1GetConversionTypeResponse {
  conversionType?: ConversionTypesV1ConversionType;
}

/** List of converstion types available for returning click ID. */
export interface ConversionTypesV1ListConversionTypesAvailableForCidResponse {
  rows?: ConversionTypesV1ListConversionTypesAvailableForCidResponseRow[];
}

export interface ConversionTypesV1ListConversionTypesAvailableForCidResponseRow {
  /** Converstion type. */
  conversionType?: ConversionTypesV1ConversionType;
  /** Value assigned for the conversion type. */
  conversionValueType?: EnumsV1ConversionValueType;
}

/** List of existing conversion types. */
export interface ConversionTypesV1ListConversionTypesResponse {
  conversionTypes?: ConversionTypesV1ConversionType[];
}

/** Feedback message for changing the exisitng conversion type. */
export interface ConversionTypesV1UpdateConversionTypeResponse {
  conversionType?: ConversionTypesV1ConversionType;
}

/** Bulk change conversion status */
export interface ConversionsV1BulkSetConversionStatusRequest {
  /** New status the conversions will receive. */
  status?: ConversionsV1ConversionStatus;
  /** Conversions to be updated. */
  conversionIds?: string[];
}

/** Feedback message for bulk conversion status change */
export interface ConversionsV1BulkSetConversionStatusResponse {
  errors?: ConversionsV1BulkSetConversionStatusResponseError[];
}

export interface ConversionsV1BulkSetConversionStatusResponseError {
  conversionId?: string;
  code?: string;
  message?: string;
}

/** Conversion */
export interface ConversionsV1Conversion {
  /** The unique identification of the conversion. */
  id?: string;
  /** The click identification associated with the conversion. */
  cid?: string;
  /** Assigned revenue origin. Can be obtained from unique trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** Type of the conversion. */
  conversionTypeId?: string;
  /** Status of the conversion. */
  status?: ConversionsV1ConversionStatus;
  /** The affiliate's payout for the given conversion. Uses decimal number as a string. */
  cost?: TypesV1Decimal;
  /** The total revenue value of a conversion. Uses decimal number as a string. */
  revenue?: TypesV1Decimal;
  /** Currency code of the conversion. Uses ISO 4217 formatting. */
  currencyCode?: string;
  /** External CID associated with the conversion. See [Conversion sources](#tag--tracking.v1.ConversionSourceService) for more details. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. */
  customerId?: string;
  /** Custom parameters associated with the conversion. */
  customParams?: ConversionsV1ConversionCustomParams;
  /**
   * Timestamp when the conversion was created. Uses RFC 3339 formatting.
   * @format date-time
   */
  createdAt?: string;
}

/** Custom parameters assigned to a conversion. */
export interface ConversionsV1ConversionCustomParams {
  /** Custom adv S1 parameter assigned to a conversion. */
  advS1?: string;
  /** Custom adv S2 parameter assigned to a conversion. */
  advS2?: string;
  /** Custom adv S3 parameter assigned to a conversion. */
  advS3?: string;
  /** Custom adv S4 parameter assigned to a conversion. */
  advS4?: string;
  /** Custom adv S5 parameter assigned to a conversion. */
  advS5?: string;
}

/** Custom parameters assigned to a conversion. */
export interface ConversionsV1ConversionCustomParams {
  /** Custom adv S1 parameter assigned to a conversion. */
  advS1?: string;
  /** Custom adv S2 parameter assigned to a conversion. */
  advS2?: string;
  /** Custom adv S3 parameter assigned to a conversion. */
  advS3?: string;
  /** Custom adv S4 parameter assigned to a conversion. */
  advS4?: string;
  /** Custom adv S5 parameter assigned to a conversion. */
  advS5?: string;
}

/** Update conversion ammount (revenue) */
export interface ConversionsV1ConversionsServiceSetConversionAmountsBody {
  /** The total revenue value of a conversion. Uses decimal number as a string. */
  revenue?: TypesV1Decimal;
  /** The affiliate's payout for the given conversion. Uses decimal number as a string. */
  cost?: TypesV1Decimal;
}

/** Change conversion status */
export interface ConversionsV1ConversionsServiceSetConversionStatusBody {
  /** New status for the conversion. */
  status?: ConversionsV1ConversionStatus;
}

/** Update a conversion partially */
export interface ConversionsV1ConversionsServiceUpdateConversionPartiallyBody {
  /** Status of the conversion. Won't be changed if not filled. */
  status?: ConversionsV1ConversionStatus;
  /** The revenue value of a conversion. Uses decimal number as a string. Won't be changed if not filled. */
  revenue?: TypesV1Decimal;
  /** The payout value of a conversion. Uses decimal number as a string. Won't be changed if not filled. */
  cost?: TypesV1Decimal;
  /** The sales amount value of a conversion. Uses decimal number as a string. Won't be changed if not filled. */
  conversionAmount?: TypesV1Decimal;
  /** External ID is used for deduplication of conversions. No other conversion can be created with the same External ID. Won't be changed if not filled. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. Won't be changed if not filled. */
  customerId?: string;
  /** Custom parameters associated with the conversion. Won't be changed if not filled. */
  customAdvParams?: ConversionsV1UpdateConversionPartiallyRequestConversionCustomParams;
  /** Custom affiliate parameters associated with the conversion. Won't be changed if not filled. */
  customAffParams?: ConversionsV1UpdateConversionPartiallyRequestConversionSourceCustomParams;
}

/** Create a new conversion */
export interface ConversionsV1CreateConversionRequest {
  /** The click identification associated with the conversion. */
  cid?: string;
  /**
   * External CID associated with the conversion. See [Conversion sources](#tag--tracking.v1.ConversionSourceService) for more details.
   *
   * When external_cid is filled, then revenue_origin_id must also be filled, and cid cannot be filled
   */
  externalCid?: string;
  /** Status of the conversion. */
  status?: ConversionsV1ConversionStatus;
  /** Assigned revenue origin. Can be obtained from unique trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** Type of the conversion. */
  conversionTypeCode?: string;
  /** The total revenue value of a conversion. Uses decimal number as a string. */
  amount?: TypesV1Decimal;
  /** Custom payouts will override automatically calculated values. */
  customPayouts?: ConversionsV1CreateConversionRequestCustomPayouts;
  /** Currency code of the conversion. Uses ISO 4217 formatting. */
  currency?: TypesV1Currency;
  /** External ID  is used for deduplication of conversions. When the conversion is created with an External ID, no other conversion can be created with the same External ID. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. */
  customerId?: string;
  /** Custom parameters associated with the conversion. */
  customParams?: ConversionsV1ConversionCustomParams;
  /**
   * Timestamp when the conversion was created. Uses RFC 3339 formatting.
   * @format date-time
   */
  createdAt?: string;
}

export interface ConversionsV1CreateConversionRequestCustomPayouts {
  revenue: TypesV1Decimal;
  cost: TypesV1Decimal;
}

/** Feedback message for newly created conversion. */
export interface ConversionsV1CreateConversionResponse {
  conversion?: ConversionsV1Conversion;
}

/** Create coupon conversion */
export interface ConversionsV1CreateCouponConversionRequest {
  /** Code of the coupon to be redeemed. */
  couponCode?: string;
  /** Status of the conversion. */
  status?: ConversionsV1ConversionStatus;
  /** Assigned revenue origin. Can be obtained from unique trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** Type of the conversion. */
  conversionTypeCode?: string;
  /** The total revenue value of a conversion. Uses decimal number as a string. */
  amount?: TypesV1Decimal;
  /** Currency code of the conversion. Uses ISO 4217 formatting. */
  currency?: TypesV1Currency;
  /** External CID associated with the conversion. See [Conversion sources](#tag--tracking.v1.ConversionSourceService) for more details. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. */
  customerId?: string;
  /** Geolocation data. */
  geoLocation?: ConversionsV1CreateCouponConversionRequestGeoLocation;
  /** Custom parameters associated with the conversion. */
  customParams?: ConversionsV1ConversionCustomParams;
}

/** Geological location */
export interface ConversionsV1CreateCouponConversionRequestGeoLocation {
  /** Country code of the location. Uses ISO 3166 three letter format. */
  countryCode?: string;
  /** Location's subdivision. Uses ISO 3166-2 format. */
  subdivisionCode?: string;
  /** City of the location. */
  city?: string;
  /** Logitude and latitude of the location. */
  cityLatLong?: GoogleTypeLatLng;
}

/** Feedback message for creation of coupon conversion. */
export interface ConversionsV1CreateCouponConversionResponse {
  conversion?: ConversionsV1Conversion;
}

/** Get a conversion by the external ID */
export interface ConversionsV1GetConversionByExternalIdRequest {
  /** External ID  is used for deduplication of conversions. When the conversion is created with an External ID, no other conversion can be created with the same External ID. */
  externalId?: string;
  /** Assigned revenue origin. Can be obtained from unique Trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** Type of the conversion. */
  conversionTypeCode?: string;
}

/** Conversion corresponding to the specified external ID. */
export interface ConversionsV1GetConversionByExternalIdResponse {
  conversion: ConversionsV1Conversion;
}

/** List of existing conversion in the system */
export interface ConversionsV1ListConversionsResponse {
  conversions?: ConversionsV1Conversion[];
}

/** Feedback message of the conversion ammount update */
export type ConversionsV1SetConversionAmountsResponse = object;

/** Feedback message for conversion status change. */
export type ConversionsV1SetConversionStatusResponse = object;

/** Custom advertiser parameters assigned to a conversion. */
export interface ConversionsV1UpdateConversionPartiallyRequestConversionCustomParams {
  /** Custom adv S1 parameter assigned to a conversion. Won't be changed if not filled. */
  advS1?: string;
  /** Custom adv S2 parameter assigned to a conversion. Won't be changed if not filled. */
  advS2?: string;
  /** Custom adv S3 parameter assigned to a conversion. Won't be changed if not filled. */
  advS3?: string;
  /** Custom adv S4 parameter assigned to a conversion. Won't be changed if not filled. */
  advS4?: string;
  /** Custom adv S5 parameter assigned to a conversion. Won't be changed if not filled. */
  advS5?: string;
}

/** Custom affiliate parameters assigned to a conversion source. */
export interface ConversionsV1UpdateConversionPartiallyRequestConversionSourceCustomParams {
  /** Custom aff S1 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS1?: string;
  /** Custom aff S2 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS2?: string;
  /** Custom aff S3 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS3?: string;
  /** Custom aff S4 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS4?: string;
  /** Custom aff S5 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS5?: string;
}

/** Feedback message for partially updated conversion. */
export interface ConversionsV1UpdateConversionPartiallyResponse {
  conversion: ConversionsV1Conversion;
}

/** Change covnersion status by External ID */
export interface ConversionsV1UpdateConversionStatusByExternalIdRequest {
  /** Revenue origin associated with the conversion. You can find this information in your unique trackdesk identifiers in the Settings. */
  revenueOriginId?: string;
  /** External ID associated with the conversion. */
  externalId?: string;
  /** Code of the conversion type. */
  conversionTypeCode?: string;
  /** New conversion status to be applied. */
  status?: ConversionsV1ConversionStatus;
}

/** Feedback for update of conversion status. */
export type ConversionsV1UpdateConversionStatusByExternalIdResponse = object;

export interface CouponStatusesV1ListCouponStatusesResponse {
  couponStatuses?: CouponsV1CouponStatus[];
}

/** Coupon */
export interface CouponsV1Coupon {
  /** Unique ID of the coupon. */
  id?: string;
  /** Advertiser associated with the coupon. */
  revenueOrigin?: CouponsV1CouponRevenueOrigin;
  /** Traffic source able to trigger coupon redemption (essentially an affiliate). */
  source?: CouponsV1CouponSource;
  /** Offer in which the coupon can be redeemed. */
  offer?: CouponsV1CouponOffer;
  /** The code of the coupon. */
  code?: string;
  /** Status of the coupon. */
  status?: CouponsV1CouponStatus;
  /** Deprecated: Unique ID of advertiser associated with the coupon. */
  revenueOriginId?: string;
}

/** An offer for which the coupon can be redeemed. */
export interface CouponsV1CouponOffer {
  /** Unique ID of the offer. */
  id?: string;
  /** Name of the offer. */
  name?: string;
}

/** Advertiser associated with the coupon. */
export interface CouponsV1CouponRevenueOrigin {
  /** Unique ID of the advertiser. */
  id?: string;
  /** Name of the advertiser. */
  name?: string;
}

/** Traffic source able to trigger coupon redemption (essentially an affiliate). */
export interface CouponsV1CouponSource {
  /** Unique system ID of the traffic source. */
  id?: string;
  /** Public ID. */
  publicId?: string;
}

/** Change status of already existing coupon. */
export interface CouponsV1CouponsServiceUpdateCouponStatusBody {
  /** New status for the coupon. */
  status?: CouponsV1CouponStatus;
}

/** Create a new coupon in the system. */
export interface CouponsV1CreateCouponRequest {
  /** Traffic source able to trigger coupon redemption (essentially an affiliate). */
  source: CouponsV1CreateCouponRequestSource;
  /** Offer in which the coupon can be redeemed. */
  offerId: string;
  /** Revenue origin associated with the coupon. If not set, the default revenue origin from the offer is selected. */
  revenueOriginId?: string;
  /** The code of the coupon. */
  code: string;
  /** Status of the coupon. */
  status: CouponsV1CouponStatus;
}

/** Traffic source able to trigger coupon redemption (essentially an affiliate). */
export interface CouponsV1CreateCouponRequestSource {
  /** Traffic source ID. */
  id?: string;
  /**
   * Traffic source's public ID.
   *
   * required implicitly by oneof
   */
  publicId?: TypesV1SourcePublicId;
}

/** Feedback message of the create coupon request. */
export interface CouponsV1CreateCouponResponse {
  coupon?: CouponsV1Coupon;
}

/** Deletion confirmation */
export type CouponsV1DeleteCouponResponse = object;

/** Details of a specific coupon */
export interface CouponsV1GetCouponResponse {
  coupon?: CouponsV1Coupon;
}

/** Generate a list of existing coupons */
export interface CouponsV1ListCouponsRequest {
  pagination?: TypesV1PaginationRequest;
  revenueOriginIds?: string[];
  /** Trafic source IDs */
  sourceIds?: string[];
  /** Offer IDs */
  offerIds?: string[];
  /** Coupon codes */
  codes?: string[];
  statuses?: CouponsV1CouponStatus[];
}

/** List of coupons existing in the system. */
export interface CouponsV1ListCouponsResponse {
  /** Coupon codes */
  coupons?: CouponsV1Coupon[];
  /** Pagination */
  pagination: TypesV1PaginationResponse;
}

/** Feedback for the update coupon request. */
export interface CouponsV1UpdateCouponStatusResponse {
  coupon?: CouponsV1Coupon;
}

export interface CurrenciesV1CreateCurrencyRequest {
  code?: string;
}

export interface CurrenciesV1CreateCurrencyResponse {
  currency?: CurrenciesV1Currency;
}

export interface CurrenciesV1Currency {
  code?: string;
  primary?: boolean;
  default?: boolean;
}

export type CurrenciesV1DeleteCurrencyResponse = object;

export interface CurrenciesV1GetPrimaryCurrencyResponse {
  currency?: CurrenciesV1Currency;
}

export interface CurrenciesV1ListCurrenciesResponse {
  currencies?: CurrenciesV1Currency[];
}

export interface CurrenciesV1ListSystemCurrenciesResponse {
  currencies?: CurrenciesV1SystemCurrency[];
}

export type CurrenciesV1SetDefaultCurrencyResponse = object;

export interface CurrenciesV1SystemCurrency {
  code?: string;
}

export interface CustomDomainsV1AssignCustomDomainRequest {
  domain?: string;
}

export type CustomDomainsV1AssignCustomDomainResponse = object;

export interface CustomDomainsV1ListCustomDomainsResponse {
  domains?: string[];
}

export type CustomDomainsV1RemoveCustomDomainResponse = object;

export interface CustomInternalPagesV1CreateCustomInternalPageRequest {
  slug: string;
  title: string;
  content: string;
}

export interface CustomInternalPagesV1CreateCustomInternalPageResponse {
  customInternalPage: CustomInternalPagesV1CustomInternalPage;
}

export interface CustomInternalPagesV1CustomInternalPage {
  id: string;
  slug: string;
  title: string;
  content: string;
  /** @format date-time */
  lastModifiedAt: string;
}

export interface CustomInternalPagesV1CustomInternalPagesServiceUpdateCustomInternalPageBody {
  slug: string;
  title: string;
  content: string;
}

export type CustomInternalPagesV1DeleteCustomInternalPageResponse = object;

export interface CustomInternalPagesV1GetCustomInternalPageBySlugResponse {
  customInternalPage: CustomInternalPagesV1CustomInternalPage;
}

export interface CustomInternalPagesV1ListCustomInternalPagesResponse {
  customInternalPages: CustomInternalPagesV1CustomInternalPage[];
}

export interface CustomInternalPagesV1UpdateCustomInternalPageResponse {
  customInternalPage: CustomInternalPagesV1CustomInternalPage;
}

export interface CustomMenuItemsV1CreateCustomMenuItemRequest {
  name: string;
  target: CustomMenuItemsV1TargetRequest;
  roleIds?: string[];
}

export interface CustomMenuItemsV1CreateCustomMenuItemResponse {
  customMenuItem: CustomMenuItemsV1CustomMenuItem;
}

export interface CustomMenuItemsV1CustomMenuItem {
  id: string;
  name: string;
  url?: string;
  customInternalPageId?: string;
}

export interface CustomMenuItemsV1CustomMenuItemsServiceUpdateCustomMenuItemBody {
  name: string;
  target: CustomMenuItemsV1TargetRequest;
  roleIds?: string[];
}

export type CustomMenuItemsV1DeleteCustomMenuItemResponse = object;

export interface CustomMenuItemsV1ListCustomMenuItemsForRoleResponse {
  items: CustomMenuItemsV1ListCustomMenuItemsForRoleResponseItem[];
}

export interface CustomMenuItemsV1ListCustomMenuItemsForRoleResponseItem {
  customMenuItem: CustomMenuItemsV1CustomMenuItem;
  target: CustomMenuItemsV1Target;
}

export interface CustomMenuItemsV1ListCustomMenuItemsResponse {
  customMenuItems: CustomMenuItemsV1ListCustomMenuItemsResponseCustomMenuItemWithRoles[];
}

export interface CustomMenuItemsV1ListCustomMenuItemsResponseCustomMenuItemWithRoles {
  customMenuItem: CustomMenuItemsV1CustomMenuItem;
  roleIds: string[];
}

export interface CustomMenuItemsV1Target {
  url?: string;
  customInternalPageSlug?: string;
}

export interface CustomMenuItemsV1TargetRequest {
  url?: string;
  customInternalPageId?: string;
}

export interface CustomMenuItemsV1UpdateCustomMenuItemResponse {
  customMenuItem: CustomMenuItemsV1CustomMenuItem;
}

export interface CustomQuotesV1CreateCustomQuoteRequest {
  stripePriceIds?: string[];
  note?: string;
}

export interface CustomQuotesV1CreateCustomQuoteResponse {
  quote: CustomQuotesV1CustomQuote;
}

export interface CustomQuotesV1CustomQuote {
  id: string;
  stripePriceIds: string[];
  note: string;
  /** @format date-time */
  createdAt: string;
}

export interface CustomQuotesV1CustomQuotesControlPanelServiceUpdateCustomQuoteBody {
  stripePriceIds?: string[];
  note?: string;
}

export interface CustomQuotesV1CustomQuotesServicePayCustomQuoteBody {
  successUrl?: string;
}

export type CustomQuotesV1DeleteCustomQuoteResponse = object;

export interface CustomQuotesV1ListCustomQuotesResponse {
  quotes: CustomQuotesV1CustomQuote[];
}

export interface CustomQuotesV1PayCustomQuoteResponse {
  stripeCheckoutSessionUrl: string;
}

export interface CustomQuotesV1UpdateCustomQuoteResponse {
  quote: CustomQuotesV1CustomQuote;
}

export interface CustomQuotesV1ValidateCustomQuoteRequest {
  stripePriceIds?: string[];
}

export interface CustomQuotesV1ValidateCustomQuoteResponse {
  error?: string;
}

export type CustomRedirectDomainsV1AssignCustomRedirectDomainResponse = object;

export interface CustomRedirectDomainsV1CheckDomainPriceResponse {
  domain?: string;
  /** @format double */
  price?: number;
}

export interface CustomRedirectDomainsV1CreateCustomRedirectDomainRequest {
  domain: string;
}

export type CustomRedirectDomainsV1CreateCustomRedirectDomainResponse = object;

export interface CustomRedirectDomainsV1ListCustomRedirectDomainsResponse {
  domains?: CustomRedirectDomainsV1ListCustomRedirectDomainsResponseDomain[];
}

export interface CustomRedirectDomainsV1ListCustomRedirectDomainsResponseDomain {
  name?: string;
  attachedTenants?: string[];
  nameServers?: string[];
  availableOnCloudflare?: boolean;
  availableOnDnsimple?: boolean;
  phishingDetected?: boolean;
  /** @format date-time */
  expiresAt?: string;
}

export type CustomRedirectDomainsV1RemoveCustomRedirectDomainResponse = object;

export interface ErrorsV1Error {
  code?: string;
  message?: string;
}

export interface ErrorsV1ErrorResponse {
  errors?: ErrorsV1Error[];
  availableCode?: ErrorsV1ErrorResponseCode;
}

export interface ErrorsV1ErrorResponseCode {
  c1?: ErrorsV1ErrorCode;
  c2?: AccountNotesV1ErrorCode;
  c3?: AffiliatesV1ErrorCode;
  c4?: AffiliatesV1RegistrationErrorCode;
  c5?: AuthenticationV1ErrorCode;
  c6?: ConversionTypesV1ErrorCode;
  c7?: ConversionsV1ErrorCode;
  c8?: CurrenciesV1ErrorCode;
  c9?: ExportV1ErrorCode;
  c10?: IntraMessagesV1ErrorCode;
  c11?: LandingPagesV1ErrorCode;
  c12?: MembershipsV1ErrorCode;
  c13?: MetadataV1ErrorCode;
  c14?: OffersV1ErrorCode;
  c15?: OffersV1SourceErrorCode;
  c16?: PaymentMethodsV1AvailableErrorCode;
  c17?: PaymentMethodsV1ErrorCode;
  c18?: ReportsV1ErrorCode;
  c19?: RolesV1ErrorCode;
  c20?: SourcesV1ErrorCode;
  c21?: TenantsV1RegistrationErrorCode;
  c22?: TenantsV1FactoryErrorCode;
  c23?: TiersV1ErrorCode;
  c24?: TrackingV1ClickErrorCode;
  c25?: TrackingV1ConversionErrorCode;
  c26?: TrackingV1ConversionSourceErrorCode;
  c27?: UsersV1RegistrationErrorCode;
  c28?: InvitationsV1ErrorCode;
  c29?: AccountsV1ErrorCode;
  c30?: ShopifyV1ErrorCode;
  c31?: CouponsV1ErrorCode;
  c32?: TierTransitionAutomationV1ErrorCode;
  c33?: RevenueOriginBillingV1ClaimErrorCode;
  c34?: RevenueOriginsV1ErrorCode;
  c35?: TipaltiV1ErrorCode;
  c36?: TenantStatisticsV1ErrorCode;
  c37?: TenantsV1DeletionErrorCode;
  v38?: TrackingBlockingV1ErrorCode;
  v39?: PricingV1ErrorCode;
  v40?: UsersV1SetPasswordErrorCode;
  v41?: UsersV1EmailSignInLinkErrorCode;
  v42?: CustomInternalPagesV1ErrorCode;
  v43?: PostbackTemplatesV1ErrorCode;
}

export interface ExportV1Export {
  mimeType?: ExportV1MimeType;
  lineEndings?: ExportV1LineEndings;
}

export interface ExportV1MimeType {
  csv?: ExportV1MimeTypeCSV;
}

export interface ExportV1MimeTypeCSV {
  delimiter?: string;
  floatingPoint?: string;
}

export interface ExportV1Scope {
  all?: ExportV1ScopeAll;
  pagination?: TypesV1PaginationRequest;
}

export type ExportV1ScopeAll = object;

/**
 * Message that represents an arbitrary HTTP body. It should only be used for
 * payload formats that can't be represented as JSON, such as raw binary or
 * an HTML page.
 *
 *
 * This message can be used both in streaming and non-streaming API methods in
 * the request as well as the response.
 *
 * It can be used as a top-level request field, which is convenient if one
 * wants to extract parameters from either the URL or HTTP template into the
 * request fields and also want access to the raw HTTP body.
 *
 * Example:
 *
 *     message GetResourceRequest {
 *       // A unique request id.
 *       string request_id = 1;
 *
 *       // The raw HTTP body is bound to this field.
 *       google.api.HttpBody http_body = 2;
 *
 *     }
 *
 *     service ResourceService {
 *       rpc GetResource(GetResourceRequest)
 *         returns (google.api.HttpBody);
 *       rpc UpdateResource(google.api.HttpBody)
 *         returns (google.protobuf.Empty);
 *
 *     }
 *
 * Example with streaming methods:
 *
 *     service CaldavService {
 *       rpc GetCalendar(stream google.api.HttpBody)
 *         returns (stream google.api.HttpBody);
 *       rpc UpdateCalendar(stream google.api.HttpBody)
 *         returns (stream google.api.HttpBody);
 *
 *     }
 *
 * Use of this type only changes how the request and response bodies are
 * handled, all other features will continue to work unchanged.
 */
export interface GoogleApiHttpBody {
  /** The HTTP Content-Type header value specifying the content type of the body. */
  contentType?: string;
  /**
   * The HTTP request/response body as raw binary.
   * @format byte
   */
  data?: string;
  /**
   * Application specific response metadata. Must be set in the first response
   * for streaming APIs.
   */
  extensions?: GoogleProtobufAny[];
}

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *     // or ...
 *     if (any.isSameTypeAs(Foo.getDefaultInstance())) {
 *       foo = any.unpack(Foo.getDefaultInstance());
 *     }
 *
 *  Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 *  Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export interface GoogleProtobufAny {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized
   * protocol buffer message. This string must contain at least
   * one "/" character. The last segment of the URL's path must represent
   * the fully qualified name of the type (as in
   * `path/google.protobuf.Duration`). The name should be in a canonical form
   * (e.g., leading "." is not accepted).
   *
   * In practice, teams usually precompile into the binary all types that they
   * expect it to use in the context of Any. However, for URLs which use the
   * scheme `http`, `https`, or no scheme, one can optionally set up a type
   * server that maps type URLs to message definitions as follows:
   *
   * * If no scheme is provided, `https` is assumed.
   * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
   *   value in binary format, or produce an error.
   * * Applications are allowed to cache lookup results based on the
   *   URL, or have them precompiled into a binary to avoid any
   *   lookup. Therefore, binary compatibility needs to be preserved
   *   on changes to types. (Use versioned type names to manage
   *   breaking changes.)
   *
   * Note: this functionality is not currently available in the official
   * protobuf release, and it is not used for type URLs beginning with
   * type.googleapis.com. As of May 2023, there are no widely used type server
   * implementations and no plans to implement one.
   *
   * Schemes other than `http`, `https` (or the empty scheme) might be
   * used with implementation specific semantics.
   */
  "@type"?: string;
  [key: string]: any;
}

export interface GoogleRpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: GoogleProtobufAny[];
}

/**
 * An object that represents a latitude/longitude pair. This is expressed as a
 * pair of doubles to represent degrees latitude and degrees longitude. Unless
 * specified otherwise, this must conform to the
 * <a href="http://www.unoosa.org/pdf/icg/2012/template/WGS_84.pdf">WGS84
 * standard</a>. Values must be within normalized ranges.
 */
export interface GoogleTypeLatLng {
  /**
   * The latitude in degrees. It must be in the range [-90.0, +90.0].
   * @format double
   */
  latitude?: number;
  /**
   * The longitude in degrees. It must be in the range [-180.0, +180.0].
   * @format double
   */
  longitude?: number;
}

export interface IntraMessagesV1AdvertiserIntraMessage {
  id: string;
  subject: string;
  content: string;
  targetGroup: IntraMessagesV1AdvertiserIntraMessageTargetGroup;
  /** @format date-time */
  sentAt: string;
}

export interface IntraMessagesV1AdvertiserIntraMessageTargetGroup {
  all?: IntraMessagesV1AdvertiserIntraMessageTargetGroupAll;
  individual?: IntraMessagesV1AdvertiserIntraMessageTargetGroupIndividual;
}

export type IntraMessagesV1AdvertiserIntraMessageTargetGroupAll = object;

export type IntraMessagesV1AdvertiserIntraMessageTargetGroupIndividual = object;

export interface IntraMessagesV1AdvertiserTargetGroupRequest {
  all?: IntraMessagesV1AdvertiserTargetGroupRequestAll;
  individual?: IntraMessagesV1AdvertiserTargetGroupRequestIndividual;
}

export type IntraMessagesV1AdvertiserTargetGroupRequestAll = object;

export interface IntraMessagesV1AdvertiserTargetGroupRequestIndividual {
  revenueOriginIds?: string[];
}

export interface IntraMessagesV1AffiliateIntraMessage {
  id: string;
  subject: string;
  content: string;
  targetGroup: IntraMessagesV1AffiliateIntraMessageTargetGroup;
  /** @format date-time */
  sentAt: string;
}

export interface IntraMessagesV1AffiliateIntraMessageTargetGroup {
  all?: IntraMessagesV1AffiliateIntraMessageTargetGroupAll;
  byAccountStatus?: IntraMessagesV1AffiliateIntraMessageTargetGroupByAccountStatus;
  bySourceTier?: IntraMessagesV1AffiliateIntraMessageTargetGroupBySourceTier;
  individual?: IntraMessagesV1AffiliateIntraMessageTargetGroupIndividual;
}

export type IntraMessagesV1AffiliateIntraMessageTargetGroupAll = object;

export interface IntraMessagesV1AffiliateIntraMessageTargetGroupByAccountStatus {
  status: EnumsV1AccountStatus;
}

export interface IntraMessagesV1AffiliateIntraMessageTargetGroupBySourceTier {
  tierId: string;
}

export type IntraMessagesV1AffiliateIntraMessageTargetGroupIndividual = object;

export interface IntraMessagesV1AffiliateTargetGroupRequest {
  all?: IntraMessagesV1AffiliateTargetGroupRequestAll;
  byAccountStatus?: IntraMessagesV1AffiliateTargetGroupRequestByAccountStatus;
  bySourceTier?: IntraMessagesV1AffiliateTargetGroupRequestBySourceTier;
  individual?: IntraMessagesV1AffiliateTargetGroupRequestIndividual;
}

export type IntraMessagesV1AffiliateTargetGroupRequestAll = object;

export interface IntraMessagesV1AffiliateTargetGroupRequestByAccountStatus {
  status: EnumsV1AccountStatus;
}

export interface IntraMessagesV1AffiliateTargetGroupRequestBySourceTier {
  tierId: string;
}

export interface IntraMessagesV1AffiliateTargetGroupRequestIndividual {
  accountIds: string[];
}

export interface IntraMessagesV1CountAdvertiserIntraMessageAvailableRecipientsRequest {
  targetGroup?: IntraMessagesV1AdvertiserTargetGroupRequest;
}

export interface IntraMessagesV1CountAdvertiserIntraMessageAvailableRecipientsResponse {
  /** @format int64 */
  groupMembersCount: number;
  /** @format int64 */
  recipientsForTodayCount: number;
  /** @format int64 */
  recipientsDailyLimit: number;
}

export interface IntraMessagesV1CountAffiliateIntraMessageAvailableRecipientsRequest {
  targetGroup?: IntraMessagesV1AffiliateTargetGroupRequest;
}

export interface IntraMessagesV1CountAffiliateIntraMessageAvailableRecipientsResponse {
  /** @format int64 */
  groupMembersCount: number;
  /** @format int64 */
  recipientsForTodayCount: number;
  /** @format int64 */
  recipientsDailyLimit: number;
}

export interface IntraMessagesV1ListAdvertiserIntraMessageRecipientsResponse {
  recipients: IntraMessagesV1ListAdvertiserIntraMessageRecipientsResponseRevenueOrigin[];
  pagination: TypesV1PaginationResponse;
}

export interface IntraMessagesV1ListAdvertiserIntraMessageRecipientsResponseRevenueOrigin {
  id: string;
  name: string;
  email: string;
}

export interface IntraMessagesV1ListAdvertiserIntraMessagesResponse {
  messages: IntraMessagesV1AdvertiserIntraMessage[];
}

export interface IntraMessagesV1ListAffiliateIntraMessageRecipientsResponse {
  recipients: IntraMessagesV1ListAffiliateIntraMessageRecipientsResponseAccount[];
  pagination: TypesV1PaginationResponse;
}

export interface IntraMessagesV1ListAffiliateIntraMessageRecipientsResponseAccount {
  id: string;
  name: string;
  email: string;
  status: EnumsV1AccountStatus;
}

export interface IntraMessagesV1ListAffiliateIntraMessagesResponse {
  messages: IntraMessagesV1AffiliateIntraMessage[];
}

export interface IntraMessagesV1SendAdvertiserIntraMessageRequest {
  subject?: string;
  replyTo?: string;
  /** empty allowed */
  content?: string;
  targetGroup?: IntraMessagesV1AdvertiserTargetGroupRequest;
}

export type IntraMessagesV1SendAdvertiserIntraMessageResponse = object;

export interface IntraMessagesV1SendAffiliateIntraMessageRequest {
  subject?: string;
  replyTo?: string;
  /** empty allowed */
  content?: string;
  targetGroup?: IntraMessagesV1AffiliateTargetGroupRequest;
}

export type IntraMessagesV1SendAffiliateIntraMessageResponse = object;

export interface InvitationsV1AcceptInvitationRequest {
  token?: string;
}

export type InvitationsV1AcceptInvitationResponse = object;

export interface InvitationsV1CreateInvitationRequest {
  email?: string;
  roleId?: string;
}

export interface InvitationsV1CreateInvitationResponse {
  invitation?: InvitationsV1Invitation;
}

export interface InvitationsV1Invitation {
  id?: string;
  email?: string;
  roleId?: string;
  /** @format date-time */
  expiresAt?: string;
  createdAccountId?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface InvitationsV1ListInvitationsResponse {
  invitations?: InvitationsV1Invitation[];
}

export interface LandingPagesV1CreateLandingPagesWithDirectLinkRequestLandingPage {
  name?: string;
  url?: string;
}

export interface LandingPagesV1CreateLandingPagesWithDirectLinkResponse {
  landingPages?: LandingPagesV1LandingPageWithDirectLink[];
}

export interface LandingPagesV1CreateLandingPagesWithRedirectLinkRequestLandingPage {
  name?: string;
  url?: string;
  targeting?: LandingPagesV1TargetingRequest;
}

export interface LandingPagesV1CreateLandingPagesWithRedirectLinkResponse {
  landingPages?: LandingPagesV1LandingPageWithRedirectLink[];
}

export type LandingPagesV1DeleteLandingPageResponse = object;

export interface LandingPagesV1GetLandingPageResponse {
  landingPage?: LandingPagesV1LandingPage;
}

export interface LandingPagesV1LandingPage {
  id?: string;
  offerId?: string;
  url?: string;
  name?: string;
  status?: LandingPagesV1LandingPageStatus;
}

export interface LandingPagesV1LandingPageWithDirectLink {
  landingPage?: LandingPagesV1LandingPage;
  directLink?: LandingPagesV1LandingPageWithDirectLinkDirectLink;
}

export interface LandingPagesV1LandingPageWithDirectLinkDirectLink {
  publicId?: string;
}

export interface LandingPagesV1LandingPageWithRedirectLink {
  landingPage?: LandingPagesV1LandingPage;
  redirectLink?: LandingPagesV1LandingPageWithRedirectLinkRedirectLink;
}

export interface LandingPagesV1LandingPageWithRedirectLinkRedirectLink {
  targeting?: LandingPagesV1Targeting;
}

export interface LandingPagesV1LandingPagesServiceCreateLandingPagesWithDirectLinkBody {
  landingPages?: LandingPagesV1CreateLandingPagesWithDirectLinkRequestLandingPage[];
}

export interface LandingPagesV1LandingPagesServiceCreateLandingPagesWithRedirectLinkBody {
  landingPages?: LandingPagesV1CreateLandingPagesWithRedirectLinkRequestLandingPage[];
}

export interface LandingPagesV1LandingPagesServicePrioritizeLandingPagesBody {
  orderedLandingPageIds?: string[];
}

export interface LandingPagesV1LandingPagesServiceUpdateLandingPageWithDirectLinkBody {
  name?: string;
  url?: string;
  status?: LandingPagesV1LandingPageStatus;
}

export interface LandingPagesV1LandingPagesServiceUpdateLandingPageWithRedirectLinkBody {
  name?: string;
  url?: string;
  status?: LandingPagesV1LandingPageStatus;
  targeting?: LandingPagesV1TargetingRequest;
}

export interface LandingPagesV1ListLandingPagesWithDirectLinkByOfferResponse {
  landingPages?: LandingPagesV1LandingPageWithDirectLink[];
}

export interface LandingPagesV1ListLandingPagesWithRedirectLinkByOfferResponse {
  landingPages?: LandingPagesV1LandingPageWithRedirectLink[];
}

export type LandingPagesV1PrioritizeLandingPagesResponse = object;

export interface LandingPagesV1Targeting {
  locations?: LocationsV1Location[];
  languages?: string[];
  devices?: EnumsV1Device[];
  operatingSystems?: EnumsV1OperatingSystem[];
}

export interface LandingPagesV1TargetingRequest {
  locations?: LocationsV1LocationRequest[];
  languages?: string[];
  devices?: EnumsV1Device[];
  operatingSystems?: EnumsV1OperatingSystem[];
}

export interface LandingPagesV1UpdateLandingPageWithDirectLinkResponse {
  landingPage?: LandingPagesV1LandingPageWithDirectLink;
}

export interface LandingPagesV1UpdateLandingPageWithRedirectLinkResponse {
  landingPage?: LandingPagesV1LandingPageWithRedirectLink;
}

export interface LocationsV1ListSystemLocationsResponse {
  locations?: LocationsV1Location[];
}

export interface LocationsV1Location {
  countryCode: string;
  subdivision?: string;
  city?: string;
}

export interface LocationsV1LocationRequest {
  countryCode: string;
  subdivision?: string;
  city?: string;
}

export type MembershipsV1CancelShopifyMembershipResponse = object;

export interface MembershipsV1CreateCustomerPortalSessionRequest {
  returnUrl?: string;
}

export interface MembershipsV1CreateCustomerPortalSessionResponse {
  portalUrl?: string;
}

export interface MembershipsV1CreateCustomerRequest {
  email?: string;
  name?: string;
}

export interface MembershipsV1CreateCustomerResponse {
  customer?: MembershipsV1Customer;
}

export interface MembershipsV1CreateShopifyMembershipRequest {
  shopifyIntegrationId?: string;
  membership?: MembershipsV1CreateShopifyMembershipRequestMembership;
  returnUrl?: string;
}

export interface MembershipsV1CreateShopifyMembershipRequestMembership {
  planId?: MembershipsV1PlanId;
  billingCycle?: MembershipsV1BillingCycle;
  currency?: MembershipsV1Currency;
}

export interface MembershipsV1CreateShopifyMembershipResponse {
  confirmationUrl?: string;
}

export interface MembershipsV1Customer {
  id?: string;
  email?: string;
  name?: string;
  taxExempt?: EnumsV1CustomerTaxExempt;
  address?: MembershipsV1CustomerAddress;
  taxId?: MembershipsV1CustomerTaxId;
}

export interface MembershipsV1CustomerAddress {
  address?: string;
  additionalAddress?: string;
  city?: string;
  postal?: string;
  countryCode?: string;
}

export interface MembershipsV1CustomerTaxId {
  value?: string;
  type?: EnumsV1CustomerTaxIdType;
}

export interface MembershipsV1GetCustomerResponse {
  email?: string;
  customerId?: string;
  name?: string;
  subscriptions?: MembershipsV1GetCustomerResponseSubscription[];
}

export interface MembershipsV1GetCustomerResponseSubscription {
  status?: string;
  /** @format date-time */
  trialStart?: string;
  /** @format date-time */
  trialEnd?: string;
  /** @format date-time */
  startDate?: string;
  plan?: MembershipsV1GetCustomerResponseSubscriptionPlan;
  latestInvoice?: MembershipsV1GetCustomerResponseSubscriptionInvoice;
}

export interface MembershipsV1GetCustomerResponseSubscriptionInvoice {
  attempted?: boolean;
  /** @format int64 */
  attemptCount?: string;
  /** @format date-time */
  dueDate?: string;
  /** @format date-time */
  nextPaymentAttempt?: string;
  status?: string;
}

export interface MembershipsV1GetCustomerResponseSubscriptionPlan {
  /** @format int64 */
  amount?: string;
  currency?: string;
  interval?: string;
  /** @format int64 */
  intervalCount?: string;
  nickname?: string;
  /** @format int64 */
  trialPeriodDays?: string;
}

export interface MembershipsV1GetMembershipCancellationDataResponse {
  stripeSubscriptionId?: string;
  raaftSecurityToken?: string;
  cancelAtPeriodEnd: boolean;
  /** @format date-time */
  chargePausedUntil?: string;
}

export interface MembershipsV1GetMembershipCurrencyResponse {
  currency?: MembershipsV1Currency;
}

export interface MembershipsV1GetMembershipPlanUsageResponse {
  planId?: MembershipsV1PlanId;
  primaryCurrencyCode?: string;
  revenueInPrimaryCurrency?: TypesV1Decimal;
  revenueInUsd?: TypesV1Decimal;
  limitInUsd?: TypesV1Decimal;
  isLimitExceeded?: boolean;
}

export interface MembershipsV1GetMembershipResponse {
  status?: MembershipsV1Status;
  planId?: MembershipsV1PlanId;
  /** @format date-time */
  endsAt?: string;
}

export interface MembershipsV1RenewMembershipRequest {
  membership?: MembershipsV1RenewMembershipRequestMembership;
  checkout?: MembershipsV1RenewMembershipRequestCheckout;
}

export interface MembershipsV1RenewMembershipRequestCheckout {
  successUrl?: string;
  cancelUrl?: string;
}

export interface MembershipsV1RenewMembershipRequestMembership {
  planId?: MembershipsV1PlanId;
  billingCycle?: MembershipsV1BillingCycle;
  currency?: MembershipsV1Currency;
}

export interface MembershipsV1RenewMembershipResponse {
  checkout?: MembershipsV1RenewMembershipResponseCheckout;
}

export interface MembershipsV1RenewMembershipResponseCheckout {
  sessionUrl?: string;
}

export interface MembershipsV1StartFreeTrialRequest {
  planId?: MembershipsV1PlanId;
}

export interface MembershipsV1StartFreeTrialResponse {
  status?: MembershipsV1Status;
  planId?: MembershipsV1PlanId;
  /** @format date-time */
  endsAt?: string;
}

export interface MetadataV1MetadataMasterServiceSetMetadataBeforeTenantReadyBody {
  metadata?: TypesV1Metadata;
}

export type MetadataV1SetMetadataBeforeTenantReadyResponse = object;

export interface MetadataV1SetMetadataRequest {
  metadata?: TypesV1Metadata;
}

export type MetadataV1SetMetadataResponse = object;

export interface NotificationsV1CreateCustomNotificationEventRequest {
  name: string;
  topic: EnumsV1CustomNotificationEventTopic;
  rule: NotificationsV1CustomNotificationEventRule;
  metric: NotificationsV1CustomNotificationEventMetric;
  /** @format int32 */
  lookBackHours: number;
}

export interface NotificationsV1CreateCustomNotificationEventResponse {
  event: NotificationsV1CustomNotificationEvent;
}

export interface NotificationsV1CustomNotificationEvent {
  id: string;
  name: string;
  topic: EnumsV1CustomNotificationEventTopic;
  rule: NotificationsV1CustomNotificationEventRule;
  metric: NotificationsV1CustomNotificationEventMetric;
  /** @format int32 */
  lookBackHours: number;
  paused?: boolean;
  /** @format date-time */
  createdAt?: string;
}

export interface NotificationsV1CustomNotificationEventMetric {
  criteria: EnumsV1CustomNotificationEventCriteria;
  operation: EnumsV1CustomNotificationEventOperation;
  threshold: TypesV1UnsignedDecimal;
}

export interface NotificationsV1CustomNotificationEventRule {
  sourceIds?: string[];
  revenueOriginIds?: string[];
  offerIds?: string[];
  conversionTypeIds?: string[];
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

export interface NotificationsV1CustomNotificationEventsServiceUpdateCustomNotificationEventBody {
  name: string;
  topic: EnumsV1CustomNotificationEventTopic;
  rule: NotificationsV1CustomNotificationEventRule;
  metric: NotificationsV1CustomNotificationEventMetric;
  /** @format int32 */
  lookBackHours: number;
}

export interface NotificationsV1CustomNotificationEventsServiceUpdateCustomNotificationEventPausedBody {
  paused: boolean;
}

export type NotificationsV1DeleteCustomNotificationEventResponse = object;

export interface NotificationsV1GetEffectiveNotificationSettingsResponse {
  settings: NotificationsV1NotificationSettings;
}

export interface NotificationsV1GetNotificationDefaultsSettingsResponse {
  settings: NotificationsV1NotificationSettings;
}

export interface NotificationsV1GetNotificationSettingsResponse {
  settings?: NotificationsV1NotificationSettings;
}

export interface NotificationsV1ListCustomNotificationEventsRequest {
  paused?: boolean;
}

export interface NotificationsV1ListCustomNotificationEventsResponse {
  events: NotificationsV1CustomNotificationEvent[];
}

export interface NotificationsV1ListNotificationsRequest {
  pagination: TypesV1PaginationRequest;
  read?: boolean;
}

export interface NotificationsV1ListNotificationsResponse {
  pagination: TypesV1PaginationResponse;
  notifications: NotificationsV1Notification[];
}

export type NotificationsV1MarkAllNotificationsAsReadRequest = object;

export type NotificationsV1MarkAllNotificationsAsReadResponse = object;

export interface NotificationsV1MarkNotificationsAsReadRequest {
  notificationIds: string[];
  read: boolean;
}

export type NotificationsV1MarkNotificationsAsReadResponse = object;

export interface NotificationsV1Notification {
  id: string;
  event: EnumsV1NotificationEvent;
  metadata?: NotificationsV1NotificationMetadata;
  read: boolean;
  /** @format date-time */
  createdAt: string;
}

export interface NotificationsV1NotificationMetadata {
  example?: NotificationsV1NotificationMetadataExample;
  affiliateMissingBillingDetails?: NotificationsV1NotificationMetadataAffiliate;
  affiliateMissingPaymentMethod?: NotificationsV1NotificationMetadataAffiliate;
  affiliateRegistered?: NotificationsV1NotificationMetadataAffiliateRegistered;
  affiliateRegistrationPending?: NotificationsV1NotificationMetadataAffiliate;
  applyToRunRequest?: NotificationsV1NotificationMetadataApplyToRunRequest;
  conversionFraudDetected?: NotificationsV1NotificationMetadataConversions;
  conversionPendingDetected?: NotificationsV1NotificationMetadataConversions;
  conversionErrorDetected?: NotificationsV1NotificationMetadataConversions;
  offerDraft?: NotificationsV1NotificationMetadataOffer;
  offerNotIntegrated?: NotificationsV1NotificationMetadataOffer;
  tierAutomationTierChanged?: NotificationsV1NotificationMetadataTierAutomationTierChanged;
  customEvent?: NotificationsV1NotificationMetadataCustomEvent;
}

export interface NotificationsV1NotificationMetadataAffiliate {
  accountId: string;
  accountName: string;
}

export interface NotificationsV1NotificationMetadataAffiliateRegistered {
  accountId: string;
  accountName: string;
  parentAccountId?: string;
  parentAccountName?: string;
}

export interface NotificationsV1NotificationMetadataApplyToRunRequest {
  accountId: string;
  accountName: string;
  offerId: string;
  offerName: string;
  offerSourceId: string;
}

export interface NotificationsV1NotificationMetadataConversions {
  /** @format int64 */
  conversionCount: number;
  /** @format date-time */
  checkedFrom: string;
  /** @format date-time */
  checkedTo: string;
}

export interface NotificationsV1NotificationMetadataCustomEvent {
  customEventId: string;
  name: string;
  topic: EnumsV1CustomNotificationEventTopic;
  metric: NotificationsV1CustomNotificationEventMetric;
  ids: string[];
  /** @format date-time */
  checkedFrom: string;
  /** @format date-time */
  checkedTo: string;
}

export interface NotificationsV1NotificationMetadataExample {
  field1?: string;
  field2?: string;
}

export interface NotificationsV1NotificationMetadataOffer {
  offerId: string;
  offerName: string;
}

export interface NotificationsV1NotificationMetadataTierAutomationTierChanged {
  accountIds: string[];
  sourcePublicIds: string[];
}

export interface NotificationsV1NotificationSettings {
  affiliateMissingBillingDetails?: NotificationsV1NotificationSettingsPreferences;
  affiliateMissingPaymentMethod?: NotificationsV1NotificationSettingsPreferences;
  affiliateRegistered?: NotificationsV1NotificationSettingsPreferences;
  affiliateRegistrationPending?: NotificationsV1NotificationSettingsPreferences;
  applyToRunRequested?: NotificationsV1NotificationSettingsPreferences;
  conversionErrorDetected?: NotificationsV1NotificationSettingsPreferences;
  conversionFraudDetected?: NotificationsV1NotificationSettingsPreferences;
  conversionPendingDetected?: NotificationsV1NotificationSettingsPreferences;
  offerDraft?: NotificationsV1NotificationSettingsPreferences;
  offerNotIntegrated?: NotificationsV1NotificationSettingsPreferences;
  tierAutomationTierChanged?: NotificationsV1NotificationSettingsPreferences;
  /** Map of custom notification event ids to its notification preferences. */
  customEvents?: Record<string, NotificationsV1NotificationSettingsPreferences>;
}

export interface NotificationsV1NotificationSettingsPreferences {
  channels?: EnumsV1NotificationChannel[];
}

export interface NotificationsV1SetNotificationDefaultsSettingsRequest {
  settings?: NotificationsV1NotificationSettings;
}

export type NotificationsV1SetNotificationDefaultsSettingsResponse = object;

export interface NotificationsV1SetNotificationSettingsRequest {
  settings?: NotificationsV1NotificationSettings;
}

export type NotificationsV1SetNotificationSettingsResponse = object;

export type NotificationsV1UpdateCustomNotificationEventPausedResponse = object;

export interface NotificationsV1UpdateCustomNotificationEventResponse {
  event: NotificationsV1CustomNotificationEvent;
}

export interface OfferCapsV1AddOfferCapSourceLimitResponse {
  offerCapId: string;
  sourceId: string;
  limit: OfferCapsV1Limit;
}

export interface OfferCapsV1Cap {
  id: string;
  offerId: string;
  conversionTypes: ConversionTypesV1ConversionType[];
  calculationMethod: EnumsV1OfferCapCalculationMethod;
  conversionStatuses: ConversionsV1ConversionStatus[];
  limits: OfferCapsV1CapLimits;
  fallback?: TypesV1Fallback;
  utilization: OfferCapsV1CapUtilization;
}

export interface OfferCapsV1CapLimits {
  total: OfferCapsV1Limit;
  bySource: OfferCapsV1CapLimitsSourceLimit;
}

export interface OfferCapsV1CapLimitsSourceLimit {
  default: OfferCapsV1Limit;
  individual: OfferCapsV1CapLimitsSourceLimitIndividual[];
}

export interface OfferCapsV1CapLimitsSourceLimitIndividual {
  sourceId: string;
  limit: OfferCapsV1Limit;
}

export interface OfferCapsV1CapUtilization {
  /** @format int64 */
  totalNumberOfConversions: string;
  totalSumOfRevenue: TypesV1Decimal;
  bySource: OfferCapsV1CapUtilizationSourceUtilization[];
}

export interface OfferCapsV1CapUtilizationSourceUtilization {
  sourceId: string;
  /** @format int64 */
  numberOfConversions: string;
  sumOfRevenue: TypesV1Decimal;
}

export interface OfferCapsV1CreateOfferCapRequest {
  offerId?: string;
  conversionTypeIds?: string[];
  calculationMethod?: EnumsV1OfferCapCalculationMethod;
  conversionStatuses?: ConversionsV1ConversionStatus[];
  limits?: OfferCapsV1CreateOfferCapRequestLimits;
  fallback?: TypesV1FallbackRequest;
}

export interface OfferCapsV1CreateOfferCapRequestLimits {
  /** optional */
  total?: OfferCapsV1Limit;
  /** optional */
  sourceDefault?: OfferCapsV1Limit;
}

export interface OfferCapsV1CreateOfferCapResponse {
  cap: OfferCapsV1Cap;
}

export type OfferCapsV1DeleteOfferCapResponse = object;

export interface OfferCapsV1Limit {
  day: OfferCapsV1LimitDay;
}

export interface OfferCapsV1LimitDay {
  everyDay: TypesV1Decimal;
}

export interface OfferCapsV1ListOfferCapsResponse {
  caps: OfferCapsV1Cap[];
}

export interface OfferCapsV1OfferCapsServiceAddOfferCapSourceLimitBody {
  limit?: OfferCapsV1Limit;
}

export type OfferCapsV1RemoveOfferCapSourceLimitResponse = object;

export interface OffersV1ApplicationCustomization {
  consent?: string;
  customQuestions?: TypesV1CustomQuestionSettings[];
}

export type OffersV1ApplyForAssignmentToOfferResponse = object;

export interface OffersV1AssignSourcesToOfferResponse {
  sources?: OffersV1AssignSourcesToOfferResponseSource[];
}

export interface OffersV1AssignSourcesToOfferResponseSource {
  id?: string;
}

export interface OffersV1CloneOfferResponse {
  id?: string;
}

export interface OffersV1CreateOfferRequest {
  offer?: OffersV1OfferIn;
  usedTemplateId?: string;
}

export interface OffersV1CreateOfferResponse {
  offer?: OffersV1OfferOut;
}

export type OffersV1DeleteOfferResponse = object;

export interface OffersV1GetOfferCreativesResponse {
  creatives: OffersV1OfferCreative[];
}

export interface OffersV1GetOfferResponse {
  offer?: OffersV1OfferOut;
}

export interface OffersV1GetOfferTrackingApiAuthorizationResponse {
  trackingApiAuthorization: OffersV1OfferTrackingApiAuthorization;
}

export interface OffersV1GetOfferTrackingQualityControlResponse {
  qualityControl?: SettingsV1TrackingQualityControl;
}

export interface OffersV1ListApplicationsForAssignmentToOfferResponse {
  applications?: OffersV1ListApplicationsForAssignmentToOfferResponseApplication[];
}

export interface OffersV1ListApplicationsForAssignmentToOfferResponseApplication {
  id?: string;
  application?: OffersV1OfferApplication;
  access?: OffersV1Access;
  account?: OffersV1ListApplicationsForAssignmentToOfferResponseApplicationAccount;
  source?: OffersV1ListApplicationsForAssignmentToOfferResponseApplicationSource;
  offer?: OffersV1ListApplicationsForAssignmentToOfferResponseApplicationOffer;
}

export interface OffersV1ListApplicationsForAssignmentToOfferResponseApplicationAccount {
  id?: string;
  name?: string;
}

export interface OffersV1ListApplicationsForAssignmentToOfferResponseApplicationOffer {
  id?: string;
  name?: string;
}

export interface OffersV1ListApplicationsForAssignmentToOfferResponseApplicationSource {
  id?: string;
  publicId?: string;
}

export interface OffersV1ListOfferOwnersResponse {
  offerOwners?: OffersV1OfferOwner[];
}

export interface OffersV1ListOfferRevenueOriginsResponse {
  revenueOrigins?: OffersV1ListOfferRevenueOriginsResponseRevenueOrigin[];
}

export interface OffersV1ListOfferRevenueOriginsResponseRevenueOrigin {
  id?: string;
}

export interface OffersV1ListOffersResponse {
  offers?: OffersV1ListOffersResponseOffer[];
}

export interface OffersV1ListOffersResponseOffer {
  info?: OffersV1OfferOut;
  pricing?: OffersV1ListOffersResponseOfferPricing;
  access?: OffersV1Access;
}

export interface OffersV1ListOffersResponseOfferPricing {
  superGroups: PricingV1SuperGroup[];
  countries: string[];
  currencies: string[];
}

export interface OffersV1ListOffersWithAnuraOverriddenResponse {
  offers?: OffersV1OfferOut[];
}

export interface OffersV1ListSourcesAssignedToOfferResponse {
  sourcesAssignments?: OffersV1ListSourcesAssignedToOfferResponseSourceAssignment[];
}

export interface OffersV1ListSourcesAssignedToOfferResponseSourceAssignment {
  id?: string;
  /** @format date-time */
  assignedAt?: string;
  access?: OffersV1Access;
  application?: OffersV1OfferApplication;
  account?: OffersV1ListSourcesAssignedToOfferResponseSourceAssignmentAccount;
  source?: OffersV1ListSourcesAssignedToOfferResponseSourceAssignmentSource;
}

export interface OffersV1ListSourcesAssignedToOfferResponseSourceAssignmentAccount {
  id?: string;
  name?: string;
}

export interface OffersV1ListSourcesAssignedToOfferResponseSourceAssignmentSource {
  id?: string;
  publicId?: string;
}

export interface OffersV1ListSourcesNotAssignedToOfferResponse {
  sources?: OffersV1ListSourcesNotAssignedToOfferResponseSource[];
}

export interface OffersV1ListSourcesNotAssignedToOfferResponseSource {
  id?: string;
  publicId?: string;
}

export interface OffersV1OfferApplication {
  note: string;
  customQuestions?: OffersV1OfferApplicationCustomQuestions;
}

export interface OffersV1OfferApplicationCustomQuestions {
  consent?: boolean;
  customQuestionAnswers?: TypesV1CustomQuestionAnswer[];
}

export interface OffersV1OfferCreative {
  type: EnumsV1CreativeType;
  content: string;
  /** @format date-time */
  createdAt: string;
  meta: OffersV1OfferCreativeMeta;
}

export interface OffersV1OfferCreativeMeta {
  /** @format int64 */
  width?: number;
  /** @format int64 */
  height?: number;
  /** @format int64 */
  size?: number;
}

export interface OffersV1OfferIn {
  categoryId?: string;
  name?: string;
  ownerId?: string;
  defaultRevenueOriginId?: string;
  description?: string;
  restrictions?: string;
  note?: string;
  thumbnail?: boolean;
  visibility?: OffersV1Visibility;
  devices?: EnumsV1Device[];
  trafficSources?: OffersV1TrafficSource[];
  tags?: OffersV1OfferInTag[];
  /** Optional value for `VISIBILITY_APPLY_TO_RUN` offers. */
  applicationCustomization?: OffersV1ApplicationCustomization;
}

export interface OffersV1OfferInTag {
  tagId?: string;
}

export interface OffersV1OfferOut {
  id?: string;
  categoryId?: string;
  name?: string;
  status?: OffersV1Status;
  ownerId?: string;
  defaultRevenueOriginId?: string;
  description?: string;
  restrictions?: string;
  note?: string;
  thumbnail?: boolean;
  visibility?: OffersV1Visibility;
  devices?: EnumsV1Device[];
  trafficSources?: OffersV1TrafficSource[];
  tags?: OffersV1OfferOutTag[];
  usedTemplateId?: string;
  pinned?: boolean;
  trackingType?: OffersV1TrackingType;
  /** @format date-time */
  deactivateAt?: string;
  defaultRedirectDomain?: string;
  /** Optional value for `VISIBILITY_APPLY_TO_RUN` offers. */
  applicationCustomization?: OffersV1ApplicationCustomization;
  redirectDomainsType?: EnumsV1RedirectDomainsType;
  statusInactiveFallback?: TypesV1Fallback;
  noSuitableLpFallback?: TypesV1Fallback;
  anuraEnabled?: boolean;
}

export interface OffersV1OfferOutTag {
  tagId?: string;
}

export interface OffersV1OfferOwner {
  id?: string;
  accountId?: string;
}

export interface OffersV1OfferSourcesServiceApplyForAssignmentToOfferBody {
  sourceId: string;
  application: OffersV1OfferApplication;
}

export interface OffersV1OfferSourcesServiceAssignSourcesToOfferBody {
  sourceIds?: string[];
  access: OffersV1Access;
}

export interface OffersV1OfferSourcesServiceResolveApplicationForAssignmentToOfferBody {
  access: OffersV1Access;
}

export interface OffersV1OfferTrackingApiAuthorization {
  conversion: OffersV1OfferTrackingApiAuthorizationConversion;
}

export interface OffersV1OfferTrackingApiAuthorizationConversion {
  whitelistedIps: string[];
}

export interface OffersV1OffersServiceScheduleOfferDeactivationBody {
  /** @format date-time */
  deactivateAt?: string;
  fallback?: TypesV1FallbackRequest;
}

export interface OffersV1OffersServiceSetOfferCreativesBody {
  creatives: OffersV1OfferCreative[];
}

export interface OffersV1OffersServiceUpdateOfferAnuraEnabledBody {
  enabled?: boolean;
}

export interface OffersV1OffersServiceUpdateOfferBody {
  offer?: OffersV1OfferIn;
}

export interface OffersV1OffersServiceUpdateOfferDefaultRedirectDomainBody {
  defaultRedirectDomain?: string;
}

export interface OffersV1OffersServiceUpdateOfferNoSuitableLpFallbackBody {
  fallback?: TypesV1FallbackRequest;
}

export interface OffersV1OffersServiceUpdateOfferPinnedBody {
  pinned?: boolean;
}

export interface OffersV1OffersServiceUpdateOfferRedirectDomainsTypeBody {
  redirectDomainsType: EnumsV1RedirectDomainsType;
}

export interface OffersV1OffersServiceUpdateOfferStatusBody {
  status: OffersV1Status;
  statusInactiveFallback?: TypesV1FallbackRequest;
}

export interface OffersV1OffersServiceUpdateOfferTrackingApiAuthorizationBody {
  conversion: OffersV1UpdateOfferTrackingApiAuthorizationRequestConversion;
}

export interface OffersV1OffersServiceUpdateOfferTrackingQualityControlBody {
  qualityControl?: SettingsV1TrackingQualityControlRequest;
}

export type OffersV1ResolveApplicationForAssignmentToOfferResponse = object;

export type OffersV1ScheduleOfferDeactivationResponse = object;

export type OffersV1SetOfferCreativesResponse = object;

export type OffersV1SetSourceAccessToOfferResponse = object;

export type OffersV1UnassignSourceFromOfferResponse = object;

export type OffersV1UpdateOfferAnuraEnabledResponse = object;

export type OffersV1UpdateOfferDefaultRedirectDomainResponse = object;

export interface OffersV1UpdateOfferNoSuitableLpFallbackResponse {
  fallback?: TypesV1Fallback;
}

export interface OffersV1UpdateOfferPinnedResponse {
  pinned?: boolean;
}

export type OffersV1UpdateOfferRedirectDomainsTypeResponse = object;

export interface OffersV1UpdateOfferResponse {
  offer?: OffersV1OfferOut;
}

export interface OffersV1UpdateOfferStatusResponse {
  status: OffersV1Status;
  statusInactiveFallback?: TypesV1Fallback;
}

export interface OffersV1UpdateOfferTrackingApiAuthorizationRequestConversion {
  whitelistedIps: string[];
}

export interface OffersV1UpdateOfferTrackingApiAuthorizationResponse {
  trackingApiAuthorization: OffersV1OfferTrackingApiAuthorization;
}

export interface OffersV1UpdateOfferTrackingQualityControlResponse {
  qualityControl?: SettingsV1TrackingQualityControl;
}

export interface PartnershipsV1AccessPartnershipsAppResponse {
  magicLink: string;
}

export interface PaymentMethodsV1AvailablePaymentMethod {
  id?: string;
  type?: PaymentMethodsV1PaymentMethodType;
  currencyCode?: string;
  note?: string;
}

export interface PaymentMethodsV1CreateAvailablePaymentMethodRequest {
  type?: PaymentMethodsV1PaymentMethodType;
  currency?: TypesV1Currency;
  note?: string;
}

export interface PaymentMethodsV1CreateAvailablePaymentMethodResponse {
  availablePaymentMethod?: PaymentMethodsV1AvailablePaymentMethod;
}

/** Create a new payment method. */
export interface PaymentMethodsV1CreatePaymentMethodRequest {
  /** Payment method account, */
  accountId?: string;
  /** Payment method type. */
  type?: PaymentMethodsV1PaymentMethodType;
  /** Currency for the payment method. Uses ISO 4217 format. */
  currency?: TypesV1Currency;
  /** Payment method data. */
  data?: PaymentMethodsV1PaymentMethodData;
}

/** Feedback for creation of the payment method. */
export interface PaymentMethodsV1CreatePaymentMethodResponse {
  paymentMethod?: PaymentMethodsV1PaymentMethod;
}

export type PaymentMethodsV1DeleteAvailablePaymentMethodResponse = object;

/** Feedback for deleetion of payment method. */
export type PaymentMethodsV1DeletePaymentMethodResponse = object;

export interface PaymentMethodsV1GetAvailablePaymentMethodResponse {
  availablePaymentMethod?: PaymentMethodsV1AvailablePaymentMethod;
}

/** Details of the requested payment method. */
export interface PaymentMethodsV1GetPaymentMethodResponse {
  paymentMethod?: PaymentMethodsV1PaymentMethod;
}

export interface PaymentMethodsV1ListAvailablePaymentMethodsByAccountResponse {
  availablePaymentMethods?: PaymentMethodsV1AvailablePaymentMethod[];
}

/** List of all active payment methods in the system. */
export interface PaymentMethodsV1ListPaymentMethodsByAccountResponse {
  paymentMethods?: PaymentMethodsV1PaymentMethod[];
}

export interface PaymentMethodsV1ListSupportedPaymentMethodTypesResponse {
  paymentMethodTypes?: PaymentMethodsV1ListSupportedPaymentMethodTypesResponsePaymentMethodType[];
}

export interface PaymentMethodsV1ListSupportedPaymentMethodTypesResponsePaymentMethodType {
  paymentMethodType?: PaymentMethodsV1PaymentMethodType;
  currencyCodes?: string[];
}

/** Payment method detail */
export interface PaymentMethodsV1PaymentMethod {
  /** Identifier of the payment method. */
  id?: string;
  /** Account associated with the payment method. */
  accountId?: string;
  /** Payment method type. */
  type?: PaymentMethodsV1PaymentMethodType;
  /** Currency used in the payment method. Uses ISO 4217 format. */
  currencyCode?: string;
  /** Detailed data of the selected payment method. See below for more details. */
  data?: PaymentMethodsV1PaymentMethodData;
  /** Designates if payment method is set as default. Only one payment method can have this set as true. */
  default?: boolean;
}

/** Payment methods details */
export interface PaymentMethodsV1PaymentMethodData {
  bankTransfer?: PaymentMethodsV1PaymentMethodDataBankTransfer;
  bitcoin?: PaymentMethodsV1PaymentMethodDataBitcoin;
  creditStore?: PaymentMethodsV1PaymentMethodDataCreditStore;
  directDeposit?: PaymentMethodsV1PaymentMethodDataDirectDeposit;
  ether?: PaymentMethodsV1PaymentMethodDataEther;
  giftCard?: PaymentMethodsV1PaymentMethodDataGiftCard;
  /** Mercado Pago. */
  mercadoPago?: PaymentMethodsV1PaymentMethodDataMercadoPago;
  neteller?: PaymentMethodsV1PaymentMethodDataNeteller;
  payoneer?: PaymentMethodsV1PaymentMethodDataPayoneer;
  payPal?: PaymentMethodsV1PaymentMethodDataPayPal;
  revolut?: PaymentMethodsV1PaymentMethodDataRevolut;
  sepa?: PaymentMethodsV1PaymentMethodDataSepa;
  skrill?: PaymentMethodsV1PaymentMethodDataSkrill;
  tipalti?: PaymentMethodsV1PaymentMethodDataTipalti;
  usdc?: PaymentMethodsV1PaymentMethodDataUsdc;
  usdt?: PaymentMethodsV1PaymentMethodDataUsdt;
  wise?: PaymentMethodsV1PaymentMethodDataWise;
}

/** Bank transfer */
export interface PaymentMethodsV1PaymentMethodDataBankTransfer {
  /** Bank account number */
  bankAccountNumber?: string;
  /** Address of the bank */
  bankAddress?: string;
  /** Name of the bank */
  bankName?: string;
  /** SWIFT code for the account */
  swift?: string;
  /** ABA number (for U.S. transfers) */
  aba?: string;
  /** Internal note. */
  note?: string;
}

/** Bitcoin */
export interface PaymentMethodsV1PaymentMethodDataBitcoin {
  /** Address of the crypto wallet. */
  cryptoWalletAddress?: string;
  /** Internal note. */
  note?: string;
}

/** Credit store */
export interface PaymentMethodsV1PaymentMethodDataCreditStore {
  /** Credit store code. */
  identification?: string;
  /** Internal note. */
  note?: string;
}

/** Direct bank deposit */
export interface PaymentMethodsV1PaymentMethodDataDirectDeposit {
  /** Bank account number. */
  accountNumber?: string;
  /** Holder of the bank account. */
  accountHolder?: string;
  /** Name of the bank. */
  bankName?: string;
  /** ABA/bank routing number of the bank. */
  bankRoutingNumber?: string;
  /** Internal note. */
  note?: string;
}

/** Ether */
export interface PaymentMethodsV1PaymentMethodDataEther {
  /** Crypto wallet address. */
  cryptoWalletAddress?: string;
  /** Internal note. */
  note?: string;
}

/** Gift card */
export interface PaymentMethodsV1PaymentMethodDataGiftCard {
  /** Gift card code. */
  identification?: string;
  /** Internal note. */
  note?: string;
}

/** Mercado Pago. */
export interface PaymentMethodsV1PaymentMethodDataMercadoPago {
  /** Registered email. */
  email?: string;
  /** First name. */
  firstName?: string;
  /** Last name. */
  lastName?: string;
  /** Internal note. */
  note?: string;
}

/** Neteller */
export interface PaymentMethodsV1PaymentMethodDataNeteller {
  /** Registered email. */
  email?: string;
  /** Internal note. */
  note?: string;
}

/** PayPal */
export interface PaymentMethodsV1PaymentMethodDataPayPal {
  /** Registered email. */
  email?: string;
  /** Internal note. */
  note?: string;
}

/** Payoneer */
export interface PaymentMethodsV1PaymentMethodDataPayoneer {
  /** Registered email. */
  email?: string;
  /** Internal note. */
  note?: string;
}

/** Revolut */
export interface PaymentMethodsV1PaymentMethodDataRevolut {
  /** Revolut tag. */
  revolutTag?: string;
  /** Revolut tag. */
  phoneNumber?: string;
  /** Connected email address. */
  email?: string;
  /** Internal note. */
  note?: string;
}

/** SEPA */
export interface PaymentMethodsV1PaymentMethodDataSepa {
  /** IBAN of the account. */
  iban?: string;
  /** Name of the beneficiary. */
  beneficiaryName?: string;
  /** BIC/SWIFT of the banking institution. */
  bic?: string;
  /** Internal note. */
  note?: string;
}

/** Skrill */
export interface PaymentMethodsV1PaymentMethodDataSkrill {
  /** Registered email. */
  email?: string;
  /** Internal note. */
  note?: string;
}

/** Tipalti */
export interface PaymentMethodsV1PaymentMethodDataTipalti {
  /** ID of the payee. */
  payeeId?: string;
  /** Internal note. */
  note?: string;
}

/** USDC */
export interface PaymentMethodsV1PaymentMethodDataUsdc {
  /** Crypto wallet address. */
  cryptoWalletAddress?: string;
  /** Internal note. */
  note?: string;
}

/** USDT */
export interface PaymentMethodsV1PaymentMethodDataUsdt {
  /** Crypto wallet address. */
  cryptoWalletAddress?: string;
  /** Internal note. */
  note?: string;
}

/** Wise */
export interface PaymentMethodsV1PaymentMethodDataWise {
  /** Registered email. */
  email?: string;
  /** Internal note. */
  note?: string;
}

/** Update exisintg payment method. */
export interface PaymentMethodsV1PaymentMethodServiceUpdatePaymentMethodBody {
  /** Type of the payment method. */
  type?: PaymentMethodsV1PaymentMethodType;
  /** Currency for the payment method. Uses ISO 4217 format. */
  currency?: TypesV1Currency;
  /** Payment method data. */
  data?: PaymentMethodsV1PaymentMethodData;
}

/** Set a new deafult payment method. */
export interface PaymentMethodsV1SetPaymentMethodAccountDefaultRequest {
  id?: string;
  accountId?: string;
}

/** Feedback for default payment method change request. */
export type PaymentMethodsV1SetPaymentMethodAccountDefaultResponse = object;

/** Feedback for the update of the payment method. */
export interface PaymentMethodsV1UpdatePaymentMethodResponse {
  paymentMethod?: PaymentMethodsV1PaymentMethod;
}

export interface PersonalAccessTokensV1CreatePersonalAccessTokenRequest {
  description?: string;
}

export interface PersonalAccessTokensV1CreatePersonalAccessTokenResponse {
  personalAccessToken?: PersonalAccessTokensV1PersonalAccessToken;
}

export type PersonalAccessTokensV1DeletePersonalAccessTokenResponse = object;

export interface PersonalAccessTokensV1ListPersonalAccessTokensResponse {
  personalAccessTokens?: PersonalAccessTokensV1PersonalAccessToken[];
}

export interface PersonalAccessTokensV1PersonalAccessToken {
  id?: string;
  description?: string;
  token?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface PlansV1ListPlansResponse {
  plans?: PlansV1ListPlansResponsePlan[];
}

export interface PlansV1ListPlansResponsePlan {
  tenantType: SettingsV1TenantType;
  planId: MembershipsV1PlanId;
  featureIds?: EnumsV1FeatureId[];
}

export interface PostbackTemplatesV1CreatePostbackTemplateRequest {
  postbackTemplate?: PostbackTemplatesV1PostbackTemplateW;
}

export type PostbackTemplatesV1CreatePostbackTemplateResponse = object;

export type PostbackTemplatesV1DeletePostbackTemplateResponse = object;

export interface PostbackTemplatesV1GetPostbackTemplateResponse {
  postbackTemplate?: PostbackTemplatesV1PostbackTemplate;
}

export interface PostbackTemplatesV1ListPostbackTemplatesResponse {
  postbackTemplates?: PostbackTemplatesV1PostbackTemplate[];
}

export interface PostbackTemplatesV1PostbackTemplate {
  id?: string;
  source?: PostbackTemplatesV1PostbackTemplateSource;
  offersBlacklisted?: boolean;
  type?: PostbackTemplatesV1PostbackTemplateType;
  params?: PostbackTemplatesV1PostbackTemplateParams;
  conversionStatuses?: ConversionsV1ConversionStatus[];
  conversionTypes?: PostbackTemplatesV1PostbackTemplateConversionType[];
  offers?: PostbackTemplatesV1PostbackTemplateOffer[];
  /** @format date-time */
  createdAt?: string;
}

export interface PostbackTemplatesV1PostbackTemplateConversionType {
  id?: string;
  name?: string;
}

export interface PostbackTemplatesV1PostbackTemplateOffer {
  id?: string;
  name?: string;
}

export interface PostbackTemplatesV1PostbackTemplateSource {
  id?: string;
  publicId?: string;
}

export interface PostbackTemplatesV1PostbackTemplateParams {
  httpGet?: PostbackTemplatesV1PostbackTemplateParamsHttpGet;
}

export interface PostbackTemplatesV1PostbackTemplateParamsHttpGet {
  url: string;
}

export interface PostbackTemplatesV1PostbackTemplateW {
  sourceId?: string;
  offersBlacklisted?: boolean;
  type?: PostbackTemplatesV1PostbackTemplateType;
  params?: PostbackTemplatesV1PostbackTemplateParams;
  /** FIXME: Validate non-empty and unique here when validator is fixed (remove implementation in controllers) */
  conversionStatuses?: ConversionsV1ConversionStatus[];
  conversionTypeIds?: string[];
  offerIds?: string[];
}

export interface PostbackTemplatesV1PostbackTemplatesServiceUpdatePostbackTemplateBody {
  postbackTemplate?: PostbackTemplatesV1PostbackTemplateW;
}

export type PostbackTemplatesV1UpdatePostbackTemplateResponse = object;

export interface PostbacksV1GetPostbackResponse {
  postback?: PostbacksV1GetPostbackResponsePostback;
}

export interface PostbacksV1GetPostbackResponsePostback {
  id?: string;
  status?: PostbacksV1PostbackStatus;
  conversionId?: string;
  source?: PostbacksV1GetPostbackResponsePostbackSource;
  offer?: PostbacksV1GetPostbackResponsePostbackOffer;
  conversionType?: PostbacksV1GetPostbackResponsePostbackConversionType;
  /** Check all validations on any index update. */
  conversionStatus?: ConversionsV1ConversionStatus;
  attempts?: PostbacksV1GetPostbackResponsePostbackAttempt[];
  /** @format date-time */
  createdAt?: string;
}

export interface PostbacksV1GetPostbackResponsePostbackAttempt {
  id?: string;
  request?: PostbacksV1GetPostbackResponsePostbackAttemptRequest;
  response?: PostbacksV1GetPostbackResponsePostbackAttemptResponse;
  /** @format date-time */
  createdAt?: string;
}

export interface PostbacksV1GetPostbackResponsePostbackAttemptRequest {
  http?: PostbacksV1GetPostbackResponsePostbackAttemptRequestHttp;
}

export interface PostbacksV1GetPostbackResponsePostbackAttemptRequestHttp {
  method?: string;
  url?: string;
}

export interface PostbacksV1GetPostbackResponsePostbackAttemptResponse {
  http?: PostbacksV1GetPostbackResponsePostbackAttemptResponseHttp;
}

export interface PostbacksV1GetPostbackResponsePostbackAttemptResponseHttp {
  /** @format int64 */
  statusCode?: string;
  body?: string;
}

export interface PostbacksV1GetPostbackResponsePostbackConversionType {
  id?: string;
  name?: string;
}

export interface PostbacksV1GetPostbackResponsePostbackOffer {
  id?: string;
  name?: string;
}

export interface PostbacksV1GetPostbackResponsePostbackSource {
  id?: string;
  publicId?: string;
}

export interface PostbacksV1ListPostbacksRequest {
  pagination?: TypesV1PaginationRequest;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  sourceIds?: string[];
  offerIds?: string[];
  conversionTypeIds?: string[];
  conversionIds?: string[];
  /** FIXME: Validate non-empty and unique here when validator is fixed (remove implementation in controllers) */
  conversionStatuses?: ConversionsV1ConversionStatus[];
  statuses?: PostbacksV1PostbackStatus[];
}

export interface PostbacksV1ListPostbacksResponse {
  postbacks?: PostbacksV1ListPostbacksResponsePostback[];
  pagination: TypesV1PaginationResponse;
}

export interface PostbacksV1ListPostbacksResponsePostback {
  id?: string;
  status?: PostbacksV1PostbackStatus;
  conversionId?: string;
  source?: PostbacksV1ListPostbacksResponsePostbackSource;
  offer?: PostbacksV1ListPostbacksResponsePostbackOffer;
  conversionType?: PostbacksV1ListPostbacksResponsePostbackConversionType;
  /** Check all validations on any index update. */
  conversionStatus?: ConversionsV1ConversionStatus;
  /** @format date-time */
  createdAt?: string;
}

export interface PostbacksV1ListPostbacksResponsePostbackConversionType {
  id?: string;
  name?: string;
}

export interface PostbacksV1ListPostbacksResponsePostbackOffer {
  id?: string;
  name?: string;
}

export interface PostbacksV1ListPostbacksResponsePostbackSource {
  id?: string;
  publicId?: string;
}

export interface PricingV1ConversionTypeSetting {
  id?: string;
  conversionTypeId?: string;
  conversionValueType?: EnumsV1ConversionValueType;
  /** @format int32 */
  conversionCountLimit?: number;
  /** @format int32 */
  onHoldPeriodHours?: number;
  /** Check all validations on any index update. */
  finalConversionStatus?: ConversionsV1ConversionStatus;
}

export interface PricingV1Cost {
  id?: string;
  conversionTypeId?: string;
  explicit?: TypesV1AmountOrRate;
  default?: PricingV1DefaultCost;
}

export interface PricingV1CreateCost {
  conversionTypeId?: string;
  explicit?: TypesV1AmountOrRate;
  default?: PricingV1SetDefaultCost;
}

export interface PricingV1CreateGroup {
  default: boolean;
  currency: TypesV1Currency;
  revenues: PricingV1CreateRevenue[];
  tierCosts: PricingV1CreateTierCost[];
  sourceCosts?: PricingV1CreateSourceCost[];
}

export interface PricingV1CreatePricingRequest {
  assignedOffers?: PricingV1CreatePricingRequestOfferAssignment[];
  conversionTypeSettings?: PricingV1CreatePricingRequestConversionTypeSetting[];
  superGroups: PricingV1CreateSuperGroup[];
}

export interface PricingV1CreatePricingRequestConversionTypeSetting {
  conversionTypeId?: string;
  conversionValueType?: EnumsV1ConversionValueType;
  /** @format int32 */
  conversionCountLimit?: number;
  /** @format int32 */
  onHoldPeriodHours?: number;
  /** Check all validations on any index update. */
  finalConversionStatus?: ConversionsV1ConversionStatus;
}

export interface PricingV1CreatePricingRequestOfferAssignment {
  offerId?: string;
}

export interface PricingV1CreatePricingResponse {
  pricing?: PricingV1Pricing;
}

export interface PricingV1CreateRevenue {
  conversionTypeId?: string;
  revenue?: TypesV1AmountOrRate;
  noValue?: boolean;
}

export interface PricingV1CreateSourceCost {
  sourceId?: string;
  costs?: PricingV1CreateCost[];
}

export interface PricingV1CreateSuperGroup {
  name: string;
  rules: PricingV1SuperGroupRule[];
  default: boolean;
  groups: PricingV1CreateGroup[];
}

export interface PricingV1CreateTierCost {
  tierId?: string;
  costs?: PricingV1CreateCost[];
}

export interface PricingV1DefaultCost {
  amount?: TypesV1Decimal;
  rate?: TypesV1Decimal;
  useDefaultRate?: boolean;
}

export interface PricingV1GetOwnPricingForOfferResponse {
  pricing?: PricingV1GetOwnPricingForOfferResponsePricing;
}

export interface PricingV1GetOwnPricingForOfferResponseGroup {
  id: string;
  currency: TypesV1Currency;
  costs: PricingV1Cost[];
}

export interface PricingV1GetOwnPricingForOfferResponsePricing {
  id: string;
  assignedOffers: PricingV1OfferAssignment[];
  conversionTypeSettings: PricingV1ConversionTypeSetting[];
  superGroups: PricingV1GetOwnPricingForOfferResponseSuperGroup[];
}

export interface PricingV1GetOwnPricingForOfferResponseSuperGroup {
  id: string;
  name: string;
  rules: PricingV1SuperGroupRule[];
  default: string;
  groups: PricingV1GetOwnPricingForOfferResponseGroup[];
}

export interface PricingV1GetPricingForOfferResponse {
  pricing?: PricingV1Pricing;
}

export interface PricingV1Group {
  id: string;
  default: boolean;
  currency: TypesV1Currency;
  revenues: PricingV1Revenue[];
  tierCosts: PricingV1TierCost[];
  sourceCosts: PricingV1SourceCost[];
}

export interface PricingV1OfferAssignment {
  id?: string;
  offerId?: string;
}

export interface PricingV1Pricing {
  id: string;
  assignedOffers: PricingV1OfferAssignment[];
  conversionTypeSettings: PricingV1ConversionTypeSetting[];
  superGroups: PricingV1SuperGroup[];
}

export interface PricingV1PricingIn {
  assignedOffers?: PricingV1PricingInOfferAssignment[];
  conversionTypeSettings?: PricingV1PricingInConversionTypeSetting[];
  superGroups: PricingV1UpdateSuperGroup[];
}

export interface PricingV1PricingInConversionTypeSetting {
  id?: string;
  conversionTypeId?: string;
  conversionValueType?: EnumsV1ConversionValueType;
  /** @format int32 */
  conversionCountLimit?: number;
  /** @format int32 */
  onHoldPeriodHours?: number;
  /** Check all validations on any index update. */
  finalConversionStatus?: ConversionsV1ConversionStatus;
}

export interface PricingV1PricingInOfferAssignment {
  id?: string;
  offerId?: string;
}

export interface PricingV1PricingServicePrioritizePricingSuperGroupsBody {
  orderedSuperGroupIds?: string[];
}

export interface PricingV1PricingServiceUpdatePricingBody {
  pricing?: PricingV1PricingIn;
}

export type PricingV1PrioritizePricingSuperGroupsResponse = object;

export interface PricingV1Revenue {
  id?: string;
  conversionTypeId?: string;
  revenue?: TypesV1AmountOrRate;
  noValue?: boolean;
}

export interface PricingV1SetDefaultCost {
  useDefaultRate?: boolean;
}

export interface PricingV1SourceCost {
  sourceId?: string;
  costs?: PricingV1Cost[];
}

export interface PricingV1SuperGroup {
  id: string;
  name: string;
  rules: PricingV1SuperGroupRule[];
  default: boolean;
  /** @format int32 */
  priority: number;
  groups: PricingV1Group[];
}

export interface PricingV1SuperGroupRule {
  locations?: PricingV1SuperGroupRuleLocation[];
  coupons?: PricingV1SuperGroupRuleCoupon[];
  conversionCount?: PricingV1SuperGroupRuleConversionCount;
  customerIds?: string[];
  advS1s?: string[];
  advS2s?: string[];
  advS3s?: string[];
  advS4s?: string[];
  advS5s?: string[];
  affS1s?: string[];
  affS2s?: string[];
  affS3s?: string[];
  affS4s?: string[];
  affS5s?: string[];
}

export interface PricingV1SuperGroupRuleConversionCount {
  /** @format int64 */
  min: number;
  /** @format int64 */
  max?: number;
}

export interface PricingV1SuperGroupRuleCoupon {
  code: string;
  revenueOriginId?: string;
}

export interface PricingV1SuperGroupRuleLocation {
  countryCode: string;
  subdivisionCode?: string;
  /** not supported yet */
  city?: string;
}

export interface PricingV1TierCost {
  tierId?: string;
  costs?: PricingV1Cost[];
}

export interface PricingV1UpdateCost {
  id?: string;
  conversionTypeId?: string;
  explicit?: TypesV1AmountOrRate;
  default?: PricingV1SetDefaultCost;
}

export interface PricingV1UpdateGroup {
  id?: string;
  default: boolean;
  currency: TypesV1Currency;
  revenues: PricingV1UpdateRevenue[];
  tierCosts: PricingV1UpdateTierCost[];
  sourceCosts?: PricingV1UpdateSourceCost[];
}

export interface PricingV1UpdatePricingResponse {
  pricing?: PricingV1Pricing;
}

export interface PricingV1UpdateRevenue {
  id?: string;
  conversionTypeId?: string;
  revenue?: TypesV1AmountOrRate;
  noValue?: boolean;
}

export interface PricingV1UpdateSourceCost {
  sourceId?: string;
  costs?: PricingV1UpdateCost[];
}

export interface PricingV1UpdateSuperGroup {
  id?: string;
  name: string;
  rules: PricingV1SuperGroupRule[];
  default: boolean;
  groups: PricingV1UpdateGroup[];
}

export interface PricingV1UpdateTierCost {
  tierId?: string;
  costs?: PricingV1UpdateCost[];
}

export interface PricingAdjustmentsV1CreatePricingAdjustmentRequest {
  pricingAdjustment: PricingAdjustmentsV1PricingAdjustmentIn;
}

export interface PricingAdjustmentsV1CreatePricingAdjustmentResponse {
  pricingAdjustment: PricingAdjustmentsV1PricingAdjustmentOut;
}

export type PricingAdjustmentsV1DeletePricingAdjustmentResponse = object;

export interface PricingAdjustmentsV1GetPricingAdjustmentResponse {
  pricingAdjustment: PricingAdjustmentsV1PricingAdjustmentOut;
}

export interface PricingAdjustmentsV1ListPricingAdjustmentsResponse {
  pricingAdjustments: PricingAdjustmentsV1PricingAdjustmentOut[];
}

export interface PricingAdjustmentsV1PricingAdjustmentIn {
  name: string;
  status: EnumsV1PricingAdjustmentStatus;
  rules?: PricingAdjustmentsV1Rule[];
  revenueRate?: TypesV1UnsignedDecimal;
  costRate?: TypesV1UnsignedDecimal;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface PricingAdjustmentsV1PricingAdjustmentOut {
  id: string;
  name: string;
  status: EnumsV1PricingAdjustmentStatus;
  rules?: PricingAdjustmentsV1Rule[];
  revenueRate?: TypesV1Decimal;
  costRate?: TypesV1Decimal;
  /** @format int64 */
  position: number;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format date-time */
  createdAt: string;
}

export interface PricingAdjustmentsV1PricingAdjustmentServiceUpdatePricingAdjustmentBody {
  pricingAdjustment: PricingAdjustmentsV1PricingAdjustmentIn;
}

export interface PricingAdjustmentsV1PricingAdjustmentServiceUpdatePricingAdjustmentPositionBody {
  /** @format int64 */
  position: number;
}

export interface PricingAdjustmentsV1Rule {
  sourceIds?: string[];
  tierIds?: string[];
  offer?: TypesV1RuleElementScope;
  tagIds?: string[];
  categoryIds?: string[];
  conversionCount?: PricingAdjustmentsV1RuleConversionCount;
  conversionTypeIds?: string[];
  affS1?: PricingAdjustmentsV1RuleAffS;
  affS2?: PricingAdjustmentsV1RuleAffS;
  affS3?: PricingAdjustmentsV1RuleAffS;
  affS4?: PricingAdjustmentsV1RuleAffS;
  affS5?: PricingAdjustmentsV1RuleAffS;
}

export interface PricingAdjustmentsV1RuleAffS {
  isEmpty?: boolean;
  equals?: PricingAdjustmentsV1RuleAffSEquals;
}

export interface PricingAdjustmentsV1RuleAffSEquals {
  values: string[];
}

export interface PricingAdjustmentsV1RuleConversionCount {
  /** @format int64 */
  min: number;
  /** @format int64 */
  max?: number;
}

export type PricingAdjustmentsV1UpdatePricingAdjustmentPositionResponse =
  object;

export interface PricingAdjustmentsV1UpdatePricingAdjustmentResponse {
  pricingAdjustment: PricingAdjustmentsV1PricingAdjustmentOut;
}

export interface RedirectDomainsV1ListRedirectDomainsResponse {
  redirectDomains: RedirectDomainsV1ListRedirectDomainsResponseRedirectDomain[];
}

export interface RedirectDomainsV1ListRedirectDomainsResponseRedirectDomain {
  name: string;
  custom: boolean;
}

export interface RedirectLinksV1ListRedirectLinksRequest {
  offerIds?: string[];
}

export interface RedirectLinksV1ListRedirectLinksResponse {
  redirectLinks?: RedirectLinksV1ListRedirectLinksResponseRedirectLink[];
}

export interface RedirectLinksV1ListRedirectLinksResponseRedirectLink {
  id: string;
  landingPage: RedirectLinksV1ListRedirectLinksResponseRedirectLinkLandingPage;
  offer: RedirectLinksV1ListRedirectLinksResponseRedirectLinkOffer;
}

export interface RedirectLinksV1ListRedirectLinksResponseRedirectLinkLandingPage {
  id: string;
  url: string;
  name: string;
}

export interface RedirectLinksV1ListRedirectLinksResponseRedirectLinkOffer {
  id: string;
  name: string;
}

export interface ReferralAccountSettingsV1CommissionRates {
  rates?: TypesV1Decimal[];
}

export interface ReferralAccountSettingsV1CreateReferralAccountSettingRequest {
  accountId?: string;
  /** optional */
  commissionRates?: ReferralAccountSettingsV1CommissionRates;
}

export type ReferralAccountSettingsV1CreateReferralAccountSettingResponse =
  object;

export type ReferralAccountSettingsV1DeleteReferralAccountSettingResponse =
  object;

export interface ReferralAccountSettingsV1GetReferralAccountSettingResponse {
  referralAccountSetting?: ReferralAccountSettingsV1ReferralAccountSetting;
}

export interface ReferralAccountSettingsV1ListReferralAccountSettingsRequest {
  pagination: TypesV1PaginationRequest;
  accountIds?: string[];
  hasOwnCommissionRates?: boolean;
}

export interface ReferralAccountSettingsV1ListReferralAccountSettingsResponse {
  referralAccountSettings?: ReferralAccountSettingsV1ReferralAccountSetting[];
  pagination: TypesV1PaginationResponse;
}

export interface ReferralAccountSettingsV1ReferralAccountSetting {
  id: string;
  account: ReferralAccountSettingsV1ReferralAccountSettingAccount;
  commissionRates?: ReferralAccountSettingsV1CommissionRates;
}

export interface ReferralAccountSettingsV1ReferralAccountSettingAccount {
  id: string;
  name: string;
}

export interface ReferralAccountSettingsV1ReferralAccountSettingServiceUpdateReferralAccountSettingBody {
  /** optional */
  commissionRates?: ReferralAccountSettingsV1CommissionRates;
}

export type ReferralAccountSettingsV1UpdateReferralAccountSettingResponse =
  object;

export interface ReferralsV1GetChildAccountsCountResponse {
  /** @format uint64 */
  count?: string;
}

/** Affiliate account */
export interface ReportsV1Account {
  /** Internal ID */
  id?: string;
  /** Affiliate name */
  name?: string;
}

/** Affiliate report request */
export interface ReportsV1AffiliateOverviewReportRequest {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Conversion types */
  conversionTypeIds?: string[];
  /** Conversion statuses */
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

/** Affiliate report data */
export interface ReportsV1AffiliateOverviewReportResponse {
  rows?: ReportsV1AffiliateOverviewReportResponseRow[];
  total?: ReportsV1OverviewReportTotal;
}

export interface ReportsV1AffiliateOverviewReportResponseRow {
  /** Affiliate account information */
  account?: ReportsV1Account;
  /**
   * Number of clicks
   * @format int64
   */
  clickCount?: string;
  /**
   * Gross number of clicks
   * @format int64
   */
  grossClickCount?: string;
  /**
   * Number of coupon uses
   * @format int64
   */
  couponCount?: string;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /**
   * Number of MLM commissions
   * @format int64
   */
  commissionCount?: string;
  /** Total conversion amount */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue */
  totalRevenue?: TypesV1Decimal;
  /** Total payout to affiliates */
  totalCost?: TypesV1Decimal;
  /** Total payout of MLM commissions */
  totalCommissionAmount?: TypesV1Decimal;
  /** Total profit */
  profit?: TypesV1Decimal;
  /** Total advertiser profit */
  advertiserProfit?: TypesV1Decimal;
  /** Conversion per click ratio */
  conversionPerClickRate?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliate */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount per click */
  conversionAmountPerClick?: TypesV1Decimal;
  /** Average revenue per click */
  revenuePerClick?: TypesV1Decimal;
  /** Average affiliate payout per click */
  costPerClick?: TypesV1Decimal;
  /** Average MLM commission payout per click */
  averageCommissionAmount?: TypesV1Decimal;
}

/** Category */
export interface ReportsV1Category {
  /** Category ID */
  id?: string;
  /** Category name */
  name?: string;
}

/** Click report filters */
export interface ReportsV1ClickReportFilters {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Click ID */
  cids?: string[];
  /** External CID */
  externalCids?: string[];
  /** Country code. Uses ISO 3166 three letter format */
  countryCodes?: string[];
  /** Traffic source IDs */
  sourceIds?: string[];
  /** Offer ID */
  offerIds?: string[];
  /** IP address of click's origin */
  ipAddresses?: string[];
  /** Referrer URL */
  referrer?: string;
  /** Aff s1 custom parameter */
  affS1s?: string[];
  /** Aff s2 custom parameter */
  affS2s?: string[];
  /** Aff s3 custom parameter */
  affS3s?: string[];
  /** Aff s4 custom parameter */
  affS4s?: string[];
  /** Aff s5 custom parameter */
  affS5s?: string[];
  /** Is click flagged by fraud detection? */
  fraudSuspicion?: TypesV1FraudSuspicionFilter;
  /** Advertisers */
  revenueOriginIds?: string[];
}

/** Click report request */
export interface ReportsV1ClickReportRequest {
  /** Pagination */
  pagination?: TypesV1PaginationRequest;
  /** Filters (see above) */
  filters?: ReportsV1ClickReportFilters;
}

/** Click report data */
export interface ReportsV1ClickReportResponse {
  rows?: ReportsV1ClickReportResponseRow[];
  pagination: TypesV1PaginationResponse;
}

/** Click identifiers */
export interface ReportsV1ClickReportResponseConversionSourceExternalIdentifier {
  /** External identifier ID */
  id?: string;
  /** External click ID */
  externalCid?: string;
  /** Click's revenue origin (or advertiser) */
  revenueOriginId?: string;
}

/** Custom affiliate parameters */
export interface ReportsV1ClickReportResponseCustomParams {
  /** Aff s1 parameter */
  affS1?: string;
  /** Aff s2 parameter */
  affS2?: string;
  /** Aff s3 parameter */
  affS3?: string;
  /** Aff s4 parameter */
  affS4?: string;
  /** Aff s5 parameter */
  affS5?: string;
}

/** Offer */
export interface ReportsV1ClickReportResponseOffer {
  /** Offer ID */
  id?: string;
  /** Offer name */
  name?: string;
}

/** Revenue origin (or advertiser) */
export interface ReportsV1ClickReportResponseRevenueOrigin {
  /** Revenue origin/advertiser ID */
  id?: string;
  /** Revenue origin/advertiser name */
  name?: string;
}

export interface ReportsV1ClickReportResponseRow {
  /**
   * Timestamp
   * @format date-time
   */
  createdAt?: string;
  /** Click ID */
  cid?: string;
  /** Deprecated: Click external ID */
  conversionSourceExternalIdentifier?: ReportsV1ClickReportResponseConversionSourceExternalIdentifier;
  /** Click external IDs */
  conversionSourceExternalIdentifiers?: ReportsV1ClickReportResponseConversionSourceExternalIdentifier[];
  /** Country code */
  countryCode?: string;
  /** Traffic source */
  source?: ReportsV1ClickReportResponseSource;
  /** Offer */
  offer?: ReportsV1ClickReportResponseOffer;
  /** IP address */
  ipAddress?: string;
  /** Browser, OS and device */
  userAgent?: string;
  /** Referrer URL */
  referrer?: string;
  /**
   * Gross click count
   * @format int64
   */
  grossClickCount?: number;
  /** Custom parameters */
  params?: ReportsV1ClickReportResponseCustomParams;
  /** Is flagged by fraud detection system? */
  fraudSuspicion?: TypesV1FraudSuspicion;
  /** Click status */
  status?: EnumsV1ClickStatus;
  /** Revenue origin/advertiser */
  revenueOrigin?: ReportsV1ClickReportResponseRevenueOrigin;
  /** Click origin (type) */
  type?: EnumsV1ClickType;
  /** Click properties applied during LP targeting */
  targetingData?: ReportsV1ClickReportResponseTargetingData;
  /** Anura fraud detection */
  anura?: TypesV1Anura;
}

/** Source affiliate */
export interface ReportsV1ClickReportResponseSource {
  /** Affiliate ID */
  id?: string;
  /** Affiliate public ID */
  publicId?: string;
}

/** Click properties applied during LP targeting */
export interface ReportsV1ClickReportResponseTargetingData {
  location?: LocationsV1Location;
  language?: string;
  device?: ReportsV1ClickReportResponseTargetingDataDevice;
  operatingSystem?: ReportsV1ClickReportResponseTargetingDataOperatingSystem;
}

export interface ReportsV1ClickReportResponseTargetingDataDevice {
  value: EnumsV1Device;
}

export interface ReportsV1ClickReportResponseTargetingDataOperatingSystem {
  value: EnumsV1OperatingSystem;
}

/** MLM commission report filters */
export interface ReportsV1CommissionReportFilters {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Conversion IDs */
  conversionIds?: string[];
  /** Parent affiliate ID */
  referralAccountIds?: string[];
  /** Currency codes */
  currencyCodes?: string[];
  /** Conversion statuses */
  conversionStatuses?: ConversionsV1ConversionStatus[];
  /** Conversion types */
  conversionTypeIds?: string[];
}

/** MLM commission report request */
export interface ReportsV1CommissionReportRequest {
  pagination?: TypesV1PaginationRequest;
  filters?: ReportsV1CommissionReportFilters;
}

/** MLM commission report */
export interface ReportsV1CommissionReportResponse {
  rows?: ReportsV1CommissionReportResponseRow[];
  pagination: TypesV1PaginationResponse;
}

export interface ReportsV1CommissionReportResponseConversionSourceAccount {
  /** Conversion affiliate internal ID */
  id?: string;
  /** Conversion affiliate name */
  name?: string;
  /** Conversion affiliate email */
  email?: string;
}

/** Conversion type */
export interface ReportsV1CommissionReportResponseConversionType {
  /** Conversion type ID */
  id?: string;
  /** Conversion type name */
  name?: string;
}

export interface ReportsV1CommissionReportResponseRow {
  /**
   * Timestamp of commission creation
   * @format date-time
   */
  createdAt?: string;
  /** Commission ID */
  id?: string;
  /** Conversion ID */
  conversionId?: string;
  /** Parent affiliate */
  referralAccount?: ReportsV1Account;
  /** Commission amount */
  amount?: TypesV1Decimal;
  /** Currency code */
  currencyCode?: string;
  /**
   * Conversion status
   * Check all validations on any index update.
   */
  conversionStatus?: ConversionsV1ConversionStatus;
  /** Settlement ID */
  accountSettlementId?: string;
  /** Conversion type */
  conversionType?: ReportsV1CommissionReportResponseConversionType;
  /** Conversion affiliate */
  conversionSourceAccount?: ReportsV1CommissionReportResponseConversionSourceAccount;
}

export interface ReportsV1ConversionDrilldown {
  conversionTypeIds?: string[];
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

/** Filters for conversion report */
export interface ReportsV1ConversionReportFilters {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Conversion IDs */
  conversionIds?: string[];
  /** Click IDs */
  cids?: string[];
  /** External click IDs */
  externalCids?: string[];
  /** Coupon codes */
  couponCodes?: string[];
  /** Country code. Uses ISO 3166 three letter format */
  countryCodes?: string[];
  /** Source IDs */
  sourceIds?: string[];
  /** Offer IDs */
  offerIds?: string[];
  /** Conversion sources */
  conversionStatuses?: ConversionsV1ConversionStatus[];
  /** Conversion types */
  conversionTypeIds?: string[];
  /** Traffic source types */
  conversionSourceTypes?: string[];
  /** External IDs */
  externalIds?: string[];
  /** Customer IDs */
  customerIds?: string[];
  /** Custom adv s1 parameter */
  advS1s?: string[];
  /** Custom adv s2 parameter */
  advS2s?: string[];
  /** Custom adv s3 parameter */
  advS3s?: string[];
  /** Custom adv s4 parameter */
  advS4s?: string[];
  /** Custom adv s5 parameter */
  advS5s?: string[];
  /** Custom aff s1 parameter */
  affS1s?: string[];
  /** Custom aff s2 parameter */
  affS2s?: string[];
  /** Custom aff s3 parameter */
  affS3s?: string[];
  /** Custom aff s4 parameter */
  affS4s?: string[];
  /** Custom aff s5 parameter */
  affS5s?: string[];
  /** Currency codes. Uses ISO 4217 format */
  currencyCodes?: string[];
  /** Is flagged by fraud detection? */
  fraudSuspicion?: TypesV1FraudSuspicionFilter;
  /** Advertisers */
  revenueOriginIds?: string[];
  /** Settlement IDs */
  settlementIds?: string[];
  /** Self-billing invoice IDs */
  accountSettlementIds?: string[];
  /** Claim IDs */
  claimIds?: string[];
}

/** Conversion report request */
export interface ReportsV1ConversionReportRequest {
  /** Pagination */
  pagination?: TypesV1PaginationRequest;
  /** Conversion report filters (see above) */
  filters?: ReportsV1ConversionReportFilters;
}

/** Conversion report data */
export interface ReportsV1ConversionReportResponse {
  rows?: ReportsV1ConversionReportResponseRow[];
  pagination: TypesV1PaginationResponse;
}

/** Custom affiliate parameters */
export interface ReportsV1ConversionReportResponseConversionSourceCustomParams {
  /** Custom aff s1 parameter */
  affS1?: string;
  /** Custom aff s2 parameter */
  affS2?: string;
  /** Custom aff s3 parameter */
  affS3?: string;
  /** Custom aff s4 parameter */
  affS4?: string;
  /** Custom aff s5 parameter */
  affS5?: string;
}

/** Conversion type */
export interface ReportsV1ConversionReportResponseConversionType {
  /** Conversion type ID */
  id?: string;
  /** Conversion type name */
  name?: string;
}

/** Custom advertiser parameters */
export interface ReportsV1ConversionReportResponseCustomParams {
  /** Custom adv s1 parameter */
  advS1?: string;
  /** Custom adv s2 parameter */
  advS2?: string;
  /** Custom adv s3 parameter */
  advS3?: string;
  /** Custom adv s4 parameter */
  advS4?: string;
  /** Custom adv s5 parameter */
  advS5?: string;
}

/** Revenue origin / advertiser */
export interface ReportsV1ConversionReportResponseRevenueOrigin {
  /** Advertiser ID */
  id?: string;
  /** Advertiser name */
  name?: string;
}

export interface ReportsV1ConversionReportResponseRow {
  /**
   * Timestamp of conversion's creation
   * @format date-time
   */
  createdAt?: string;
  /** Conversion ID */
  conversionId?: string;
  /** Click ID */
  cid?: string;
  /** External click ID */
  externalCid?: string;
  /** Coupon code */
  couponCode?: string;
  /** Country code */
  countryCode?: string;
  /** Traffic source */
  source?: ReportsV1ConversionReportResponseSource;
  /** Offer */
  offer?: ReportsV1Offer;
  /**
   * Conversion status
   * Check all validations on any index update.
   */
  conversionStatus?: ConversionsV1ConversionStatus;
  /** Conversion type */
  conversionType?: ReportsV1ConversionReportResponseConversionType;
  /** Traffic source type */
  conversionSourceType?: string;
  /** Original amount of the conversion the revenue and cost is calculated from */
  conversionAmount?: TypesV1Decimal;
  /** Revenue */
  revenue?: TypesV1Decimal;
  /** Payout to affiliate */
  cost?: TypesV1Decimal;
  /** Adjusted revenue */
  normalizedRevenue?: TypesV1Decimal;
  /** Adjusted payout to affiliate */
  normalizedCost?: TypesV1Decimal;
  /** Original revenue */
  originalRevenue?: TypesV1Decimal;
  /** Original payout to affiliate */
  originalCost?: TypesV1Decimal;
  /**
   * Timestamp of last revenue adjustment
   * @format date-time
   */
  revenueUpdatedAt?: string;
  /**
   * Timestamp of last payout to affiliate adjustment
   * @format date-time
   */
  costUpdatedAt?: string;
  /** Custom payouts override automatically calculated values */
  customPayoutsApplied?: boolean;
  /** Currency code */
  currencyCode?: string;
  /** External ID */
  externalId?: string;
  /** Customer ID */
  customerId?: string;
  /** Custom parameters */
  params?: ReportsV1ConversionReportResponseCustomParams;
  /** Conversion source parameters */
  conversionSourceParams?: ReportsV1ConversionReportResponseConversionSourceCustomParams;
  /** Settlement ID */
  settlementId?: string;
  /** Self-billing invoice ID */
  accountSettlementId?: string;
  /** Is flagged by fraud detection system? */
  fraudSuspicion?: TypesV1FraudSuspicion;
  /**
   * On-hold period end timestamp
   * @format date-time
   */
  onHoldUntil?: string;
  /** Revenue origin / advertiser */
  revenueOrigin?: ReportsV1ConversionReportResponseRevenueOrigin;
  /** Claim ID */
  claimId?: string;
  /** Revenue adjustment name. Revenue was adjusted only if it was filled. */
  revenueAdjustmentName?: string;
  /** Affiliate's payout adjustment name. Affiliate's payout was adjusted only if it was filled. */
  costAdjustmentName?: string;
}

/** Source affiliate */
export interface ReportsV1ConversionReportResponseSource {
  /** Affiliate ID */
  id?: string;
  /** Affiliate public ID */
  publicId?: string;
}

/** Country overview report request */
export interface ReportsV1CountryOverviewReportRequest {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Conversion types */
  conversionTypeIds?: string[];
  /** Conversion statuses */
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

/** Country overview report data */
export interface ReportsV1CountryOverviewReportResponse {
  rows?: ReportsV1CountryOverviewReportResponseRow[];
  total?: ReportsV1OverviewReportTotal;
}

export interface ReportsV1CountryOverviewReportResponseRow {
  /** Country code. Uses ISO 3166 three letter format */
  countryCode?: string;
  /**
   * Number of clicks
   * @format int64
   */
  clickCount?: string;
  /**
   * Gross number of clicks
   * @format int64
   */
  grossClickCount?: string;
  /**
   * Number of coupon uses
   * @format int64
   */
  couponCount?: string;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /**
   * Number of MLM commissions
   * @format int64
   */
  commissionCount?: string;
  /** Total conversion amount */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue */
  totalRevenue?: TypesV1Decimal;
  /** Total payout for affiliates */
  totalCost?: TypesV1Decimal;
  /** Total MLM commission payouts */
  totalCommissionAmount?: TypesV1Decimal;
  /** Total profit */
  profit?: TypesV1Decimal;
  /** Total advertiser profit */
  advertiserProfit?: TypesV1Decimal;
  /** Conversion per click ratio */
  conversionPerClickRate?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliate */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount per click */
  conversionAmountPerClick?: TypesV1Decimal;
  /** Average revenue per click */
  revenuePerClick?: TypesV1Decimal;
  /** Average affiliate payout per click */
  costPerClick?: TypesV1Decimal;
  /** Average MLM commission payout per click */
  averageCommissionAmount?: TypesV1Decimal;
}

/** Coupon */
export interface ReportsV1Coupon {
  /** Coupon ID */
  id?: string;
  /** Coupon code */
  code?: string;
}

/** Coupon redemption report filters */
export interface ReportsV1CouponRedemptionReportFilters {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Coupon redemption ID */
  cids?: string[];
  /** External CID */
  externalCids?: string[];
  /** Country code. Uses ISO 3166 three letter format */
  countryCodes?: string[];
  /** Traffic source IDs */
  sourceIds?: string[];
  /** Offer ID */
  offerIds?: string[];
  /** Aff s1 custom parameter */
  affS1s?: string[];
  /** Aff s2 custom parameter */
  affS2s?: string[];
  /** Aff s3 custom parameter */
  affS3s?: string[];
  /** Aff s4 custom parameter */
  affS4s?: string[];
  /** Aff s5 custom parameter */
  affS5s?: string[];
  /** Advertisers */
  revenueOriginIds?: string[];
  /** Coupon codes */
  couponCodes?: string[];
}

/** Coupon redemption report request */
export interface ReportsV1CouponRedemptionReportRequest {
  /** Pagination */
  pagination?: TypesV1PaginationRequest;
  /** Filters (see above) */
  filters?: ReportsV1CouponRedemptionReportFilters;
}

/** Coupon redemption report data */
export interface ReportsV1CouponRedemptionReportResponse {
  rows?: ReportsV1CouponRedemptionReportResponseRow[];
  pagination: TypesV1PaginationResponse;
}

/** Coupon identifiers */
export interface ReportsV1CouponRedemptionReportResponseConversionSourceExternalIdentifier {
  /** External identifier ID */
  id?: string;
  /** External coupon redemption ID */
  externalCid?: string;
  /** Coupon's revenue origin (or advertiser) */
  revenueOriginId?: string;
}

/** Custom affiliate parameters */
export interface ReportsV1CouponRedemptionReportResponseCustomParams {
  /** Aff s1 parameter */
  affS1?: string;
  /** Aff s2 parameter */
  affS2?: string;
  /** Aff s3 parameter */
  affS3?: string;
  /** Aff s4 parameter */
  affS4?: string;
  /** Aff s5 parameter */
  affS5?: string;
}

/** Offer */
export interface ReportsV1CouponRedemptionReportResponseOffer {
  /** Offer ID */
  id?: string;
  /** Offer name */
  name?: string;
}

/** Revenue origin (or advertiser) */
export interface ReportsV1CouponRedemptionReportResponseRevenueOrigin {
  /** Revenue origin/advertiser ID */
  id?: string;
  /** Revenue origin/advertiser name */
  name?: string;
}

export interface ReportsV1CouponRedemptionReportResponseRow {
  /**
   * Timestamp
   * @format date-time
   */
  createdAt?: string;
  /** Coupon redemption ID */
  cid?: string;
  /** Deprecated: Coupon external ID */
  conversionSourceExternalIdentifier?: ReportsV1CouponRedemptionReportResponseConversionSourceExternalIdentifier;
  /** Coupon redemption external IDs */
  conversionSourceExternalIdentifiers?: ReportsV1CouponRedemptionReportResponseConversionSourceExternalIdentifier[];
  /** Country code */
  countryCode?: string;
  /** Traffic source */
  source?: ReportsV1CouponRedemptionReportResponseSource;
  /** Offer */
  offer?: ReportsV1CouponRedemptionReportResponseOffer;
  /** Custom parameters */
  params?: ReportsV1CouponRedemptionReportResponseCustomParams;
  /** Coupon ID */
  couponId?: string;
  /** Coupon code */
  couponCode?: string;
  /** Coupon status */
  couponStatus?: CouponsV1CouponStatus;
  /** Revenue origin/advertiser */
  revenueOrigin?: ReportsV1CouponRedemptionReportResponseRevenueOrigin;
}

/** Source affiliate */
export interface ReportsV1CouponRedemptionReportResponseSource {
  /** Affiliate ID */
  id?: string;
  /** Affiliate public ID */
  publicId?: string;
}

export interface ReportsV1CreateReportPresetsForAccountRequest {
  presets?: ReportsV1ReportPreset[];
}

export interface ReportsV1CreateReportPresetsForAccountResponse {
  reportPresets?: ReportsV1ReportPresets;
}

/** Daily overview report request */
export interface ReportsV1DailyOverviewReportRequest {
  /** Start date of reported days */
  from?: string;
  /** End day of reported days */
  to?: string;
  /** Timezone to offset in reports */
  timezone?: string;
  /** Conversion types present in the report */
  conversionTypeIds?: string[];
  conversionStatuses?: ConversionsV1ConversionStatus[];
  sourceIds?: string[];
}

/** Daily overview data */
export interface ReportsV1DailyOverviewReportResponse {
  rows?: ReportsV1DailyOverviewReportResponseRow[];
  total?: ReportsV1OverviewReportTotal;
}

export interface ReportsV1DailyOverviewReportResponseRow {
  /** Date */
  date?: string;
  /**
   * Number of clicks
   * @format int64
   */
  clickCount?: string;
  /**
   * Gross number of clicks
   * @format int64
   */
  grossClickCount?: string;
  /**
   * Number of coupon uses
   * @format int64
   */
  couponCount?: string;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /**
   * Number of MLM commissions
   * @format int64
   */
  commissionCount?: string;
  /** Total conversion amount for the day */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue for the day */
  totalRevenue?: TypesV1Decimal;
  /** Total affiliate payout for the day */
  totalCost?: TypesV1Decimal;
  /** Total MLM commissions payout for the day */
  totalCommissionAmount?: TypesV1Decimal;
  /** Total profit for the day */
  profit?: TypesV1Decimal;
  /** Total advertiser profit for the day */
  advertiserProfit?: TypesV1Decimal;
  /** Conversion per click ratio */
  conversionPerClickRate?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliate */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount per click */
  conversionAmountPerClick?: TypesV1Decimal;
  /** Average revenue per click */
  revenuePerClick?: TypesV1Decimal;
  /** Average affiliate payout per click */
  costPerClick?: TypesV1Decimal;
  /** Average MLM commission payout per click */
  averageCommissionAmount?: TypesV1Decimal;
}

export type ReportsV1DeleteReportPresetsForAccountResponse = object;

/** Export click report request */
export interface ReportsV1ExportClickReportRequest {
  /** Click report filters */
  filters?: ReportsV1ClickReportFilters;
  /** Click export configuration */
  config?: ExportV1Export;
  /** Click export scope */
  scope?: ExportV1Scope;
}

/** Click report export */
export interface ReportsV1ExportClickReportResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

/** Export commission report request */
export interface ReportsV1ExportCommissionReportRequest {
  /** Filters */
  filters?: ReportsV1CommissionReportFilters;
  /** Export configuration */
  config?: ExportV1Export;
  /** Export scope */
  scope?: ExportV1Scope;
}

/** Exported MLM commissions */
export interface ReportsV1ExportCommissionReportResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

/** Export conversion report request */
export interface ReportsV1ExportConversionReportRequest {
  /** Filters */
  filters?: ReportsV1ConversionReportFilters;
  /** Export configuration */
  config?: ExportV1Export;
  /** Export scope */
  scope?: ExportV1Scope;
}

/** Conversion export */
export interface ReportsV1ExportConversionReportResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

/** Export coupon redemption report request */
export interface ReportsV1ExportCouponRedemptionReportRequest {
  /** Coupon redemption report filters */
  filters?: ReportsV1CouponRedemptionReportFilters;
  /** Coupon export configuration */
  config?: ExportV1Export;
  /** Coupon export scope */
  scope?: ExportV1Scope;
}

/** Coupon redemption report export */
export interface ReportsV1ExportCouponRedemptionReportResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

/** Export general overview request */
export interface ReportsV1ExportGeneralOverviewReportRequest {
  /** Filters (see above) */
  filters?: ReportsV1GeneralOverviewReportFilters;
  /** Grouping levels */
  groupingLevels?: EnumsV1ReportGrouping[];
  /** Optional conversion drilldown statistics */
  conversionDrilldown?: ReportsV1ConversionDrilldown;
  /** Timezone to offset in reports */
  timezone?: string;
  /** Export configuration */
  config?: ExportV1Export;
}

/** Export general overview response */
export interface ReportsV1ExportGeneralOverviewReportResponse {
  /**
   * Message that represents an arbitrary HTTP body. It should only be used for
   * payload formats that can't be represented as JSON, such as raw binary or
   * an HTML page.
   *
   *
   * This message can be used both in streaming and non-streaming API methods in
   * the request as well as the response.
   *
   * It can be used as a top-level request field, which is convenient if one
   * wants to extract parameters from either the URL or HTTP template into the
   * request fields and also want access to the raw HTTP body.
   *
   * Example:
   *
   *     message GetResourceRequest {
   *       // A unique request id.
   *       string request_id = 1;
   *
   *       // The raw HTTP body is bound to this field.
   *       google.api.HttpBody http_body = 2;
   *
   *     }
   *
   *     service ResourceService {
   *       rpc GetResource(GetResourceRequest)
   *         returns (google.api.HttpBody);
   *       rpc UpdateResource(google.api.HttpBody)
   *         returns (google.protobuf.Empty);
   *
   *     }
   *
   * Example with streaming methods:
   *
   *     service CaldavService {
   *       rpc GetCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *       rpc UpdateCalendar(stream google.api.HttpBody)
   *         returns (stream google.api.HttpBody);
   *
   *     }
   *
   * Use of this type only changes how the request and response bodies are
   * handled, all other features will continue to work unchanged.
   */
  body?: GoogleApiHttpBody;
}

/** General report filters */
export interface ReportsV1GeneralOverviewReportFilters {
  /** Time range */
  timeRange: TypesV1TimeRange;
  /** Conversion types */
  conversionTypeIds?: string[];
  /** Conversion statuses */
  conversionStatuses?: ConversionsV1ConversionStatus[];
  /** Traffic source IDs */
  sourceIds?: string[];
  /** Account IDs */
  accountIds?: string[];
  /** Country codes */
  countryCodes?: string[];
  /** Revenue origin IDs */
  revenueOriginIds?: string[];
  /** Offer IDs */
  offerIds?: string[];
  /** Category IDs */
  categoryIds?: string[];
  /** Tier IDs */
  tierIds?: string[];
  /** Landing page IDs */
  landingPageIds?: string[];
  /** Coupon IDs */
  couponIds?: string[];
  /** Affiliate manager ID */
  affiliateManagerId?: string;
}

/** General overview request */
export interface ReportsV1GeneralOverviewReportRequest {
  /** Filters (see above) */
  filters: ReportsV1GeneralOverviewReportFilters;
  /** Grouping levels */
  groupingLevels: EnumsV1ReportGrouping[];
  /** Optional conversion drilldown statistics */
  conversionDrilldown?: ReportsV1ConversionDrilldown;
  /** Timezone to offset in reports */
  timezone: string;
}

/** General overview data */
export interface ReportsV1GeneralOverviewReportResponse {
  rows: ReportsV1GeneralOverviewReportResponseRow[];
  total: ReportsV1GeneralOverviewReportResponseTotal;
}

export interface ReportsV1GeneralOverviewReportResponseConversionDrilldownValues {
  conversionTypeId?: string;
  /** Check all validations on any index update. */
  conversionStatus?: ConversionsV1ConversionStatus;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /** Total conversion amount */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue */
  totalRevenue?: TypesV1Decimal;
  /** Total payout to affiliates */
  totalCost?: TypesV1Decimal;
  /** Total profit */
  profit?: TypesV1Decimal;
  /** Total advertiser profit */
  advertiserProfit?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliates */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount of click conversions */
  averageClickConversionAmount?: TypesV1Decimal;
  /** Average revenue of click conversions */
  averageClickRevenue?: TypesV1Decimal;
  /** Average payout to affiliates of click conversions */
  averageClickCost?: TypesV1Decimal;
}

export interface ReportsV1GeneralOverviewReportResponseRow {
  values: ReportsV1OverviewReportValues;
  conversionDrilldownValues?: ReportsV1GeneralOverviewReportResponseConversionDrilldownValues[];
  subRows?: ReportsV1GeneralOverviewReportResponseRow[];
  /** @format date-time */
  hour?: string;
  /** @format date-time */
  day?: string;
  /** @format date-time */
  week?: string;
  /** @format date-time */
  month?: string;
  /** @format date-time */
  year?: string;
  account?: ReportsV1Account;
  countryCode?: string;
  offer?: ReportsV1Offer;
  revenueOrigin?: ReportsV1RevenueOrigin;
  affiliateManagerAccount?: ReportsV1Account;
  category?: ReportsV1Category;
  coupon?: ReportsV1Coupon;
  landingPage?: ReportsV1LandingPage;
  source?: ReportsV1Source;
  tier?: ReportsV1Tier;
}

export interface ReportsV1GeneralOverviewReportResponseTotal {
  values: ReportsV1OverviewReportValues;
  conversionDrilldownValues?: ReportsV1GeneralOverviewReportResponseConversionDrilldownValues[];
}

export interface ReportsV1GetReportPresetsForAccountResponse {
  reportPresets?: ReportsV1ReportPresets;
}

/** Landing page */
export interface ReportsV1LandingPage {
  /** Internal ID */
  id?: string;
  /** Landing page name */
  name?: string;
  /** Landing page URL */
  url?: string;
}

/** Offer */
export interface ReportsV1Offer {
  /** Offer ID */
  id?: string;
  /** Offer name */
  name?: string;
}

/** Offer report request */
export interface ReportsV1OfferOverviewReportRequest {
  /** Time range */
  timeRange?: TypesV1TimeRange;
  /** Conversion types */
  conversionTypeIds?: string[];
  /** Conversion statuses */
  conversionStatuses?: ConversionsV1ConversionStatus[];
  sourceIds?: string[];
}

/** Offer report data */
export interface ReportsV1OfferOverviewReportResponse {
  rows?: ReportsV1OfferOverviewReportResponseRow[];
  total?: ReportsV1OverviewReportTotal;
}

export interface ReportsV1OfferOverviewReportResponseRow {
  /** Offer */
  offer?: ReportsV1Offer;
  /**
   * Number of clicks,
   * @format int64
   */
  clickCount?: string;
  /**
   * Gross number of clicks
   * @format int64
   */
  grossClickCount?: string;
  /**
   * Number of coupon uses
   * @format int64
   */
  couponCount?: string;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /**
   * Number of MLM commissions
   * @format int64
   */
  commissionCount?: string;
  /** Total conversion amount */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue */
  totalRevenue?: TypesV1Decimal;
  /** Total payout to affiliates */
  totalCost?: TypesV1Decimal;
  /** Total payout of MLM commissions */
  totalCommissionAmount?: TypesV1Decimal;
  /** Total profit */
  profit?: TypesV1Decimal;
  /** Total advertiser profit */
  advertiserProfit?: TypesV1Decimal;
  /** Conversion per click ratio */
  conversionPerClickRate?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliate */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount per click */
  conversionAmountPerClick?: TypesV1Decimal;
  /** Average revenue per click */
  revenuePerClick?: TypesV1Decimal;
  /** Average affiliate payout per click */
  costPerClick?: TypesV1Decimal;
  /** Average MLM commission payout per click */
  averageCommissionAmount?: TypesV1Decimal;
}

/** Overview report total */
export interface ReportsV1OverviewReportTotal {
  /**
   * Number of clicks
   * @format int64
   */
  clickCount?: string;
  /**
   * Gross number of clicks
   * @format int64
   */
  grossClickCount?: string;
  /**
   * Number of coupon uses
   * @format int64
   */
  couponCount?: string;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /**
   * Number of MLM commissions
   * @format int64
   */
  commissionCount?: string;
  /** Total conversion amount */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue */
  totalRevenue?: TypesV1Decimal;
  /** Total payout to affiliates */
  totalCost?: TypesV1Decimal;
  /** Total payout of MLM commissions */
  totalCommissionAmount?: TypesV1Decimal;
  /** Total profit */
  profit?: TypesV1Decimal;
  /** Total advertiser profit */
  advertiserProfit?: TypesV1Decimal;
  /** Conversions per clicks ratio */
  conversionPerClickRate?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliates */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount per click */
  conversionAmountPerClick?: TypesV1Decimal;
  /** Average revenue per click */
  revenuePerClick?: TypesV1Decimal;
  /** Average payout to affiliates per click */
  costPerClick?: TypesV1Decimal;
  /** Average MLM commission amount paid */
  averageCommissionAmount?: TypesV1Decimal;
}

/** Overview report values */
export interface ReportsV1OverviewReportValues {
  /**
   * Number of clicks
   * @format int64
   */
  clickCount?: string;
  /**
   * Gross number of clicks
   * @format int64
   */
  grossClickCount?: string;
  /**
   * Number of coupon uses
   * @format int64
   */
  couponCount?: string;
  /**
   * Number of conversions
   * @format int64
   */
  conversionCount?: string;
  /**
   * Number of MLM commissions
   * @format int64
   */
  commissionCount?: string;
  /** Total conversion amount */
  totalConversionAmount?: TypesV1Decimal;
  /** Total revenue */
  totalRevenue?: TypesV1Decimal;
  /** Total payout to affiliates */
  totalCost?: TypesV1Decimal;
  /** Total payout of MLM commissions */
  totalCommissionAmount?: TypesV1Decimal;
  /** Total profit */
  profit?: TypesV1Decimal;
  /** Total advertiser profit */
  advertiserProfit?: TypesV1Decimal;
  /** Conversions per clicks ratio */
  conversionPerClickRate?: TypesV1Decimal;
  /** Average conversion amount */
  averageConversionAmount?: TypesV1Decimal;
  /** Average revenue */
  averageRevenue?: TypesV1Decimal;
  /** Average payout to affiliates */
  averageCost?: TypesV1Decimal;
  /** Average conversion amount per click */
  conversionAmountPerClick?: TypesV1Decimal;
  /** Average revenue per click */
  revenuePerClick?: TypesV1Decimal;
  /** Average payout to affiliates per click */
  costPerClick?: TypesV1Decimal;
  /** Average MLM commission amount paid */
  averageCommissionAmount?: TypesV1Decimal;
}

export interface ReportsV1ReportPreset {
  name: string;
  groupingLevels: EnumsV1ReportGrouping[];
  conversionDrilldown?: ReportsV1ConversionDrilldown;
}

export interface ReportsV1ReportPresets {
  id: string;
  presets: ReportsV1ReportPreset[];
}

/** Advertiser */
export interface ReportsV1RevenueOrigin {
  /** Advertiser ID */
  id: string;
  /** Advertiser name */
  name: string;
}

/** Source */
export interface ReportsV1Source {
  /** Source ID */
  id?: string;
  /** Affiliate public ID */
  publicId?: string;
}

/** Tier */
export interface ReportsV1Tier {
  /** Tier ID */
  id?: string;
  /** Tier name */
  name?: string;
}

export interface ReportsV1UpdateReportPresetsForAccountRequest {
  presets?: ReportsV1ReportPreset[];
}

export interface ReportsV1UpdateReportPresetsForAccountResponse {
  reportPresets?: ReportsV1ReportPresets;
}

export interface RevenueOriginBillingV1Claim {
  /** ID of advertiser settlement. */
  id: string;
  /** Advertiser for which the settlement is generated. */
  revenueOrigin: RevenueOriginBillingV1ClaimRevenueOrigin;
  /** Total amount generated in the settlement. */
  amount: TypesV1Decimal;
  /** Currency used in settlement. */
  currency: TypesV1Currency;
  /**
   * Settled until date.
   * @format date-time
   */
  until: string;
  /** Advertiser billing details. */
  billingDetail: RevenueOriginBillingV1ClaimBillingDetail;
  /** Your billing details. */
  tenantBillingDetail: SettingsV1BillingDetail;
  /** Advertiser payment method information. */
  paymentMethodForAdvertiser?: string;
  /** Optional note for the settlement. */
  note: string;
  /**
   * Date of settlement creation.
   * @format date-time
   */
  createdAt: string;
}

export interface RevenueOriginBillingV1ClaimBillingDetail {
  /** Name of advertiser. */
  name: string;
  /** Address line 1. */
  addressLine1: string;
  /** City. */
  city: string;
  /** Country code. */
  countryCode: string;
  /** Postal code. */
  postalCode: string;
  /** Address line 2. */
  addressLine2?: string;
  /** Invoicing email. */
  invoicingEmail?: string;
  /** VAT number. */
  vat?: string;
}

export interface RevenueOriginBillingV1ClaimRevenueOrigin {
  /** Advertiser ID. */
  id: string;
  /** Name of advertiser. */
  name: string;
}

export interface RevenueOriginBillingV1ClaimBalancesRequest {
  /** Advertiser settlements filter. */
  filter: RevenueOriginBillingV1RevenueOriginOpenBalanceFilter;
  /** Advertiser ID. */
  revenueOriginId: string;
  /** Optional note. */
  note: string;
}

export interface RevenueOriginBillingV1ClaimBalancesResponse {
  /** Advertiser settlements. */
  claim: RevenueOriginBillingV1Claim;
}

export type RevenueOriginBillingV1DeleteClaimResponse = object;

export interface RevenueOriginBillingV1GetBalancesForRevenueOriginResponse {
  /** Total balance generated from approved conversions and MLM commissions. */
  openBalance: TypesV1Decimal;
  /** Total balance generated from on-hold conversions and MLM commissions. */
  onHoldBalance: TypesV1Decimal;
  /** Total balance claimed from advertiser. */
  claimedBalance: TypesV1Decimal;
}

export interface RevenueOriginBillingV1GetClaimResponse {
  /** Advertiser settlement ID. */
  claim: RevenueOriginBillingV1Claim;
}

export interface RevenueOriginBillingV1ListClaimsResponse {
  /** Advertiser settlements. */
  claims: RevenueOriginBillingV1Claim[];
  pagination: TypesV1PaginationResponse;
}

export interface RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponse {
  balances: RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponseBalance[];
  pagination: TypesV1PaginationResponse;
}

export interface RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponseBalance {
  /** Advertiser ID. */
  revenueOrigin: RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponseRevenueOrigin;
  /** Total amount generated from approved conversions and MLM commissions. */
  openBalance: TypesV1Decimal;
  /** Totam amount generated from on-hold conversions and MLM commissions. */
  onHoldBalance: TypesV1Decimal;
  /** Designates if advertiser billing details are present. */
  hasBillingDetails: boolean;
}

export interface RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponseRevenueOrigin {
  /** ID of specific advertiser. */
  id: string;
  /** Name of specific advertiser. */
  name: string;
}

export interface RevenueOriginBillingV1RevenueOriginOpenBalanceFilter {
  /** @format date-time */
  until: string;
  minAmount?: TypesV1Decimal;
}

export interface RevenueOriginBillingV1SummarizeRevenueOriginOpenBalancesResponse {
  openBalance: TypesV1Decimal;
  onHoldBalance: TypesV1Decimal;
}

export interface RevenueOriginGroupsV1ListRevenueOriginGroupsResponse {
  revenueOriginGroups?: RevenueOriginGroupsV1RevenueOriginGroup[];
}

export interface RevenueOriginGroupsV1RevenueOriginGroup {
  id?: string;
}

/** Create advertiser. */
export interface RevenueOriginsV1CreateRevenueOriginRequest {
  /** Name of the advertiser. */
  name: string;
  /** Email of the advertiser. */
  email: string;
  /** Billing details of the advertiser. */
  billingDetail: RevenueOriginsV1RevenueOriginBillingDetail;
  /** Admin note to the advertiser. */
  adminNote: string;
}

/** Details of the created advertiser. */
export interface RevenueOriginsV1CreateRevenueOriginResponse {
  /** Advertiser. */
  revenueOrigin: RevenueOriginsV1RevenueOrigin;
}

export interface RevenueOriginsV1GetDefaultRevenueOriginIdResponse {
  id: string;
}

export interface RevenueOriginsV1GetRevenueOriginTrackingApiAuthorizationResponse {
  trackingApiAuthorization: RevenueOriginsV1RevenueOriginTrackingApiAuthorization;
}

export interface RevenueOriginsV1GetRevenueOriginTrackingQualityControlResponse {
  qualityControl?: SettingsV1TrackingQualityControl;
}

/** List advertisers in the system */
export interface RevenueOriginsV1ListRevenueOriginsRequest {
  /** Pagination offset of the listed advertisers. */
  pagination?: TypesV1OptionalPaginationRequest;
  /** Additional filters to be applied. */
  filters?: RevenueOriginsV1RevenueOriginsFilters;
}

/** List of advertisers matching the pagination and filters */
export interface RevenueOriginsV1ListRevenueOriginsResponse {
  /** Advertisers. */
  revenueOrigins: RevenueOriginsV1RevenueOrigin[];
  /** Pagination. */
  pagination: TypesV1PaginationResponse;
}

/** Advertiser. */
export interface RevenueOriginsV1RevenueOrigin {
  /** ID of the advertiser. */
  id: string;
  /** Name of the advertiser. */
  name: string;
  /** Email of the advertiser. */
  email: string;
  /** Billing details of the advertiser. */
  billingDetail?: RevenueOriginsV1RevenueOriginBillingDetail;
  /** Admin note to the advertiser. */
  adminNote: string;
  /** Status of the advertiser. */
  status: EnumsV1RevenueOriginStatus;
  /** Account of the advertiser. */
  account?: RevenueOriginsV1RevenueOriginAccount;
}

/** Account of the advertiser. */
export interface RevenueOriginsV1RevenueOriginAccount {
  /** ID of the account. */
  id: string;
  /** Status of the account. */
  status: EnumsV1AccountStatus;
}

/** Billing details of the advertiser. */
export interface RevenueOriginsV1RevenueOriginBillingDetail {
  /** Full name on the billing details. */
  name: string;
  /** First line of the address. */
  addressLine1: string;
  /** City of the address. */
  city: string;
  /** Country code for the address. Uses ISO-3166, two letter formatting. */
  countryCode: string;
  /** Postal code of the address. */
  postalCode: string;
  /** Second line of the address. */
  addressLine2?: string;
  /** Email used for invoicing. */
  invoicingEmail?: string;
  /** VAT information. */
  vat?: string;
}

/** Billing details of the advertiser. */
export interface RevenueOriginsV1RevenueOriginBillingDetail {
  /** Full name on the billing details. */
  name: string;
  /** First line of the address. */
  addressLine1: string;
  /** City of the address. */
  city: string;
  /** Country code for the address. Uses ISO-3166, two letter formatting. */
  countryCode: string;
  /** Postal code of the address. */
  postalCode: string;
  /** Second line of the address. */
  addressLine2?: string;
  /** Email used for invoicing. */
  invoicingEmail?: string;
  /** VAT information. */
  vat?: string;
}

export interface RevenueOriginsV1RevenueOriginTrackingApiAuthorization {
  conversion: RevenueOriginsV1RevenueOriginTrackingApiAuthorizationConversion;
}

export interface RevenueOriginsV1RevenueOriginTrackingApiAuthorizationConversion {
  whitelistedIps: string[];
}

/** Filters available for advertisers. */
export interface RevenueOriginsV1RevenueOriginsFilters {
  /** IDs of advertisers to be filtered. */
  ids?: string[];
  /** Emails of advertisers to be filtered. */
  emails?: string[];
  /** Name of advertisers to be filtered. */
  name?: string;
  /** Advertisers with or without account to be filtered. */
  hasAccount?: boolean;
}

/** Update advertiser. */
export interface RevenueOriginsV1RevenueOriginsServiceUpdateRevenueOriginBody {
  /** Email of the advertiser. */
  name: string;
  /** Billing details of the advertiser. */
  billingDetail: RevenueOriginsV1RevenueOriginBillingDetail;
  /** Admin note to the advertiser. */
  adminNote: string;
}

export interface RevenueOriginsV1RevenueOriginsServiceUpdateRevenueOriginTrackingApiAuthorizationBody {
  conversion: RevenueOriginsV1UpdateRevenueOriginTrackingApiAuthorizationRequestConversion;
}

export interface RevenueOriginsV1RevenueOriginsServiceUpdateRevenueOriginTrackingQualityControlBody {
  qualityControl?: SettingsV1TrackingQualityControlRequest;
}

/** Details of the updated advertiser. */
export interface RevenueOriginsV1UpdateRevenueOriginResponse {
  /** Advertiser. */
  revenueOrigin: RevenueOriginsV1RevenueOrigin;
}

export interface RevenueOriginsV1UpdateRevenueOriginTrackingApiAuthorizationRequestConversion {
  whitelistedIps: string[];
}

export interface RevenueOriginsV1UpdateRevenueOriginTrackingApiAuthorizationResponse {
  trackingApiAuthorization: RevenueOriginsV1RevenueOriginTrackingApiAuthorization;
}

export interface RevenueOriginsV1UpdateRevenueOriginTrackingQualityControlResponse {
  qualityControl?: SettingsV1TrackingQualityControl;
}

export interface RolesV1CreateRoleRequest {
  name?: string;
}

export interface RolesV1CreateRoleResponse {
  role?: RolesV1Role;
}

export type RolesV1DeleteRoleResponse = object;

export interface RolesV1GetRoleResponse {
  role?: RolesV1Role;
}

export interface RolesV1ListRolePermissionsResponse {
  rolePermissions?: RolesV1RolePermissions;
}

export interface RolesV1ListRolesResponse {
  roles?: RolesV1Role[];
}

export interface RolesV1Role {
  id?: string;
  name?: string;
  protected?: boolean;
}

export interface RolesV1RolePermissions {
  roleId?: string;
  permissionIds?: string[];
}

export interface RolesV1RolesServiceSetRolePermissionsBody {
  permissions?: RolesV1SetRolePermissionsRequestPermission[];
}

export interface RolesV1RolesServiceUpdateRoleBody {
  name?: string;
}

export interface RolesV1SetRolePermissionsRequestPermission {
  id?: string;
}

export interface RolesV1SetRolePermissionsResponse {
  rolePermissions?: RolesV1RolePermissions;
}

export interface RolesV1UpdateRoleResponse {
  role?: RolesV1Role;
}

export interface SettingsV1AdvertiserParamsVisibility {
  advS1: boolean;
  advS2: boolean;
  advS3: boolean;
  advS4: boolean;
  advS5: boolean;
  externalId: boolean;
  customerId: boolean;
  externalCid: boolean;
}

export interface SettingsV1AffiliateConversionVisibility {
  conversionStatus?: SettingsV1AffiliateConversionVisibilityConversionStatus;
}

export interface SettingsV1AffiliateConversionVisibilityConversionStatus {
  statuses: ConversionsV1ConversionStatus[];
  blacklisted: boolean;
}

export interface SettingsV1AffiliateRegistrationCustomization {
  pageStyle: EnumsV1AffiliateRegistrationPageStyle;
  lightModeTopBannerUrl?: string;
  darkModeTopBannerUrl?: string;
  lightModeBottomBannerUrl?: string;
  darkModeBottomBannerUrl?: string;
  pageNote?: string;
}

export interface SettingsV1AffiliateTrackingLinkSettings {
  defaultParams: SettingsV1AffiliateTrackingLinkSettingsDefaultParams;
}

export interface SettingsV1AffiliateTrackingLinkSettingsDefaultParams {
  affS1?: string;
  affS2?: string;
  affS3?: string;
  affS4?: string;
  affS5?: string;
}

/** Billing details set for tenant (i.e. your company billing details). */
export interface SettingsV1BillingDetail {
  /** Legal name. */
  name?: string;
  /** Address. */
  addressLine1?: string;
  /** City. */
  city?: string;
  /** Country code */
  countryCode?: string;
  /** Postal code. */
  postalCode?: string;
  /** Additional address details. */
  addressLine2?: string;
  /** Invoicing email. */
  invoicingEmail?: string;
  /** VAT number. */
  vat?: string;
}

export interface SettingsV1ClaimGenerating {
  enabled?: SettingsV1ClaimGeneratingEnabled;
  disabled?: boolean;
}

export interface SettingsV1ClaimGeneratingEnabled {
  schedule: SettingsV1ClaimGeneratingSchedule;
  minAmount: TypesV1Decimal;
}

export interface SettingsV1ClaimGeneratingMonthly {
  /** @format int64 */
  day?: number;
  lastDay?: boolean;
}

export interface SettingsV1ClaimGeneratingSchedule {
  /** @format date-time */
  startAt: string;
  weekly?: SettingsV1ClaimGeneratingWeekly;
  monthly?: SettingsV1ClaimGeneratingMonthly;
}

export interface SettingsV1ClaimGeneratingWeekly {
  weekday: EnumsV1Weekday;
}

export interface SettingsV1ClickTrackingSettings {
  conversionAttributionType: EnumsV1ConversionAttributionType;
  /** @format int64 */
  conversionSourceExpirationDays: number;
}

export interface SettingsV1ContactForAdvertisers {
  contactName: string;
  email?: string;
  phone?: string;
  messenger: TypesV1Messenger;
}

export interface SettingsV1ContactForAffiliates {
  contactName?: string;
  email?: string;
  phone?: string;
  /** optional */
  messenger?: TypesV1Messenger;
}

export interface SettingsV1DataVisibilityForAdvertisers {
  affS1: boolean;
  affS2: boolean;
  affS3: boolean;
  affS4: boolean;
  affS5: boolean;
  referrer: boolean;
  externalId: boolean;
  customerId: boolean;
  externalCid: boolean;
}

export interface SettingsV1DefaultReportFiltering {
  conversionStatuses: ConversionsV1ConversionStatus[];
}

export interface SettingsV1EmailCustomization {
  welcomeAdvertiserApproved?: SettingsV1EmailCustomizationBasicEmailData;
  welcomeAdvertiserPending?: SettingsV1EmailCustomizationBasicEmailData;
  welcomeAffiliateApproved?: SettingsV1EmailCustomizationBasicEmailData;
  welcomeAffiliatePending?: SettingsV1EmailCustomizationBasicEmailData;
  inviteUser?: SettingsV1EmailCustomizationInviteUserEmailData;
}

export interface SettingsV1EmailCustomizationBasicEmailData {
  subject: string;
  body: string;
  buttonLabel?: string;
}

export interface SettingsV1EmailCustomizationInviteUserEmailData {
  subject: string;
  bodyHeader: string;
  bodyFooter: string;
  buttonLabel?: string;
}

export interface SettingsV1FeatureLimit {
  featureId?: EnumsV1FeatureId;
  params?: SettingsV1FeatureLimitParams;
}

export interface SettingsV1FeatureLimitParams {
  /** @format uint64 */
  maxCount?: string;
}

export interface SettingsV1Firebase {
  config?: SettingsV1FirebaseConfig;
  authEmulatorHost?: string;
  firestoreEmulatorHost?: string;
  storageEmulatorHost?: string;
}

export interface SettingsV1FirebaseConfig {
  apiKey?: string;
  appId?: string;
  authDomain?: string;
  measurementId?: string;
  messagingSenderId?: string;
  projectId?: string;
  storageBucket?: string;
}

export interface SettingsV1General {
  name?: string;
  domains?: string[];
  websiteUrl?: string;
  imagesUrls?: SettingsV1GeneralImagesUrls;
  timezone?: string;
  currencyCode?: string;
  defaultRegisteredAccountStatus?: EnumsV1AccountStatus;
}

export interface SettingsV1GeneralImagesUrls {
  lightModeLogo?: string;
  darkModeLogo?: string;
  favicon?: string;
}

export interface SettingsV1GetAdvertiserDashboardNoteResponse {
  note?: string;
}

export interface SettingsV1GetAdvertiserParamsVisibilityResponse {
  visibility: SettingsV1AdvertiserParamsVisibility;
}

export interface SettingsV1GetAdvertiserPendingRegistrationNoteResponse {
  note?: string;
}

export interface SettingsV1GetAdvertiserRegistrationPageNoteResponse {
  note?: string;
}

export interface SettingsV1GetAdvertiserVatRequiredResponse {
  required: boolean;
}

export interface SettingsV1GetAffiliateConversionVisibilityResponse {
  visibility: SettingsV1AffiliateConversionVisibility;
}

export interface SettingsV1GetAffiliatePendingRegistrationNoteResponse {
  note?: string;
}

export interface SettingsV1GetAffiliateRegistrationCustomizationResponse {
  customization?: SettingsV1AffiliateRegistrationCustomization;
}

export interface SettingsV1GetAffiliateTrackingLinkSettingsResponse {
  settings?: SettingsV1AffiliateTrackingLinkSettings;
}

export interface SettingsV1GetAnuraResponse {
  instance?: string;
  enabled?: boolean;
}

export interface SettingsV1GetBillingDetailResponse {
  /** Billing details set for tenant (i.e. your company billing details). */
  billingDetail?: SettingsV1BillingDetail;
}

export interface SettingsV1GetClaimGeneratingResponse {
  claimGenerating: SettingsV1ClaimGenerating;
}

export interface SettingsV1GetClickTrackingSettingsResponse {
  settings: SettingsV1ClickTrackingSettings;
}

export interface SettingsV1GetCompletedStepsResponse {
  completedSteps?: string[];
}

export interface SettingsV1GetContactForAdvertisersResponse {
  contact?: SettingsV1ContactForAdvertisers;
}

export interface SettingsV1GetContactForAffiliatesResponse {
  contact?: SettingsV1ContactForAffiliates;
}

export interface SettingsV1GetDashboardNoteResponse {
  note?: string;
}

export interface SettingsV1GetDashboardPromosVisibilityResponse {
  hideDashboardPromos: boolean;
}

export interface SettingsV1GetDataVisibilityForAdvertisersResponse {
  visibility: SettingsV1DataVisibilityForAdvertisers;
}

export interface SettingsV1GetDefaultRedirectDomainResponse {
  defaultRedirectDomain?: string;
}

export interface SettingsV1GetDefaultRegisteredAdvertiserAccountStatusResponse {
  accountStatus: EnumsV1AccountStatus;
}

export interface SettingsV1GetDefaultReportFilteringResponse {
  filtering?: SettingsV1DefaultReportFiltering;
}

export interface SettingsV1GetEmailCustomizationResponse {
  customization: SettingsV1EmailCustomization;
}

export interface SettingsV1GetEnvironmentSettingsResponse {
  environmentDomain: string;
  firebase: SettingsV1Firebase;
  /** TODO: remove, apparently not used */
  stripe?: SettingsV1Stripe;
  recaptcha: SettingsV1Recaptcha;
  raaft: SettingsV1Raaft;
}

export interface SettingsV1GetGeneralResponse {
  general?: SettingsV1General;
}

export interface SettingsV1GetGlobalRedirectDomainsVisibilityResponse {
  showGlobal: boolean;
}

export interface SettingsV1GetPaymentMethodForAdvertisersResponse {
  paymentMethod?: string;
}

export interface SettingsV1GetRedirectDomainsTypeResponse {
  redirectDomainsType: EnumsV1RedirectDomainsType;
}

export interface SettingsV1GetReferralSettingsResponse {
  enabled: boolean;
  referralAccountSettingsAsWhitelist: boolean;
  commissionRates: TypesV1Decimal[];
  conversionSourceAccountVisible: boolean;
  commissionSourceAmountType: EnumsV1CommissionSourceAmountType;
}

export interface SettingsV1GetStripeBillingDetailResponse {
  billingDetail?: SettingsV1GetStripeBillingDetailResponseStripeBillingDetail;
}

export interface SettingsV1GetStripeBillingDetailResponseStripeBillingDetail {
  name?: string;
  address?: SettingsV1GetStripeBillingDetailResponseStripeBillingDetailAddress;
  invoicingEmail?: string;
  vat?: string;
}

export interface SettingsV1GetStripeBillingDetailResponseStripeBillingDetailAddress {
  addressLine1?: string;
  city?: string;
  countryCode?: string;
  postalCode?: string;
  addressLine2?: string;
}

export interface SettingsV1GetTenantPrivateResponse {
  dashboardNote?: string;
}

export interface SettingsV1GetTenantSettingsResponse {
  environmentDomain: string;
  firebase?: SettingsV1Firebase;
  stripe?: SettingsV1Stripe;
  recaptcha?: SettingsV1Recaptcha;
  tenantSettings?: SettingsV1TenantSettings;
  featureIds?: EnumsV1FeatureId[];
  featureLimits?: SettingsV1FeatureLimit[];
  membershipStatus?: MembershipsV1Status;
  googleCertifiedBaseDomain: string;
}

export interface SettingsV1GetTrackingApiAuthorizationResponse {
  trackingApiAuthorization: SettingsV1TrackingApiAuthorization;
}

export interface SettingsV1GetTrackingQualityControlResponse {
  qualityControl?: SettingsV1TrackingQualityControl;
}

export interface SettingsV1PreviewEmailCustomizationRequest {
  emailType?: SettingsV1EmailType;
}

export interface SettingsV1PreviewEmailCustomizationResponse {
  subject: string;
  body: string;
}

export interface SettingsV1PublicBillingDetail {
  name?: string;
  addressLine1?: string;
  city?: string;
  countryCode?: string;
  postalCode?: string;
  addressLine2?: string;
  invoicingEmail?: string;
  vat?: string;
}

export interface SettingsV1Raaft {
  appId: string;
}

export interface SettingsV1Recaptcha {
  siteKey?: string;
  token?: string;
}

export interface SettingsV1SmartLinks {
  visibleToAffiliates: boolean;
  offersVisibleInReports: boolean;
}

export interface SettingsV1Stripe {
  publishableKey?: string;
}

export interface SettingsV1TenantDetail {
  id?: string;
  name?: string;
  websiteUrl?: string;
}

export interface SettingsV1TenantSettings {
  lightModeLogoUrl?: string;
  darkModeLogoUrl?: string;
  faviconUrl?: string;
  termsAndConditionText?: string;
  billingDetails?: SettingsV1PublicBillingDetail;
  currencyCode?: string;
  /** @format date-time */
  registeredAt?: string;
  loginEnabled?: boolean;
  loginAvailable?: boolean;
  trafficEnabled?: boolean;
  trafficAvailable?: boolean;
  timezone?: string;
  tenantDetail?: SettingsV1TenantDetail;
  membershipPlanId?: MembershipsV1PlanId;
  membershipPlatformId?: MembershipsV1PlatformId;
  fraudSuspicionsVisible?: boolean;
  referralEnabled?: boolean;
  adminAccessStatus?: SettingsV1AdminAccessStatus;
  colorTheme?: TypesV1ColorTheme;
  defaultTheme: EnumsV1Theme;
  defaultLanguage?: string;
  affiliatesVatRequired?: boolean;
  tenantType?: SettingsV1TenantType;
  onboardingStatus?: SettingsV1OnboardingStatus;
  revenueVisible: boolean;
  conversionAmountVisible: boolean;
  isAffiliateRateCostBasedOnConversionAmount: boolean;
  /** @format date-time */
  membershipEndAt?: string;
  freeTrialActive?: boolean;
  marketplaceAccessOverridden?: boolean;
  advertiserParamsVisibility: SettingsV1AdvertiserParamsVisibility;
  referralConversionSourceAccountVisible?: boolean;
  affiliatePostbackConversionAmountAndRevenueEnabled?: boolean;
  smartLinks?: SettingsV1SmartLinks;
  defaultReportFiltering?: SettingsV1DefaultReportFiltering;
  hideDashboardPromos: boolean;
}

export interface SettingsV1TrackingApiAuthorization {
  conversion: SettingsV1TrackingApiAuthorizationConversion;
}

export interface SettingsV1TrackingApiAuthorizationConversion {
  requireAuthentication: boolean;
  whitelistedIps: string[];
  allowUnauthenticatedUpdate: boolean;
}

export interface SettingsV1TrackingQualityControl {
  items: SettingsV1TrackingQualityControlItem[];
}

export interface SettingsV1TrackingQualityControlItem {
  id: string;
  applicationRate: TypesV1UnsignedDecimal;
  rules: SettingsV1TrackingQualityControlRules;
}

export interface SettingsV1TrackingQualityControlRules {
  conversionTypeIds?: string[];
}

export interface SettingsV1TrackingQualityControlRequest {
  items: SettingsV1TrackingQualityControlRequestItem[];
}

export interface SettingsV1TrackingQualityControlRequestItem {
  id?: string;
  applicationRate: TypesV1UnsignedDecimal;
  rules?: SettingsV1TrackingQualityControlRequestRules;
}

export interface SettingsV1TrackingQualityControlRequestRules {
  conversionTypeIds?: string[];
}

export interface SettingsV1UpdateAdvertiserDashboardNoteRequest {
  note?: string;
}

export interface SettingsV1UpdateAdvertiserDashboardNoteResponse {
  note?: string;
}

export interface SettingsV1UpdateAdvertiserParamsVisibilityRequest {
  visibility: SettingsV1AdvertiserParamsVisibility;
}

export interface SettingsV1UpdateAdvertiserParamsVisibilityResponse {
  visibility: SettingsV1AdvertiserParamsVisibility;
}

export interface SettingsV1UpdateAdvertiserPendingRegistrationNoteRequest {
  note?: string;
}

export interface SettingsV1UpdateAdvertiserPendingRegistrationNoteResponse {
  note?: string;
}

export interface SettingsV1UpdateAdvertiserRegistrationPageNoteRequest {
  note?: string;
}

export interface SettingsV1UpdateAdvertiserRegistrationPageNoteResponse {
  note?: string;
}

export interface SettingsV1UpdateAdvertiserVatRequiredRequest {
  required: boolean;
}

export interface SettingsV1UpdateAdvertiserVatRequiredResponse {
  required: boolean;
}

export interface SettingsV1UpdateAffiliateConversionVisibilityRequest {
  visibility?: SettingsV1AffiliateConversionVisibility;
}

export interface SettingsV1UpdateAffiliateConversionVisibilityResponse {
  visibility: SettingsV1AffiliateConversionVisibility;
}

export interface SettingsV1UpdateAffiliatePendingRegistrationNoteRequest {
  note?: string;
}

export interface SettingsV1UpdateAffiliatePendingRegistrationNoteResponse {
  note?: string;
}

export interface SettingsV1UpdateAffiliatePostbackConversionAmountAndRevenueEnabledRequest {
  affiliatePostbackConversionAmountAndRevenueEnabled: boolean;
}

export interface SettingsV1UpdateAffiliatePostbackConversionAmountAndRevenueEnabledResponse {
  affiliatePostbackConversionAmountAndRevenueEnabled: boolean;
}

export interface SettingsV1UpdateAffiliateRateCostBaseRequest {
  isAffiliateRateCostBasedOnConversionAmount: boolean;
}

export interface SettingsV1UpdateAffiliateRateCostBaseResponse {
  isAffiliateRateCostBasedOnConversionAmount: boolean;
}

export interface SettingsV1UpdateAffiliateRegistrationCustomizationRequest {
  customization?: SettingsV1AffiliateRegistrationCustomization;
}

export interface SettingsV1UpdateAffiliateRegistrationCustomizationResponse {
  customization?: SettingsV1AffiliateRegistrationCustomization;
}

export interface SettingsV1UpdateAffiliateTrackingLinkSettingsRequest {
  settings?: SettingsV1AffiliateTrackingLinkSettings;
}

export interface SettingsV1UpdateAffiliateTrackingLinkSettingsResponse {
  settings?: SettingsV1AffiliateTrackingLinkSettings;
}

export interface SettingsV1UpdateAffiliatesVatRequiredRequest {
  required?: boolean;
}

export interface SettingsV1UpdateAffiliatesVatRequiredResponse {
  required?: boolean;
}

export interface SettingsV1UpdateAnuraEnabledRequest {
  enabled: boolean;
}

export type SettingsV1UpdateAnuraEnabledResponse = object;

export interface SettingsV1UpdateAnuraInstanceRequest {
  anuraInstance?: string;
}

export type SettingsV1UpdateAnuraInstanceResponse = object;

export interface SettingsV1UpdateBillingDetailRequest {
  name?: string;
  addressLine1?: string;
  city?: string;
  countryCode?: string;
  postalCode?: string;
  addressLine2?: string;
  invoicingEmail?: string;
  vat?: string;
}

export interface SettingsV1UpdateBillingDetailResponse {
  /** Billing details set for tenant (i.e. your company billing details). */
  billingDetail?: SettingsV1BillingDetail;
}

export interface SettingsV1UpdateClaimGeneratingRequest {
  enabled?: SettingsV1UpdateClaimGeneratingRequestEnabled;
  disabled?: boolean;
}

export interface SettingsV1UpdateClaimGeneratingRequestEnabled {
  schedule: SettingsV1UpdateClaimGeneratingRequestSchedule;
  minAmount: TypesV1Decimal;
}

export interface SettingsV1UpdateClaimGeneratingRequestMonthly {
  /** @format int64 */
  day?: number;
  lastDay?: boolean;
}

export interface SettingsV1UpdateClaimGeneratingRequestSchedule {
  /** @format date-time */
  startAt: string;
  weekly?: SettingsV1UpdateClaimGeneratingRequestWeekly;
  monthly?: SettingsV1UpdateClaimGeneratingRequestMonthly;
}

export interface SettingsV1UpdateClaimGeneratingRequestWeekly {
  weekday: EnumsV1Weekday;
}

export interface SettingsV1UpdateClaimGeneratingResponse {
  claimGenerating: SettingsV1ClaimGenerating;
}

export interface SettingsV1UpdateClickTrackingSettingsRequest {
  settings: SettingsV1ClickTrackingSettings;
}

export interface SettingsV1UpdateClickTrackingSettingsResponse {
  settings: SettingsV1ClickTrackingSettings;
}

export interface SettingsV1UpdateColorThemeRequest {
  colorTheme?: SettingsV1UpdateColorThemeRequestColorTheme;
}

export interface SettingsV1UpdateColorThemeRequestColorTheme {
  theme?: string;
  backgroundEnabled?: boolean;
}

export interface SettingsV1UpdateColorThemeResponse {
  colorTheme?: TypesV1ColorTheme;
}

export interface SettingsV1UpdateCompletedStepsRequest {
  completedSteps?: string[];
}

export type SettingsV1UpdateCompletedStepsResponse = object;

export interface SettingsV1UpdateContactForAdvertisersRequest {
  contact?: SettingsV1ContactForAdvertisers;
}

export interface SettingsV1UpdateContactForAdvertisersResponse {
  contact?: SettingsV1ContactForAdvertisers;
}

export interface SettingsV1UpdateContactForAffiliatesRequest {
  /** optional */
  contact?: SettingsV1ContactForAffiliates;
}

export type SettingsV1UpdateContactForAffiliatesResponse = object;

export interface SettingsV1UpdateConversionAmountVisibleRequest {
  visible: boolean;
}

export interface SettingsV1UpdateConversionAmountVisibleResponse {
  visible: boolean;
}

export interface SettingsV1UpdateDashboardNoteRequest {
  note?: string;
}

export interface SettingsV1UpdateDashboardNoteResponse {
  note?: string;
}

export interface SettingsV1UpdateDashboardPromosVisibilityRequest {
  hideDashboardPromos: boolean;
}

export type SettingsV1UpdateDashboardPromosVisibilityResponse = object;

export interface SettingsV1UpdateDataVisibilityForAdvertisersRequest {
  visibility: SettingsV1DataVisibilityForAdvertisers;
}

export interface SettingsV1UpdateDataVisibilityForAdvertisersResponse {
  visibility: SettingsV1DataVisibilityForAdvertisers;
}

export interface SettingsV1UpdateDefaultLanguageRequest {
  defaultLanguage?: string;
}

export interface SettingsV1UpdateDefaultLanguageResponse {
  defaultLanguage?: string;
}

export interface SettingsV1UpdateDefaultRedirectDomainRequest {
  defaultRedirectDomain?: string;
}

export type SettingsV1UpdateDefaultRedirectDomainResponse = object;

export interface SettingsV1UpdateDefaultRegisteredAdvertiserAccountStatusRequest {
  accountStatus: EnumsV1AccountStatus;
}

export interface SettingsV1UpdateDefaultRegisteredAdvertiserAccountStatusResponse {
  accountStatus: EnumsV1AccountStatus;
}

export interface SettingsV1UpdateDefaultReportFilteringRequest {
  filtering?: SettingsV1DefaultReportFiltering;
}

export interface SettingsV1UpdateDefaultReportFilteringResponse {
  filtering?: SettingsV1DefaultReportFiltering;
}

export interface SettingsV1UpdateDefaultThemeRequest {
  theme: EnumsV1Theme;
}

export interface SettingsV1UpdateDefaultThemeResponse {
  theme: EnumsV1Theme;
}

export interface SettingsV1UpdateEmailCustomizationRequest {
  customization?: SettingsV1EmailCustomization;
}

export interface SettingsV1UpdateEmailCustomizationResponse {
  customization: SettingsV1EmailCustomization;
}

export interface SettingsV1UpdateFraudSuspicionsVisibleRequest {
  visible?: boolean;
}

export interface SettingsV1UpdateFraudSuspicionsVisibleResponse {
  visible?: boolean;
}

export interface SettingsV1UpdateGeneralRequest {
  name?: string;
  websiteUrl?: TypesV1Url;
  imagesUrls?: SettingsV1UpdateGeneralRequestImagesUrls;
  timezone?: string;
  defaultRegisteredAccountStatus?: EnumsV1AccountStatus;
}

export interface SettingsV1UpdateGeneralRequestImagesUrls {
  lightModeLogo?: string;
  darkModeLogo?: string;
  favicon?: string;
}

export interface SettingsV1UpdateGeneralResponse {
  general?: SettingsV1General;
}

export interface SettingsV1UpdateGlobalRedirectDomainsVisibilityRequest {
  showGlobal: boolean;
}

export type SettingsV1UpdateGlobalRedirectDomainsVisibilityResponse = object;

export interface SettingsV1UpdateOnboardingStatusRequest {
  status?: SettingsV1OnboardingStatus;
}

export interface SettingsV1UpdateOnboardingStatusResponse {
  status?: SettingsV1OnboardingStatus;
}

export interface SettingsV1UpdatePaymentMethodForAdvertisersRequest {
  paymentMethod?: string;
}

export interface SettingsV1UpdatePaymentMethodForAdvertisersResponse {
  paymentMethod?: string;
}

export interface SettingsV1UpdateQuickSetupDoneRequest {
  quickSetupDone?: boolean;
}

export type SettingsV1UpdateQuickSetupDoneResponse = object;

export interface SettingsV1UpdateRedirectDomainsTypeRequest {
  redirectDomainsType: EnumsV1RedirectDomainsType;
}

export type SettingsV1UpdateRedirectDomainsTypeResponse = object;

export interface SettingsV1UpdateReferralSettingsRequest {
  enabled: boolean;
  referralAccountSettingsAsWhitelist: boolean;
  commissionRates: TypesV1Decimal[];
  conversionSourceAccountVisible: boolean;
  commissionSourceAmountType: EnumsV1CommissionSourceAmountType;
}

export interface SettingsV1UpdateReferralSettingsResponse {
  enabled: boolean;
  referralAccountSettingsAsWhitelist: boolean;
  commissionRates: TypesV1Decimal[];
  conversionSourceAccountVisible: boolean;
  commissionSourceAmountType: EnumsV1CommissionSourceAmountType;
}

export interface SettingsV1UpdateRevenueVisibleRequest {
  visible: boolean;
}

export interface SettingsV1UpdateRevenueVisibleResponse {
  visible: boolean;
}

export interface SettingsV1UpdateSmartLinksSettingsRequest {
  visibleToAffiliates: boolean;
  offersVisibleInReports: boolean;
}

export interface SettingsV1UpdateSmartLinksSettingsResponse {
  visibleToAffiliates: boolean;
  offersVisibleInReports: boolean;
}

export interface SettingsV1UpdateTermsAndConditionsTextRequest {
  text?: string;
}

export interface SettingsV1UpdateTermsAndConditionsTextResponse {
  text?: string;
}

export interface SettingsV1UpdateTrackingApiAuthorizationRequest {
  conversion: SettingsV1UpdateTrackingApiAuthorizationRequestConversion;
}

export interface SettingsV1UpdateTrackingApiAuthorizationRequestConversion {
  requireAuthentication: boolean;
  whitelistedIps: string[];
  allowUnauthenticatedUpdate: boolean;
}

export interface SettingsV1UpdateTrackingApiAuthorizationResponse {
  trackingApiAuthorization: SettingsV1TrackingApiAuthorization;
}

export interface SettingsV1UpdateTrackingQualityControlRequest {
  qualityControl?: SettingsV1TrackingQualityControlRequest;
}

export interface SettingsV1UpdateTrackingQualityControlResponse {
  qualityControl?: SettingsV1TrackingQualityControl;
}

export interface ShopifyV1ActivateShopifyIntegrationResponse {
  shopifyIntegration?: ShopifyV1ShopifyIntegration;
}

export interface ShopifyV1AuthorizeShopifyIntegrationResponse {
  shopifyIntegration?: ShopifyV1ShopifyIntegration;
}

export interface ShopifyV1CreateShopifyIntegrationRequest {
  shopId?: string;
  revenueOriginId?: string;
  orderReceivedConversionTypeId?: string;
}

export interface ShopifyV1CreateShopifyIntegrationResponse {
  shopifyIntegration?: ShopifyV1ShopifyIntegration;
}

export interface ShopifyV1CreateShopifyOrderUpdatedWebhookRequest {
  shopId?: string;
  token?: string;
  address?: string;
}

export interface ShopifyV1CreateShopifyOrderUpdatedWebhookResponse {
  /** @format int64 */
  id?: string;
}

export interface ShopifyV1CreateShopifyWebPixelRequest {
  shopId?: string;
  token?: string;
  revenueOriginId?: string;
  orderReceivedConversionTypeCode?: string;
}

export interface ShopifyV1CreateShopifyWebPixelResponse {
  shopifyResponse?: string;
}

export interface ShopifyV1DeactivateShopifyIntegrationResponse {
  shopifyIntegration?: ShopifyV1ShopifyIntegration;
}

export type ShopifyV1DeleteShopifyIntegrationResponse = object;

export interface ShopifyV1DeleteShopifyWebPixelRequest {
  shopId?: string;
  token?: string;
  id?: string;
}

export type ShopifyV1DeleteShopifyWebPixelResponse = object;

export interface ShopifyV1DeleteShopifyWebhookRequest {
  shopId?: string;
  token?: string;
  /** @format int64 */
  id?: string;
}

export type ShopifyV1DeleteShopifyWebhookResponse = object;

export interface ShopifyV1GetShopifyAuthorizationUrlRequest {
  shopId?: string;
}

export interface ShopifyV1GetShopifyAuthorizationUrlResponse {
  authorizationUrl?: string;
}

export interface ShopifyV1GetShopifyIntegrationAuthorizationUrlResponse {
  authorizationUrl?: string;
}

export interface ShopifyV1GetShopifyIntegrationResponse {
  shopifyIntegration?: ShopifyV1ShopifyIntegration;
}

export interface ShopifyV1ListShopifyIntegrationsResponse {
  shopifyIntegrations?: ShopifyV1ShopifyIntegration[];
}

export interface ShopifyV1ListShopifyWebhooksRequest {
  shopId?: string;
  token?: string;
}

export interface ShopifyV1ListShopifyWebhooksResponse {
  webhooks?: ShopifyV1ListShopifyWebhooksResponseWebhook[];
}

export interface ShopifyV1ListShopifyWebhooksResponseWebhook {
  /** @format int64 */
  id?: string;
  address?: string;
  topic?: string;
  format?: string;
}

export interface ShopifyV1ShopifyIntegration {
  id?: string;
  shopId?: string;
  revenueOriginId?: string;
  orderReceivedConversionTypeId?: string;
  isAuthorized?: boolean;
  appInstalled?: boolean;
  scriptActive?: boolean;
  updatedOrderStatusSyncActive?: boolean;
}

export type ShopifyV1ShopifyIntegrationsServiceActivateShopifyIntegrationBody =
  object;

export interface ShopifyV1ShopifyIntegrationsServiceAuthorizeShopifyIntegrationBody {
  urlQuery?: string;
}

export type ShopifyV1ShopifyIntegrationsServiceDeactivateShopifyIntegrationBody =
  object;

export interface ShortLinksV1CreateShortLinkRequest {
  sourceId: string;
  offerId: string;
}

export type ShortLinksV1CreateShortLinkResponse = object;

export type ShortLinksV1DeleteShortLinkResponse = object;

export interface ShortLinksV1GetShortLinkResponse {
  shortLink: ShortLinksV1ShortLink;
}

export interface ShortLinksV1ListForSourceOfferResponse {
  shortLinks: ShortLinksV1ShortLink[];
}

export interface ShortLinksV1ShortLink {
  id: string;
  tenantId: string;
  sourceId: string;
  offerId?: string;
}

export type SmartLinksV1AddRedirectLinkToSmartLinkResponse = object;

export interface SmartLinksV1CreateSmartLinkRequest {
  name: string;
  description?: string;
  metric: EnumsV1SmartLinkMetric;
  redirectLinkIds: string[];
  /** @format int64 */
  minimalUsage?: number;
  conversionTypeIds?: string[];
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

export interface SmartLinksV1CreateSmartLinkResponse {
  smartLink: SmartLinksV1SmartLink;
}

export interface SmartLinksV1GetSmartLinkResponse {
  smartLink: SmartLinksV1SmartLink;
}

export interface SmartLinksV1ListSmartLinksResponse {
  smartLinks?: SmartLinksV1SmartLink[];
}

export type SmartLinksV1RemoveRedirectLinkFromSmartLinkResponse = object;

export type SmartLinksV1ResetSmartLinkUsageWeightsResponse = object;

export type SmartLinksV1SetSmartLinkRedirectLinkWeightResponse = object;

export interface SmartLinksV1SmartLink {
  id: string;
  name: string;
  description: string;
  metric: EnumsV1SmartLinkMetric;
  status: EnumsV1SmartLinkStatus;
  details?: SmartLinksV1SmartLinkDetail[];
  /** @format int64 */
  minimalUsage: number;
  statusDisabledFallback?: TypesV1Fallback;
  noSuitableLpFallback?: TypesV1Fallback;
  conversionTypes: ConversionTypesV1ConversionType[];
  conversionStatuses: ConversionsV1ConversionStatus[];
}

export interface SmartLinksV1SmartLinkDetail {
  id: string;
  /** @format int64 */
  linkUsageCount?: number;
  /** @format int64 */
  weight?: number;
  redirectLink: SmartLinksV1SmartLinkDetailRedirectLink;
}

export interface SmartLinksV1SmartLinkDetailRedirectLink {
  id: string;
  countryCode?: string;
  offer: SmartLinksV1SmartLinkDetailRedirectLinkOffer;
  landingPage: SmartLinksV1SmartLinkDetailRedirectLinkLandingPage;
}

export interface SmartLinksV1SmartLinkDetailRedirectLinkLandingPage {
  id: string;
  name: string;
  url: string;
  status: LandingPagesV1LandingPageStatus;
}

export interface SmartLinksV1SmartLinkDetailRedirectLinkOffer {
  id: string;
  name: string;
  status: OffersV1Status;
}

export interface SmartLinksV1SmartLinksServiceSetSmartLinkRedirectLinkWeightBody {
  /** @format int32 */
  weight: number;
}

export interface SmartLinksV1SmartLinksServiceUpdateSmartLinkBody {
  name: string;
  description: string;
  metric: EnumsV1SmartLinkMetric;
  /** @format int64 */
  minimalUsage?: number;
  conversionTypeIds?: string[];
  conversionStatuses?: ConversionsV1ConversionStatus[];
}

export interface SmartLinksV1SmartLinksServiceUpdateSmartLinkNoSuitableLpFallbackBody {
  fallback?: TypesV1FallbackRequest;
}

export interface SmartLinksV1SmartLinksServiceUpdateSmartLinkStatusBody {
  status: EnumsV1SmartLinkStatus;
  statusDisabledFallback?: TypesV1FallbackRequest;
}

export interface SmartLinksV1UpdateSmartLinkNoSuitableLpFallbackResponse {
  fallback?: TypesV1Fallback;
}

export interface SmartLinksV1UpdateSmartLinkResponse {
  smartLink: SmartLinksV1SmartLink;
}

export interface SmartLinksV1UpdateSmartLinkStatusResponse {
  status: EnumsV1SmartLinkStatus;
  statusDisabledFallback?: TypesV1Fallback;
}

export interface SourcesV1ListSourcesResponse {
  sources?: SourcesV1Source[];
}

export interface SourcesV1Source {
  id?: string;
  publicId?: string;
  tierId?: string;
  accountId?: string;
  status?: SourcesV1SourceStatus;
}

export interface StripeV1CreateStripeIntegrationResponse {
  integration?: StripeV1StripeIntegration;
}

export type StripeV1DeleteStripeIntegrationResponse = object;

export interface StripeV1GetStripeIntegrationApiVersionResponse {
  currentVersion?: string;
  minVersion?: string;
  supported?: boolean;
}

export interface StripeV1GetStripeIntegrationCustomerDetailResponse {
  conversionSources?: StripeV1GetStripeIntegrationCustomerDetailResponseConversionSource[];
}

export interface StripeV1GetStripeIntegrationCustomerDetailResponseConversionSource {
  cid?: string;
  externalCid?: string;
  source?: StripeV1GetStripeIntegrationCustomerDetailResponseConversionSourceSource;
  offer?: StripeV1GetStripeIntegrationCustomerDetailResponseConversionSourceOffer;
  type?: ConversionSourcesV1ConversionSourceType;
}

export interface StripeV1GetStripeIntegrationCustomerDetailResponseConversionSourceOffer {
  id?: string;
  name?: string;
}

export interface StripeV1GetStripeIntegrationCustomerDetailResponseConversionSourceSource {
  id?: string;
  publicId?: string;
  accountId?: string;
}

export interface StripeV1GetStripeIntegrationResponse {
  integration?: StripeV1StripeIntegration;
}

export interface StripeV1SetStripeIntegrationCouponsTrackingResponse {
  enabled?: boolean;
}

export interface StripeV1StripeIntegration {
  stripeAccountId?: string;
  /** @format date-time */
  lastSyncAt?: string;
  couponsTrackingEnabled?: boolean;
}

export interface StripeV1StripeIntegrationsServiceGetStripeIntegrationCustomerDetailBody {
  billingEmail?: string;
}

export interface StripeV1StripeIntegrationsServiceSetStripeIntegrationCouponsTrackingBody {
  enabled?: boolean;
}

export interface StripeV1SyncStripeIntegrationResponse {
  result?: string;
}

/** Create a new offer tag. */
export interface TagsV1CreateTagRequest {
  /** Name of the color tag. */
  name?: string;
  /** Color of the offer tag, uses HTML hex color code. */
  hexColorCode?: string;
}

/** Feedback for create offer tag request. */
export interface TagsV1CreateTagResponse {
  /** Tag identifer. */
  tag?: TagsV1Tag;
}

/** Feedback for delete offer tag request. */
export type TagsV1DeleteTagResponse = object;

/** Details of requested offer tag. */
export interface TagsV1GetTagResponse {
  tag?: TagsV1Tag;
}

/** List of existing offer tags. */
export interface TagsV1ListTagsResponse {
  tags?: TagsV1Tag[];
}

/** Offer tag */
export interface TagsV1Tag {
  /** Unique identifer of the offer tag. */
  id?: string;
  /** Name of the offer tag. */
  name?: string;
  /** Color of the offer tag, uses HTML hex color code. */
  hexColorCode?: string;
}

/** Update existing offer tag. */
export interface TagsV1TagsServiceUpdateTagBody {
  /** Name of the color tag. */
  name?: string;
  /** Color of the offer tag, uses HTML hex color code. */
  hexColorCode?: string;
}

/** Feedback for updating an offer tag. */
export interface TagsV1UpdateTagResponse {
  /** Tag identifer. */
  tag?: TagsV1Tag;
}

export interface TenantStatisticsV1ListInactiveTenantsResponse {
  tenantIds: string[];
  /** @format date-time */
  latestAdminLoginAt: string;
}

export interface TenantStatisticsV1ListTenantStatisticsRequest {
  period?: TenantStatisticsV1Period;
  tenantIds?: string[];
  hasClicks?: boolean;
  hasConversions?: boolean;
}

export interface TenantStatisticsV1ListTenantStatisticsResponse {
  tenantStatistics?: TenantStatisticsV1TenantStatistics[];
}

export interface TenantStatisticsV1TenantStatistics {
  tenantId?: string;
  /** @format date-time */
  datetime?: string;
  /** @format int64 */
  clicks?: number;
  /** @format date-time */
  lastClickCreatedAt?: string;
  /** @format int64 */
  conversions?: number;
  /** @format date-time */
  lastConversionCreatedAt?: string;
  /** @format int64 */
  tiers?: number;
  /** @format int64 */
  conversionTypes?: number;
  /** @format int64 */
  paymentMethods?: number;
  /** @format double */
  cost?: number;
  /** @format double */
  revenue?: number;
  /** @format int64 */
  adminAccounts?: number;
  /** @format int64 */
  affiliateAccounts?: number;
  /** @format int64 */
  finishedOffers?: number;
  /** @format int64 */
  draftOffers?: number;
  /** @format date-time */
  registeredAt?: string;
  hasLogo?: boolean;
  membershipPlanId?: string;
  lastAutomaticMembershipPlanId?: string;
  firebaseUserId?: string;
  stripeIntegrationAccountIds?: string;
  loginEnabled?: boolean;
  trafficEnabled?: boolean;
  adminAccessStatus?: SettingsV1AdminAccessStatus;
  adminAccessEnabled?: boolean;
  /** @format date-time */
  lastAdminLoginAt?: string;
  freeTrialActive?: boolean;
}

export type TenantsV1CleanTenantResponse = object;

export interface TenantsV1CreateEcommerceTenantResponse {
  adminAccount?: TenantsV1CreateEcommerceTenantResponseAdminAccount;
}

export interface TenantsV1CreateEcommerceTenantResponseAdminAccount {
  name?: string;
  email?: string;
}

export type TenantsV1DeleteCurrentTenantResponse = object;

export interface TenantsV1DeleteInactiveTenantsRequest {
  tenantIds?: string[];
  /** @format date-time */
  latestAdminLoginAt?: string;
}

export interface TenantsV1DeleteInactiveTenantsResponse {
  deletedTenantIds: string[];
  skippedActiveTenantIds: string[];
  skippedNoDnsTenantIds: string[];
  error?: TenantsV1DeleteInactiveTenantsResponseError;
}

export interface TenantsV1DeleteInactiveTenantsResponseError {
  tenantId: string;
  message: string;
  unprocessedTenantIds: string[];
}

export type TenantsV1DeleteTenantResponse = object;

export interface TenantsV1IsTenantIdAvailableRequest {
  id?: TypesV1TenantId;
}

export interface TenantsV1IsTenantIdAvailableResponse {
  available?: boolean;
}

export interface TenantsV1ListTenantsResponse {
  tenants?: TenantsV1ListTenantsResponseTenant[];
}

export interface TenantsV1ListTenantsResponseTenant {
  id?: string;
  name?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface TenantsV1ListUserTenantsResponse {
  tenants?: TenantsV1ListUserTenantsResponseTenant[];
}

export interface TenantsV1ListUserTenantsResponseTenant {
  id?: string;
  name?: string;
}

export interface TenantsV1RegisterEcommerceRequest {
  tenantId?: TypesV1TenantId;
  name?: string;
  currency?: TypesV1Currency;
  timezone?: string;
  websiteUrl?: TypesV1Url;
  membership?: TenantsV1RegisterEcommerceRequestMembership;
}

export interface TenantsV1RegisterEcommerceRequestMembership {
  platformId?: MembershipsV1PlatformId;
  stripeCustomerId?: string;
}

export type TenantsV1RegisterEcommerceResponse = object;

/** fields not validated intentionally (private service & validation definitions duplicity) */
export interface TenantsV1WelcomeTenantRequestAdminAccount {
  name?: string;
  email?: string;
}

export type TenantsV1WelcomeTenantResponse = object;

export interface TierTransitionAutomationV1BidirectionalTierTransition {
  ascensionThreshold: TierTransitionAutomationV1Threshold;
  declensionThreshold?: TierTransitionAutomationV1Threshold;
}

export interface TierTransitionAutomationV1ConversionFilter {
  conversionTypeIds?: string[];
}

export interface TierTransitionAutomationV1CreateTierTransitionRequest {
  sourceTierId: string;
  targetTierId: string;
  transitionType: TierTransitionAutomationV1TransitionType;
}

export interface TierTransitionAutomationV1CreateTierTransitionResponse {
  tierTransition: TierTransitionAutomationV1TierTransition;
}

export type TierTransitionAutomationV1DeleteTierTransitionResponse = object;

export interface TierTransitionAutomationV1GetTierTransitionAutomationSettingsResponse {
  tierTransitionAutomationSettings?: TierTransitionAutomationV1GetTierTransitionAutomationSettingsResponseTierTransitionAutomationSettings;
}

export interface TierTransitionAutomationV1GetTierTransitionAutomationSettingsResponseTierTransitionAutomationSettings {
  type: EnumsV1TierTransitionType;
  metric: EnumsV1TierTransitionMetric;
  period: EnumsV1TierTransitionPeriod;
  conversionFilter?: TierTransitionAutomationV1ConversionFilter;
}

export interface TierTransitionAutomationV1ListTierTransitionsResponse {
  tierTransitions?: TierTransitionAutomationV1TierTransition[];
}

export interface TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequest {
  disabled?: TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestTierTransitionsDisabled;
  lifetime?: TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestTierTransitionsLifetime;
  periodical?: TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestTierTransitionsPeriodical;
}

export interface TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestBidirectionalTierTransition {
  id: string;
  ascensionThreshold: TierTransitionAutomationV1Threshold;
  declensionThreshold?: TierTransitionAutomationV1Threshold;
}

export type TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestTierTransitionsDisabled =
  object;

export interface TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestTierTransitionsLifetime {
  metric: EnumsV1TierTransitionMetric;
  conversionFilter?: TierTransitionAutomationV1ConversionFilter;
  tierTransitions?: TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestUnidirectionalTierTransition[];
}

export interface TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestTierTransitionsPeriodical {
  metric: EnumsV1TierTransitionMetric;
  period: EnumsV1TierTransitionPeriod;
  conversionFilter?: TierTransitionAutomationV1ConversionFilter;
  tierTransitions?: TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestBidirectionalTierTransition[];
}

export interface TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequestUnidirectionalTierTransition {
  id: string;
  threshold: TierTransitionAutomationV1Threshold;
}

export type TierTransitionAutomationV1SetTierTransitionAutomationSettingsResponse =
  object;

export interface TierTransitionAutomationV1Threshold {
  revenue?: TypesV1UnsignedDecimal;
  cost?: TypesV1UnsignedDecimal;
  conversionCount?: TypesV1UnsignedDecimal;
}

export interface TierTransitionAutomationV1TierTransition {
  id: string;
  sourceTierId: string;
  targetTierId: string;
  transitionType: TierTransitionAutomationV1TransitionType;
}

export interface TierTransitionAutomationV1TierTransitionAutomationServiceUpdateTierTransitionBody {
  targetTierId: string;
  transitionType: TierTransitionAutomationV1TransitionType;
}

export interface TierTransitionAutomationV1TransitionType {
  disabled?: TierTransitionAutomationV1TransitionTypeDisabled;
  lifetime?: TierTransitionAutomationV1UnidirectionalTierTransition;
  periodical?: TierTransitionAutomationV1BidirectionalTierTransition;
}

export type TierTransitionAutomationV1TransitionTypeDisabled = object;

export interface TierTransitionAutomationV1UnidirectionalTierTransition {
  ascensionThreshold: TierTransitionAutomationV1Threshold;
}

export interface TierTransitionAutomationV1UpdateTierTransitionResponse {
  tierTransition: TierTransitionAutomationV1TierTransition;
}

/** Create a new affilaite tier */
export interface TiersV1CreateTierRequest {
  /** Name of the tier. */
  name?: string;
  /** Default affiliate payout rate for the tier. Uses decimal as a string. */
  defaultRate?: TypesV1Decimal;
}

/** Create new affilaite response. */
export interface TiersV1CreateTierResponse {
  /** ID of the created tier. */
  tier?: TiersV1Tier;
}

/** Deletion request response. */
export type TiersV1DeleteTierResponse = object;

/** Detail of requested affilaite tier. */
export interface TiersV1GetTierResponse {
  tier?: TiersV1Tier;
}

/** List of all active tier in the system. */
export interface TiersV1ListTiersResponse {
  tiers?: TiersV1Tier[];
}

/** Affiliate tier */
export interface TiersV1Tier {
  /** Unique identifer of the tier. */
  id?: string;
  /** Name of the tier. */
  name?: string;
  /** Default affiliate payout rate for the tier. Uses decimal as a string. */
  defaultRate?: TypesV1Decimal;
  /** Designates if tier is the default that gets assigned to new affiliates, only one tier can be set as true. */
  default?: boolean;
}

/** Update an existing affilaite tier. */
export interface TiersV1TiersServiceUpdateTierBody {
  /** Name of the tier. */
  name?: string;
  /** Default affiliate payout rate for the tier. Uses decimal as a string. */
  defaultRate?: TypesV1Decimal;
}

/** Update existing affiliate tier response. */
export interface TiersV1UpdateTierResponse {
  tier?: TiersV1Tier;
}

export type TipaltiV1CheckPaymentBatchStatusResponse = object;

export interface TipaltiV1CreatePaymentBatchResponse {
  /** Unique ID of a payment batch */
  paymentBatchId?: string;
}

export interface TipaltiV1CreateTipaltiAuthorizationLinkResponse {
  link?: string;
}

export interface TipaltiV1GetPayeeDashboardLinkResponse {
  link?: string;
}

export interface TipaltiV1GetPayeeForAccountResponse {
  payeeId?: string;
  isPayable?: boolean;
  hasPaymentMethod?: boolean;
}

export interface TipaltiV1GetTipaltiIntegrationResponse {
  authorization?: TipaltiV1GetTipaltiIntegrationResponseAuthorization;
}

export interface TipaltiV1GetTipaltiIntegrationResponseAuthorization {
  hasAuthorizationTokens?: boolean;
  masterKey?: string;
  payerName?: string;
}

export interface TipaltiV1ListPayableAccountSettlementsResponse {
  /** Unique IDs of account settlements payable via Tipalti. */
  payableAccountSettlementIds?: string[];
  /** Unique IDs of account settlements yet unpaid via Tipalti. */
  unpaidAccountSettlementIds?: string[];
}

export interface TipaltiV1SubmitTipaltiAuthorizationCodeRequest {
  code?: string;
}

export type TipaltiV1SubmitTipaltiAuthorizationCodeResponse = object;

export interface TipaltiV1TipaltiPaymentsServiceCheckPaymentBatchStatusBody {
  /** Unique ID of a payment batch */
  paymentBatchId?: string;
}

export interface TipaltiV1UpdateTipaltiIFrameAuthorizationRequest {
  masterKey?: string;
  payerName?: string;
}

export type TipaltiV1UpdateTipaltiIFrameAuthorizationResponse = object;

export interface TrackingV1ClickCustomParams {
  affS1?: string;
  affS2?: string;
  affS3?: string;
  affS4?: string;
  affS5?: string;
}

/** Create a new conversion */
export interface TrackingV1CreateConversionRequest {
  /** The click identification associated with the conversion. */
  cid?: string;
  /**
   * External CID associated with the conversion. See [Conversion sources](#tag--tracking.v1.ConversionSourceService) for more details.
   *
   * when external_cid is filled, then revenue_origin_id must also be filled, and cid cannot be filled
   */
  externalCid?: string;
  /**
   * Coupons to be redeemed within the conversion.
   *
   * when coupon codes are not empty, then revenue_origin_id must also be filled
   */
  couponCodes?: string[];
  /** Assigned revenue origin. Can be obtained from unique trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** Type of the conversion. */
  conversionTypeCode?: string;
  /** Status of the conversion. */
  status?: ConversionsV1ConversionStatus;
  /** The total revenue value of a conversion. Uses decimal number as a string. */
  amount?: TypesV1Decimal;
  /** Currency code of the conversion. Uses ISO 4217 formatting. */
  currency?: TypesV1Currency;
  /** External ID  is used for deduplication of conversions. When the conversion is created with an External ID, no other conversion can be created with the same External ID. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. */
  customerId?: string;
  /** Custom parameters associated with the conversion. */
  customParams?: ConversionsV1ConversionCustomParams;
}

/** Feedback message for new conversion creation. */
export interface TrackingV1CreateConversionResponse {
  /** CID of the source click/coupon tied to the conversion. CID is available when conversion is successfully paired. */
  cid?: string;
}

export interface TrackingV1CreateDirectClickRequest {
  linkId?: string;
  sourceId?: string;
  referrer?: string;
  customParams?: TrackingV1ClickCustomParams;
}

export interface TrackingV1CreateDirectClickResponse {
  cid: string;
  /** @format date-time */
  expiredAt: string;
  conversionAttributionType: EnumsV1ConversionAttributionType;
  anuraInstance?: string;
}

/** Add external CID to a conversion. */
export interface TrackingV1SetExternalCidRequest {
  /** Unique extrenal ID code. */
  externalCid?: string;
  /** Assigned revenue origin. Can be obtained from unique trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** CID – the click ID associated with the conversion. */
  cid?: string;
}

/** Feedback for adding external ID. */
export type TrackingV1SetExternalCidResponse = object;

/** Update conversion. */
export interface TrackingV1UpdateConversionRequest {
  /** Identifier of the conversion. */
  identifier: TrackingV1UpdateConversionRequestIdentifier;
  /** Status of the conversion. Won't be changed if not filled. */
  status?: ConversionsV1ConversionStatus;
  /** The revenue value of a conversion. Uses decimal number as a string. Won't be changed if not filled. */
  revenue?: TypesV1Decimal;
  /** The payout value of a conversion. Uses decimal number as a string. Won't be changed if not filled. */
  cost?: TypesV1Decimal;
  /** The sales amount value of a conversion. Uses decimal number as a string. Won't be changed if not filled. */
  conversionAmount?: TypesV1Decimal;
  /** External ID is used for deduplication of conversions. No other conversion can be created with the same External ID. Won't be changed if not filled. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. Won't be changed if not filled. */
  customerId?: string;
  /** Custom parameters associated with the conversion. Won't be changed if not filled. */
  customAdvParams?: TrackingV1UpdateConversionRequestConversionCustomParams;
  /** Custom affiliate parameters associated with the conversion. Won't be changed if not filled. */
  customAffParams?: TrackingV1UpdateConversionRequestConversionSourceCustomParams;
}

/** Custom advertiser parameters assigned to a conversion. */
export interface TrackingV1UpdateConversionRequestConversionCustomParams {
  /** Custom adv S1 parameter assigned to a conversion. Won't be changed if not filled. */
  advS1?: string;
  /** Custom adv S2 parameter assigned to a conversion. Won't be changed if not filled. */
  advS2?: string;
  /** Custom adv S3 parameter assigned to a conversion. Won't be changed if not filled. */
  advS3?: string;
  /** Custom adv S4 parameter assigned to a conversion. Won't be changed if not filled. */
  advS4?: string;
  /** Custom adv S5 parameter assigned to a conversion. Won't be changed if not filled. */
  advS5?: string;
}

/** Custom affiliate parameters assigned to a conversion source. */
export interface TrackingV1UpdateConversionRequestConversionSourceCustomParams {
  /** Custom aff S1 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS1?: string;
  /** Custom aff S2 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS2?: string;
  /** Custom aff S3 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS3?: string;
  /** Custom aff S4 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS4?: string;
  /** Custom aff S5 parameter assigned to a conversion source. Won't be changed if not filled. */
  affS5?: string;
}

/** Identifier of the conversion. */
export interface TrackingV1UpdateConversionRequestIdentifier {
  /** ID of the conversion. */
  id?: string;
  /** External identifier of the conversion. */
  external?: TrackingV1UpdateConversionRequestIdentifierExternal;
}

/** External identifier of the conversion. */
export interface TrackingV1UpdateConversionRequestIdentifierExternal {
  /** Revenue origin associated with the conversion. You can find this information in your unique trackdesk identifiers in the Settings. */
  revenueOriginId?: string;
  /** External ID associated with the conversion. */
  externalId?: string;
  /** Code of the conversion type. */
  conversionTypeCode?: string;
}

/** Feedback message for update conversion. */
export type TrackingV1UpdateConversionResponse = object;

export interface TrackingBlockingV1Condition {
  isEmpty?: boolean;
  equals?: string;
}

export interface TrackingBlockingV1GetTrackingBlockingResponse {
  trackingBlocking?: TrackingBlockingV1TrackingBlocking;
}

export interface TrackingBlockingV1SetTrackingBlockingRequest {
  trackingBlocking?: TrackingBlockingV1TrackingBlocking;
}

export type TrackingBlockingV1SetTrackingBlockingResponse = object;

export interface TrackingBlockingV1TrackingBlocking {
  /**
   * List of rules with conditions to block clicks. Each elements consists of a set of ANDed conditions (when all conditions are met the click is blocked).
   * Additionally multiple condition sets (list elements) are ORed together (if at least one condition set is met the click is blocked).
   */
  clickRules?: TrackingBlockingV1TrackingBlockingClickRule[];
  /**
   * List of rules with conditions to block conversions. Each elements consists of a set of ANDed conditions (when all conditions are met the conversion is blocked).
   * Additionally multiple condition sets (list elements) are ORed together (if at least one condition set is met the conversion is blocked).
   */
  conversionRules?: TrackingBlockingV1TrackingBlockingConversionRule[];
}

export interface TrackingBlockingV1TrackingBlockingClickRule {
  affS1?: TrackingBlockingV1Condition;
  affS2?: TrackingBlockingV1Condition;
  affS3?: TrackingBlockingV1Condition;
  affS4?: TrackingBlockingV1Condition;
  affS5?: TrackingBlockingV1Condition;
}

export interface TrackingBlockingV1TrackingBlockingConversionRule {
  advS1?: TrackingBlockingV1Condition;
  advS2?: TrackingBlockingV1Condition;
  advS3?: TrackingBlockingV1Condition;
  advS4?: TrackingBlockingV1Condition;
  advS5?: TrackingBlockingV1Condition;
  externalId?: TrackingBlockingV1Condition;
  customerId?: TrackingBlockingV1Condition;
}

export interface TypesV1AmountOrRate {
  amount?: TypesV1Decimal;
  rate?: TypesV1Decimal;
}

export interface TypesV1Anura {
  anuraScore?: EnumsV1AnuraScore;
  result?: TypesV1AnuraResult;
}

export interface TypesV1AnuraResult {
  result?: string;
  /** @format int32 */
  mobile?: number;
  /** @format int32 */
  adblocker?: number;
  ruleSets?: string[];
}

export interface TypesV1ColorTheme {
  theme?: string;
  backgroundEnabled?: boolean;
}

export interface TypesV1Currency {
  /** The three-letter currency code defined in ISO 4217. */
  code?: string;
}

export interface TypesV1CustomQuestionAnswer {
  question?: string;
  answer?: TypesV1CustomQuestionAnswerAnswer;
}

export interface TypesV1CustomQuestionAnswerAnswer {
  text?: string;
  checkbox?: boolean;
  options?: TypesV1CustomQuestionAnswerAnswerOptions;
}

export interface TypesV1CustomQuestionAnswerAnswerOptions {
  values?: string[];
}

export interface TypesV1CustomQuestionSettings {
  question: string;
  visibility: EnumsV1QuestionVisibility;
  basicQuestion?: TypesV1CustomQuestionSettingsBasicQuestion;
  selectOptionQuestion?: TypesV1CustomQuestionSettingsSelectOptionQuestion;
}

export interface TypesV1CustomQuestionSettingsBasicQuestion {
  answerType: EnumsV1AnswerType;
}

export interface TypesV1CustomQuestionSettingsSelectOptionQuestion {
  selectMultiple?: boolean;
  options: string[];
}

export interface TypesV1Decimal {
  value?: string;
}

export interface TypesV1Fallback {
  offerId?: string;
  smartLinkId?: string;
  customUrl?: string;
}

export interface TypesV1FallbackRequest {
  offerId?: string;
  smartLinkId?: string;
  customUrl?: string;
}

export interface TypesV1FraudSuspicion {
  isSuspected?: boolean;
  causes?: EnumsV1FraudSuspicionCause[];
}

export interface TypesV1FraudSuspicionFilter {
  isSuspected?: boolean;
}

export interface TypesV1Messenger {
  signal?: TypesV1MessengerSignal;
  skype?: TypesV1MessengerSkype;
  telegram?: TypesV1MessengerTelegram;
  whatsapp?: TypesV1MessengerWhatsapp;
}

export interface TypesV1MessengerSignal {
  phoneNumber?: string;
}

export interface TypesV1MessengerSkype {
  username?: string;
}

export interface TypesV1MessengerTelegram {
  phoneNumber?: string;
}

export interface TypesV1MessengerWhatsapp {
  phoneNumber?: string;
}

export interface TypesV1Metadata {
  /** max len 40 minus space for prefix */
  key?: string;
  value?: string;
}

export interface TypesV1OptionalPaginationRequest {
  /** @format int64 */
  limit?: number;
  /** @format int64 */
  offset?: number;
}

export interface TypesV1PaginationRequest {
  /** @format int64 */
  limit?: number;
  /** @format int64 */
  offset?: number;
}

export interface TypesV1PaginationResponse {
  /** @format int64 */
  totalCount?: number;
  hasMore?: boolean;
}

export interface TypesV1RuleElementScope {
  ids: string[];
  blacklisted: boolean;
}

/** Only lowercase alphanumeric characters allowed. */
export interface TypesV1SourcePublicId {
  value?: string;
}

export interface TypesV1TenantId {
  value?: string;
}

export interface TypesV1TimeRange {
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface TypesV1UnsignedDecimal {
  value?: string;
}

export interface TypesV1Url {
  value?: string;
}

export interface UsersV1GetAccountResponse {
  id?: string;
  tenants?: string[];
  mfaEnrollments?: UsersV1GetAccountResponseMultiFactorEnrollment[];
}

export interface UsersV1GetAccountResponseMultiFactorEnrollment {
  id?: string;
}

export interface UsersV1GetCustomTokenResponse {
  customToken?: string;
}

export interface UsersV1GetEmailSignInLinkRequest {
  email: string;
}

export interface UsersV1GetEmailSignInLinkResponse {
  link: string;
}

export type UsersV1InitUserResponse = object;

export interface UsersV1IsUserWithoutPasswordResponse {
  isWithoutPassword: boolean;
}

export interface UsersV1ListSuperAdminsResponse {
  superAdmins?: UsersV1SuperAdmin[];
}

export interface UsersV1RegisterSuperAdminRequest {
  name?: string;
  email?: string;
  password?: string;
}

export type UsersV1RegisterSuperAdminResponse = object;

export interface UsersV1RegisterUserRequest {
  name?: string;
  email?: string;
  password?: string;
  recaptchaToken?: string;
  businessEmailValidation?: boolean;
}

export type UsersV1RegisterUserResponse = object;

export type UsersV1RemoveMfaFromAccountResponse = object;

export interface UsersV1ResetPasswordOutsideTenantRequest {
  email?: string;
}

export type UsersV1ResetPasswordOutsideTenantResponse = object;

export interface UsersV1ResetPasswordWithinTenantRequest {
  email?: string;
}

export type UsersV1ResetPasswordWithinTenantResponse = object;

export interface UsersV1SendEmailSignInLinkRequest {
  email: string;
}

export type UsersV1SendEmailSignInLinkResponse = object;

export interface UsersV1SetPasswordRequest {
  password: string;
}

export type UsersV1SetPasswordResponse = object;

export interface UsersV1SuperAdmin {
  name?: string;
  email?: string;
  uid?: string;
}

export interface UsersV1UserChangeEmailRequest {
  firebaseId: string;
  email: string;
}

export type UsersV1UserChangeEmailResponse = object;

export type UsersV1VerifyEmailOutsideTenantResponse = object;

export interface UsersV1VerifyEmailSignInLinkRequest {
  email: string;
  oobCode: string;
}

export interface UsersV1VerifyEmailSignInLinkResponse {
  token: string;
  customToken: string;
}

/** Create a new webhook. */
export interface WebhooksV1CreateWebhookRequest {
  /**
   * Webhook specification
   * Webhook.
   */
  webhook: WebhooksV1Webhook;
}

/** Feedback for create webhook request. */
export interface WebhooksV1CreateWebhookResponse {
  /** Unique identifier of the webhook */
  id?: string;
}

/** Feedback for delete webhook request. */
export type WebhooksV1DeleteWebhookResponse = object;

export interface WebhooksV1Event {
  /** Tenant ID associated with the webhooks */
  tenantId?: string;
  clickCreated?: ClicksV1Click;
  /** Notifies about a new conversion registered by the system. */
  conversionCreated?: WebhooksV1EventConversionCreated;
  affiliateCreated?: AffiliatesV1Affiliate;
  /** Notifies about the change of affiliate's status in the system. */
  affiliateStatusChanged?: WebhooksV1EventAffiliateStatusChanged;
  /** Notifies about the change of affiliate's tier in the system. */
  affiliateTierChanged?: WebhooksV1EventAffiliateTierChanged;
  /** Notifies about a creation of new Stripe integration. */
  stripeIntegrationCreated?: WebhooksV1EventStripeIntegrationCreated;
  /** Notifies about the deletion of Stripe integration. */
  stripeIntegrationDeleted?: WebhooksV1EventStripeIntegrationDeleted;
  /** Notifies about the change of conversion's status in the system. */
  conversionStatusChanged?: WebhooksV1EventConversionStatusChanged;
  /** Notifies about a creation of a new settlement. */
  settlementCreated?: WebhooksV1EventSettlementCreated;
  /** Notifies about a creation of a new coupon. */
  couponCreated?: WebhooksV1EventCouponCreated;
  /** Notifies when a free trial is started. */
  freeTrialStarted?: WebhooksV1EventFreeTrialStarted;
}

/** Notifies about the change of affiliate's status in the system. */
export interface WebhooksV1EventAffiliateStatusChanged {
  /** Email of the affiliate */
  email?: string;
  /** Public identifiers (Referral IDs) of the affiliate */
  publicIds?: string[];
  /** Original status of the affiliate's account */
  originalStatus?: EnumsV1AccountStatus;
  /** New status of the affiliate's account */
  newStatus?: EnumsV1AccountStatus;
}

/** Notifies about the change of affiliate's tier in the system. */
export interface WebhooksV1EventAffiliateTierChanged {
  /** E-mail of the affiliate */
  email?: string;
  /** Public identifier (Referral ID) of the affiliate */
  publicId?: string;
  /** Original tier name of the affiliate's account */
  originalTierName?: string;
  /** New tier name of the affiliate's account */
  newTierName?: string;
}

/** Notifies about a new conversion registered by the system. */
export interface WebhooksV1EventConversionCreated {
  /** Unique identifier of the conversion */
  id?: string;
  /** ID of the click associated with the conversion */
  cid?: string;
  /** Conversions' revenue origin, obtainable from trackdesk identifiers in app */
  revenueOriginId?: string;
  /** Type of the conversion */
  conversionTypeId?: string;
  /**
   * Status of the conversion
   * Check all validations on any index update.
   */
  status?: ConversionsV1ConversionStatus;
  /** Payout for the affiliate. Decimal value as a string. */
  cost?: TypesV1Decimal;
  /** Conversion's revenue amount. Decimal value as string. */
  revenue?: TypesV1Decimal;
  /** Currency code, uses ISO 4217 format */
  currencyCode?: string;
  /** External ID, see [Conversion source service](#post-/tracking/external-cid/v1) for more details */
  externalId?: string;
  /** Customer ID, your specific custom identifier */
  customerId?: string;
  /** List of custom adv parameters */
  customParams?: WebhooksV1EventConversionCreatedCustomParams;
  /** Offer associated with the conversion */
  offer?: OffersV1OfferOut;
  /** Affiliate credited with the conversion */
  affiliate?: AffiliatesV1Affiliate;
  /** Type of the conversion */
  conversionType?: ConversionTypesV1ConversionType;
}

export interface WebhooksV1EventConversionCreatedCustomParams {
  /** Custom adv S1 parameter */
  advS1?: string;
  /** Custom adv S2 parameter */
  advS2?: string;
  /** Custom adv S3 parameter */
  advS3?: string;
  /** Custom adv S4 parameter */
  advS4?: string;
  /** Custom adv S5 parameter */
  advS5?: string;
}

/** Notifies about the change of conversion's status in the system. */
export interface WebhooksV1EventConversionStatusChanged {
  /** Unique identifier of the conversion */
  id?: string;
  /**
   * Original status of the conversion
   * Check all validations on any index update.
   */
  originalStatus?: ConversionsV1ConversionStatus;
  /**
   * New status of the conversion
   * Check all validations on any index update.
   */
  newStatus?: ConversionsV1ConversionStatus;
}

/** Notifies about a creation of a new coupon. */
export interface WebhooksV1EventCouponCreated {
  /** Unique identifier of the coupon */
  id?: string;
  /** Coupon code */
  code?: string;
  /** Coupon's revenue origin, obtainable from Trackdesk identifiers in app */
  revenueOriginId?: string;
  /** Affiliate credited with the coupon */
  affiliate?: AffiliatesV1Affiliate;
  /** Offer associated with the coupon */
  offer?: OffersV1OfferOut;
}

/** Notifies when a free trial is started. */
export interface WebhooksV1EventFreeTrialStarted {
  planId?: MembershipsV1PlanId;
  /** @format date-time */
  endAt?: string;
}

/** Notifies about a creation of a new settlement. */
export interface WebhooksV1EventSettlementCreated {
  /** Unique identifier of the settlement */
  id?: string;
  /**
   * Settled balances until this time
   * @format date-time
   */
  until?: string;
  /** Settled amount */
  amount?: TypesV1Decimal;
  /** Currency of the settled amount */
  currencyCode?: string;
  /** Settlement note */
  note?: string;
}

/** Notifies about a creation of new Stripe integration. */
export interface WebhooksV1EventStripeIntegrationCreated {
  /** Unique identifier of the integration */
  id?: string;
  /** Stripe account associated with the integration */
  stripeAccountId?: string;
}

/** Notifies about the deletion of Stripe integration. */
export interface WebhooksV1EventStripeIntegrationDeleted {
  /** Unique identifier of the integration */
  id?: string;
  /** Stripe account associated with the integration */
  stripeAccountId?: string;
}

/** Existing webhooks. */
export interface WebhooksV1ListWebhooksResponse {
  webhooks?: WebhooksV1Webhook[];
}

/** Request a test ping for existing webhook. */
export interface WebhooksV1SendWebhookRequest {
  /** URL to which the webhook should send a request */
  url: string;
  /** Type of event for the webhook test */
  eventType: WebhooksV1EventType;
}

/** Ping of existing webhook. */
export interface WebhooksV1SendWebhookResponse {
  event?: WebhooksV1Event;
}

/** Webhook. */
export interface WebhooksV1Webhook {
  /** Unique identifier of the webhook */
  id?: string;
  /** URL to which the webhook should send a request */
  url: string;
  /** Type of event for which the webhook should be executed */
  eventTypes: WebhooksV1EventType[];
}

export interface AccountServiceListAccountsParams {
  roleIds?: string[];
}

export interface AffiliateIntraMessagesServiceListAffiliateIntraMessageRecipientsParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  id: string;
}

export interface SettlementServiceListAccountSettlementsParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  /** @format date-time */
  "timeRange.from"?: string;
  /** @format date-time */
  "timeRange.to"?: string;
  /** ID of affiliate for which to show affiliate settlements. */
  accountId?: string;
}

export interface BalanceServiceListOpenBalancesParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  /**
   * Day until which the settlement is settled.
   * @format date-time
   */
  "filter.until"?: string;
  "filter.minAmount.value"?: string;
  /** Payment methods used for the settlement. */
  "filter.defaultPaymentMethodTypes"?: (
    | "PAYMENT_METHOD_TYPE_UNSPECIFIED"
    | "PAYMENT_METHOD_TYPE_BANK_TRANSFER"
    | "PAYMENT_METHOD_TYPE_BITCOIN"
    | "PAYMENT_METHOD_TYPE_CREDIT_STORE"
    | "PAYMENT_METHOD_TYPE_DIRECT_DEPOSIT"
    | "PAYMENT_METHOD_TYPE_ETHER"
    | "PAYMENT_METHOD_TYPE_GIFT_CARD"
    | "PAYMENT_METHOD_TYPE_MERCADO_PAGO"
    | "PAYMENT_METHOD_TYPE_NETELLER"
    | "PAYMENT_METHOD_TYPE_PAYONEER"
    | "PAYMENT_METHOD_TYPE_PAY_PAL"
    | "PAYMENT_METHOD_TYPE_REVOLUT"
    | "PAYMENT_METHOD_TYPE_SEPA"
    | "PAYMENT_METHOD_TYPE_SKRILL"
    | "PAYMENT_METHOD_TYPE_TIPALTI"
    | "PAYMENT_METHOD_TYPE_USDC"
    | "PAYMENT_METHOD_TYPE_USDT"
    | "PAYMENT_METHOD_TYPE_WISE"
  )[];
}

export interface BalanceServiceSummarizeOpenBalancesByPaymentMethodParams {
  /**
   * Day until which the settlement is settled.
   * @format date-time
   */
  "filter.until"?: string;
  "filter.minAmount.value"?: string;
  /** Payment methods used for the settlement. */
  "filter.defaultPaymentMethodTypes"?: (
    | "PAYMENT_METHOD_TYPE_UNSPECIFIED"
    | "PAYMENT_METHOD_TYPE_BANK_TRANSFER"
    | "PAYMENT_METHOD_TYPE_BITCOIN"
    | "PAYMENT_METHOD_TYPE_CREDIT_STORE"
    | "PAYMENT_METHOD_TYPE_DIRECT_DEPOSIT"
    | "PAYMENT_METHOD_TYPE_ETHER"
    | "PAYMENT_METHOD_TYPE_GIFT_CARD"
    | "PAYMENT_METHOD_TYPE_MERCADO_PAGO"
    | "PAYMENT_METHOD_TYPE_NETELLER"
    | "PAYMENT_METHOD_TYPE_PAYONEER"
    | "PAYMENT_METHOD_TYPE_PAY_PAL"
    | "PAYMENT_METHOD_TYPE_REVOLUT"
    | "PAYMENT_METHOD_TYPE_SEPA"
    | "PAYMENT_METHOD_TYPE_SKRILL"
    | "PAYMENT_METHOD_TYPE_TIPALTI"
    | "PAYMENT_METHOD_TYPE_USDC"
    | "PAYMENT_METHOD_TYPE_USDT"
    | "PAYMENT_METHOD_TYPE_WISE"
  )[];
}

export interface SettlementServiceListSettlementsParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  /** @format date-time */
  "timeRange.from"?: string;
  /** @format date-time */
  "timeRange.to"?: string;
}

export interface ClicksServiceListClicksParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
}

export interface ConversionServiceCreateConversion2Params {
  /** The click identification associated with the conversion. */
  cid?: string;
  /**
   * External CID associated with the conversion. See [Conversion sources](#tag--tracking.v1.ConversionSourceService) for more details.
   *
   * when external_cid is filled, then revenue_origin_id must also be filled, and cid cannot be filled
   */
  externalCid?: string;
  /**
   * Coupons to be redeemed within the conversion.
   *
   * when coupon codes are not empty, then revenue_origin_id must also be filled
   */
  couponCodes?: string[];
  /** Assigned revenue origin. Can be obtained from unique trackdesk identifiers in the settings. */
  revenueOriginId?: string;
  /** Type of the conversion. */
  conversionTypeCode?: string;
  /**
   * Status of the conversion.
   * @default "CONVERSION_STATUS_UNSPECIFIED"
   */
  status?:
    | "CONVERSION_STATUS_UNSPECIFIED"
    | "CONVERSION_STATUS_APPROVED"
    | "CONVERSION_STATUS_FRAUD"
    | "CONVERSION_STATUS_NOT_ALLOWED"
    | "CONVERSION_STATUS_BLOCKED"
    | "CONVERSION_STATUS_ON_HOLD"
    | "CONVERSION_STATUS_PENDING"
    | "CONVERSION_STATUS_REFUNDED"
    | "CONVERSION_STATUS_REJECTED"
    | "CONVERSION_STATUS_TEST"
    | "CONVERSION_STATUS_QUALITY_CONTROL";
  "amount.value"?: string;
  /** The three-letter currency code defined in ISO 4217. */
  "currency.code"?: string;
  /** External ID  is used for deduplication of conversions. When the conversion is created with an External ID, no other conversion can be created with the same External ID. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. */
  customerId?: string;
  /** Custom adv S1 parameter assigned to a conversion. */
  "customParams.advS1"?: string;
  /** Custom adv S2 parameter assigned to a conversion. */
  "customParams.advS2"?: string;
  /** Custom adv S3 parameter assigned to a conversion. */
  "customParams.advS3"?: string;
  /** Custom adv S4 parameter assigned to a conversion. */
  "customParams.advS4"?: string;
  /** Custom adv S5 parameter assigned to a conversion. */
  "customParams.advS5"?: string;
}

export interface ConversionServiceUpdateConversion2Params {
  /** ID of the conversion. */
  "identifier.id"?: string;
  /** Revenue origin associated with the conversion. You can find this information in your unique trackdesk identifiers in the Settings. */
  "identifier.external.revenueOriginId"?: string;
  /** External ID associated with the conversion. */
  "identifier.external.externalId"?: string;
  /** Code of the conversion type. */
  "identifier.external.conversionTypeCode"?: string;
  /**
   * Status of the conversion. Won't be changed if not filled.
   * @default "CONVERSION_STATUS_UNSPECIFIED"
   */
  status?:
    | "CONVERSION_STATUS_UNSPECIFIED"
    | "CONVERSION_STATUS_APPROVED"
    | "CONVERSION_STATUS_FRAUD"
    | "CONVERSION_STATUS_NOT_ALLOWED"
    | "CONVERSION_STATUS_BLOCKED"
    | "CONVERSION_STATUS_ON_HOLD"
    | "CONVERSION_STATUS_PENDING"
    | "CONVERSION_STATUS_REFUNDED"
    | "CONVERSION_STATUS_REJECTED"
    | "CONVERSION_STATUS_TEST"
    | "CONVERSION_STATUS_QUALITY_CONTROL";
  "revenue.value"?: string;
  "cost.value"?: string;
  "conversionAmount.value"?: string;
  /** External ID is used for deduplication of conversions. No other conversion can be created with the same External ID. Won't be changed if not filled. */
  externalId?: string;
  /** Customer ID, your specific custom identifer. Won't be changed if not filled. */
  customerId?: string;
  /** Custom adv S1 parameter assigned to a conversion. Won't be changed if not filled. */
  "customAdvParams.advS1"?: string;
  /** Custom adv S2 parameter assigned to a conversion. Won't be changed if not filled. */
  "customAdvParams.advS2"?: string;
  /** Custom adv S3 parameter assigned to a conversion. Won't be changed if not filled. */
  "customAdvParams.advS3"?: string;
  /** Custom adv S4 parameter assigned to a conversion. Won't be changed if not filled. */
  "customAdvParams.advS4"?: string;
  /** Custom adv S5 parameter assigned to a conversion. Won't be changed if not filled. */
  "customAdvParams.advS5"?: string;
  /** Custom aff S1 parameter assigned to a conversion source. Won't be changed if not filled. */
  "customAffParams.affS1"?: string;
  /** Custom aff S2 parameter assigned to a conversion source. Won't be changed if not filled. */
  "customAffParams.affS2"?: string;
  /** Custom aff S3 parameter assigned to a conversion source. Won't be changed if not filled. */
  "customAffParams.affS3"?: string;
  /** Custom aff S4 parameter assigned to a conversion source. Won't be changed if not filled. */
  "customAffParams.affS4"?: string;
  /** Custom aff S5 parameter assigned to a conversion source. Won't be changed if not filled. */
  "customAffParams.affS5"?: string;
}

export interface ConversionsServiceListConversionsParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
}

export interface OffersServiceListOffersParams {
  name?: string;
  /** @default "VISIBILITY_UNSPECIFIED" */
  visibility?:
    | "VISIBILITY_UNSPECIFIED"
    | "VISIBILITY_PUBLIC"
    | "VISIBILITY_PRIVATE"
    | "VISIBILITY_APPLY_TO_RUN";
  statuses?: (
    | "STATUS_UNSPECIFIED"
    | "STATUS_DRAFT"
    | "STATUS_ACTIVE"
    | "STATUS_INACTIVE"
  )[];
  tagIds?: string[];
  countryCodes?: string[];
  conversionTypeIds?: string[];
  categoryIds?: string[];
  pinned?: boolean;
  ids?: string[];
}

export interface OfferSourcesServiceListApplicationsForAssignmentToOfferParams {
  accesses?: (
    | "ACCESS_UNSPECIFIED"
    | "ACCESS_ALLOWED"
    | "ACCESS_FORBIDDEN"
    | "ACCESS_PENDING"
  )[];
}

export interface OfferSourcesServiceSetSourceAccessToOfferParams {
  /** @default "ACCESS_UNSPECIFIED" */
  access?:
    | "ACCESS_UNSPECIFIED"
    | "ACCESS_ALLOWED"
    | "ACCESS_FORBIDDEN"
    | "ACCESS_PENDING";
  id: string;
}

export interface OffersServiceCloneOfferParams {
  newName?: string;
  originalOfferId: string;
}

export interface ClaimServiceListClaimsParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  /** @format date-time */
  "timeRange.from"?: string;
  /** @format date-time */
  "timeRange.to"?: string;
}

export interface RevenueOriginBalanceServiceListRevenueOriginOpenBalancesParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  /** @format date-time */
  "filter.until": string;
  "filter.minAmount.value"?: string;
}

export interface RevenueOriginBalanceServiceSummarizeRevenueOriginOpenBalancesParams {
  /** @format date-time */
  "filter.until": string;
  "filter.minAmount.value"?: string;
}

export interface AdvertiserIntraMessagesServiceListAdvertiserIntraMessageRecipientsParams {
  /** @format int64 */
  "pagination.limit"?: number;
  /** @format int64 */
  "pagination.offset"?: number;
  id: string;
}

export interface ShortLinksServiceListForSourceOfferParams {
  sourceId: string;
  offerId: string;
}

export interface SmartLinksServiceListSmartLinksParams {
  offerIds?: string[];
  statuses?: (
    | "SMART_LINK_STATUS_UNSPECIFIED"
    | "SMART_LINK_STATUS_ENABLED"
    | "SMART_LINK_STATUS_DISABLED"
  )[];
}

export interface TenantStatisticsServiceListInactiveTenantsParams {
  /** @format date-time */
  latestAdminLoginAt?: string;
}

export interface TenantDeletionServiceDeleteTenantParams {
  keepMailchimpContacts?: boolean;
  tenantIdValue: string;
}

export interface TipaltiPaymentsServiceGetPayeeDashboardLinkParams {
  accountId?: string;
}

export interface TipaltiPaymentsServiceGetPayeeForAccountParams {
  accountId?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://{tenantId}.trackdesk.com";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Trackdesk public API
 * @version 1.0
 * @license UNLICENSED (https://trackdesk.com/terms-conditions)
 * @termsOfService https://trackdesk.com/terms-conditions
 * @baseUrl https://{tenantId}.trackdesk.com
 * @contact Trackdesk Support <support@trackdesk.com> (https://trackdesk.com)
 *
 * API documentation
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  accountNotesV1AccountNoteService = {
    /**
     * No description
     *
     * @tags account_notes.v1.AccountNoteService
     * @name AccountNoteServiceCreateAccountNote
     * @request POST:/account-notes/v1
     * @secure
     * @response `200` `AccountNotesV1CreateAccountNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountNoteServiceCreateAccountNote: (
      body: AccountNotesV1CreateAccountNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AccountNotesV1CreateAccountNoteResponse, GoogleRpcStatus>({
        path: `/account-notes/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags account_notes.v1.AccountNoteService
     * @name AccountNoteServiceListAccountNotesForAccount
     * @request GET:/account-notes/v1/account/{accountId}
     * @secure
     * @response `200` `AccountNotesV1ListAccountNotesForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountNoteServiceListAccountNotesForAccount: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AccountNotesV1ListAccountNotesForAccountResponse,
        GoogleRpcStatus
      >({
        path: `/account-notes/v1/account/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags account_notes.v1.AccountNoteService
     * @name AccountNoteServiceDeleteAccountNote
     * @request DELETE:/account-notes/v1/{id}
     * @secure
     * @response `200` `AccountNotesV1DeleteAccountNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountNoteServiceDeleteAccountNote: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<AccountNotesV1DeleteAccountNoteResponse, GoogleRpcStatus>({
        path: `/account-notes/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  accountStatusesV1AccountStatusService = {
    /**
     * No description
     *
     * @tags account_statuses.v1.AccountStatusService
     * @name AccountStatusServiceListAccountStatuses
     * @request GET:/account-statuses/v1
     * @secure
     * @response `200` `AccountStatusesV1ListAccountStatusesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountStatusServiceListAccountStatuses: (params: RequestParams = {}) =>
      this.request<
        AccountStatusesV1ListAccountStatusesResponse,
        GoogleRpcStatus
      >({
        path: `/account-statuses/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  accountsV1AccountService = {
    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceListAccounts
     * @request GET:/accounts/v1
     * @secure
     * @response `200` `AccountsV1ListAccountsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceListAccounts: (
      query: AccountServiceListAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<AccountsV1ListAccountsResponse, GoogleRpcStatus>({
        path: `/accounts/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceGetContactEmail
     * @request GET:/accounts/v1/contact-email
     * @secure
     * @response `200` `AccountsV1GetContactEmailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceGetContactEmail: (params: RequestParams = {}) =>
      this.request<AccountsV1GetContactEmailResponse, GoogleRpcStatus>({
        path: `/accounts/v1/contact-email`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceListAccountsWithSource
     * @request GET:/accounts/v1/with-source
     * @secure
     * @response `200` `AccountsV1ListAccountsWithSourceResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceListAccountsWithSource: (params: RequestParams = {}) =>
      this.request<AccountsV1ListAccountsWithSourceResponse, GoogleRpcStatus>({
        path: `/accounts/v1/with-source`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceGetAccount
     * @request GET:/accounts/v1/{id}
     * @secure
     * @response `200` `AccountsV1GetAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceGetAccount: (id: string, params: RequestParams = {}) =>
      this.request<AccountsV1GetAccountResponse, GoogleRpcStatus>({
        path: `/accounts/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceDeleteAccount
     * @request DELETE:/accounts/v1/{id}
     * @secure
     * @response `200` `AccountsV1DeleteAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceDeleteAccount: (id: string, params: RequestParams = {}) =>
      this.request<AccountsV1DeleteAccountResponse, GoogleRpcStatus>({
        path: `/accounts/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceUpdateAccount
     * @request PATCH:/accounts/v1/{id}
     * @secure
     * @response `200` `AccountsV1UpdateAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceUpdateAccount: (
      id: string,
      body: AccountsV1AccountServiceUpdateAccountBody,
      params: RequestParams = {},
    ) =>
      this.request<AccountsV1UpdateAccountResponse, GoogleRpcStatus>({
        path: `/accounts/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts.v1.AccountService
     * @name AccountServiceSetPrimaryAccount
     * @request PUT:/accounts/v1/{id}/set-primary
     * @secure
     * @response `200` `AccountsV1SetPrimaryAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    accountServiceSetPrimaryAccount: (id: string, params: RequestParams = {}) =>
      this.request<AccountsV1SetPrimaryAccountResponse, GoogleRpcStatus>({
        path: `/accounts/v1/${id}/set-primary`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  billingDetailsV1BillingDetailService = {
    /**
     * @description Returns the billing details of a specified affiliate registered in the system.
     *
     * @tags billing_details.v1.BillingDetailService
     * @name BillingDetailServiceGetBillingDetailByAccount
     * @summary Get your affiliate's billing details
     * @request GET:/accounts/v1/{accountId}/billing-detail
     * @secure
     * @response `200` `BillingDetailsV1GetBillingDetailByAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    billingDetailServiceGetBillingDetailByAccount: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        BillingDetailsV1GetBillingDetailByAccountResponse,
        GoogleRpcStatus
      >({
        path: `/accounts/v1/${accountId}/billing-detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Fill in the billing details for affiliate's account.
     *
     * @tags billing_details.v1.BillingDetailService
     * @name BillingDetailServiceSetBillingDetail
     * @summary Set billing detail
     * @request POST:/billing-details/v1
     * @secure
     * @response `200` `BillingDetailsV1SetBillingDetailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    billingDetailServiceSetBillingDetail: (
      body: BillingDetailsV1SetBillingDetailRequest,
      params: RequestParams = {},
    ) =>
      this.request<BillingDetailsV1SetBillingDetailResponse, GoogleRpcStatus>({
        path: `/billing-details/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the currently set billing details of your company/project.
     *
     * @tags billing_details.v1.BillingDetailService
     * @name BillingDetailServiceGetBillingDetail
     * @summary Get billing detail
     * @request GET:/billing-details/v1/{id}
     * @secure
     * @response `200` `BillingDetailsV1GetBillingDetailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    billingDetailServiceGetBillingDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<BillingDetailsV1GetBillingDetailResponse, GoogleRpcStatus>({
        path: `/billing-details/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  paymentMethodsV1PaymentMethodService = {
    /**
     * @description Provides a list of payment methods set up in the system.
     *
     * @tags payment_methods.v1.PaymentMethodService
     * @name PaymentMethodServiceListPaymentMethodsByAccount
     * @summary List exisintg payment methods
     * @request GET:/accounts/v1/{accountId}/payment-methods
     * @secure
     * @response `200` `PaymentMethodsV1ListPaymentMethodsByAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodServiceListPaymentMethodsByAccount: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1ListPaymentMethodsByAccountResponse,
        GoogleRpcStatus
      >({
        path: `/accounts/v1/${accountId}/payment-methods`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new payment method for the affiliate account. Once created, it can be set as a default payment method using `SetPaymentMethodAccountDefault` endpoint.
     *
     * @tags payment_methods.v1.PaymentMethodService
     * @name PaymentMethodServiceCreatePaymentMethod
     * @summary Create a new payment method
     * @request POST:/payment-methods/v1
     * @secure
     * @response `200` `PaymentMethodsV1CreatePaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodServiceCreatePaymentMethod: (
      body: PaymentMethodsV1CreatePaymentMethodRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1CreatePaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/payment-methods/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Sets the specified payment method as default option for affiliates.
     *
     * @tags payment_methods.v1.PaymentMethodService
     * @name PaymentMethodServiceSetPaymentMethodAccountDefault
     * @summary Set payment method as default
     * @request POST:/payment-methods/v1/set-account-default
     * @secure
     * @response `200` `PaymentMethodsV1SetPaymentMethodAccountDefaultResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodServiceSetPaymentMethodAccountDefault: (
      body: PaymentMethodsV1SetPaymentMethodAccountDefaultRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1SetPaymentMethodAccountDefaultResponse,
        GoogleRpcStatus
      >({
        path: `/payment-methods/v1/set-account-default`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides details of selected payment method.
     *
     * @tags payment_methods.v1.PaymentMethodService
     * @name PaymentMethodServiceGetPaymentMethod
     * @summary Get payment method details
     * @request GET:/payment-methods/v1/{id}
     * @secure
     * @response `200` `PaymentMethodsV1GetPaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodServiceGetPaymentMethod: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMethodsV1GetPaymentMethodResponse, GoogleRpcStatus>({
        path: `/payment-methods/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes selected payment method from the system.
     *
     * @tags payment_methods.v1.PaymentMethodService
     * @name PaymentMethodServiceDeletePaymentMethod
     * @summary Delete payment method
     * @request DELETE:/payment-methods/v1/{id}
     * @secure
     * @response `200` `PaymentMethodsV1DeletePaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodServiceDeletePaymentMethod: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1DeletePaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/payment-methods/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the data for selected payment method.
     *
     * @tags payment_methods.v1.PaymentMethodService
     * @name PaymentMethodServiceUpdatePaymentMethod
     * @summary Update payment method
     * @request PATCH:/payment-methods/v1/{id}
     * @secure
     * @response `200` `PaymentMethodsV1UpdatePaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodServiceUpdatePaymentMethod: (
      id: string,
      body: PaymentMethodsV1PaymentMethodServiceUpdatePaymentMethodBody,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1UpdatePaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/payment-methods/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  activityLogsV1ActivityLogsService = {
    /**
     * No description
     *
     * @tags activity_logs.v1.ActivityLogsService
     * @name ActivityLogsServiceListActivityLogs
     * @request POST:/activity-logs/v1/list
     * @secure
     * @response `200` `ActivityLogsV1ListActivityLogsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    activityLogsServiceListActivityLogs: (
      body: ActivityLogsV1ListActivityLogsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogsV1ListActivityLogsResponse, GoogleRpcStatus>({
        path: `/activity-logs/v1/list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags activity_logs.v1.ActivityLogsService
     * @name ActivityLogsServiceGetActivityLog
     * @request GET:/activity-logs/v1/{id}
     * @secure
     * @response `200` `ActivityLogsV1GetActivityLogResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    activityLogsServiceGetActivityLog: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogsV1GetActivityLogResponse, GoogleRpcStatus>({
        path: `/activity-logs/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  advertisersV1AdvertiserService = {
    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserService
     * @name AdvertiserServiceListAdvertisers
     * @request POST:/advertisers/v1
     * @secure
     * @response `200` `AdvertisersV1ListAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserServiceListAdvertisers: (
      body: AdvertisersV1ListAdvertisersRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdvertisersV1ListAdvertisersResponse, GoogleRpcStatus>({
        path: `/advertisers/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserService
     * @name AdvertiserServiceRegisterAdvertiserWithExistingRevenueOrigin
     * @request POST:/advertisers/v1/register-with-existing-revenue-origin
     * @secure
     * @response `200` `AdvertisersV1RegisterAdvertiserWithExistingRevenueOriginResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserServiceRegisterAdvertiserWithExistingRevenueOrigin: (
      body: AdvertisersV1RegisterAdvertiserWithExistingRevenueOriginRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AdvertisersV1RegisterAdvertiserWithExistingRevenueOriginResponse,
        GoogleRpcStatus
      >({
        path: `/advertisers/v1/register-with-existing-revenue-origin`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserService
     * @name AdvertiserServiceRegisterAdvertiserWithUser
     * @request POST:/advertisers/v1/register-with-user
     * @secure
     * @response `200` `AdvertisersV1RegisterAdvertiserWithUserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserServiceRegisterAdvertiserWithUser: (
      body: AdvertisersV1RegisterAdvertiserWithUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AdvertisersV1RegisterAdvertiserWithUserResponse,
        GoogleRpcStatus
      >({
        path: `/advertisers/v1/register-with-user`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserService
     * @name AdvertiserServiceGetAdvertiser
     * @request GET:/advertisers/v1/{accountId}
     * @secure
     * @response `200` `AdvertisersV1GetAdvertiserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserServiceGetAdvertiser: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<AdvertisersV1GetAdvertiserResponse, GoogleRpcStatus>({
        path: `/advertisers/v1/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserService
     * @name AdvertiserServiceDeleteAdvertiser
     * @request DELETE:/advertisers/v1/{accountId}
     * @secure
     * @response `200` `AdvertisersV1DeleteAdvertiserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserServiceDeleteAdvertiser: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<AdvertisersV1DeleteAdvertiserResponse, GoogleRpcStatus>({
        path: `/advertisers/v1/${accountId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserService
     * @name AdvertiserServiceUpdateAdvertiser
     * @request PATCH:/advertisers/v1/{accountId}
     * @secure
     * @response `200` `AdvertisersV1UpdateAdvertiserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserServiceUpdateAdvertiser: (
      accountId: string,
      body: AdvertisersV1AdvertiserServiceUpdateAdvertiserBody,
      params: RequestParams = {},
    ) =>
      this.request<AdvertisersV1UpdateAdvertiserResponse, GoogleRpcStatus>({
        path: `/advertisers/v1/${accountId}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  advertisersV1AdvertiserRegistrationService = {
    /**
     * No description
     *
     * @tags advertisers.v1.AdvertiserRegistrationService
     * @name AdvertiserRegistrationServiceRegisterAdvertiser
     * @request POST:/advertisers/v1/register
     * @secure
     * @response `200` `AdvertisersV1RegisterAdvertiserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserRegistrationServiceRegisterAdvertiser: (
      body: AdvertisersV1RegisterAdvertiserRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdvertisersV1RegisterAdvertiserResponse, GoogleRpcStatus>({
        path: `/advertisers/v1/register`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  intraMessagesV1AffiliateIntraMessagesService = {
    /**
     * No description
     *
     * @tags intra_messages.v1.AffiliateIntraMessagesService
     * @name AffiliateIntraMessagesServiceListAffiliateIntraMessages
     * @request GET:/affiliate-intra-messages/v1
     * @secure
     * @response `200` `IntraMessagesV1ListAffiliateIntraMessagesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateIntraMessagesServiceListAffiliateIntraMessages: (
      params: RequestParams = {},
    ) =>
      this.request<
        IntraMessagesV1ListAffiliateIntraMessagesResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-intra-messages/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags intra_messages.v1.AffiliateIntraMessagesService
     * @name AffiliateIntraMessagesServiceSendAffiliateIntraMessage
     * @request POST:/affiliate-intra-messages/v1
     * @secure
     * @response `200` `IntraMessagesV1SendAffiliateIntraMessageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateIntraMessagesServiceSendAffiliateIntraMessage: (
      body: IntraMessagesV1SendAffiliateIntraMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        IntraMessagesV1SendAffiliateIntraMessageResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-intra-messages/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags intra_messages.v1.AffiliateIntraMessagesService
     * @name AffiliateIntraMessagesServiceCountAffiliateIntraMessageAvailableRecipients
     * @request POST:/affiliate-intra-messages/v1/available-recipients
     * @secure
     * @response `200` `IntraMessagesV1CountAffiliateIntraMessageAvailableRecipientsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateIntraMessagesServiceCountAffiliateIntraMessageAvailableRecipients:
      (
        body: IntraMessagesV1CountAffiliateIntraMessageAvailableRecipientsRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          IntraMessagesV1CountAffiliateIntraMessageAvailableRecipientsResponse,
          GoogleRpcStatus
        >({
          path: `/affiliate-intra-messages/v1/available-recipients`,
          method: "POST",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags intra_messages.v1.AffiliateIntraMessagesService
     * @name AffiliateIntraMessagesServiceListAffiliateIntraMessageRecipients
     * @request GET:/affiliate-intra-messages/v1/{id}/recipients
     * @secure
     * @response `200` `IntraMessagesV1ListAffiliateIntraMessageRecipientsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateIntraMessagesServiceListAffiliateIntraMessageRecipients: (
      {
        id,
        ...query
      }: AffiliateIntraMessagesServiceListAffiliateIntraMessageRecipientsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        IntraMessagesV1ListAffiliateIntraMessageRecipientsResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-intra-messages/v1/${id}/recipients`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  affiliateManagersV1AffiliateManagerService = {
    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceListAffiliateManagers
     * @request POST:/affiliate-managers/v1
     * @secure
     * @response `200` `AffiliateManagersV1ListAffiliateManagersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceListAffiliateManagers: (
      body: AffiliateManagersV1ListAffiliateManagersRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1ListAffiliateManagersResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceBulkUpdateAffiliateManagers
     * @request POST:/affiliate-managers/v1/bulk-update
     * @secure
     * @response `200` `AffiliateManagersV1BulkUpdateAffiliateManagersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceBulkUpdateAffiliateManagers: (
      body: AffiliateManagersV1BulkUpdateAffiliateManagersRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1BulkUpdateAffiliateManagersResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1/bulk-update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceCreateAffiliateManagerWithUser
     * @request POST:/affiliate-managers/v1/create-with-user
     * @secure
     * @response `200` `AffiliateManagersV1CreateAffiliateManagerWithUserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceCreateAffiliateManagerWithUser: (
      body: AffiliateManagersV1CreateAffiliateManagerWithUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1CreateAffiliateManagerWithUserResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1/create-with-user`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceGetAffiliateManager
     * @request GET:/affiliate-managers/v1/{accountId}
     * @secure
     * @response `200` `AffiliateManagersV1GetAffiliateManagerResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceGetAffiliateManager: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1GetAffiliateManagerResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceAssignAffiliates
     * @request POST:/affiliate-managers/v1/{accountId}/assign-affiliates
     * @secure
     * @response `200` `AffiliateManagersV1AssignAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceAssignAffiliates: (
      accountId: string,
      body: AffiliateManagersV1AffiliateManagerServiceAssignAffiliatesBody,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1AssignAffiliatesResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1/${accountId}/assign-affiliates`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceListAssignedAffiliates
     * @request GET:/affiliate-managers/v1/{accountId}/assigned-affiliates
     * @secure
     * @response `200` `AffiliateManagersV1ListAssignedAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceListAssignedAffiliates: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1ListAssignedAffiliatesResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1/${accountId}/assigned-affiliates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliate_managers.v1.AffiliateManagerService
     * @name AffiliateManagerServiceUnassignAffiliate
     * @request POST:/affiliate-managers/v1/{accountId}/unassign-affiliate
     * @secure
     * @response `200` `AffiliateManagersV1UnassignAffiliateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateManagerServiceUnassignAffiliate: (
      accountId: string,
      body: AffiliateManagersV1AffiliateManagerServiceUnassignAffiliateBody,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliateManagersV1UnassignAffiliateResponse,
        GoogleRpcStatus
      >({
        path: `/affiliate-managers/v1/${accountId}/unassign-affiliate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  reportsV1ReportsService = {
    /**
     * @description Shows data related to individual affiliates and their performance.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceAffiliateOverviewReport
     * @summary Affiliate overview report
     * @request POST:/affiliate-overview-report/v1
     * @secure
     * @response `200` `ReportsV1AffiliateOverviewReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceAffiliateOverviewReport: (
      body: ReportsV1AffiliateOverviewReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1AffiliateOverviewReportResponse, GoogleRpcStatus>({
        path: `/affiliate-overview-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides information about registered clicks.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceClickReport
     * @summary Click report
     * @request POST:/click-report/v1
     * @secure
     * @response `200` `ReportsV1ClickReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceClickReport: (
      body: ReportsV1ClickReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1ClickReportResponse, GoogleRpcStatus>({
        path: `/click-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Export a view of a set click report configuration.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceExportClickReport
     * @summary Export click report
     * @request POST:/click-report/v1/export
     * @secure
     * @response `200` `ReportsV1ExportClickReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceExportClickReport: (
      body: ReportsV1ExportClickReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1ExportClickReportResponse, GoogleRpcStatus>({
        path: `/click-report/v1/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Show data about MLM commissions tracked in the system.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceCommissionReport
     * @summary Commission report
     * @request POST:/commission-report/v1
     * @secure
     * @response `200` `ReportsV1CommissionReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceCommissionReport: (
      body: ReportsV1CommissionReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1CommissionReportResponse, GoogleRpcStatus>({
        path: `/commission-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Export a view of a set commission report configuration.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceExportCommissionReport
     * @summary Export commission report
     * @request POST:/commission-report/v1/export
     * @secure
     * @response `200` `ReportsV1ExportCommissionReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceExportCommissionReport: (
      body: ReportsV1ExportCommissionReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1ExportCommissionReportResponse, GoogleRpcStatus>({
        path: `/commission-report/v1/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Shows data related to conversions tracked by the system.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceConversionReport
     * @summary Conversion report
     * @request POST:/conversion-report/v1
     * @secure
     * @response `200` `ReportsV1ConversionReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceConversionReport: (
      body: ReportsV1ConversionReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1ConversionReportResponse, GoogleRpcStatus>({
        path: `/conversion-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Export a view of a set conversion report configuration.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceExportConversionReport
     * @summary Export conversion report
     * @request POST:/conversion-report/v1/export
     * @secure
     * @response `200` `ReportsV1ExportConversionReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceExportConversionReport: (
      body: ReportsV1ExportConversionReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1ExportConversionReportResponse, GoogleRpcStatus>({
        path: `/conversion-report/v1/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Displays performance data grouped by specific countries.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceCountryOverviewReport
     * @summary Country overview
     * @request POST:/country-overview-report/v1
     * @secure
     * @response `200` `ReportsV1CountryOverviewReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceCountryOverviewReport: (
      body: ReportsV1CountryOverviewReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1CountryOverviewReportResponse, GoogleRpcStatus>({
        path: `/country-overview-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides information about redeemed coupons.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceCouponRedemptionReport
     * @summary Coupon redemption report
     * @request POST:/coupon-redemption-report/v1
     * @secure
     * @response `200` `ReportsV1CouponRedemptionReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceCouponRedemptionReport: (
      body: ReportsV1CouponRedemptionReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1CouponRedemptionReportResponse, GoogleRpcStatus>({
        path: `/coupon-redemption-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Export a view of a set coupon redemption report configuration.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceExportCouponRedemptionReport
     * @summary Export coupon redemption report
     * @request POST:/coupon-redemption-report/v1/export
     * @secure
     * @response `200` `ReportsV1ExportCouponRedemptionReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceExportCouponRedemptionReport: (
      body: ReportsV1ExportCouponRedemptionReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReportsV1ExportCouponRedemptionReportResponse,
        GoogleRpcStatus
      >({
        path: `/coupon-redemption-report/v1/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Features overview of the daily performance, providing data such as clicks, conversions, revenue, payouts etc. per given day.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceDailyOverviewReport
     * @summary Daily overview report
     * @request POST:/daily-overview-report/v1
     * @secure
     * @response `200` `ReportsV1DailyOverviewReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceDailyOverviewReport: (
      body: ReportsV1DailyOverviewReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1DailyOverviewReportResponse, GoogleRpcStatus>({
        path: `/daily-overview-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides a comprehensive performance overview with data aggregated at multiple levels (such as daily, country, affiliate, offer, etc.).
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceGeneralOverviewReport
     * @summary General overview
     * @request POST:/general-overview-report/v1
     * @secure
     * @response `200` `ReportsV1GeneralOverviewReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceGeneralOverviewReport: (
      body: ReportsV1GeneralOverviewReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1GeneralOverviewReportResponse, GoogleRpcStatus>({
        path: `/general-overview-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides a comprehensive performance overview with data aggregated at multiple levels (such as daily, country, affiliate, offer, etc.).
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceExportGeneralOverviewReport
     * @summary Export general overview
     * @request POST:/general-overview-report/v1/export
     * @secure
     * @response `200` `ReportsV1ExportGeneralOverviewReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceExportGeneralOverviewReport: (
      body: ReportsV1ExportGeneralOverviewReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReportsV1ExportGeneralOverviewReportResponse,
        GoogleRpcStatus
      >({
        path: `/general-overview-report/v1/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Shows performance overview grouped by individual offers.
     *
     * @tags reports.v1.ReportsService
     * @name ReportsServiceOfferOverviewReport
     * @summary Offer overview
     * @request POST:/offer-overview-report/v1
     * @secure
     * @response `200` `ReportsV1OfferOverviewReportResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportsServiceOfferOverviewReport: (
      body: ReportsV1OfferOverviewReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportsV1OfferOverviewReportResponse, GoogleRpcStatus>({
        path: `/offer-overview-report/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  affiliatesV1AffiliateService = {
    /**
     * @description List the existing affiliates in your system.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceListAffiliates
     * @summary List affiliates
     * @request POST:/affiliates/v1
     * @secure
     * @response `200` `AffiliatesV1ListAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceListAffiliates: (
      body: AffiliatesV1ListAffiliatesRequest,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1ListAffiliatesResponse, GoogleRpcStatus>({
        path: `/affiliates/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Make bulk changes to selected affiliates.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceBulkUpdateAffiliates
     * @summary Bulk update affiliates
     * @request POST:/affiliates/v1/bulk-update
     * @secure
     * @response `200` `AffiliatesV1BulkUpdateAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceBulkUpdateAffiliates: (
      body: AffiliatesV1BulkUpdateAffiliatesRequest,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1BulkUpdateAffiliatesResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/bulk-update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Export details of affiliates from the system.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceExportAffiliates
     * @summary Export affiliates
     * @request POST:/affiliates/v1/export
     * @secure
     * @response `200` `AffiliatesV1ExportAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceExportAffiliates: (
      body: AffiliatesV1ExportAffiliatesRequest,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1ExportAffiliatesResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new affiliate in your system.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceRegisterAffiliateWithUser
     * @summary Create new affiliate
     * @request POST:/affiliates/v1/register-with-user
     * @secure
     * @response `200` `AffiliatesV1RegisterAffiliateWithUserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceRegisterAffiliateWithUser: (
      body: AffiliatesV1RegisterAffiliateWithUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliatesV1RegisterAffiliateWithUserResponse,
        GoogleRpcStatus
      >({
        path: `/affiliates/v1/register-with-user`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the data the affiliate filled in during registration.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceGetAffiliateRegistrationData
     * @summary Affiliate registration data
     * @request GET:/affiliates/v1/registration-data/{accountId}
     * @secure
     * @response `200` `AffiliatesV1GetAffiliateRegistrationDataResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceGetAffiliateRegistrationData: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliatesV1GetAffiliateRegistrationDataResponse,
        GoogleRpcStatus
      >({
        path: `/affiliates/v1/registration-data/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List MLM sub-affiliates for current account.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceListSubAffiliates
     * @summary List MLM sub-affiliates
     * @request POST:/affiliates/v1/sub-affiliates
     * @secure
     * @response `200` `AffiliatesV1ListSubAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceListSubAffiliates: (
      body: AffiliatesV1ListSubAffiliatesRequest,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1ListSubAffiliatesResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/sub-affiliates`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed information about a specific affiliate.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceGetAffiliate
     * @summary Affiliate details
     * @request GET:/affiliates/v1/{accountId}
     * @secure
     * @response `200` `AffiliatesV1GetAffiliateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceGetAffiliate: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1GetAffiliateResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes affiliate from the system.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceDeleteAffiliate
     * @summary Delete affiliate
     * @request DELETE:/affiliates/v1/{accountId}
     * @secure
     * @response `200` `AffiliatesV1DeleteAffiliateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceDeleteAffiliate: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1DeleteAffiliateResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/${accountId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the affiliate in your system.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceUpdateAffiliate
     * @summary Update affiliate
     * @request PATCH:/affiliates/v1/{accountId}
     * @secure
     * @response `200` `AffiliatesV1UpdateAffiliateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceUpdateAffiliate: (
      accountId: string,
      body: AffiliatesV1AffiliateServiceUpdateAffiliateBody,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1UpdateAffiliateResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/${accountId}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceSetAffiliateDefaultRedirectDomain
     * @request PUT:/affiliates/v1/{accountId}/default-redirect-domain
     * @secure
     * @response `200` `AffiliatesV1SetAffiliateDefaultRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceSetAffiliateDefaultRedirectDomain: (
      accountId: string,
      body: AffiliatesV1AffiliateServiceSetAffiliateDefaultRedirectDomainBody,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliatesV1SetAffiliateDefaultRedirectDomainResponse,
        GoogleRpcStatus
      >({
        path: `/affiliates/v1/${accountId}/default-redirect-domain`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceSetAffiliateReferralAccount
     * @request PUT:/affiliates/v1/{accountId}/referral-account
     * @secure
     * @response `200` `AffiliatesV1SetAffiliateReferralAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceSetAffiliateReferralAccount: (
      accountId: string,
      body: AffiliatesV1AffiliateServiceSetAffiliateReferralAccountBody,
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliatesV1SetAffiliateReferralAccountResponse,
        GoogleRpcStatus
      >({
        path: `/affiliates/v1/${accountId}/referral-account`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Lets you change the status of an affiliate.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceSetAffiliateStatus
     * @summary Set affiliate status
     * @request PUT:/affiliates/v1/{sourcePublicId.value}/status
     * @secure
     * @response `200` `AffiliatesV1SetAffiliateStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceSetAffiliateStatus: (
      sourcePublicIdValue: string,
      body: AffiliatesV1AffiliateServiceSetAffiliateStatusBody,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1SetAffiliateStatusResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/${sourcePublicIdValue}/status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Set a tier for the selected affiliates.
     *
     * @tags affiliates.v1.AffiliateService
     * @name AffiliateServiceSetAffiliateTier
     * @summary Set affiliate tier
     * @request PUT:/affiliates/v1/{sourcePublicId.value}/tier
     * @secure
     * @response `200` `AffiliatesV1SetAffiliateTierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateServiceSetAffiliateTier: (
      sourcePublicIdValue: string,
      body: AffiliatesV1AffiliateServiceSetAffiliateTierBody,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1SetAffiliateTierResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/${sourcePublicIdValue}/tier`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  affiliatesV1AffiliateRegistrationService = {
    /**
     * No description
     *
     * @tags affiliates.v1.AffiliateRegistrationService
     * @name AffiliateRegistrationServiceRegisterAffiliate
     * @request POST:/affiliates/v1/register
     * @secure
     * @response `200` `AffiliatesV1RegisterAffiliateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateRegistrationServiceRegisterAffiliate: (
      body: AffiliatesV1RegisterAffiliateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AffiliatesV1RegisterAffiliateResponse, GoogleRpcStatus>({
        path: `/affiliates/v1/register`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  affiliatesV1AffiliateRegistrationFormService = {
    /**
     * No description
     *
     * @tags affiliates.v1.AffiliateRegistrationFormService
     * @name AffiliateRegistrationFormServiceGetAffiliateRegistrationForm
     * @request GET:/affiliates/v1/registration-form
     * @secure
     * @response `200` `AffiliatesV1GetAffiliateRegistrationFormResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateRegistrationFormServiceGetAffiliateRegistrationForm: (
      params: RequestParams = {},
    ) =>
      this.request<
        AffiliatesV1GetAffiliateRegistrationFormResponse,
        GoogleRpcStatus
      >({
        path: `/affiliates/v1/registration-form`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  affiliatesV1AffiliateRegistrationSettingsService = {
    /**
     * No description
     *
     * @tags affiliates.v1.AffiliateRegistrationSettingsService
     * @name AffiliateRegistrationSettingsServiceUpdateAffiliateRegistrationFormSettings
     * @request POST:/affiliates/v1/registration-form/settings
     * @secure
     * @response `200` `AffiliatesV1UpdateAffiliateRegistrationFormSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    affiliateRegistrationSettingsServiceUpdateAffiliateRegistrationFormSettings:
      (
        body: AffiliatesV1UpdateAffiliateRegistrationFormSettingsRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          AffiliatesV1UpdateAffiliateRegistrationFormSettingsResponse,
          GoogleRpcStatus
        >({
          path: `/affiliates/v1/registration-form/settings`,
          method: "POST",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),
  };
  albatoIntegrationsV1AlbatoIntegrationsService = {
    /**
     * No description
     *
     * @tags albato_integrations.v1.AlbatoIntegrationsService
     * @name AlbatoIntegrationsServiceRetrieveAlbatoIntegrationsSessionToken
     * @request GET:/albato-integrations/v1/session-token
     * @secure
     * @response `200` `AlbatoIntegrationsV1RetrieveAlbatoIntegrationsSessionTokenResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    albatoIntegrationsServiceRetrieveAlbatoIntegrationsSessionToken: (
      params: RequestParams = {},
    ) =>
      this.request<
        AlbatoIntegrationsV1RetrieveAlbatoIntegrationsSessionTokenResponse,
        GoogleRpcStatus
      >({
        path: `/albato-integrations/v1/session-token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  anuraV1AnuraService = {
    /**
     * No description
     *
     * @tags anura.v1.AnuraService
     * @name AnuraServiceProcessAnuraScriptClickId
     * @request POST:/anura/v1/script-click-id/{cid}/{anuraId}
     * @secure
     * @response `200` `AnuraV1ProcessAnuraScriptClickIdResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    anuraServiceProcessAnuraScriptClickId: (
      cid: string,
      anuraId: string,
      params: RequestParams = {},
    ) =>
      this.request<AnuraV1ProcessAnuraScriptClickIdResponse, GoogleRpcStatus>({
        path: `/anura/v1/script-click-id/${cid}/${anuraId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  authenticationV1AuthenticationService = {
    /**
     * No description
     *
     * @tags authentication.v1.AuthenticationService
     * @name AuthenticationServiceGetAccount
     * @request GET:/authentication/v1/get-account
     * @secure
     * @response `200` `AuthenticationV1GetAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    authenticationServiceGetAccount: (params: RequestParams = {}) =>
      this.request<AuthenticationV1GetAccountResponse, GoogleRpcStatus>({
        path: `/authentication/v1/get-account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags authentication.v1.AuthenticationService
     * @name AuthenticationServiceGetImpersonableAccounts
     * @request GET:/authentication/v1/get-impersonable-accounts
     * @secure
     * @response `200` `AuthenticationV1GetImpersonableAccountsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    authenticationServiceGetImpersonableAccounts: (
      params: RequestParams = {},
    ) =>
      this.request<
        AuthenticationV1GetImpersonableAccountsResponse,
        GoogleRpcStatus
      >({
        path: `/authentication/v1/get-impersonable-accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  paymentMethodsV1AvailablePaymentMethodService = {
    /**
     * No description
     *
     * @tags payment_methods.v1.AvailablePaymentMethodService
     * @name AvailablePaymentMethodServiceListAvailablePaymentMethodsByAccount
     * @request GET:/available-payment-methods/v1
     * @secure
     * @response `200` `PaymentMethodsV1ListAvailablePaymentMethodsByAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    availablePaymentMethodServiceListAvailablePaymentMethodsByAccount: (
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1ListAvailablePaymentMethodsByAccountResponse,
        GoogleRpcStatus
      >({
        path: `/available-payment-methods/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment_methods.v1.AvailablePaymentMethodService
     * @name AvailablePaymentMethodServiceCreateAvailablePaymentMethod
     * @request POST:/available-payment-methods/v1
     * @secure
     * @response `200` `PaymentMethodsV1CreateAvailablePaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    availablePaymentMethodServiceCreateAvailablePaymentMethod: (
      body: PaymentMethodsV1CreateAvailablePaymentMethodRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1CreateAvailablePaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/available-payment-methods/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment_methods.v1.AvailablePaymentMethodService
     * @name AvailablePaymentMethodServiceGetAvailablePaymentMethod
     * @request GET:/available-payment-methods/v1/{id}
     * @secure
     * @response `200` `PaymentMethodsV1GetAvailablePaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    availablePaymentMethodServiceGetAvailablePaymentMethod: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1GetAvailablePaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/available-payment-methods/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment_methods.v1.AvailablePaymentMethodService
     * @name AvailablePaymentMethodServiceDeleteAvailablePaymentMethod
     * @request DELETE:/available-payment-methods/v1/{id}
     * @secure
     * @response `200` `PaymentMethodsV1DeleteAvailablePaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    availablePaymentMethodServiceDeleteAvailablePaymentMethod: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1DeleteAvailablePaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/available-payment-methods/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  billingV1BalanceService = {
    /**
     * No description
     *
     * @tags billing.v1.BalanceService
     * @name BalanceServiceGetBalancesForAccount
     * @request GET:/billing/v1/account-balances/{accountId}
     * @secure
     * @response `200` `BillingV1GetBalancesForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    balanceServiceGetBalancesForAccount: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1GetBalancesForAccountResponse, GoogleRpcStatus>({
        path: `/billing/v1/account-balances/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get information about current open balance per individual affiliates. Service provides details about balance per conversion status and lists affiliate payment method.
     *
     * @tags billing.v1.BalanceService
     * @name BalanceServiceListOpenBalances
     * @summary Get open balance
     * @request GET:/billing/v1/open-balances
     * @secure
     * @response `200` `BillingV1ListOpenBalancesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    balanceServiceListOpenBalances: (
      query: BalanceServiceListOpenBalancesParams,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1ListOpenBalancesResponse, GoogleRpcStatus>({
        path: `/billing/v1/open-balances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get information about current open balance per individual affiliates. Service provides details about balance per conversion status and lists affiliate payment method.
     *
     * @tags billing.v1.BalanceService
     * @name BalanceServiceListOpenBalances2
     * @summary Get open balance
     * @request POST:/billing/v1/open-balances/list
     * @secure
     * @response `200` `BillingV1ListOpenBalancesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    balanceServiceListOpenBalances2: (
      body: BillingV1ListOpenBalancesRequest,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1ListOpenBalancesResponse, GoogleRpcStatus>({
        path: `/billing/v1/open-balances/list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing.v1.BalanceService
     * @name BalanceServiceSummarizeOpenBalancesByPaymentMethod
     * @request GET:/billing/v1/open-balances/summary/payment-method
     * @secure
     * @response `200` `BillingV1SummarizeOpenBalancesByPaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    balanceServiceSummarizeOpenBalancesByPaymentMethod: (
      query: BalanceServiceSummarizeOpenBalancesByPaymentMethodParams,
      params: RequestParams = {},
    ) =>
      this.request<
        BillingV1SummarizeOpenBalancesByPaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/billing/v1/open-balances/summary/payment-method`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing.v1.BalanceService
     * @name BalanceServiceSummarizeOpenBalancesByPaymentMethod2
     * @request POST:/billing/v1/open-balances/summary/payment-method
     * @secure
     * @response `200` `BillingV1SummarizeOpenBalancesByPaymentMethodResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    balanceServiceSummarizeOpenBalancesByPaymentMethod2: (
      body: BillingV1SummarizeOpenBalancesByPaymentMethodRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        BillingV1SummarizeOpenBalancesByPaymentMethodResponse,
        GoogleRpcStatus
      >({
        path: `/billing/v1/open-balances/summary/payment-method`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  billingV1SettlementService = {
    /**
     * @description Get a list of all settlements tied to a specific affiliate.
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceListAccountSettlements
     * @summary List affiliate settlement
     * @request GET:/billing/v1/account-settlements
     * @secure
     * @response `200` `BillingV1ListAccountSettlementsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceListAccountSettlements: (
      query: SettlementServiceListAccountSettlementsParams,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1ListAccountSettlementsResponse, GoogleRpcStatus>({
        path: `/billing/v1/account-settlements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes settlement for specific affiliate without deleting the entirety of a single settlement.
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceDeleteAccountSettlement
     * @summary Delete affiliate settlement
     * @request DELETE:/billing/v1/account-settlements/{id}
     * @secure
     * @response `200` `BillingV1DeleteAccountSettlementResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceDeleteAccountSettlement: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1DeleteAccountSettlementResponse, GoogleRpcStatus>({
        path: `/billing/v1/account-settlements/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new settlement for specific affiliate until selected date.
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceSettleBalances
     * @summary Create settlement
     * @request POST:/billing/v1/settle-balances
     * @secure
     * @response `200` `BillingV1SettleBalancesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceSettleBalances: (
      body: BillingV1SettleBalancesRequest,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1SettleBalancesResponse, GoogleRpcStatus>({
        path: `/billing/v1/settle-balances`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all existing settlements in the selected timeframe.
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceListSettlements
     * @summary List settlements
     * @request GET:/billing/v1/settlements
     * @secure
     * @response `200` `BillingV1ListSettlementsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceListSettlements: (
      query: SettlementServiceListSettlementsParams,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1ListSettlementsResponse, GoogleRpcStatus>({
        path: `/billing/v1/settlements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get information about the settlement.
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceGetSettlement
     * @summary Get settlement
     * @request GET:/billing/v1/settlements/{id}
     * @secure
     * @response `200` `BillingV1GetSettlementResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceGetSettlement: (id: string, params: RequestParams = {}) =>
      this.request<BillingV1GetSettlementResponse, GoogleRpcStatus>({
        path: `/billing/v1/settlements/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete the entirety of a single settlement. This might include settlements of multiple affiliates.
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceDeleteSettlement
     * @summary Delete settlement
     * @request DELETE:/billing/v1/settlements/{id}
     * @secure
     * @response `200` `BillingV1DeleteSettlementResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceDeleteSettlement: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1DeleteSettlementResponse, GoogleRpcStatus>({
        path: `/billing/v1/settlements/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceExportSettlement
     * @request POST:/billing/v1/settlements/{id}/export
     * @secure
     * @response `200` `BillingV1ExportSettlementResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceExportSettlement: (
      id: string,
      body: BillingV1SettlementServiceExportSettlementBody,
      params: RequestParams = {},
    ) =>
      this.request<BillingV1ExportSettlementResponse, GoogleRpcStatus>({
        path: `/billing/v1/settlements/${id}/export`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing.v1.SettlementService
     * @name SettlementServiceExportSettlementForMassPayment
     * @request POST:/billing/v1/settlements/{id}/export-for-mass-payment
     * @secure
     * @response `200` `BillingV1ExportSettlementForMassPaymentResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settlementServiceExportSettlementForMassPayment: (
      id: string,
      body: BillingV1SettlementServiceExportSettlementForMassPaymentBody,
      params: RequestParams = {},
    ) =>
      this.request<
        BillingV1ExportSettlementForMassPaymentResponse,
        GoogleRpcStatus
      >({
        path: `/billing/v1/settlements/${id}/export-for-mass-payment`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  categoriesV1CategoriesService = {
    /**
     * No description
     *
     * @tags categories.v1.CategoriesService
     * @name CategoriesServiceListCategories
     * @request GET:/categories/v1
     * @secure
     * @response `200` `CategoriesV1ListCategoriesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    categoriesServiceListCategories: (params: RequestParams = {}) =>
      this.request<CategoriesV1ListCategoriesResponse, GoogleRpcStatus>({
        path: `/categories/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags categories.v1.CategoriesService
     * @name CategoriesServiceCreateCategory
     * @request POST:/categories/v1
     * @secure
     * @response `200` `CategoriesV1CreateCategoryResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    categoriesServiceCreateCategory: (
      body: CategoriesV1CreateCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<CategoriesV1CreateCategoryResponse, GoogleRpcStatus>({
        path: `/categories/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags categories.v1.CategoriesService
     * @name CategoriesServiceDeleteCategory
     * @request DELETE:/categories/v1/{id}
     * @secure
     * @response `200` `CategoriesV1DeleteCategoryResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    categoriesServiceDeleteCategory: (id: string, params: RequestParams = {}) =>
      this.request<CategoriesV1DeleteCategoryResponse, GoogleRpcStatus>({
        path: `/categories/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags categories.v1.CategoriesService
     * @name CategoriesServiceUpdateCategory
     * @request PUT:/categories/v1/{id}
     * @secure
     * @response `200` `CategoriesV1UpdateCategoryResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    categoriesServiceUpdateCategory: (
      id: string,
      body: CategoriesV1CategoriesServiceUpdateCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<CategoriesV1UpdateCategoryResponse, GoogleRpcStatus>({
        path: `/categories/v1/${id}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  clicksV1ClicksService = {
    /**
     * @description Provides a list of existing clicks in the system.
     *
     * @tags clicks.v1.ClicksService
     * @name ClicksServiceListClicks
     * @summary List clicks
     * @request GET:/clicks/v1
     * @secure
     * @response `200` `ClicksV1ListClicksResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    clicksServiceListClicks: (
      query: ClicksServiceListClicksParams,
      params: RequestParams = {},
    ) =>
      this.request<ClicksV1ListClicksResponse, GoogleRpcStatus>({
        path: `/clicks/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new click in the system.
     *
     * @tags clicks.v1.ClicksService
     * @name ClicksServiceCreateClick
     * @summary Create click
     * @request POST:/clicks/v1
     * @secure
     * @response `200` `ClicksV1CreateClickResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    clicksServiceCreateClick: (
      body: ClicksV1CreateClickRequest,
      params: RequestParams = {},
    ) =>
      this.request<ClicksV1CreateClickResponse, GoogleRpcStatus>({
        path: `/clicks/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  clicksV1RedirectClicksService = {
    /**
     * No description
     *
     * @tags clicks.v1.RedirectClicksService
     * @name RedirectClicksServiceCreateRedirectClick
     * @request POST:/clicks/v1/redirect
     * @secure
     * @response `200` `ClicksV1CreateRedirectClickResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    redirectClicksServiceCreateRedirectClick: (
      body: ClicksV1CreateRedirectClickRequest,
      params: RequestParams = {},
    ) =>
      this.request<ClicksV1CreateRedirectClickResponse, GoogleRpcStatus>({
        path: `/clicks/v1/redirect`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags clicks.v1.RedirectClicksService
     * @name RedirectClicksServiceCreateRedirectLandingPageClick
     * @request POST:/clicks/v1/redirect-landing-page
     * @secure
     * @response `200` `ClicksV1CreateRedirectLandingPageClickResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    redirectClicksServiceCreateRedirectLandingPageClick: (
      body: ClicksV1CreateRedirectLandingPageClickRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ClicksV1CreateRedirectLandingPageClickResponse,
        GoogleRpcStatus
      >({
        path: `/clicks/v1/redirect-landing-page`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags clicks.v1.RedirectClicksService
     * @name RedirectClicksServiceCreateRedirectSmartLinkClick
     * @request POST:/clicks/v1/redirect-smart-link
     * @secure
     * @response `200` `ClicksV1CreateRedirectSmartLinkClickResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    redirectClicksServiceCreateRedirectSmartLinkClick: (
      body: ClicksV1CreateRedirectSmartLinkClickRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ClicksV1CreateRedirectSmartLinkClickResponse,
        GoogleRpcStatus
      >({
        path: `/clicks/v1/redirect-smart-link`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  controlPanelV1ControlPanelService = {
    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateAdminAccess
     * @request PUT:/control-panel/v1/admin-access
     * @secure
     * @response `200` `ControlPanelV1UpdateAdminAccessResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateAdminAccess: (
      body: ControlPanelV1UpdateAdminAccessRequest,
      params: RequestParams = {},
    ) =>
      this.request<ControlPanelV1UpdateAdminAccessResponse, GoogleRpcStatus>({
        path: `/control-panel/v1/admin-access`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateCustomFeatureLimits
     * @request PUT:/control-panel/v1/custom-feature-limits
     * @secure
     * @response `200` `ControlPanelV1UpdateCustomFeatureLimitsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateCustomFeatureLimits: (
      body: ControlPanelV1UpdateCustomFeatureLimitsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ControlPanelV1UpdateCustomFeatureLimitsResponse,
        GoogleRpcStatus
      >({
        path: `/control-panel/v1/custom-feature-limits`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateCustomFreemiumRevenueLimit
     * @request PUT:/control-panel/v1/custom-freemium-revenue-limit
     * @secure
     * @response `200` `ControlPanelV1UpdateCustomFreemiumRevenueLimitResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateCustomFreemiumRevenueLimit: (
      body: ControlPanelV1UpdateCustomFreemiumRevenueLimitRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ControlPanelV1UpdateCustomFreemiumRevenueLimitResponse,
        GoogleRpcStatus
      >({
        path: `/control-panel/v1/custom-freemium-revenue-limit`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceSetFreeTrial
     * @request POST:/control-panel/v1/free-trial
     * @secure
     * @response `200` `ControlPanelV1SetFreeTrialResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceSetFreeTrial: (
      body: ControlPanelV1SetFreeTrialRequest,
      params: RequestParams = {},
    ) =>
      this.request<ControlPanelV1SetFreeTrialResponse, GoogleRpcStatus>({
        path: `/control-panel/v1/free-trial`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceResetFreeTrial
     * @request POST:/control-panel/v1/free-trial/reset
     * @secure
     * @response `200` `ControlPanelV1ResetFreeTrialResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceResetFreeTrial: (params: RequestParams = {}) =>
      this.request<ControlPanelV1ResetFreeTrialResponse, GoogleRpcStatus>({
        path: `/control-panel/v1/free-trial/reset`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateLoginEnabled
     * @request PUT:/control-panel/v1/login-enabled
     * @secure
     * @response `200` `ControlPanelV1UpdateLoginEnabledResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateLoginEnabled: (
      body: ControlPanelV1UpdateLoginEnabledRequest,
      params: RequestParams = {},
    ) =>
      this.request<ControlPanelV1UpdateLoginEnabledResponse, GoogleRpcStatus>({
        path: `/control-panel/v1/login-enabled`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateMarketplaceAccessOverridden
     * @request PUT:/control-panel/v1/marketplace-access-overridden
     * @secure
     * @response `200` `ControlPanelV1UpdateMarketplaceAccessOverriddenResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateMarketplaceAccessOverridden: (
      body: ControlPanelV1UpdateMarketplaceAccessOverriddenRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ControlPanelV1UpdateMarketplaceAccessOverriddenResponse,
        GoogleRpcStatus
      >({
        path: `/control-panel/v1/marketplace-access-overridden`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateMembershipPlan
     * @request PUT:/control-panel/v1/membership-plan
     * @secure
     * @response `200` `ControlPanelV1UpdateMembershipPlanResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateMembershipPlan: (
      body: ControlPanelV1UpdateMembershipPlanRequest,
      params: RequestParams = {},
    ) =>
      this.request<ControlPanelV1UpdateMembershipPlanResponse, GoogleRpcStatus>(
        {
          path: `/control-panel/v1/membership-plan`,
          method: "PUT",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpgradeToNetwork
     * @request POST:/control-panel/v1/network-upgrade
     * @secure
     * @response `200` `ControlPanelV1UpgradeToNetworkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpgradeToNetwork: (params: RequestParams = {}) =>
      this.request<ControlPanelV1UpgradeToNetworkResponse, GoogleRpcStatus>({
        path: `/control-panel/v1/network-upgrade`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceGetControlPanelSettings
     * @request GET:/control-panel/v1/settings
     * @secure
     * @response `200` `ControlPanelV1GetControlPanelSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceGetControlPanelSettings: (params: RequestParams = {}) =>
      this.request<
        ControlPanelV1GetControlPanelSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/control-panel/v1/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateSuperadminNote
     * @request PUT:/control-panel/v1/superadmin-note
     * @secure
     * @response `200` `ControlPanelV1UpdateSuperadminNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateSuperadminNote: (
      body: ControlPanelV1UpdateSuperadminNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<ControlPanelV1UpdateSuperadminNoteResponse, GoogleRpcStatus>(
        {
          path: `/control-panel/v1/superadmin-note`,
          method: "PUT",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceSyncSubscriptions
     * @request POST:/control-panel/v1/sync-subscriptions
     * @secure
     * @response `200` `ControlPanelV1SyncSubscriptionsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceSyncSubscriptions: (params: RequestParams = {}) =>
      this.request<ControlPanelV1SyncSubscriptionsResponse, GoogleRpcStatus>({
        path: `/control-panel/v1/sync-subscriptions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceUpdateTrafficEnabled
     * @request PUT:/control-panel/v1/traffic-enabled
     * @secure
     * @response `200` `ControlPanelV1UpdateTrafficEnabledResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceUpdateTrafficEnabled: (
      body: ControlPanelV1UpdateTrafficEnabledRequest,
      params: RequestParams = {},
    ) =>
      this.request<ControlPanelV1UpdateTrafficEnabledResponse, GoogleRpcStatus>(
        {
          path: `/control-panel/v1/traffic-enabled`,
          method: "PUT",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags control_panel.v1.ControlPanelService
     * @name ControlPanelServiceRegulateUsage
     * @request POST:/usage/v1/regulate
     * @secure
     * @response `200` `ControlPanelV1RegulateUsageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    controlPanelServiceRegulateUsage: (params: RequestParams = {}) =>
      this.request<ControlPanelV1RegulateUsageResponse, GoogleRpcStatus>({
        path: `/usage/v1/regulate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  conversionRequestsV1ConversionRequestsService = {
    /**
     * No description
     *
     * @tags conversion_requests.v1.ConversionRequestsService
     * @name ConversionRequestsServiceListErrorConversionRequests
     * @request GET:/conversion-requests/v1/errors
     * @secure
     * @response `200` `ConversionRequestsV1ListErrorConversionRequestsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionRequestsServiceListErrorConversionRequests: (
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionRequestsV1ListErrorConversionRequestsResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-requests/v1/errors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  conversionSourcesV1ConversionSourceExternalIdentifiersService = {
    /**
     * No description
     *
     * @tags conversion_sources.v1.ConversionSourceExternalIdentifiersService
     * @name ConversionSourceExternalIdentifiersServiceCreateConversionSourceExternalIdentifier
     * @request POST:/conversion-sources/v1/external-identifiers
     * @secure
     * @response `200` `ConversionSourcesV1CreateConversionSourceExternalIdentifierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionSourceExternalIdentifiersServiceCreateConversionSourceExternalIdentifier:
      (
        body: ConversionSourcesV1CreateConversionSourceExternalIdentifierRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          ConversionSourcesV1CreateConversionSourceExternalIdentifierResponse,
          GoogleRpcStatus
        >({
          path: `/conversion-sources/v1/external-identifiers`,
          method: "POST",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags conversion_sources.v1.ConversionSourceExternalIdentifiersService
     * @name ConversionSourceExternalIdentifiersServiceDeleteConversionSourceExternalIdentifier
     * @request DELETE:/conversion-sources/v1/external-identifiers/{id}
     * @secure
     * @response `200` `ConversionSourcesV1DeleteConversionSourceExternalIdentifierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionSourceExternalIdentifiersServiceDeleteConversionSourceExternalIdentifier:
      (id: string, params: RequestParams = {}) =>
        this.request<
          ConversionSourcesV1DeleteConversionSourceExternalIdentifierResponse,
          GoogleRpcStatus
        >({
          path: `/conversion-sources/v1/external-identifiers/${id}`,
          method: "DELETE",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags conversion_sources.v1.ConversionSourceExternalIdentifiersService
     * @name ConversionSourceExternalIdentifiersServiceUpdateConversionSourceExternalIdentifier
     * @request PUT:/conversion-sources/v1/external-identifiers/{id}
     * @secure
     * @response `200` `ConversionSourcesV1UpdateConversionSourceExternalIdentifierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionSourceExternalIdentifiersServiceUpdateConversionSourceExternalIdentifier:
      (
        id: string,
        body: ConversionSourcesV1ConversionSourceExternalIdentifiersServiceUpdateConversionSourceExternalIdentifierBody,
        params: RequestParams = {},
      ) =>
        this.request<
          ConversionSourcesV1UpdateConversionSourceExternalIdentifierResponse,
          GoogleRpcStatus
        >({
          path: `/conversion-sources/v1/external-identifiers/${id}`,
          method: "PUT",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),
  };
  conversionStatusesV1ConversionStatusService = {
    /**
     * No description
     *
     * @tags conversion_statuses.v1.ConversionStatusService
     * @name ConversionStatusServiceListConversionStatuses
     * @request GET:/conversion-statuses/v1
     * @secure
     * @response `200` `ConversionStatusesV1ListConversionStatusesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionStatusServiceListConversionStatuses: (
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionStatusesV1ListConversionStatusesResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-statuses/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  conversionTypesV1ConversionTypesService = {
    /**
     * @description Gives a list of exisitng covnersion types in the system.
     *
     * @tags conversion_types.v1.ConversionTypesService
     * @name ConversionTypesServiceListConversionTypes
     * @summary List conversion types
     * @request GET:/conversion-types/v1
     * @secure
     * @response `200` `ConversionTypesV1ListConversionTypesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionTypesServiceListConversionTypes: (params: RequestParams = {}) =>
      this.request<
        ConversionTypesV1ListConversionTypesResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-types/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new conversion type in the system.
     *
     * @tags conversion_types.v1.ConversionTypesService
     * @name ConversionTypesServiceCreateConversionType
     * @summary Create new conversion type
     * @request POST:/conversion-types/v1
     * @secure
     * @response `200` `ConversionTypesV1CreateConversionTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionTypesServiceCreateConversionType: (
      body: ConversionTypesV1CreateConversionTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionTypesV1CreateConversionTypeResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-types/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides a list of conversion types that are available for requesting click identifer (CID)
     *
     * @tags conversion_types.v1.ConversionTypesService
     * @name ConversionTypesServiceListConversionTypesAvailableForCid
     * @summary List conversion types available for CID
     * @request GET:/conversion-types/v1/for-cid/{cid}
     * @secure
     * @response `200` `ConversionTypesV1ListConversionTypesAvailableForCidResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionTypesServiceListConversionTypesAvailableForCid: (
      cid: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionTypesV1ListConversionTypesAvailableForCidResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-types/v1/for-cid/${cid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get more infromation about a specific conversion type.
     *
     * @tags conversion_types.v1.ConversionTypesService
     * @name ConversionTypesServiceGetConversionType
     * @summary Conversion type details
     * @request GET:/conversion-types/v1/{id}
     * @secure
     * @response `200` `ConversionTypesV1GetConversionTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionTypesServiceGetConversionType: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversionTypesV1GetConversionTypeResponse, GoogleRpcStatus>(
        {
          path: `/conversion-types/v1/${id}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Deletes a conversion type from the system.
     *
     * @tags conversion_types.v1.ConversionTypesService
     * @name ConversionTypesServiceDeleteConversionType
     * @summary Delete conversion type
     * @request DELETE:/conversion-types/v1/{id}
     * @secure
     * @response `200` `ConversionTypesV1DeleteConversionTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionTypesServiceDeleteConversionType: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionTypesV1DeleteConversionTypeResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-types/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an existing conversion type.
     *
     * @tags conversion_types.v1.ConversionTypesService
     * @name ConversionTypesServiceUpdateConversionType
     * @summary Change conversion type
     * @request PATCH:/conversion-types/v1/{id}
     * @secure
     * @response `200` `ConversionTypesV1UpdateConversionTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionTypesServiceUpdateConversionType: (
      id: string,
      body: ConversionTypesV1ConversionTypesServiceUpdateConversionTypeBody,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionTypesV1UpdateConversionTypeResponse,
        GoogleRpcStatus
      >({
        path: `/conversion-types/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  trackingV1ConversionService = {
    /**
     * @description Create a new conversion in the system.
     *
     * @tags tracking.v1.ConversionService
     * @name ConversionServiceCreateConversion2
     * @summary Create conversion
     * @request GET:/conversion/v1
     * @secure
     * @response `200` `TrackingV1CreateConversionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionServiceCreateConversion2: (
      query: ConversionServiceCreateConversion2Params,
      params: RequestParams = {},
    ) =>
      this.request<TrackingV1CreateConversionResponse, GoogleRpcStatus>({
        path: `/conversion/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new conversion in the system.
     *
     * @tags tracking.v1.ConversionService
     * @name ConversionServiceCreateConversion
     * @summary Create conversion
     * @request POST:/conversion/v1
     * @secure
     * @response `200` `TrackingV1CreateConversionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionServiceCreateConversion: (
      body: TrackingV1CreateConversionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TrackingV1CreateConversionResponse, GoogleRpcStatus>({
        path: `/conversion/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update selected properties of a conversion.
     *
     * @tags tracking.v1.ConversionService
     * @name ConversionServiceUpdateConversion2
     * @summary Update conversion
     * @request GET:/conversion/v1/update
     * @secure
     * @response `200` `TrackingV1UpdateConversionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionServiceUpdateConversion2: (
      query: ConversionServiceUpdateConversion2Params,
      params: RequestParams = {},
    ) =>
      this.request<TrackingV1UpdateConversionResponse, GoogleRpcStatus>({
        path: `/conversion/v1/update`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update selected properties of a conversion.
     *
     * @tags tracking.v1.ConversionService
     * @name ConversionServiceUpdateConversion
     * @summary Update conversion
     * @request POST:/conversion/v1/update
     * @secure
     * @response `200` `TrackingV1UpdateConversionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionServiceUpdateConversion: (
      body: TrackingV1UpdateConversionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TrackingV1UpdateConversionResponse, GoogleRpcStatus>({
        path: `/conversion/v1/update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  conversionsV1ConversionsService = {
    /**
     * @description List existing conversions based on the provided parameters.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceListConversions
     * @summary List conversions
     * @request GET:/conversions/v1
     * @secure
     * @response `200` `ConversionsV1ListConversionsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceListConversions: (
      query: ConversionsServiceListConversionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ConversionsV1ListConversionsResponse, GoogleRpcStatus>({
        path: `/conversions/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new conversion in the system.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceCreateConversion
     * @summary Create conversion
     * @request POST:/conversions/v1
     * @secure
     * @response `200` `ConversionsV1CreateConversionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceCreateConversion: (
      body: ConversionsV1CreateConversionRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConversionsV1CreateConversionResponse, GoogleRpcStatus>({
        path: `/conversions/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Change the status of multiple already existing conversions.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceBulkSetConversionStatus
     * @summary Bulk set conversion status
     * @request PUT:/conversions/v1/bulk-set-status
     * @secure
     * @response `200` `ConversionsV1BulkSetConversionStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceBulkSetConversionStatus: (
      body: ConversionsV1BulkSetConversionStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionsV1BulkSetConversionStatusResponse,
        GoogleRpcStatus
      >({
        path: `/conversions/v1/bulk-set-status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get an existing conversion based on the provided external ID.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceGetConversionByExternalId
     * @summary Get conversion by external ID
     * @request POST:/conversions/v1/by-external-id
     * @secure
     * @response `200` `ConversionsV1GetConversionByExternalIdResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceGetConversionByExternalId: (
      body: ConversionsV1GetConversionByExternalIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionsV1GetConversionByExternalIdResponse,
        GoogleRpcStatus
      >({
        path: `/conversions/v1/by-external-id`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new coupon conversion in the system.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceCreateCouponConversion
     * @summary Create coupon conversion
     * @request POST:/conversions/v1/coupon
     * @secure
     * @response `200` `ConversionsV1CreateCouponConversionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceCreateCouponConversion: (
      body: ConversionsV1CreateCouponConversionRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionsV1CreateCouponConversionResponse,
        GoogleRpcStatus
      >({
        path: `/conversions/v1/coupon`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update selected properties of a conversion.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceUpdateConversionPartially
     * @summary Update conversion partially
     * @request PATCH:/conversions/v1/{id}
     * @secure
     * @response `200` `ConversionsV1UpdateConversionPartiallyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceUpdateConversionPartially: (
      id: string,
      body: ConversionsV1ConversionsServiceUpdateConversionPartiallyBody,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionsV1UpdateConversionPartiallyResponse,
        GoogleRpcStatus
      >({
        path: `/conversions/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Change the amount (revenue) of a given conversion.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceSetConversionAmounts
     * @summary Set conversion amounts
     * @request PUT:/conversions/v1/{id}/amounts
     * @secure
     * @response `200` `ConversionsV1SetConversionAmountsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceSetConversionAmounts: (
      id: string,
      body: ConversionsV1ConversionsServiceSetConversionAmountsBody,
      params: RequestParams = {},
    ) =>
      this.request<ConversionsV1SetConversionAmountsResponse, GoogleRpcStatus>({
        path: `/conversions/v1/${id}/amounts`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Change the status of an already existing conversion.
     *
     * @tags conversions.v1.ConversionsService
     * @name ConversionsServiceSetConversionStatus
     * @summary Set conversion status
     * @request PUT:/conversions/v1/{id}/status
     * @secure
     * @response `200` `ConversionsV1SetConversionStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionsServiceSetConversionStatus: (
      id: string,
      body: ConversionsV1ConversionsServiceSetConversionStatusBody,
      params: RequestParams = {},
    ) =>
      this.request<ConversionsV1SetConversionStatusResponse, GoogleRpcStatus>({
        path: `/conversions/v1/${id}/status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  conversionsV1ConversionStatusesByExternalIdService = {
    /**
     * @description Update the status of conversions by matching with external ID (see [Conversion sources](#tag--tracking.v1.ConversionSourceService) for more details).
     *
     * @tags conversions.v1.ConversionStatusesByExternalIdService
     * @name ConversionStatusesByExternalIdServiceUpdateConversionStatusByExternalId
     * @summary Change conversion status by External ID
     * @request POST:/conversions/v1/update-status-by-external-id
     * @secure
     * @response `200` `ConversionsV1UpdateConversionStatusByExternalIdResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionStatusesByExternalIdServiceUpdateConversionStatusByExternalId: (
      body: ConversionsV1UpdateConversionStatusByExternalIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ConversionsV1UpdateConversionStatusByExternalIdResponse,
        GoogleRpcStatus
      >({
        path: `/conversions/v1/update-status-by-external-id`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  couponStatusesV1CouponStatusService = {
    /**
     * No description
     *
     * @tags coupon_statuses.v1.CouponStatusService
     * @name CouponStatusServiceListCouponStatuses
     * @request GET:/coupon-statuses/v1
     * @secure
     * @response `200` `CouponStatusesV1ListCouponStatusesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    couponStatusServiceListCouponStatuses: (params: RequestParams = {}) =>
      this.request<CouponStatusesV1ListCouponStatusesResponse, GoogleRpcStatus>(
        {
          path: `/coupon-statuses/v1`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),
  };
  couponsV1CouponsService = {
    /**
     * @description Creates a new coupon in the system.
     *
     * @tags coupons.v1.CouponsService
     * @name CouponsServiceCreateCoupon
     * @summary Create a new coupon.
     * @request POST:/coupons/v1
     * @secure
     * @response `200` `CouponsV1CreateCouponResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    couponsServiceCreateCoupon: (
      body: CouponsV1CreateCouponRequest,
      params: RequestParams = {},
    ) =>
      this.request<CouponsV1CreateCouponResponse, GoogleRpcStatus>({
        path: `/coupons/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all existing coupons in the system.
     *
     * @tags coupons.v1.CouponsService
     * @name CouponsServiceListCoupons
     * @summary List coupons
     * @request POST:/coupons/v1/list
     * @secure
     * @response `200` `CouponsV1ListCouponsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    couponsServiceListCoupons: (
      body: CouponsV1ListCouponsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CouponsV1ListCouponsResponse, GoogleRpcStatus>({
        path: `/coupons/v1/list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed infromation about a specific coupon.
     *
     * @tags coupons.v1.CouponsService
     * @name CouponsServiceGetCoupon
     * @summary Get coupon details
     * @request GET:/coupons/v1/{id}
     * @secure
     * @response `200` `CouponsV1GetCouponResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    couponsServiceGetCoupon: (id: string, params: RequestParams = {}) =>
      this.request<CouponsV1GetCouponResponse, GoogleRpcStatus>({
        path: `/coupons/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an existing coupon from the system.
     *
     * @tags coupons.v1.CouponsService
     * @name CouponsServiceDeleteCoupon
     * @summary Delete coupon
     * @request DELETE:/coupons/v1/{id}
     * @secure
     * @response `200` `CouponsV1DeleteCouponResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    couponsServiceDeleteCoupon: (id: string, params: RequestParams = {}) =>
      this.request<CouponsV1DeleteCouponResponse, GoogleRpcStatus>({
        path: `/coupons/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the status of an already existing coupon
     *
     * @tags coupons.v1.CouponsService
     * @name CouponsServiceUpdateCouponStatus
     * @summary Update coupon status
     * @request PUT:/coupons/v1/{id}/status
     * @secure
     * @response `200` `CouponsV1UpdateCouponStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    couponsServiceUpdateCouponStatus: (
      id: string,
      body: CouponsV1CouponsServiceUpdateCouponStatusBody,
      params: RequestParams = {},
    ) =>
      this.request<CouponsV1UpdateCouponStatusResponse, GoogleRpcStatus>({
        path: `/coupons/v1/${id}/status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  currenciesV1CurrenciesService = {
    /**
     * No description
     *
     * @tags currencies.v1.CurrenciesService
     * @name CurrenciesServiceListCurrencies
     * @request GET:/currencies/v1
     * @secure
     * @response `200` `CurrenciesV1ListCurrenciesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    currenciesServiceListCurrencies: (params: RequestParams = {}) =>
      this.request<CurrenciesV1ListCurrenciesResponse, GoogleRpcStatus>({
        path: `/currencies/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags currencies.v1.CurrenciesService
     * @name CurrenciesServiceCreateCurrency
     * @request POST:/currencies/v1
     * @secure
     * @response `200` `CurrenciesV1CreateCurrencyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    currenciesServiceCreateCurrency: (
      body: CurrenciesV1CreateCurrencyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CurrenciesV1CreateCurrencyResponse, GoogleRpcStatus>({
        path: `/currencies/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags currencies.v1.CurrenciesService
     * @name CurrenciesServiceGetPrimaryCurrency
     * @request GET:/currencies/v1/primary
     * @secure
     * @response `200` `CurrenciesV1GetPrimaryCurrencyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    currenciesServiceGetPrimaryCurrency: (params: RequestParams = {}) =>
      this.request<CurrenciesV1GetPrimaryCurrencyResponse, GoogleRpcStatus>({
        path: `/currencies/v1/primary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags currencies.v1.CurrenciesService
     * @name CurrenciesServiceDeleteCurrency
     * @request DELETE:/currencies/v1/{code}
     * @secure
     * @response `200` `CurrenciesV1DeleteCurrencyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    currenciesServiceDeleteCurrency: (
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<CurrenciesV1DeleteCurrencyResponse, GoogleRpcStatus>({
        path: `/currencies/v1/${code}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags currencies.v1.CurrenciesService
     * @name CurrenciesServiceSetDefaultCurrency
     * @request PUT:/currencies/v1/{code}/default
     * @secure
     * @response `200` `CurrenciesV1SetDefaultCurrencyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    currenciesServiceSetDefaultCurrency: (
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<CurrenciesV1SetDefaultCurrencyResponse, GoogleRpcStatus>({
        path: `/currencies/v1/${code}/default`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customDomainsV1CustomDomainsService = {
    /**
     * No description
     *
     * @tags custom_domains.v1.CustomDomainsService
     * @name CustomDomainsServiceListCustomDomains
     * @request GET:/custom-domains/v1
     * @secure
     * @response `200` `CustomDomainsV1ListCustomDomainsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customDomainsServiceListCustomDomains: (params: RequestParams = {}) =>
      this.request<CustomDomainsV1ListCustomDomainsResponse, GoogleRpcStatus>({
        path: `/custom-domains/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_domains.v1.CustomDomainsService
     * @name CustomDomainsServiceAssignCustomDomain
     * @request POST:/custom-domains/v1
     * @secure
     * @response `200` `CustomDomainsV1AssignCustomDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customDomainsServiceAssignCustomDomain: (
      body: CustomDomainsV1AssignCustomDomainRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomDomainsV1AssignCustomDomainResponse, GoogleRpcStatus>({
        path: `/custom-domains/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_domains.v1.CustomDomainsService
     * @name CustomDomainsServiceRemoveCustomDomain
     * @request DELETE:/custom-domains/v1/{domain}
     * @secure
     * @response `200` `CustomDomainsV1RemoveCustomDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customDomainsServiceRemoveCustomDomain: (
      domain: string,
      params: RequestParams = {},
    ) =>
      this.request<CustomDomainsV1RemoveCustomDomainResponse, GoogleRpcStatus>({
        path: `/custom-domains/v1/${domain}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customInternalPagesV1CustomInternalPagesService = {
    /**
     * No description
     *
     * @tags custom_internal_pages.v1.CustomInternalPagesService
     * @name CustomInternalPagesServiceListCustomInternalPages
     * @request GET:/custom-internal-pages/v1
     * @secure
     * @response `200` `CustomInternalPagesV1ListCustomInternalPagesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customInternalPagesServiceListCustomInternalPages: (
      params: RequestParams = {},
    ) =>
      this.request<
        CustomInternalPagesV1ListCustomInternalPagesResponse,
        GoogleRpcStatus
      >({
        path: `/custom-internal-pages/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_internal_pages.v1.CustomInternalPagesService
     * @name CustomInternalPagesServiceCreateCustomInternalPage
     * @request POST:/custom-internal-pages/v1
     * @secure
     * @response `200` `CustomInternalPagesV1CreateCustomInternalPageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customInternalPagesServiceCreateCustomInternalPage: (
      body: CustomInternalPagesV1CreateCustomInternalPageRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomInternalPagesV1CreateCustomInternalPageResponse,
        GoogleRpcStatus
      >({
        path: `/custom-internal-pages/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_internal_pages.v1.CustomInternalPagesService
     * @name CustomInternalPagesServiceGetCustomInternalPageBySlug
     * @request GET:/custom-internal-pages/v1/slug/{slug}
     * @secure
     * @response `200` `CustomInternalPagesV1GetCustomInternalPageBySlugResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customInternalPagesServiceGetCustomInternalPageBySlug: (
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomInternalPagesV1GetCustomInternalPageBySlugResponse,
        GoogleRpcStatus
      >({
        path: `/custom-internal-pages/v1/slug/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_internal_pages.v1.CustomInternalPagesService
     * @name CustomInternalPagesServiceDeleteCustomInternalPage
     * @request DELETE:/custom-internal-pages/v1/{id}
     * @secure
     * @response `200` `CustomInternalPagesV1DeleteCustomInternalPageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customInternalPagesServiceDeleteCustomInternalPage: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomInternalPagesV1DeleteCustomInternalPageResponse,
        GoogleRpcStatus
      >({
        path: `/custom-internal-pages/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_internal_pages.v1.CustomInternalPagesService
     * @name CustomInternalPagesServiceUpdateCustomInternalPage
     * @request PATCH:/custom-internal-pages/v1/{id}
     * @secure
     * @response `200` `CustomInternalPagesV1UpdateCustomInternalPageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customInternalPagesServiceUpdateCustomInternalPage: (
      id: string,
      body: CustomInternalPagesV1CustomInternalPagesServiceUpdateCustomInternalPageBody,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomInternalPagesV1UpdateCustomInternalPageResponse,
        GoogleRpcStatus
      >({
        path: `/custom-internal-pages/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customMenuItemsV1CustomMenuItemsService = {
    /**
     * No description
     *
     * @tags custom_menu_items.v1.CustomMenuItemsService
     * @name CustomMenuItemsServiceListCustomMenuItems
     * @request GET:/custom-menu-items/v1
     * @secure
     * @response `200` `CustomMenuItemsV1ListCustomMenuItemsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customMenuItemsServiceListCustomMenuItems: (params: RequestParams = {}) =>
      this.request<
        CustomMenuItemsV1ListCustomMenuItemsResponse,
        GoogleRpcStatus
      >({
        path: `/custom-menu-items/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_menu_items.v1.CustomMenuItemsService
     * @name CustomMenuItemsServiceCreateCustomMenuItem
     * @request POST:/custom-menu-items/v1
     * @secure
     * @response `200` `CustomMenuItemsV1CreateCustomMenuItemResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customMenuItemsServiceCreateCustomMenuItem: (
      body: CustomMenuItemsV1CreateCustomMenuItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomMenuItemsV1CreateCustomMenuItemResponse,
        GoogleRpcStatus
      >({
        path: `/custom-menu-items/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_menu_items.v1.CustomMenuItemsService
     * @name CustomMenuItemsServiceListCustomMenuItemsForRole
     * @request GET:/custom-menu-items/v1/role/{roleId}
     * @secure
     * @response `200` `CustomMenuItemsV1ListCustomMenuItemsForRoleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customMenuItemsServiceListCustomMenuItemsForRole: (
      roleId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomMenuItemsV1ListCustomMenuItemsForRoleResponse,
        GoogleRpcStatus
      >({
        path: `/custom-menu-items/v1/role/${roleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_menu_items.v1.CustomMenuItemsService
     * @name CustomMenuItemsServiceDeleteCustomMenuItem
     * @request DELETE:/custom-menu-items/v1/{id}
     * @secure
     * @response `200` `CustomMenuItemsV1DeleteCustomMenuItemResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customMenuItemsServiceDeleteCustomMenuItem: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomMenuItemsV1DeleteCustomMenuItemResponse,
        GoogleRpcStatus
      >({
        path: `/custom-menu-items/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_menu_items.v1.CustomMenuItemsService
     * @name CustomMenuItemsServiceUpdateCustomMenuItem
     * @request PUT:/custom-menu-items/v1/{id}
     * @secure
     * @response `200` `CustomMenuItemsV1UpdateCustomMenuItemResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customMenuItemsServiceUpdateCustomMenuItem: (
      id: string,
      body: CustomMenuItemsV1CustomMenuItemsServiceUpdateCustomMenuItemBody,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomMenuItemsV1UpdateCustomMenuItemResponse,
        GoogleRpcStatus
      >({
        path: `/custom-menu-items/v1/${id}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customQuotesV1CustomQuotesControlPanelService = {
    /**
     * No description
     *
     * @tags custom_quotes.v1.CustomQuotesControlPanelService
     * @name CustomQuotesControlPanelServiceListCustomQuotes
     * @request GET:/custom-quotes/v1
     * @secure
     * @response `200` `CustomQuotesV1ListCustomQuotesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customQuotesControlPanelServiceListCustomQuotes: (
      params: RequestParams = {},
    ) =>
      this.request<CustomQuotesV1ListCustomQuotesResponse, GoogleRpcStatus>({
        path: `/custom-quotes/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_quotes.v1.CustomQuotesControlPanelService
     * @name CustomQuotesControlPanelServiceCreateCustomQuote
     * @request POST:/custom-quotes/v1
     * @secure
     * @response `200` `CustomQuotesV1CreateCustomQuoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customQuotesControlPanelServiceCreateCustomQuote: (
      body: CustomQuotesV1CreateCustomQuoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomQuotesV1CreateCustomQuoteResponse, GoogleRpcStatus>({
        path: `/custom-quotes/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_quotes.v1.CustomQuotesControlPanelService
     * @name CustomQuotesControlPanelServiceValidateCustomQuote
     * @request POST:/custom-quotes/v1/validate
     * @secure
     * @response `200` `CustomQuotesV1ValidateCustomQuoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customQuotesControlPanelServiceValidateCustomQuote: (
      body: CustomQuotesV1ValidateCustomQuoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomQuotesV1ValidateCustomQuoteResponse, GoogleRpcStatus>({
        path: `/custom-quotes/v1/validate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_quotes.v1.CustomQuotesControlPanelService
     * @name CustomQuotesControlPanelServiceDeleteCustomQuote
     * @request DELETE:/custom-quotes/v1/{id}
     * @secure
     * @response `200` `CustomQuotesV1DeleteCustomQuoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customQuotesControlPanelServiceDeleteCustomQuote: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CustomQuotesV1DeleteCustomQuoteResponse, GoogleRpcStatus>({
        path: `/custom-quotes/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_quotes.v1.CustomQuotesControlPanelService
     * @name CustomQuotesControlPanelServiceUpdateCustomQuote
     * @request POST:/custom-quotes/v1/{id}
     * @secure
     * @response `200` `CustomQuotesV1UpdateCustomQuoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customQuotesControlPanelServiceUpdateCustomQuote: (
      id: string,
      body: CustomQuotesV1CustomQuotesControlPanelServiceUpdateCustomQuoteBody,
      params: RequestParams = {},
    ) =>
      this.request<CustomQuotesV1UpdateCustomQuoteResponse, GoogleRpcStatus>({
        path: `/custom-quotes/v1/${id}`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customQuotesV1CustomQuotesService = {
    /**
     * No description
     *
     * @tags custom_quotes.v1.CustomQuotesService
     * @name CustomQuotesServicePayCustomQuote
     * @request POST:/custom-quotes/v1/{id}/pay
     * @secure
     * @response `200` `CustomQuotesV1PayCustomQuoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customQuotesServicePayCustomQuote: (
      id: string,
      body: CustomQuotesV1CustomQuotesServicePayCustomQuoteBody,
      params: RequestParams = {},
    ) =>
      this.request<CustomQuotesV1PayCustomQuoteResponse, GoogleRpcStatus>({
        path: `/custom-quotes/v1/${id}/pay`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customRedirectDomainsV1CustomRedirectDomainsService = {
    /**
     * No description
     *
     * @tags custom_redirect_domains.v1.CustomRedirectDomainsService
     * @name CustomRedirectDomainsServiceListCustomRedirectDomains
     * @request GET:/custom-redirect-domains/v1
     * @secure
     * @response `200` `CustomRedirectDomainsV1ListCustomRedirectDomainsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customRedirectDomainsServiceListCustomRedirectDomains: (
      params: RequestParams = {},
    ) =>
      this.request<
        CustomRedirectDomainsV1ListCustomRedirectDomainsResponse,
        GoogleRpcStatus
      >({
        path: `/custom-redirect-domains/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_redirect_domains.v1.CustomRedirectDomainsService
     * @name CustomRedirectDomainsServiceCreateCustomRedirectDomain
     * @request POST:/custom-redirect-domains/v1
     * @secure
     * @response `200` `CustomRedirectDomainsV1CreateCustomRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customRedirectDomainsServiceCreateCustomRedirectDomain: (
      body: CustomRedirectDomainsV1CreateCustomRedirectDomainRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomRedirectDomainsV1CreateCustomRedirectDomainResponse,
        GoogleRpcStatus
      >({
        path: `/custom-redirect-domains/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_redirect_domains.v1.CustomRedirectDomainsService
     * @name CustomRedirectDomainsServiceCheckDomainPrice
     * @request GET:/custom-redirect-domains/v1/price/{domain}
     * @secure
     * @response `200` `CustomRedirectDomainsV1CheckDomainPriceResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customRedirectDomainsServiceCheckDomainPrice: (
      domain: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomRedirectDomainsV1CheckDomainPriceResponse,
        GoogleRpcStatus
      >({
        path: `/custom-redirect-domains/v1/price/${domain}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_redirect_domains.v1.CustomRedirectDomainsService
     * @name CustomRedirectDomainsServiceRemoveCustomRedirectDomain
     * @request DELETE:/custom-redirect-domains/v1/{domain}/{tenantId}
     * @secure
     * @response `200` `CustomRedirectDomainsV1RemoveCustomRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customRedirectDomainsServiceRemoveCustomRedirectDomain: (
      domain: string,
      tenantId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomRedirectDomainsV1RemoveCustomRedirectDomainResponse,
        GoogleRpcStatus
      >({
        path: `/custom-redirect-domains/v1/${domain}/${tenantId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom_redirect_domains.v1.CustomRedirectDomainsService
     * @name CustomRedirectDomainsServiceAssignCustomRedirectDomain
     * @request POST:/custom-redirect-domains/v1/{domain}/{tenantId}
     * @secure
     * @response `200` `CustomRedirectDomainsV1AssignCustomRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customRedirectDomainsServiceAssignCustomRedirectDomain: (
      domain: string,
      tenantId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomRedirectDomainsV1AssignCustomRedirectDomainResponse,
        GoogleRpcStatus
      >({
        path: `/custom-redirect-domains/v1/${domain}/${tenantId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackingV1ClickService = {
    /**
     * No description
     *
     * @tags tracking.v1.ClickService
     * @name ClickServiceCreateDirectClick
     * @request POST:/direct-click/v1
     * @secure
     * @response `200` `TrackingV1CreateDirectClickResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    clickServiceCreateDirectClick: (
      body: TrackingV1CreateDirectClickRequest,
      params: RequestParams = {},
    ) =>
      this.request<TrackingV1CreateDirectClickResponse, GoogleRpcStatus>({
        path: `/direct-click/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  errorsV1ErrorsService = {
    /**
     * No description
     *
     * @tags errors.v1.ErrorsService
     * @name ErrorsServiceError
     * @request GET:/errors/v1
     * @secure
     * @response `200` `ErrorsV1ErrorResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    errorsServiceError: (params: RequestParams = {}) =>
      this.request<ErrorsV1ErrorResponse, GoogleRpcStatus>({
        path: `/errors/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackingV1ConversionSourceService = {
    /**
     * @description Adds external click identifier to a conversion.
     *
     * @tags tracking.v1.ConversionSourceService
     * @name ConversionSourceServiceSetExternalCid
     * @summary Set external CID
     * @request POST:/external-cid/v1
     * @secure
     * @response `200` `TrackingV1SetExternalCidResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    conversionSourceServiceSetExternalCid: (
      body: TrackingV1SetExternalCidRequest,
      params: RequestParams = {},
    ) =>
      this.request<TrackingV1SetExternalCidResponse, GoogleRpcStatus>({
        path: `/external-cid/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  invitationsV1InvitationService = {
    /**
     * No description
     *
     * @tags invitations.v1.InvitationService
     * @name InvitationServiceListInvitations
     * @request GET:/invitations/v1
     * @secure
     * @response `200` `InvitationsV1ListInvitationsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    invitationServiceListInvitations: (params: RequestParams = {}) =>
      this.request<InvitationsV1ListInvitationsResponse, GoogleRpcStatus>({
        path: `/invitations/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations.v1.InvitationService
     * @name InvitationServiceCreateInvitation
     * @request POST:/invitations/v1
     * @secure
     * @response `200` `InvitationsV1CreateInvitationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    invitationServiceCreateInvitation: (
      body: InvitationsV1CreateInvitationRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationsV1CreateInvitationResponse, GoogleRpcStatus>({
        path: `/invitations/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  invitationsV1InvitationAcceptationService = {
    /**
     * No description
     *
     * @tags invitations.v1.InvitationAcceptationService
     * @name InvitationAcceptationServiceAcceptInvitation
     * @request POST:/invitations/v1/accept
     * @secure
     * @response `200` `InvitationsV1AcceptInvitationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    invitationAcceptationServiceAcceptInvitation: (
      body: InvitationsV1AcceptInvitationRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationsV1AcceptInvitationResponse, GoogleRpcStatus>({
        path: `/invitations/v1/accept`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  landingPagesV1LandingPagesService = {
    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceGetLandingPage
     * @request GET:/landing-pages/v1/{id}
     * @secure
     * @response `200` `LandingPagesV1GetLandingPageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceGetLandingPage: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<LandingPagesV1GetLandingPageResponse, GoogleRpcStatus>({
        path: `/landing-pages/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceDeleteLandingPage
     * @request DELETE:/landing-pages/v1/{id}
     * @secure
     * @response `200` `LandingPagesV1DeleteLandingPageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceDeleteLandingPage: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<LandingPagesV1DeleteLandingPageResponse, GoogleRpcStatus>({
        path: `/landing-pages/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceUpdateLandingPageWithDirectLink
     * @request PATCH:/landing-pages/v1/{id}/direct-link
     * @secure
     * @response `200` `LandingPagesV1UpdateLandingPageWithDirectLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceUpdateLandingPageWithDirectLink: (
      id: string,
      body: LandingPagesV1LandingPagesServiceUpdateLandingPageWithDirectLinkBody,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1UpdateLandingPageWithDirectLinkResponse,
        GoogleRpcStatus
      >({
        path: `/landing-pages/v1/${id}/direct-link`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceUpdateLandingPageWithRedirectLink
     * @request PATCH:/landing-pages/v1/{id}/redirect-link
     * @secure
     * @response `200` `LandingPagesV1UpdateLandingPageWithRedirectLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceUpdateLandingPageWithRedirectLink: (
      id: string,
      body: LandingPagesV1LandingPagesServiceUpdateLandingPageWithRedirectLinkBody,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1UpdateLandingPageWithRedirectLinkResponse,
        GoogleRpcStatus
      >({
        path: `/landing-pages/v1/${id}/redirect-link`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceListLandingPagesWithDirectLinkByOffer
     * @request GET:/offers/v1/{offerId}/landing-pages-direct-link
     * @secure
     * @response `200` `LandingPagesV1ListLandingPagesWithDirectLinkByOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceListLandingPagesWithDirectLinkByOffer: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1ListLandingPagesWithDirectLinkByOfferResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${offerId}/landing-pages-direct-link`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceCreateLandingPagesWithDirectLink
     * @request POST:/offers/v1/{offerId}/landing-pages-direct-link
     * @secure
     * @response `200` `LandingPagesV1CreateLandingPagesWithDirectLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceCreateLandingPagesWithDirectLink: (
      offerId: string,
      body: LandingPagesV1LandingPagesServiceCreateLandingPagesWithDirectLinkBody,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1CreateLandingPagesWithDirectLinkResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${offerId}/landing-pages-direct-link`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceListLandingPagesWithRedirectLinkByOffer
     * @request GET:/offers/v1/{offerId}/landing-pages-redirect-link
     * @secure
     * @response `200` `LandingPagesV1ListLandingPagesWithRedirectLinkByOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceListLandingPagesWithRedirectLinkByOffer: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1ListLandingPagesWithRedirectLinkByOfferResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${offerId}/landing-pages-redirect-link`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServiceCreateLandingPagesWithRedirectLink
     * @request POST:/offers/v1/{offerId}/landing-pages-redirect-link
     * @secure
     * @response `200` `LandingPagesV1CreateLandingPagesWithRedirectLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServiceCreateLandingPagesWithRedirectLink: (
      offerId: string,
      body: LandingPagesV1LandingPagesServiceCreateLandingPagesWithRedirectLinkBody,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1CreateLandingPagesWithRedirectLinkResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${offerId}/landing-pages-redirect-link`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags landing_pages.v1.LandingPagesService
     * @name LandingPagesServicePrioritizeLandingPages
     * @request PUT:/offers/v1/{offerId}/landing-pages/prioritize
     * @secure
     * @response `200` `LandingPagesV1PrioritizeLandingPagesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    landingPagesServicePrioritizeLandingPages: (
      offerId: string,
      body: LandingPagesV1LandingPagesServicePrioritizeLandingPagesBody,
      params: RequestParams = {},
    ) =>
      this.request<
        LandingPagesV1PrioritizeLandingPagesResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${offerId}/landing-pages/prioritize`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  membershipsV1MembershipsService = {
    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceGetMembership
     * @request GET:/memberships/v1
     * @secure
     * @response `200` `MembershipsV1GetMembershipResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceGetMembership: (params: RequestParams = {}) =>
      this.request<MembershipsV1GetMembershipResponse, GoogleRpcStatus>({
        path: `/memberships/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceGetMembershipCancellationData
     * @request GET:/memberships/v1/cancellation-data
     * @secure
     * @response `200` `MembershipsV1GetMembershipCancellationDataResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceGetMembershipCancellationData: (
      params: RequestParams = {},
    ) =>
      this.request<
        MembershipsV1GetMembershipCancellationDataResponse,
        GoogleRpcStatus
      >({
        path: `/memberships/v1/cancellation-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceGetMembershipCurrency
     * @request GET:/memberships/v1/currency
     * @secure
     * @response `200` `MembershipsV1GetMembershipCurrencyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceGetMembershipCurrency: (params: RequestParams = {}) =>
      this.request<MembershipsV1GetMembershipCurrencyResponse, GoogleRpcStatus>(
        {
          path: `/memberships/v1/currency`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceStartFreeTrial
     * @request POST:/memberships/v1/free-trial/start
     * @secure
     * @response `200` `MembershipsV1StartFreeTrialResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceStartFreeTrial: (
      body: MembershipsV1StartFreeTrialRequest,
      params: RequestParams = {},
    ) =>
      this.request<MembershipsV1StartFreeTrialResponse, GoogleRpcStatus>({
        path: `/memberships/v1/free-trial/start`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceGetMembershipPlanUsage
     * @request GET:/memberships/v1/plan-usage
     * @secure
     * @response `200` `MembershipsV1GetMembershipPlanUsageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceGetMembershipPlanUsage: (params: RequestParams = {}) =>
      this.request<
        MembershipsV1GetMembershipPlanUsageResponse,
        GoogleRpcStatus
      >({
        path: `/memberships/v1/plan-usage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceRenewMembership
     * @request POST:/memberships/v1/renew
     * @secure
     * @response `200` `MembershipsV1RenewMembershipResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceRenewMembership: (
      body: MembershipsV1RenewMembershipRequest,
      params: RequestParams = {},
    ) =>
      this.request<MembershipsV1RenewMembershipResponse, GoogleRpcStatus>({
        path: `/memberships/v1/renew`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceCancelShopifyMembership
     * @request DELETE:/memberships/v1/shopify
     * @secure
     * @response `200` `MembershipsV1CancelShopifyMembershipResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceCancelShopifyMembership: (params: RequestParams = {}) =>
      this.request<
        MembershipsV1CancelShopifyMembershipResponse,
        GoogleRpcStatus
      >({
        path: `/memberships/v1/shopify`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags memberships.v1.MembershipsService
     * @name MembershipsServiceCreateShopifyMembership
     * @request POST:/memberships/v1/shopify
     * @secure
     * @response `200` `MembershipsV1CreateShopifyMembershipResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    membershipsServiceCreateShopifyMembership: (
      body: MembershipsV1CreateShopifyMembershipRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        MembershipsV1CreateShopifyMembershipResponse,
        GoogleRpcStatus
      >({
        path: `/memberships/v1/shopify`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  membershipsV1CustomerPortalService = {
    /**
     * No description
     *
     * @tags memberships.v1.CustomerPortalService
     * @name CustomerPortalServiceCreateCustomerPortalSession
     * @request POST:/memberships/v1/customer-portal-session
     * @secure
     * @response `200` `MembershipsV1CreateCustomerPortalSessionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customerPortalServiceCreateCustomerPortalSession: (
      body: MembershipsV1CreateCustomerPortalSessionRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        MembershipsV1CreateCustomerPortalSessionResponse,
        GoogleRpcStatus
      >({
        path: `/memberships/v1/customer-portal-session`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  membershipsV1CustomersNodeService = {
    /**
     * No description
     *
     * @tags memberships.v1.CustomersNodeService
     * @name CustomersNodeServiceGetCustomer
     * @request GET:/memberships/v1/customers
     * @secure
     * @response `200` `MembershipsV1GetCustomerResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customersNodeServiceGetCustomer: (params: RequestParams = {}) =>
      this.request<MembershipsV1GetCustomerResponse, GoogleRpcStatus>({
        path: `/memberships/v1/customers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  membershipsV1CustomersMasterService = {
    /**
     * No description
     *
     * @tags memberships.v1.CustomersMasterService
     * @name CustomersMasterServiceCreateCustomer
     * @request POST:/memberships/v1/customers
     * @secure
     * @response `200` `MembershipsV1CreateCustomerResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customersMasterServiceCreateCustomer: (
      body: MembershipsV1CreateCustomerRequest,
      params: RequestParams = {},
    ) =>
      this.request<MembershipsV1CreateCustomerResponse, GoogleRpcStatus>({
        path: `/memberships/v1/customers`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  plansV1PlansService = {
    /**
     * No description
     *
     * @tags plans.v1.PlansService
     * @name PlansServiceListPlans
     * @request GET:/memberships/v1/plans
     * @secure
     * @response `200` `PlansV1ListPlansResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    plansServiceListPlans: (params: RequestParams = {}) =>
      this.request<PlansV1ListPlansResponse, GoogleRpcStatus>({
        path: `/memberships/v1/plans`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  metadataV1MetadataNodeService = {
    /**
     * No description
     *
     * @tags metadata.v1.MetadataNodeService
     * @name MetadataNodeServiceSetMetadata
     * @request PATCH:/metadata/v1
     * @secure
     * @response `200` `MetadataV1SetMetadataResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    metadataNodeServiceSetMetadata: (
      body: MetadataV1SetMetadataRequest,
      params: RequestParams = {},
    ) =>
      this.request<MetadataV1SetMetadataResponse, GoogleRpcStatus>({
        path: `/metadata/v1`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  metadataV1MetadataMasterService = {
    /**
     * No description
     *
     * @tags metadata.v1.MetadataMasterService
     * @name MetadataMasterServiceSetMetadataBeforeTenantReady
     * @request PATCH:/metadata/v1/{stripeCustomerId}
     * @secure
     * @response `200` `MetadataV1SetMetadataBeforeTenantReadyResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    metadataMasterServiceSetMetadataBeforeTenantReady: (
      stripeCustomerId: string,
      body: MetadataV1MetadataMasterServiceSetMetadataBeforeTenantReadyBody,
      params: RequestParams = {},
    ) =>
      this.request<
        MetadataV1SetMetadataBeforeTenantReadyResponse,
        GoogleRpcStatus
      >({
        path: `/metadata/v1/${stripeCustomerId}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  notificationsV1CustomNotificationEventsService = {
    /**
     * No description
     *
     * @tags notifications.v1.CustomNotificationEventsService
     * @name CustomNotificationEventsServiceCreateCustomNotificationEvent
     * @request POST:/notifications/v1/custom-events
     * @secure
     * @response `200` `NotificationsV1CreateCustomNotificationEventResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customNotificationEventsServiceCreateCustomNotificationEvent: (
      body: NotificationsV1CreateCustomNotificationEventRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1CreateCustomNotificationEventResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/custom-events`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.CustomNotificationEventsService
     * @name CustomNotificationEventsServiceListCustomNotificationEvents
     * @request POST:/notifications/v1/custom-events/list
     * @secure
     * @response `200` `NotificationsV1ListCustomNotificationEventsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customNotificationEventsServiceListCustomNotificationEvents: (
      body: NotificationsV1ListCustomNotificationEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1ListCustomNotificationEventsResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/custom-events/list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.CustomNotificationEventsService
     * @name CustomNotificationEventsServiceDeleteCustomNotificationEvent
     * @request DELETE:/notifications/v1/custom-events/{id}
     * @secure
     * @response `200` `NotificationsV1DeleteCustomNotificationEventResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customNotificationEventsServiceDeleteCustomNotificationEvent: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1DeleteCustomNotificationEventResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/custom-events/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.CustomNotificationEventsService
     * @name CustomNotificationEventsServiceUpdateCustomNotificationEvent
     * @request PUT:/notifications/v1/custom-events/{id}
     * @secure
     * @response `200` `NotificationsV1UpdateCustomNotificationEventResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customNotificationEventsServiceUpdateCustomNotificationEvent: (
      id: string,
      body: NotificationsV1CustomNotificationEventsServiceUpdateCustomNotificationEventBody,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1UpdateCustomNotificationEventResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/custom-events/${id}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.CustomNotificationEventsService
     * @name CustomNotificationEventsServiceUpdateCustomNotificationEventPaused
     * @request PUT:/notifications/v1/custom-events/{id}/paused
     * @secure
     * @response `200` `NotificationsV1UpdateCustomNotificationEventPausedResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customNotificationEventsServiceUpdateCustomNotificationEventPaused: (
      id: string,
      body: NotificationsV1CustomNotificationEventsServiceUpdateCustomNotificationEventPausedBody,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1UpdateCustomNotificationEventPausedResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/custom-events/${id}/paused`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  notificationsV1NotificationsService = {
    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceGetNotificationDefaultsSettings
     * @request GET:/notifications/v1/defaults
     * @secure
     * @response `200` `NotificationsV1GetNotificationDefaultsSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceGetNotificationDefaultsSettings: (
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1GetNotificationDefaultsSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/defaults`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceSetNotificationDefaultsSettings
     * @request PUT:/notifications/v1/defaults
     * @secure
     * @response `200` `NotificationsV1SetNotificationDefaultsSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceSetNotificationDefaultsSettings: (
      body: NotificationsV1SetNotificationDefaultsSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1SetNotificationDefaultsSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/defaults`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceGetEffectiveNotificationSettings
     * @request GET:/notifications/v1/effective-settings
     * @secure
     * @response `200` `NotificationsV1GetEffectiveNotificationSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceGetEffectiveNotificationSettings: (
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1GetEffectiveNotificationSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/effective-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceListNotifications
     * @request POST:/notifications/v1/list
     * @secure
     * @response `200` `NotificationsV1ListNotificationsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceListNotifications: (
      body: NotificationsV1ListNotificationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<NotificationsV1ListNotificationsResponse, GoogleRpcStatus>({
        path: `/notifications/v1/list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceMarkAllNotificationsAsRead
     * @request POST:/notifications/v1/mark-all-as-read
     * @secure
     * @response `200` `NotificationsV1MarkAllNotificationsAsReadResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceMarkAllNotificationsAsRead: (
      body: NotificationsV1MarkAllNotificationsAsReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1MarkAllNotificationsAsReadResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/mark-all-as-read`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceMarkNotificationsAsRead
     * @request POST:/notifications/v1/mark-as-read
     * @secure
     * @response `200` `NotificationsV1MarkNotificationsAsReadResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceMarkNotificationsAsRead: (
      body: NotificationsV1MarkNotificationsAsReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1MarkNotificationsAsReadResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/mark-as-read`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceGetNotificationSettings
     * @request GET:/notifications/v1/settings
     * @secure
     * @response `200` `NotificationsV1GetNotificationSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceGetNotificationSettings: (params: RequestParams = {}) =>
      this.request<
        NotificationsV1GetNotificationSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notifications.v1.NotificationsService
     * @name NotificationsServiceSetNotificationSettings
     * @request PUT:/notifications/v1/settings
     * @secure
     * @response `200` `NotificationsV1SetNotificationSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    notificationsServiceSetNotificationSettings: (
      body: NotificationsV1SetNotificationSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsV1SetNotificationSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/notifications/v1/settings`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  offerCapsV1OfferCapsService = {
    /**
     * No description
     *
     * @tags offer_caps.v1.OfferCapsService
     * @name OfferCapsServiceCreateOfferCap
     * @request POST:/offer-caps/v1
     * @secure
     * @response `200` `OfferCapsV1CreateOfferCapResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerCapsServiceCreateOfferCap: (
      body: OfferCapsV1CreateOfferCapRequest,
      params: RequestParams = {},
    ) =>
      this.request<OfferCapsV1CreateOfferCapResponse, GoogleRpcStatus>({
        path: `/offer-caps/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offer_caps.v1.OfferCapsService
     * @name OfferCapsServiceListOfferCaps
     * @request GET:/offer-caps/v1/offer/{offerId}
     * @secure
     * @response `200` `OfferCapsV1ListOfferCapsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerCapsServiceListOfferCaps: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<OfferCapsV1ListOfferCapsResponse, GoogleRpcStatus>({
        path: `/offer-caps/v1/offer/${offerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offer_caps.v1.OfferCapsService
     * @name OfferCapsServiceDeleteOfferCap
     * @request DELETE:/offer-caps/v1/{id}
     * @secure
     * @response `200` `OfferCapsV1DeleteOfferCapResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerCapsServiceDeleteOfferCap: (id: string, params: RequestParams = {}) =>
      this.request<OfferCapsV1DeleteOfferCapResponse, GoogleRpcStatus>({
        path: `/offer-caps/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offer_caps.v1.OfferCapsService
     * @name OfferCapsServiceRemoveOfferCapSourceLimit
     * @request DELETE:/offer-caps/v1/{offerCapId}/source/{sourceId}
     * @secure
     * @response `200` `OfferCapsV1RemoveOfferCapSourceLimitResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerCapsServiceRemoveOfferCapSourceLimit: (
      offerCapId: string,
      sourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OfferCapsV1RemoveOfferCapSourceLimitResponse,
        GoogleRpcStatus
      >({
        path: `/offer-caps/v1/${offerCapId}/source/${sourceId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offer_caps.v1.OfferCapsService
     * @name OfferCapsServiceAddOfferCapSourceLimit
     * @request POST:/offer-caps/v1/{offerCapId}/source/{sourceId}
     * @secure
     * @response `200` `OfferCapsV1AddOfferCapSourceLimitResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerCapsServiceAddOfferCapSourceLimit: (
      offerCapId: string,
      sourceId: string,
      body: OfferCapsV1OfferCapsServiceAddOfferCapSourceLimitBody,
      params: RequestParams = {},
    ) =>
      this.request<OfferCapsV1AddOfferCapSourceLimitResponse, GoogleRpcStatus>({
        path: `/offer-caps/v1/${offerCapId}/source/${sourceId}`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  offersV1OfferOwnersService = {
    /**
     * No description
     *
     * @tags offers.v1.OfferOwnersService
     * @name OfferOwnersServiceListOfferOwners
     * @request GET:/offer-owners/v1
     * @secure
     * @response `200` `OffersV1ListOfferOwnersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerOwnersServiceListOfferOwners: (params: RequestParams = {}) =>
      this.request<OffersV1ListOfferOwnersResponse, GoogleRpcStatus>({
        path: `/offer-owners/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  offersV1OffersService = {
    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceListOffers
     * @request GET:/offers/v1
     * @secure
     * @response `200` `OffersV1ListOffersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceListOffers: (
      query: OffersServiceListOffersParams,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1ListOffersResponse, GoogleRpcStatus>({
        path: `/offers/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceCreateOffer
     * @request POST:/offers/v1
     * @secure
     * @response `200` `OffersV1CreateOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceCreateOffer: (
      body: OffersV1CreateOfferRequest,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1CreateOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceListOffersWithAnuraOverridden
     * @request GET:/offers/v1/anura-overridden
     * @secure
     * @response `200` `OffersV1ListOffersWithAnuraOverriddenResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceListOffersWithAnuraOverridden: (params: RequestParams = {}) =>
      this.request<
        OffersV1ListOffersWithAnuraOverriddenResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/anura-overridden`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceGetOffer
     * @request GET:/offers/v1/{id}
     * @secure
     * @response `200` `OffersV1GetOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceGetOffer: (id: string, params: RequestParams = {}) =>
      this.request<OffersV1GetOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceDeleteOffer
     * @request DELETE:/offers/v1/{id}
     * @secure
     * @response `200` `OffersV1DeleteOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceDeleteOffer: (id: string, params: RequestParams = {}) =>
      this.request<OffersV1DeleteOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOffer
     * @request PATCH:/offers/v1/{id}
     * @secure
     * @response `200` `OffersV1UpdateOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOffer: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1UpdateOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferAnuraEnabled
     * @request PUT:/offers/v1/{id}/anura-enabled
     * @secure
     * @response `200` `OffersV1UpdateOfferAnuraEnabledResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferAnuraEnabled: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferAnuraEnabledBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1UpdateOfferAnuraEnabledResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}/anura-enabled`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceGetOfferCreatives
     * @request GET:/offers/v1/{id}/creatives
     * @secure
     * @response `200` `OffersV1GetOfferCreativesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceGetOfferCreatives: (id: string, params: RequestParams = {}) =>
      this.request<OffersV1GetOfferCreativesResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}/creatives`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceSetOfferCreatives
     * @request POST:/offers/v1/{id}/creatives
     * @secure
     * @response `200` `OffersV1SetOfferCreativesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceSetOfferCreatives: (
      id: string,
      body: OffersV1OffersServiceSetOfferCreativesBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1SetOfferCreativesResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}/creatives`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferDefaultRedirectDomain
     * @request PUT:/offers/v1/{id}/default-redirect-domain
     * @secure
     * @response `200` `OffersV1UpdateOfferDefaultRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferDefaultRedirectDomain: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferDefaultRedirectDomainBody,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1UpdateOfferDefaultRedirectDomainResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/default-redirect-domain`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferNoSuitableLpFallback
     * @request PUT:/offers/v1/{id}/no-suitable-lp-fallback
     * @secure
     * @response `200` `OffersV1UpdateOfferNoSuitableLpFallbackResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferNoSuitableLpFallback: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferNoSuitableLpFallbackBody,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1UpdateOfferNoSuitableLpFallbackResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/no-suitable-lp-fallback`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferPinned
     * @request PUT:/offers/v1/{id}/pinned
     * @secure
     * @response `200` `OffersV1UpdateOfferPinnedResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferPinned: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferPinnedBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1UpdateOfferPinnedResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}/pinned`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferRedirectDomainsType
     * @request PUT:/offers/v1/{id}/redirect-domain-type
     * @secure
     * @response `200` `OffersV1UpdateOfferRedirectDomainsTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferRedirectDomainsType: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferRedirectDomainsTypeBody,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1UpdateOfferRedirectDomainsTypeResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/redirect-domain-type`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceScheduleOfferDeactivation
     * @request POST:/offers/v1/{id}/schedule-deactivation
     * @secure
     * @response `200` `OffersV1ScheduleOfferDeactivationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceScheduleOfferDeactivation: (
      id: string,
      body: OffersV1OffersServiceScheduleOfferDeactivationBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1ScheduleOfferDeactivationResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}/schedule-deactivation`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferStatus
     * @request PUT:/offers/v1/{id}/status
     * @secure
     * @response `200` `OffersV1UpdateOfferStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferStatus: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferStatusBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1UpdateOfferStatusResponse, GoogleRpcStatus>({
        path: `/offers/v1/${id}/status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceGetOfferTrackingApiAuthorization
     * @request GET:/offers/v1/{id}/tracking-api-authorization
     * @secure
     * @response `200` `OffersV1GetOfferTrackingApiAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceGetOfferTrackingApiAuthorization: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1GetOfferTrackingApiAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/tracking-api-authorization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferTrackingApiAuthorization
     * @request PUT:/offers/v1/{id}/tracking-api-authorization
     * @secure
     * @response `200` `OffersV1UpdateOfferTrackingApiAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferTrackingApiAuthorization: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferTrackingApiAuthorizationBody,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1UpdateOfferTrackingApiAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/tracking-api-authorization`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceGetOfferTrackingQualityControl
     * @request GET:/offers/v1/{id}/tracking-quality-control
     * @secure
     * @response `200` `OffersV1GetOfferTrackingQualityControlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceGetOfferTrackingQualityControl: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1GetOfferTrackingQualityControlResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/tracking-quality-control`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceUpdateOfferTrackingQualityControl
     * @request PUT:/offers/v1/{id}/tracking-quality-control
     * @secure
     * @response `200` `OffersV1UpdateOfferTrackingQualityControlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceUpdateOfferTrackingQualityControl: (
      id: string,
      body: OffersV1OffersServiceUpdateOfferTrackingQualityControlBody,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1UpdateOfferTrackingQualityControlResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${id}/tracking-quality-control`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OffersService
     * @name OffersServiceCloneOffer
     * @request POST:/offers/v1/{originalOfferId}/clone
     * @secure
     * @response `200` `OffersV1CloneOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offersServiceCloneOffer: (
      { originalOfferId, ...query }: OffersServiceCloneOfferParams,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1CloneOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${originalOfferId}/clone`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  offersV1OfferSourcesService = {
    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceListApplicationsForAssignmentToOffer
     * @request GET:/offers/v1/sources/applications
     * @secure
     * @response `200` `OffersV1ListApplicationsForAssignmentToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceListApplicationsForAssignmentToOffer: (
      query: OfferSourcesServiceListApplicationsForAssignmentToOfferParams,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1ListApplicationsForAssignmentToOfferResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/sources/applications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceResolveApplicationForAssignmentToOffer
     * @request POST:/offers/v1/sources/applications/{id}/resolve
     * @secure
     * @response `200` `OffersV1ResolveApplicationForAssignmentToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceResolveApplicationForAssignmentToOffer: (
      id: string,
      body: OffersV1OfferSourcesServiceResolveApplicationForAssignmentToOfferBody,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1ResolveApplicationForAssignmentToOfferResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/sources/applications/${id}/resolve`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceSetSourceAccessToOffer
     * @request PUT:/offers/v1/sources/{id}
     * @secure
     * @response `200` `OffersV1SetSourceAccessToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceSetSourceAccessToOffer: (
      { id, ...query }: OfferSourcesServiceSetSourceAccessToOfferParams,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1SetSourceAccessToOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/sources/${id}`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceAssignSourcesToOffer
     * @request POST:/offers/v1/{offerId}/sources
     * @secure
     * @response `200` `OffersV1AssignSourcesToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceAssignSourcesToOffer: (
      offerId: string,
      body: OffersV1OfferSourcesServiceAssignSourcesToOfferBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1AssignSourcesToOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${offerId}/sources`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceApplyForAssignmentToOffer
     * @request POST:/offers/v1/{offerId}/sources/apply
     * @secure
     * @response `200` `OffersV1ApplyForAssignmentToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceApplyForAssignmentToOffer: (
      offerId: string,
      body: OffersV1OfferSourcesServiceApplyForAssignmentToOfferBody,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1ApplyForAssignmentToOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${offerId}/sources/apply`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceListSourcesAssignedToOffer
     * @request GET:/offers/v1/{offerId}/sources/assigned
     * @secure
     * @response `200` `OffersV1ListSourcesAssignedToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceListSourcesAssignedToOffer: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1ListSourcesAssignedToOfferResponse, GoogleRpcStatus>(
        {
          path: `/offers/v1/${offerId}/sources/assigned`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags offers.v1.OfferSourcesService
     * @name OfferSourcesServiceListSourcesNotAssignedToOffer
     * @request GET:/offers/v1/{offerId}/sources/unassigned
     * @secure
     * @response `200` `OffersV1ListSourcesNotAssignedToOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerSourcesServiceListSourcesNotAssignedToOffer: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OffersV1ListSourcesNotAssignedToOfferResponse,
        GoogleRpcStatus
      >({
        path: `/offers/v1/${offerId}/sources/unassigned`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags offers.v1.OfferSourcesService
 * @name OfferSourcesServiceUnassignSourceFromOffer
 * @summary Obsolete and currently unused endpoint. Access management should be handled by SetSourceAccessToOffer instead.
This can be removed in the future, when no use-case for removing the record itself is not found.
 * @request DELETE:/offers/v1/{offerId}/sources/{sourceId}
 * @secure
 * @response `200` `OffersV1UnassignSourceFromOfferResponse` A successful response.
 * @response `default` `GoogleRpcStatus` An unexpected error response.
 */
    offerSourcesServiceUnassignSourceFromOffer: (
      offerId: string,
      sourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1UnassignSourceFromOfferResponse, GoogleRpcStatus>({
        path: `/offers/v1/${offerId}/sources/${sourceId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  offersV1OfferRevenueOriginsService = {
    /**
     * No description
     *
     * @tags offers.v1.OfferRevenueOriginsService
     * @name OfferRevenueOriginsServiceListOfferRevenueOrigins
     * @request GET:/offers/v1/{offerId}/revenue-origins
     * @secure
     * @response `200` `OffersV1ListOfferRevenueOriginsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    offerRevenueOriginsServiceListOfferRevenueOrigins: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<OffersV1ListOfferRevenueOriginsResponse, GoogleRpcStatus>({
        path: `/offers/v1/${offerId}/revenue-origins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  partnershipsV1PartnershipsService = {
    /**
     * No description
     *
     * @tags partnerships.v1.PartnershipsService
     * @name PartnershipsServiceAccessPartnershipsApp
     * @request POST:/partnerships/v1/app/access
     * @secure
     * @response `200` `PartnershipsV1AccessPartnershipsAppResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    partnershipsServiceAccessPartnershipsApp: (params: RequestParams = {}) =>
      this.request<
        PartnershipsV1AccessPartnershipsAppResponse,
        GoogleRpcStatus
      >({
        path: `/partnerships/v1/app/access`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersV1ResetPasswordOutsideTenantOutsideTenantService = {
    /**
     * No description
     *
     * @tags users.v1.ResetPasswordOutsideTenantOutsideTenantService
     * @name ResetPasswordOutsideTenantOutsideTenantServiceResetPasswordOutsideTenant
     * @request POST:/passwords/v1/global-reset
     * @secure
     * @response `200` `UsersV1ResetPasswordOutsideTenantResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    resetPasswordOutsideTenantOutsideTenantServiceResetPasswordOutsideTenant: (
      body: UsersV1ResetPasswordOutsideTenantRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1ResetPasswordOutsideTenantResponse, GoogleRpcStatus>({
        path: `/passwords/v1/global-reset`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  usersV1ResetPasswordWithinTenantService = {
    /**
     * No description
     *
     * @tags users.v1.ResetPasswordWithinTenantService
     * @name ResetPasswordWithinTenantServiceResetPasswordWithinTenant
     * @request POST:/passwords/v1/reset
     * @secure
     * @response `200` `UsersV1ResetPasswordWithinTenantResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    resetPasswordWithinTenantServiceResetPasswordWithinTenant: (
      body: UsersV1ResetPasswordWithinTenantRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1ResetPasswordWithinTenantResponse, GoogleRpcStatus>({
        path: `/passwords/v1/reset`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  paymentMethodsV1PaymentMethodTypesService = {
    /**
     * No description
     *
     * @tags payment_methods.v1.PaymentMethodTypesService
     * @name PaymentMethodTypesServiceListSupportedPaymentMethodTypes
     * @request GET:/payment-method-types/v1/supported
     * @secure
     * @response `200` `PaymentMethodsV1ListSupportedPaymentMethodTypesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    paymentMethodTypesServiceListSupportedPaymentMethodTypes: (
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentMethodsV1ListSupportedPaymentMethodTypesResponse,
        GoogleRpcStatus
      >({
        path: `/payment-method-types/v1/supported`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  personalAccessTokensV1PersonalAccessTokensService = {
    /**
     * No description
     *
     * @tags personal_access_tokens.v1.PersonalAccessTokensService
     * @name PersonalAccessTokensServiceListPersonalAccessTokens
     * @request GET:/personal-access-tokens/v1
     * @secure
     * @response `200` `PersonalAccessTokensV1ListPersonalAccessTokensResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    personalAccessTokensServiceListPersonalAccessTokens: (
      params: RequestParams = {},
    ) =>
      this.request<
        PersonalAccessTokensV1ListPersonalAccessTokensResponse,
        GoogleRpcStatus
      >({
        path: `/personal-access-tokens/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags personal_access_tokens.v1.PersonalAccessTokensService
     * @name PersonalAccessTokensServiceCreatePersonalAccessToken
     * @request POST:/personal-access-tokens/v1
     * @secure
     * @response `200` `PersonalAccessTokensV1CreatePersonalAccessTokenResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    personalAccessTokensServiceCreatePersonalAccessToken: (
      body: PersonalAccessTokensV1CreatePersonalAccessTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PersonalAccessTokensV1CreatePersonalAccessTokenResponse,
        GoogleRpcStatus
      >({
        path: `/personal-access-tokens/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags personal_access_tokens.v1.PersonalAccessTokensService
     * @name PersonalAccessTokensServiceDeletePersonalAccessToken
     * @request DELETE:/personal-access-tokens/v1/{id}
     * @secure
     * @response `200` `PersonalAccessTokensV1DeletePersonalAccessTokenResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    personalAccessTokensServiceDeletePersonalAccessToken: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PersonalAccessTokensV1DeletePersonalAccessTokenResponse,
        GoogleRpcStatus
      >({
        path: `/personal-access-tokens/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  postbackTemplatesV1PostbackTemplatesService = {
    /**
     * No description
     *
     * @tags postback_templates.v1.PostbackTemplatesService
     * @name PostbackTemplatesServiceListPostbackTemplates
     * @request GET:/postback-templates/v1
     * @secure
     * @response `200` `PostbackTemplatesV1ListPostbackTemplatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbackTemplatesServiceListPostbackTemplates: (
      params: RequestParams = {},
    ) =>
      this.request<
        PostbackTemplatesV1ListPostbackTemplatesResponse,
        GoogleRpcStatus
      >({
        path: `/postback-templates/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags postback_templates.v1.PostbackTemplatesService
     * @name PostbackTemplatesServiceCreatePostbackTemplate
     * @request POST:/postback-templates/v1
     * @secure
     * @response `200` `PostbackTemplatesV1CreatePostbackTemplateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbackTemplatesServiceCreatePostbackTemplate: (
      body: PostbackTemplatesV1CreatePostbackTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PostbackTemplatesV1CreatePostbackTemplateResponse,
        GoogleRpcStatus
      >({
        path: `/postback-templates/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags postback_templates.v1.PostbackTemplatesService
     * @name PostbackTemplatesServiceGetPostbackTemplate
     * @request GET:/postback-templates/v1/{id}
     * @secure
     * @response `200` `PostbackTemplatesV1GetPostbackTemplateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbackTemplatesServiceGetPostbackTemplate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PostbackTemplatesV1GetPostbackTemplateResponse,
        GoogleRpcStatus
      >({
        path: `/postback-templates/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags postback_templates.v1.PostbackTemplatesService
     * @name PostbackTemplatesServiceDeletePostbackTemplate
     * @request DELETE:/postback-templates/v1/{id}
     * @secure
     * @response `200` `PostbackTemplatesV1DeletePostbackTemplateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbackTemplatesServiceDeletePostbackTemplate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PostbackTemplatesV1DeletePostbackTemplateResponse,
        GoogleRpcStatus
      >({
        path: `/postback-templates/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags postback_templates.v1.PostbackTemplatesService
     * @name PostbackTemplatesServiceUpdatePostbackTemplate
     * @request PATCH:/postback-templates/v1/{id}
     * @secure
     * @response `200` `PostbackTemplatesV1UpdatePostbackTemplateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbackTemplatesServiceUpdatePostbackTemplate: (
      id: string,
      body: PostbackTemplatesV1PostbackTemplatesServiceUpdatePostbackTemplateBody,
      params: RequestParams = {},
    ) =>
      this.request<
        PostbackTemplatesV1UpdatePostbackTemplateResponse,
        GoogleRpcStatus
      >({
        path: `/postback-templates/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  postbacksV1PostbacksService = {
    /**
     * No description
     *
     * @tags postbacks.v1.PostbacksService
     * @name PostbacksServiceListPostbacks
     * @request POST:/postbacks/v1
     * @secure
     * @response `200` `PostbacksV1ListPostbacksResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbacksServiceListPostbacks: (
      body: PostbacksV1ListPostbacksRequest,
      params: RequestParams = {},
    ) =>
      this.request<PostbacksV1ListPostbacksResponse, GoogleRpcStatus>({
        path: `/postbacks/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags postbacks.v1.PostbacksService
     * @name PostbacksServiceGetPostback
     * @request GET:/postbacks/v1/{id}
     * @secure
     * @response `200` `PostbacksV1GetPostbackResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    postbacksServiceGetPostback: (id: string, params: RequestParams = {}) =>
      this.request<PostbacksV1GetPostbackResponse, GoogleRpcStatus>({
        path: `/postbacks/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  pricingAdjustmentsV1PricingAdjustmentService = {
    /**
     * No description
     *
     * @tags pricing_adjustments.v1.PricingAdjustmentService
     * @name PricingAdjustmentServiceListPricingAdjustments
     * @request GET:/pricing-adjustments/v1
     * @secure
     * @response `200` `PricingAdjustmentsV1ListPricingAdjustmentsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingAdjustmentServiceListPricingAdjustments: (
      params: RequestParams = {},
    ) =>
      this.request<
        PricingAdjustmentsV1ListPricingAdjustmentsResponse,
        GoogleRpcStatus
      >({
        path: `/pricing-adjustments/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing_adjustments.v1.PricingAdjustmentService
     * @name PricingAdjustmentServiceCreatePricingAdjustment
     * @request POST:/pricing-adjustments/v1
     * @secure
     * @response `200` `PricingAdjustmentsV1CreatePricingAdjustmentResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingAdjustmentServiceCreatePricingAdjustment: (
      body: PricingAdjustmentsV1CreatePricingAdjustmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PricingAdjustmentsV1CreatePricingAdjustmentResponse,
        GoogleRpcStatus
      >({
        path: `/pricing-adjustments/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing_adjustments.v1.PricingAdjustmentService
     * @name PricingAdjustmentServiceGetPricingAdjustment
     * @request GET:/pricing-adjustments/v1/{id}
     * @secure
     * @response `200` `PricingAdjustmentsV1GetPricingAdjustmentResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingAdjustmentServiceGetPricingAdjustment: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PricingAdjustmentsV1GetPricingAdjustmentResponse,
        GoogleRpcStatus
      >({
        path: `/pricing-adjustments/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing_adjustments.v1.PricingAdjustmentService
     * @name PricingAdjustmentServiceDeletePricingAdjustment
     * @request DELETE:/pricing-adjustments/v1/{id}
     * @secure
     * @response `200` `PricingAdjustmentsV1DeletePricingAdjustmentResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingAdjustmentServiceDeletePricingAdjustment: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        PricingAdjustmentsV1DeletePricingAdjustmentResponse,
        GoogleRpcStatus
      >({
        path: `/pricing-adjustments/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing_adjustments.v1.PricingAdjustmentService
     * @name PricingAdjustmentServiceUpdatePricingAdjustment
     * @request PATCH:/pricing-adjustments/v1/{id}
     * @secure
     * @response `200` `PricingAdjustmentsV1UpdatePricingAdjustmentResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingAdjustmentServiceUpdatePricingAdjustment: (
      id: string,
      body: PricingAdjustmentsV1PricingAdjustmentServiceUpdatePricingAdjustmentBody,
      params: RequestParams = {},
    ) =>
      this.request<
        PricingAdjustmentsV1UpdatePricingAdjustmentResponse,
        GoogleRpcStatus
      >({
        path: `/pricing-adjustments/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing_adjustments.v1.PricingAdjustmentService
     * @name PricingAdjustmentServiceUpdatePricingAdjustmentPosition
     * @request PUT:/pricing-adjustments/v1/{id}/position
     * @secure
     * @response `200` `PricingAdjustmentsV1UpdatePricingAdjustmentPositionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingAdjustmentServiceUpdatePricingAdjustmentPosition: (
      id: string,
      body: PricingAdjustmentsV1PricingAdjustmentServiceUpdatePricingAdjustmentPositionBody,
      params: RequestParams = {},
    ) =>
      this.request<
        PricingAdjustmentsV1UpdatePricingAdjustmentPositionResponse,
        GoogleRpcStatus
      >({
        path: `/pricing-adjustments/v1/${id}/position`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pricingV1PricingService = {
    /**
     * No description
     *
     * @tags pricing.v1.PricingService
     * @name PricingServiceCreatePricing
     * @request POST:/pricing/v1
     * @secure
     * @response `200` `PricingV1CreatePricingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingServiceCreatePricing: (
      body: PricingV1CreatePricingRequest,
      params: RequestParams = {},
    ) =>
      this.request<PricingV1CreatePricingResponse, GoogleRpcStatus>({
        path: `/pricing/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing.v1.PricingService
     * @name PricingServiceGetPricingForOffer
     * @request GET:/pricing/v1/offers/{offerId}
     * @secure
     * @response `200` `PricingV1GetPricingForOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingServiceGetPricingForOffer: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<PricingV1GetPricingForOfferResponse, GoogleRpcStatus>({
        path: `/pricing/v1/offers/${offerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing.v1.PricingService
     * @name PricingServiceGetOwnPricingForOffer
     * @request GET:/pricing/v1/offers/{offerId}/own
     * @secure
     * @response `200` `PricingV1GetOwnPricingForOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingServiceGetOwnPricingForOffer: (
      offerId: string,
      params: RequestParams = {},
    ) =>
      this.request<PricingV1GetOwnPricingForOfferResponse, GoogleRpcStatus>({
        path: `/pricing/v1/offers/${offerId}/own`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing.v1.PricingService
     * @name PricingServiceUpdatePricing
     * @request PUT:/pricing/v1/{id}
     * @secure
     * @response `200` `PricingV1UpdatePricingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingServiceUpdatePricing: (
      id: string,
      body: PricingV1PricingServiceUpdatePricingBody,
      params: RequestParams = {},
    ) =>
      this.request<PricingV1UpdatePricingResponse, GoogleRpcStatus>({
        path: `/pricing/v1/${id}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags pricing.v1.PricingService
     * @name PricingServicePrioritizePricingSuperGroups
     * @request PUT:/pricing/v1/{id}/super-groups/prioritize
     * @secure
     * @response `200` `PricingV1PrioritizePricingSuperGroupsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    pricingServicePrioritizePricingSuperGroups: (
      id: string,
      body: PricingV1PricingServicePrioritizePricingSuperGroupsBody,
      params: RequestParams = {},
    ) =>
      this.request<
        PricingV1PrioritizePricingSuperGroupsResponse,
        GoogleRpcStatus
      >({
        path: `/pricing/v1/${id}/super-groups/prioritize`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  redirectDomainsV1RedirectDomainsService = {
    /**
     * No description
     *
     * @tags redirect_domains.v1.RedirectDomainsService
     * @name RedirectDomainsServiceListRedirectDomains
     * @request GET:/redirect-domains/v1
     * @secure
     * @response `200` `RedirectDomainsV1ListRedirectDomainsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    redirectDomainsServiceListRedirectDomains: (params: RequestParams = {}) =>
      this.request<
        RedirectDomainsV1ListRedirectDomainsResponse,
        GoogleRpcStatus
      >({
        path: `/redirect-domains/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  redirectLinksV1RedirectLinksService = {
    /**
     * No description
     *
     * @tags redirect_links.v1.RedirectLinksService
     * @name RedirectLinksServiceListRedirectLinks
     * @request POST:/redirect-links/v1
     * @secure
     * @response `200` `RedirectLinksV1ListRedirectLinksResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    redirectLinksServiceListRedirectLinks: (
      body: RedirectLinksV1ListRedirectLinksRequest,
      params: RequestParams = {},
    ) =>
      this.request<RedirectLinksV1ListRedirectLinksResponse, GoogleRpcStatus>({
        path: `/redirect-links/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  referralAccountSettingsV1ReferralAccountSettingService = {
    /**
     * No description
     *
     * @tags referral_account_settings.v1.ReferralAccountSettingService
     * @name ReferralAccountSettingServiceCreateReferralAccountSetting
     * @request POST:/referral-account-settings/v1
     * @secure
     * @response `200` `ReferralAccountSettingsV1CreateReferralAccountSettingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    referralAccountSettingServiceCreateReferralAccountSetting: (
      body: ReferralAccountSettingsV1CreateReferralAccountSettingRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReferralAccountSettingsV1CreateReferralAccountSettingResponse,
        GoogleRpcStatus
      >({
        path: `/referral-account-settings/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags referral_account_settings.v1.ReferralAccountSettingService
     * @name ReferralAccountSettingServiceListReferralAccountSettings
     * @request POST:/referral-account-settings/v1/list
     * @secure
     * @response `200` `ReferralAccountSettingsV1ListReferralAccountSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    referralAccountSettingServiceListReferralAccountSettings: (
      body: ReferralAccountSettingsV1ListReferralAccountSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReferralAccountSettingsV1ListReferralAccountSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/referral-account-settings/v1/list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags referral_account_settings.v1.ReferralAccountSettingService
     * @name ReferralAccountSettingServiceGetReferralAccountSetting
     * @request GET:/referral-account-settings/v1/{id}
     * @secure
     * @response `200` `ReferralAccountSettingsV1GetReferralAccountSettingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    referralAccountSettingServiceGetReferralAccountSetting: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ReferralAccountSettingsV1GetReferralAccountSettingResponse,
        GoogleRpcStatus
      >({
        path: `/referral-account-settings/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags referral_account_settings.v1.ReferralAccountSettingService
     * @name ReferralAccountSettingServiceDeleteReferralAccountSetting
     * @request DELETE:/referral-account-settings/v1/{id}
     * @secure
     * @response `200` `ReferralAccountSettingsV1DeleteReferralAccountSettingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    referralAccountSettingServiceDeleteReferralAccountSetting: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ReferralAccountSettingsV1DeleteReferralAccountSettingResponse,
        GoogleRpcStatus
      >({
        path: `/referral-account-settings/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags referral_account_settings.v1.ReferralAccountSettingService
     * @name ReferralAccountSettingServiceUpdateReferralAccountSetting
     * @request PUT:/referral-account-settings/v1/{id}
     * @secure
     * @response `200` `ReferralAccountSettingsV1UpdateReferralAccountSettingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    referralAccountSettingServiceUpdateReferralAccountSetting: (
      id: string,
      body: ReferralAccountSettingsV1ReferralAccountSettingServiceUpdateReferralAccountSettingBody,
      params: RequestParams = {},
    ) =>
      this.request<
        ReferralAccountSettingsV1UpdateReferralAccountSettingResponse,
        GoogleRpcStatus
      >({
        path: `/referral-account-settings/v1/${id}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  referralsV1ReferralsService = {
    /**
     * No description
     *
     * @tags referrals.v1.ReferralsService
     * @name ReferralsServiceGetChildAccountsCount
     * @request GET:/referrals/v1/child-accounts-count
     * @secure
     * @response `200` `ReferralsV1GetChildAccountsCountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    referralsServiceGetChildAccountsCount: (params: RequestParams = {}) =>
      this.request<ReferralsV1GetChildAccountsCountResponse, GoogleRpcStatus>({
        path: `/referrals/v1/child-accounts-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reportsV1ReportPresetsService = {
    /**
     * No description
     *
     * @tags reports.v1.ReportPresetsService
     * @name ReportPresetsServiceGetReportPresetsForAccount
     * @request GET:/report-presets/v1/account
     * @secure
     * @response `200` `ReportsV1GetReportPresetsForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportPresetsServiceGetReportPresetsForAccount: (
      params: RequestParams = {},
    ) =>
      this.request<
        ReportsV1GetReportPresetsForAccountResponse,
        GoogleRpcStatus
      >({
        path: `/report-presets/v1/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports.v1.ReportPresetsService
     * @name ReportPresetsServiceDeleteReportPresetsForAccount
     * @request DELETE:/report-presets/v1/account
     * @secure
     * @response `200` `ReportsV1DeleteReportPresetsForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportPresetsServiceDeleteReportPresetsForAccount: (
      params: RequestParams = {},
    ) =>
      this.request<
        ReportsV1DeleteReportPresetsForAccountResponse,
        GoogleRpcStatus
      >({
        path: `/report-presets/v1/account`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports.v1.ReportPresetsService
     * @name ReportPresetsServiceCreateReportPresetsForAccount
     * @request POST:/report-presets/v1/account
     * @secure
     * @response `200` `ReportsV1CreateReportPresetsForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportPresetsServiceCreateReportPresetsForAccount: (
      body: ReportsV1CreateReportPresetsForAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReportsV1CreateReportPresetsForAccountResponse,
        GoogleRpcStatus
      >({
        path: `/report-presets/v1/account`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports.v1.ReportPresetsService
     * @name ReportPresetsServiceUpdateReportPresetsForAccount
     * @request PUT:/report-presets/v1/account
     * @secure
     * @response `200` `ReportsV1UpdateReportPresetsForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    reportPresetsServiceUpdateReportPresetsForAccount: (
      body: ReportsV1UpdateReportPresetsForAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReportsV1UpdateReportPresetsForAccountResponse,
        GoogleRpcStatus
      >({
        path: `/report-presets/v1/account`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  revenueOriginBillingV1RevenueOriginBalanceService = {
    /**
     * No description
     *
     * @tags revenue_origin_billing.v1.RevenueOriginBalanceService
     * @name RevenueOriginBalanceServiceGetBalancesForRevenueOrigin
     * @request GET:/revenue-origin-billing/v1/balances/{revenueOriginId}
     * @secure
     * @response `200` `RevenueOriginBillingV1GetBalancesForRevenueOriginResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginBalanceServiceGetBalancesForRevenueOrigin: (
      revenueOriginId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginBillingV1GetBalancesForRevenueOriginResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-billing/v1/balances/${revenueOriginId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get information about current open balance per individual advertiser.
     *
     * @tags revenue_origin_billing.v1.RevenueOriginBalanceService
     * @name RevenueOriginBalanceServiceListRevenueOriginOpenBalances
     * @summary Advertiser open balance
     * @request GET:/revenue-origin-billing/v1/open-balances
     * @secure
     * @response `200` `RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginBalanceServiceListRevenueOriginOpenBalances: (
      query: RevenueOriginBalanceServiceListRevenueOriginOpenBalancesParams,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginBillingV1ListRevenueOriginOpenBalancesResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-billing/v1/open-balances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags revenue_origin_billing.v1.RevenueOriginBalanceService
     * @name RevenueOriginBalanceServiceSummarizeRevenueOriginOpenBalances
     * @request GET:/revenue-origin-billing/v1/open-balances/summary
     * @secure
     * @response `200` `RevenueOriginBillingV1SummarizeRevenueOriginOpenBalancesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginBalanceServiceSummarizeRevenueOriginOpenBalances: (
      query: RevenueOriginBalanceServiceSummarizeRevenueOriginOpenBalancesParams,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginBillingV1SummarizeRevenueOriginOpenBalancesResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-billing/v1/open-balances/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  revenueOriginBillingV1ClaimService = {
    /**
     * @description Generates a settlement for specific advertiser.
     *
     * @tags revenue_origin_billing.v1.ClaimService
     * @name ClaimServiceClaimBalances
     * @summary Create advertiser settlement
     * @request POST:/revenue-origin-billing/v1/claim-balances
     * @secure
     * @response `200` `RevenueOriginBillingV1ClaimBalancesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    claimServiceClaimBalances: (
      body: RevenueOriginBillingV1ClaimBalancesRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginBillingV1ClaimBalancesResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-billing/v1/claim-balances`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides a list of existing advertiser settlements.
     *
     * @tags revenue_origin_billing.v1.ClaimService
     * @name ClaimServiceListClaims
     * @summary List advertiser settlements
     * @request GET:/revenue-origin-billing/v1/claims
     * @secure
     * @response `200` `RevenueOriginBillingV1ListClaimsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    claimServiceListClaims: (
      query: ClaimServiceListClaimsParams,
      params: RequestParams = {},
    ) =>
      this.request<RevenueOriginBillingV1ListClaimsResponse, GoogleRpcStatus>({
        path: `/revenue-origin-billing/v1/claims`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides details of specific advertiser settlement details.
     *
     * @tags revenue_origin_billing.v1.ClaimService
     * @name ClaimServiceGetClaim
     * @summary Get advertiser settlement
     * @request GET:/revenue-origin-billing/v1/claims/{id}
     * @secure
     * @response `200` `RevenueOriginBillingV1GetClaimResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    claimServiceGetClaim: (id: string, params: RequestParams = {}) =>
      this.request<RevenueOriginBillingV1GetClaimResponse, GoogleRpcStatus>({
        path: `/revenue-origin-billing/v1/claims/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the selected advertiser settlement.
     *
     * @tags revenue_origin_billing.v1.ClaimService
     * @name ClaimServiceDeleteClaim
     * @summary Delete advertiser settlement
     * @request DELETE:/revenue-origin-billing/v1/claims/{id}
     * @secure
     * @response `200` `RevenueOriginBillingV1DeleteClaimResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    claimServiceDeleteClaim: (id: string, params: RequestParams = {}) =>
      this.request<RevenueOriginBillingV1DeleteClaimResponse, GoogleRpcStatus>({
        path: `/revenue-origin-billing/v1/claims/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  revenueOriginGroupsV1RevenueOriginGroupsService = {
    /**
     * No description
     *
     * @tags revenue_origin_groups.v1.RevenueOriginGroupsService
     * @name RevenueOriginGroupsServiceListRevenueOriginGroups
     * @request GET:/revenue-origin-groups/v1
     * @secure
     * @response `200` `RevenueOriginGroupsV1ListRevenueOriginGroupsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginGroupsServiceListRevenueOriginGroups: (
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginGroupsV1ListRevenueOriginGroupsResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-groups/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  intraMessagesV1AdvertiserIntraMessagesService = {
    /**
     * No description
     *
     * @tags intra_messages.v1.AdvertiserIntraMessagesService
     * @name AdvertiserIntraMessagesServiceListAdvertiserIntraMessages
     * @request GET:/revenue-origin-messages/v1
     * @secure
     * @response `200` `IntraMessagesV1ListAdvertiserIntraMessagesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserIntraMessagesServiceListAdvertiserIntraMessages: (
      params: RequestParams = {},
    ) =>
      this.request<
        IntraMessagesV1ListAdvertiserIntraMessagesResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-messages/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags intra_messages.v1.AdvertiserIntraMessagesService
     * @name AdvertiserIntraMessagesServiceSendAdvertiserIntraMessage
     * @request POST:/revenue-origin-messages/v1
     * @secure
     * @response `200` `IntraMessagesV1SendAdvertiserIntraMessageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserIntraMessagesServiceSendAdvertiserIntraMessage: (
      body: IntraMessagesV1SendAdvertiserIntraMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        IntraMessagesV1SendAdvertiserIntraMessageResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-messages/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags intra_messages.v1.AdvertiserIntraMessagesService
     * @name AdvertiserIntraMessagesServiceCountAdvertiserIntraMessageAvailableRecipients
     * @request POST:/revenue-origin-messages/v1/available-recipients
     * @secure
     * @response `200` `IntraMessagesV1CountAdvertiserIntraMessageAvailableRecipientsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserIntraMessagesServiceCountAdvertiserIntraMessageAvailableRecipients:
      (
        body: IntraMessagesV1CountAdvertiserIntraMessageAvailableRecipientsRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          IntraMessagesV1CountAdvertiserIntraMessageAvailableRecipientsResponse,
          GoogleRpcStatus
        >({
          path: `/revenue-origin-messages/v1/available-recipients`,
          method: "POST",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags intra_messages.v1.AdvertiserIntraMessagesService
     * @name AdvertiserIntraMessagesServiceListAdvertiserIntraMessageRecipients
     * @request GET:/revenue-origin-messages/v1/{id}/recipients
     * @secure
     * @response `200` `IntraMessagesV1ListAdvertiserIntraMessageRecipientsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    advertiserIntraMessagesServiceListAdvertiserIntraMessageRecipients: (
      {
        id,
        ...query
      }: AdvertiserIntraMessagesServiceListAdvertiserIntraMessageRecipientsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        IntraMessagesV1ListAdvertiserIntraMessageRecipientsResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origin-messages/v1/${id}/recipients`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  revenueOriginsV1RevenueOriginsService = {
    /**
     * @description Creates a new advertiser in your system.
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceCreateRevenueOrigin
     * @summary Create new advertiser
     * @request POST:/revenue-origins/v1
     * @secure
     * @response `200` `RevenueOriginsV1CreateRevenueOriginResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceCreateRevenueOrigin: (
      body: RevenueOriginsV1CreateRevenueOriginRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1CreateRevenueOriginResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceGetDefaultRevenueOriginId
     * @request GET:/revenue-origins/v1/default
     * @secure
     * @response `200` `RevenueOriginsV1GetDefaultRevenueOriginIdResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceGetDefaultRevenueOriginId: (
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1GetDefaultRevenueOriginIdResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1/default`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List the existing advertisers in your system.
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceListRevenueOrigins
     * @summary List advertisers
     * @request POST:/revenue-origins/v1/list
     * @secure
     * @response `200` `RevenueOriginsV1ListRevenueOriginsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceListRevenueOrigins: (
      body: RevenueOriginsV1ListRevenueOriginsRequest,
      params: RequestParams = {},
    ) =>
      this.request<RevenueOriginsV1ListRevenueOriginsResponse, GoogleRpcStatus>(
        {
          path: `/revenue-origins/v1/list`,
          method: "POST",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Update the advertiser in your system.
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceUpdateRevenueOrigin
     * @summary Update advertiser
     * @request PATCH:/revenue-origins/v1/{id}
     * @secure
     * @response `200` `RevenueOriginsV1UpdateRevenueOriginResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceUpdateRevenueOrigin: (
      id: string,
      body: RevenueOriginsV1RevenueOriginsServiceUpdateRevenueOriginBody,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1UpdateRevenueOriginResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceGetRevenueOriginTrackingApiAuthorization
     * @request GET:/revenue-origins/v1/{id}/tracking-api-authorization
     * @secure
     * @response `200` `RevenueOriginsV1GetRevenueOriginTrackingApiAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceGetRevenueOriginTrackingApiAuthorization: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1GetRevenueOriginTrackingApiAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1/${id}/tracking-api-authorization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceUpdateRevenueOriginTrackingApiAuthorization
     * @request PUT:/revenue-origins/v1/{id}/tracking-api-authorization
     * @secure
     * @response `200` `RevenueOriginsV1UpdateRevenueOriginTrackingApiAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceUpdateRevenueOriginTrackingApiAuthorization: (
      id: string,
      body: RevenueOriginsV1RevenueOriginsServiceUpdateRevenueOriginTrackingApiAuthorizationBody,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1UpdateRevenueOriginTrackingApiAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1/${id}/tracking-api-authorization`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceGetRevenueOriginTrackingQualityControl
     * @request GET:/revenue-origins/v1/{id}/tracking-quality-control
     * @secure
     * @response `200` `RevenueOriginsV1GetRevenueOriginTrackingQualityControlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceGetRevenueOriginTrackingQualityControl: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1GetRevenueOriginTrackingQualityControlResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1/${id}/tracking-quality-control`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags revenue_origins.v1.RevenueOriginsService
     * @name RevenueOriginsServiceUpdateRevenueOriginTrackingQualityControl
     * @request PUT:/revenue-origins/v1/{id}/tracking-quality-control
     * @secure
     * @response `200` `RevenueOriginsV1UpdateRevenueOriginTrackingQualityControlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    revenueOriginsServiceUpdateRevenueOriginTrackingQualityControl: (
      id: string,
      body: RevenueOriginsV1RevenueOriginsServiceUpdateRevenueOriginTrackingQualityControlBody,
      params: RequestParams = {},
    ) =>
      this.request<
        RevenueOriginsV1UpdateRevenueOriginTrackingQualityControlResponse,
        GoogleRpcStatus
      >({
        path: `/revenue-origins/v1/${id}/tracking-quality-control`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rolesV1RolesService = {
    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceListRoles
     * @request GET:/roles/v1
     * @secure
     * @response `200` `RolesV1ListRolesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceListRoles: (params: RequestParams = {}) =>
      this.request<RolesV1ListRolesResponse, GoogleRpcStatus>({
        path: `/roles/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceCreateRole
     * @request POST:/roles/v1
     * @secure
     * @response `200` `RolesV1CreateRoleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceCreateRole: (
      body: RolesV1CreateRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<RolesV1CreateRoleResponse, GoogleRpcStatus>({
        path: `/roles/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceGetRole
     * @request GET:/roles/v1/{id}
     * @secure
     * @response `200` `RolesV1GetRoleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceGetRole: (id: string, params: RequestParams = {}) =>
      this.request<RolesV1GetRoleResponse, GoogleRpcStatus>({
        path: `/roles/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceDeleteRole
     * @request DELETE:/roles/v1/{id}
     * @secure
     * @response `200` `RolesV1DeleteRoleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceDeleteRole: (id: string, params: RequestParams = {}) =>
      this.request<RolesV1DeleteRoleResponse, GoogleRpcStatus>({
        path: `/roles/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceUpdateRole
     * @request PUT:/roles/v1/{id}
     * @secure
     * @response `200` `RolesV1UpdateRoleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceUpdateRole: (
      id: string,
      body: RolesV1RolesServiceUpdateRoleBody,
      params: RequestParams = {},
    ) =>
      this.request<RolesV1UpdateRoleResponse, GoogleRpcStatus>({
        path: `/roles/v1/${id}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceListRolePermissions
     * @request GET:/roles/v1/{roleId}/permissions
     * @secure
     * @response `200` `RolesV1ListRolePermissionsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceListRolePermissions: (
      roleId: string,
      params: RequestParams = {},
    ) =>
      this.request<RolesV1ListRolePermissionsResponse, GoogleRpcStatus>({
        path: `/roles/v1/${roleId}/permissions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles.v1.RolesService
     * @name RolesServiceSetRolePermissions
     * @request POST:/roles/v1/{roleId}/permissions
     * @secure
     * @response `200` `RolesV1SetRolePermissionsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    rolesServiceSetRolePermissions: (
      roleId: string,
      body: RolesV1RolesServiceSetRolePermissionsBody,
      params: RequestParams = {},
    ) =>
      this.request<RolesV1SetRolePermissionsResponse, GoogleRpcStatus>({
        path: `/roles/v1/${roleId}/permissions`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  settingsV1SettingsService = {
    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetAdvertiserDashboardNote
     * @request GET:/settings/v1/advertiser-dashboard-note
     * @secure
     * @response `200` `SettingsV1GetAdvertiserDashboardNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetAdvertiserDashboardNote: (params: RequestParams = {}) =>
      this.request<
        SettingsV1GetAdvertiserDashboardNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-dashboard-note`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAdvertiserDashboardNote
     * @request PUT:/settings/v1/advertiser-dashboard-note
     * @secure
     * @response `200` `SettingsV1UpdateAdvertiserDashboardNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAdvertiserDashboardNote: (
      body: SettingsV1UpdateAdvertiserDashboardNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAdvertiserDashboardNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-dashboard-note`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetAdvertiserParamsVisibility
     * @request GET:/settings/v1/advertiser-params-visibility
     * @secure
     * @response `200` `SettingsV1GetAdvertiserParamsVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetAdvertiserParamsVisibility: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAdvertiserParamsVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-params-visibility`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAdvertiserParamsVisibility
     * @request PUT:/settings/v1/advertiser-params-visibility
     * @secure
     * @response `200` `SettingsV1UpdateAdvertiserParamsVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAdvertiserParamsVisibility: (
      body: SettingsV1UpdateAdvertiserParamsVisibilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAdvertiserParamsVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-params-visibility`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAdvertiserPendingRegistrationNote
     * @request PUT:/settings/v1/advertiser-pending-registration-note
     * @secure
     * @response `200` `SettingsV1UpdateAdvertiserPendingRegistrationNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAdvertiserPendingRegistrationNote: (
      body: SettingsV1UpdateAdvertiserPendingRegistrationNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAdvertiserPendingRegistrationNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-pending-registration-note`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAdvertiserRegistrationPageNote
     * @request PUT:/settings/v1/advertiser-registration-page-note
     * @secure
     * @response `200` `SettingsV1UpdateAdvertiserRegistrationPageNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAdvertiserRegistrationPageNote: (
      body: SettingsV1UpdateAdvertiserRegistrationPageNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAdvertiserRegistrationPageNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-registration-page-note`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAdvertiserVatRequired
     * @request PUT:/settings/v1/advertiser-vat-required
     * @secure
     * @response `200` `SettingsV1UpdateAdvertiserVatRequiredResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAdvertiserVatRequired: (
      body: SettingsV1UpdateAdvertiserVatRequiredRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAdvertiserVatRequiredResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-vat-required`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetAffiliateConversionVisibility
     * @request GET:/settings/v1/affiliate-conversion-visibility
     * @secure
     * @response `200` `SettingsV1GetAffiliateConversionVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetAffiliateConversionVisibility: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAffiliateConversionVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-conversion-visibility`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliateConversionVisibility
     * @request PUT:/settings/v1/affiliate-conversion-visibility
     * @secure
     * @response `200` `SettingsV1UpdateAffiliateConversionVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliateConversionVisibility: (
      body: SettingsV1UpdateAffiliateConversionVisibilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliateConversionVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-conversion-visibility`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliatePendingRegistrationNote
     * @request PUT:/settings/v1/affiliate-pending-registration-note
     * @secure
     * @response `200` `SettingsV1UpdateAffiliatePendingRegistrationNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliatePendingRegistrationNote: (
      body: SettingsV1UpdateAffiliatePendingRegistrationNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliatePendingRegistrationNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-pending-registration-note`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliatePostbackConversionAmountAndRevenueEnabled
     * @request PUT:/settings/v1/affiliate-postback-conversion-amount-and-revenue-enabled
     * @secure
     * @response `200` `SettingsV1UpdateAffiliatePostbackConversionAmountAndRevenueEnabledResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliatePostbackConversionAmountAndRevenueEnabled: (
      body: SettingsV1UpdateAffiliatePostbackConversionAmountAndRevenueEnabledRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliatePostbackConversionAmountAndRevenueEnabledResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-postback-conversion-amount-and-revenue-enabled`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliateRateCostBase
     * @request PUT:/settings/v1/affiliate-rate-cost-base
     * @secure
     * @response `200` `SettingsV1UpdateAffiliateRateCostBaseResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliateRateCostBase: (
      body: SettingsV1UpdateAffiliateRateCostBaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliateRateCostBaseResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-rate-cost-base`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliateRegistrationCustomization
     * @request PUT:/settings/v1/affiliate-registration-customization
     * @secure
     * @response `200` `SettingsV1UpdateAffiliateRegistrationCustomizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliateRegistrationCustomization: (
      body: SettingsV1UpdateAffiliateRegistrationCustomizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliateRegistrationCustomizationResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-registration-customization`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetAffiliateTrackingLinkSettings
     * @request GET:/settings/v1/affiliate-tracking-link-settings
     * @secure
     * @response `200` `SettingsV1GetAffiliateTrackingLinkSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetAffiliateTrackingLinkSettings: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAffiliateTrackingLinkSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-tracking-link-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliateTrackingLinkSettings
     * @request PUT:/settings/v1/affiliate-tracking-link-settings
     * @secure
     * @response `200` `SettingsV1UpdateAffiliateTrackingLinkSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliateTrackingLinkSettings: (
      body: SettingsV1UpdateAffiliateTrackingLinkSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliateTrackingLinkSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-tracking-link-settings`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAffiliatesVatRequired
     * @request PUT:/settings/v1/affiliates-vat-required
     * @secure
     * @response `200` `SettingsV1UpdateAffiliatesVatRequiredResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAffiliatesVatRequired: (
      body: SettingsV1UpdateAffiliatesVatRequiredRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateAffiliatesVatRequiredResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliates-vat-required`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetAnura
     * @request GET:/settings/v1/anura
     * @secure
     * @response `200` `SettingsV1GetAnuraResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetAnura: (params: RequestParams = {}) =>
      this.request<SettingsV1GetAnuraResponse, GoogleRpcStatus>({
        path: `/settings/v1/anura`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAnuraEnabled
     * @request PUT:/settings/v1/anura/enabled
     * @secure
     * @response `200` `SettingsV1UpdateAnuraEnabledResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAnuraEnabled: (
      body: SettingsV1UpdateAnuraEnabledRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateAnuraEnabledResponse, GoogleRpcStatus>({
        path: `/settings/v1/anura/enabled`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateAnuraInstance
     * @request PUT:/settings/v1/anura/instance
     * @secure
     * @response `200` `SettingsV1UpdateAnuraInstanceResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateAnuraInstance: (
      body: SettingsV1UpdateAnuraInstanceRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateAnuraInstanceResponse, GoogleRpcStatus>({
        path: `/settings/v1/anura/instance`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetBillingDetail
     * @request GET:/settings/v1/billing-detail
     * @secure
     * @response `200` `SettingsV1GetBillingDetailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetBillingDetail: (params: RequestParams = {}) =>
      this.request<SettingsV1GetBillingDetailResponse, GoogleRpcStatus>({
        path: `/settings/v1/billing-detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateBillingDetail
     * @request PUT:/settings/v1/billing-detail
     * @secure
     * @response `200` `SettingsV1UpdateBillingDetailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateBillingDetail: (
      body: SettingsV1UpdateBillingDetailRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateBillingDetailResponse, GoogleRpcStatus>({
        path: `/settings/v1/billing-detail`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetClaimGenerating
     * @request GET:/settings/v1/claim-generating
     * @secure
     * @response `200` `SettingsV1GetClaimGeneratingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetClaimGenerating: (params: RequestParams = {}) =>
      this.request<SettingsV1GetClaimGeneratingResponse, GoogleRpcStatus>({
        path: `/settings/v1/claim-generating`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateClaimGenerating
     * @request PUT:/settings/v1/claim-generating
     * @secure
     * @response `200` `SettingsV1UpdateClaimGeneratingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateClaimGenerating: (
      body: SettingsV1UpdateClaimGeneratingRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateClaimGeneratingResponse, GoogleRpcStatus>({
        path: `/settings/v1/claim-generating`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetClickTrackingSettings
     * @request GET:/settings/v1/click-tracking-settings
     * @secure
     * @response `200` `SettingsV1GetClickTrackingSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetClickTrackingSettings: (params: RequestParams = {}) =>
      this.request<SettingsV1GetClickTrackingSettingsResponse, GoogleRpcStatus>(
        {
          path: `/settings/v1/click-tracking-settings`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateClickTrackingSettings
     * @request PUT:/settings/v1/click-tracking-settings
     * @secure
     * @response `200` `SettingsV1UpdateClickTrackingSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateClickTrackingSettings: (
      body: SettingsV1UpdateClickTrackingSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateClickTrackingSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/click-tracking-settings`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateColorTheme
     * @request PUT:/settings/v1/color-theme
     * @secure
     * @response `200` `SettingsV1UpdateColorThemeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateColorTheme: (
      body: SettingsV1UpdateColorThemeRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateColorThemeResponse, GoogleRpcStatus>({
        path: `/settings/v1/color-theme`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetContactForAdvertisers
     * @request GET:/settings/v1/contact-for-advertisers
     * @secure
     * @response `200` `SettingsV1GetContactForAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetContactForAdvertisers: (params: RequestParams = {}) =>
      this.request<SettingsV1GetContactForAdvertisersResponse, GoogleRpcStatus>(
        {
          path: `/settings/v1/contact-for-advertisers`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateContactForAdvertisers
     * @request PUT:/settings/v1/contact-for-advertisers
     * @secure
     * @response `200` `SettingsV1UpdateContactForAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateContactForAdvertisers: (
      body: SettingsV1UpdateContactForAdvertisersRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateContactForAdvertisersResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/contact-for-advertisers`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetContactForAffiliates
     * @request GET:/settings/v1/contact-for-affiliates
     * @secure
     * @response `200` `SettingsV1GetContactForAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetContactForAffiliates: (params: RequestParams = {}) =>
      this.request<SettingsV1GetContactForAffiliatesResponse, GoogleRpcStatus>({
        path: `/settings/v1/contact-for-affiliates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateContactForAffiliates
     * @request PUT:/settings/v1/contact-for-affiliates
     * @secure
     * @response `200` `SettingsV1UpdateContactForAffiliatesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateContactForAffiliates: (
      body: SettingsV1UpdateContactForAffiliatesRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateContactForAffiliatesResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/contact-for-affiliates`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateConversionAmountVisible
     * @request PUT:/settings/v1/conversion-amount-visible
     * @secure
     * @response `200` `SettingsV1UpdateConversionAmountVisibleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateConversionAmountVisible: (
      body: SettingsV1UpdateConversionAmountVisibleRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateConversionAmountVisibleResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/conversion-amount-visible`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetDashboardNote
     * @request GET:/settings/v1/dashboard-note
     * @secure
     * @response `200` `SettingsV1GetDashboardNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetDashboardNote: (params: RequestParams = {}) =>
      this.request<SettingsV1GetDashboardNoteResponse, GoogleRpcStatus>({
        path: `/settings/v1/dashboard-note`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDashboardNote
     * @request PUT:/settings/v1/dashboard-note
     * @secure
     * @response `200` `SettingsV1UpdateDashboardNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDashboardNote: (
      body: SettingsV1UpdateDashboardNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateDashboardNoteResponse, GoogleRpcStatus>({
        path: `/settings/v1/dashboard-note`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetDashboardPromosVisibility
     * @request GET:/settings/v1/dashboard-promos-visibility
     * @secure
     * @response `200` `SettingsV1GetDashboardPromosVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetDashboardPromosVisibility: (params: RequestParams = {}) =>
      this.request<
        SettingsV1GetDashboardPromosVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/dashboard-promos-visibility`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDashboardPromosVisibility
     * @request PUT:/settings/v1/dashboard-promos-visibility
     * @secure
     * @response `200` `SettingsV1UpdateDashboardPromosVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDashboardPromosVisibility: (
      body: SettingsV1UpdateDashboardPromosVisibilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateDashboardPromosVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/dashboard-promos-visibility`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetDataVisibilityForAdvertisers
     * @request GET:/settings/v1/data-visibility-for-advertisers
     * @secure
     * @response `200` `SettingsV1GetDataVisibilityForAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetDataVisibilityForAdvertisers: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetDataVisibilityForAdvertisersResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/data-visibility-for-advertisers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDataVisibilityForAdvertisers
     * @request PUT:/settings/v1/data-visibility-for-advertisers
     * @secure
     * @response `200` `SettingsV1UpdateDataVisibilityForAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDataVisibilityForAdvertisers: (
      body: SettingsV1UpdateDataVisibilityForAdvertisersRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateDataVisibilityForAdvertisersResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/data-visibility-for-advertisers`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDefaultLanguage
     * @request PUT:/settings/v1/default-language
     * @secure
     * @response `200` `SettingsV1UpdateDefaultLanguageResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDefaultLanguage: (
      body: SettingsV1UpdateDefaultLanguageRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateDefaultLanguageResponse, GoogleRpcStatus>({
        path: `/settings/v1/default-language`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetDefaultRedirectDomain
     * @request GET:/settings/v1/default-redirect-domain
     * @secure
     * @response `200` `SettingsV1GetDefaultRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetDefaultRedirectDomain: (params: RequestParams = {}) =>
      this.request<SettingsV1GetDefaultRedirectDomainResponse, GoogleRpcStatus>(
        {
          path: `/settings/v1/default-redirect-domain`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDefaultRedirectDomain
     * @request PUT:/settings/v1/default-redirect-domain
     * @secure
     * @response `200` `SettingsV1UpdateDefaultRedirectDomainResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDefaultRedirectDomain: (
      body: SettingsV1UpdateDefaultRedirectDomainRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateDefaultRedirectDomainResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/default-redirect-domain`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetDefaultRegisteredAdvertiserAccountStatus
     * @request GET:/settings/v1/default-registered-advertiser-account-status
     * @secure
     * @response `200` `SettingsV1GetDefaultRegisteredAdvertiserAccountStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetDefaultRegisteredAdvertiserAccountStatus: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetDefaultRegisteredAdvertiserAccountStatusResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/default-registered-advertiser-account-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDefaultRegisteredAdvertiserAccountStatus
     * @request PUT:/settings/v1/default-registered-advertiser-account-status
     * @secure
     * @response `200` `SettingsV1UpdateDefaultRegisteredAdvertiserAccountStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDefaultRegisteredAdvertiserAccountStatus: (
      body: SettingsV1UpdateDefaultRegisteredAdvertiserAccountStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateDefaultRegisteredAdvertiserAccountStatusResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/default-registered-advertiser-account-status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetDefaultReportFiltering
     * @request GET:/settings/v1/default-report-filtering
     * @secure
     * @response `200` `SettingsV1GetDefaultReportFilteringResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetDefaultReportFiltering: (params: RequestParams = {}) =>
      this.request<
        SettingsV1GetDefaultReportFilteringResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/default-report-filtering`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDefaultReportFiltering
     * @request PUT:/settings/v1/default-report-filtering
     * @secure
     * @response `200` `SettingsV1UpdateDefaultReportFilteringResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDefaultReportFiltering: (
      body: SettingsV1UpdateDefaultReportFilteringRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateDefaultReportFilteringResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/default-report-filtering`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateDefaultTheme
     * @request PUT:/settings/v1/default-theme
     * @secure
     * @response `200` `SettingsV1UpdateDefaultThemeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateDefaultTheme: (
      body: SettingsV1UpdateDefaultThemeRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateDefaultThemeResponse, GoogleRpcStatus>({
        path: `/settings/v1/default-theme`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateFraudSuspicionsVisible
     * @request PUT:/settings/v1/fraud-suspicions-visible
     * @secure
     * @response `200` `SettingsV1UpdateFraudSuspicionsVisibleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateFraudSuspicionsVisible: (
      body: SettingsV1UpdateFraudSuspicionsVisibleRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateFraudSuspicionsVisibleResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/fraud-suspicions-visible`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetGeneral
     * @request GET:/settings/v1/general
     * @secure
     * @response `200` `SettingsV1GetGeneralResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetGeneral: (params: RequestParams = {}) =>
      this.request<SettingsV1GetGeneralResponse, GoogleRpcStatus>({
        path: `/settings/v1/general`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateGeneral
     * @request PUT:/settings/v1/general
     * @secure
     * @response `200` `SettingsV1UpdateGeneralResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateGeneral: (
      body: SettingsV1UpdateGeneralRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateGeneralResponse, GoogleRpcStatus>({
        path: `/settings/v1/general`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetGlobalRedirectDomainsVisibility
     * @request GET:/settings/v1/global-redirect-domains-visibility
     * @secure
     * @response `200` `SettingsV1GetGlobalRedirectDomainsVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetGlobalRedirectDomainsVisibility: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetGlobalRedirectDomainsVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/global-redirect-domains-visibility`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateGlobalRedirectDomainsVisibility
     * @request PUT:/settings/v1/global-redirect-domains-visibility
     * @secure
     * @response `200` `SettingsV1UpdateGlobalRedirectDomainsVisibilityResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateGlobalRedirectDomainsVisibility: (
      body: SettingsV1UpdateGlobalRedirectDomainsVisibilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateGlobalRedirectDomainsVisibilityResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/global-redirect-domains-visibility`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateOnboardingStatus
     * @request PUT:/settings/v1/onboarding-status
     * @secure
     * @response `200` `SettingsV1UpdateOnboardingStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateOnboardingStatus: (
      body: SettingsV1UpdateOnboardingStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateOnboardingStatusResponse, GoogleRpcStatus>({
        path: `/settings/v1/onboarding-status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetPaymentMethodForAdvertisers
     * @request GET:/settings/v1/payment-method-for-advertisers
     * @secure
     * @response `200` `SettingsV1GetPaymentMethodForAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetPaymentMethodForAdvertisers: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetPaymentMethodForAdvertisersResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/payment-method-for-advertisers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdatePaymentMethodForAdvertisers
     * @request PUT:/settings/v1/payment-method-for-advertisers
     * @secure
     * @response `200` `SettingsV1UpdatePaymentMethodForAdvertisersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdatePaymentMethodForAdvertisers: (
      body: SettingsV1UpdatePaymentMethodForAdvertisersRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdatePaymentMethodForAdvertisersResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/payment-method-for-advertisers`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetRedirectDomainsType
     * @request GET:/settings/v1/redirect-domains-type
     * @secure
     * @response `200` `SettingsV1GetRedirectDomainsTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetRedirectDomainsType: (params: RequestParams = {}) =>
      this.request<SettingsV1GetRedirectDomainsTypeResponse, GoogleRpcStatus>({
        path: `/settings/v1/redirect-domains-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateRedirectDomainsType
     * @request PUT:/settings/v1/redirect-domains-type
     * @secure
     * @response `200` `SettingsV1UpdateRedirectDomainsTypeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateRedirectDomainsType: (
      body: SettingsV1UpdateRedirectDomainsTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateRedirectDomainsTypeResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/redirect-domains-type`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetReferralSettings
     * @request GET:/settings/v1/referral
     * @secure
     * @response `200` `SettingsV1GetReferralSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetReferralSettings: (params: RequestParams = {}) =>
      this.request<SettingsV1GetReferralSettingsResponse, GoogleRpcStatus>({
        path: `/settings/v1/referral`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateReferralSettings
     * @request PUT:/settings/v1/referral
     * @secure
     * @response `200` `SettingsV1UpdateReferralSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateReferralSettings: (
      body: SettingsV1UpdateReferralSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateReferralSettingsResponse, GoogleRpcStatus>({
        path: `/settings/v1/referral`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateRevenueVisible
     * @request PUT:/settings/v1/revenue-visible
     * @secure
     * @response `200` `SettingsV1UpdateRevenueVisibleResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateRevenueVisible: (
      body: SettingsV1UpdateRevenueVisibleRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateRevenueVisibleResponse, GoogleRpcStatus>({
        path: `/settings/v1/revenue-visible`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateSmartLinksSettings
     * @request PUT:/settings/v1/smart-links
     * @secure
     * @response `200` `SettingsV1UpdateSmartLinksSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateSmartLinksSettings: (
      body: SettingsV1UpdateSmartLinksSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateSmartLinksSettingsResponse, GoogleRpcStatus>(
        {
          path: `/settings/v1/smart-links`,
          method: "PUT",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetStripeBillingDetail
     * @request GET:/settings/v1/stripe-billing-detail
     * @secure
     * @response `200` `SettingsV1GetStripeBillingDetailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetStripeBillingDetail: (params: RequestParams = {}) =>
      this.request<SettingsV1GetStripeBillingDetailResponse, GoogleRpcStatus>({
        path: `/settings/v1/stripe-billing-detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetTenantPrivate
     * @request GET:/settings/v1/tenant-private
     * @secure
     * @response `200` `SettingsV1GetTenantPrivateResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetTenantPrivate: (params: RequestParams = {}) =>
      this.request<SettingsV1GetTenantPrivateResponse, GoogleRpcStatus>({
        path: `/settings/v1/tenant-private`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateTermsAndConditionsText
     * @request PUT:/settings/v1/terms-and-conditions-text
     * @secure
     * @response `200` `SettingsV1UpdateTermsAndConditionsTextResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateTermsAndConditionsText: (
      body: SettingsV1UpdateTermsAndConditionsTextRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateTermsAndConditionsTextResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/terms-and-conditions-text`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetTrackingApiAuthorization
     * @request GET:/settings/v1/tracking-api-authorization
     * @secure
     * @response `200` `SettingsV1GetTrackingApiAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetTrackingApiAuthorization: (params: RequestParams = {}) =>
      this.request<
        SettingsV1GetTrackingApiAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/tracking-api-authorization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateTrackingApiAuthorization
     * @request PUT:/settings/v1/tracking-api-authorization
     * @secure
     * @response `200` `SettingsV1UpdateTrackingApiAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateTrackingApiAuthorization: (
      body: SettingsV1UpdateTrackingApiAuthorizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateTrackingApiAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/tracking-api-authorization`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceGetTrackingQualityControl
     * @request GET:/settings/v1/tracking-quality-control
     * @secure
     * @response `200` `SettingsV1GetTrackingQualityControlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceGetTrackingQualityControl: (params: RequestParams = {}) =>
      this.request<
        SettingsV1GetTrackingQualityControlResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/tracking-quality-control`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.SettingsService
     * @name SettingsServiceUpdateTrackingQualityControl
     * @request PUT:/settings/v1/tracking-quality-control
     * @secure
     * @response `200` `SettingsV1UpdateTrackingQualityControlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    settingsServiceUpdateTrackingQualityControl: (
      body: SettingsV1UpdateTrackingQualityControlRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1UpdateTrackingQualityControlResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/tracking-quality-control`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  settingsV1TenantSettingsService = {
    /**
     * No description
     *
     * @tags settings.v1.TenantSettingsService
     * @name TenantSettingsServiceGetAdvertiserPendingRegistrationNote
     * @request GET:/settings/v1/advertiser-pending-registration-note
     * @secure
     * @response `200` `SettingsV1GetAdvertiserPendingRegistrationNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantSettingsServiceGetAdvertiserPendingRegistrationNote: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAdvertiserPendingRegistrationNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-pending-registration-note`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.TenantSettingsService
     * @name TenantSettingsServiceGetAdvertiserRegistrationPageNote
     * @request GET:/settings/v1/advertiser-registration-page-note
     * @secure
     * @response `200` `SettingsV1GetAdvertiserRegistrationPageNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantSettingsServiceGetAdvertiserRegistrationPageNote: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAdvertiserRegistrationPageNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/advertiser-registration-page-note`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.TenantSettingsService
     * @name TenantSettingsServiceGetAdvertiserVatRequired
     * @request GET:/settings/v1/advertiser-vat-required
     * @secure
     * @response `200` `SettingsV1GetAdvertiserVatRequiredResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantSettingsServiceGetAdvertiserVatRequired: (
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1GetAdvertiserVatRequiredResponse, GoogleRpcStatus>(
        {
          path: `/settings/v1/advertiser-vat-required`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags settings.v1.TenantSettingsService
     * @name TenantSettingsServiceGetAffiliatePendingRegistrationNote
     * @request GET:/settings/v1/affiliate-pending-registration-note
     * @secure
     * @response `200` `SettingsV1GetAffiliatePendingRegistrationNoteResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantSettingsServiceGetAffiliatePendingRegistrationNote: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAffiliatePendingRegistrationNoteResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-pending-registration-note`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.TenantSettingsService
     * @name TenantSettingsServiceGetAffiliateRegistrationCustomization
     * @request GET:/settings/v1/affiliate-registration-customization
     * @secure
     * @response `200` `SettingsV1GetAffiliateRegistrationCustomizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantSettingsServiceGetAffiliateRegistrationCustomization: (
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1GetAffiliateRegistrationCustomizationResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/affiliate-registration-customization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.TenantSettingsService
     * @name TenantSettingsServiceGetTenantSettings
     * @request GET:/settings/v1/tenant
     * @secure
     * @response `200` `SettingsV1GetTenantSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantSettingsServiceGetTenantSettings: (params: RequestParams = {}) =>
      this.request<SettingsV1GetTenantSettingsResponse, GoogleRpcStatus>({
        path: `/settings/v1/tenant`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  settingsV1EmailCustomizationService = {
    /**
     * No description
     *
     * @tags settings.v1.EmailCustomizationService
     * @name EmailCustomizationServiceGetEmailCustomization
     * @request GET:/settings/v1/email-customization
     * @secure
     * @response `200` `SettingsV1GetEmailCustomizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    emailCustomizationServiceGetEmailCustomization: (
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1GetEmailCustomizationResponse, GoogleRpcStatus>({
        path: `/settings/v1/email-customization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.EmailCustomizationService
     * @name EmailCustomizationServiceUpdateEmailCustomization
     * @request PUT:/settings/v1/email-customization
     * @secure
     * @response `200` `SettingsV1UpdateEmailCustomizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    emailCustomizationServiceUpdateEmailCustomization: (
      body: SettingsV1UpdateEmailCustomizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateEmailCustomizationResponse, GoogleRpcStatus>(
        {
          path: `/settings/v1/email-customization`,
          method: "PUT",
          body: body,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags settings.v1.EmailCustomizationService
     * @name EmailCustomizationServicePreviewEmailCustomization
     * @request POST:/settings/v1/email-customization/preview
     * @secure
     * @response `200` `SettingsV1PreviewEmailCustomizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    emailCustomizationServicePreviewEmailCustomization: (
      body: SettingsV1PreviewEmailCustomizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SettingsV1PreviewEmailCustomizationResponse,
        GoogleRpcStatus
      >({
        path: `/settings/v1/email-customization/preview`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  settingsV1EnvironmentSettingsService = {
    /**
     * No description
     *
     * @tags settings.v1.EnvironmentSettingsService
     * @name EnvironmentSettingsServiceGetEnvironmentSettings
     * @request GET:/settings/v1/environment
     * @secure
     * @response `200` `SettingsV1GetEnvironmentSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    environmentSettingsServiceGetEnvironmentSettings: (
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1GetEnvironmentSettingsResponse, GoogleRpcStatus>({
        path: `/settings/v1/environment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  settingsV1QuickSetupService = {
    /**
     * No description
     *
     * @tags settings.v1.QuickSetupService
     * @name QuickSetupServiceGetCompletedSteps
     * @request GET:/settings/v1/quick-setup/completed-steps
     * @secure
     * @response `200` `SettingsV1GetCompletedStepsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    quickSetupServiceGetCompletedSteps: (params: RequestParams = {}) =>
      this.request<SettingsV1GetCompletedStepsResponse, GoogleRpcStatus>({
        path: `/settings/v1/quick-setup/completed-steps`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.QuickSetupService
     * @name QuickSetupServiceUpdateCompletedSteps
     * @request PUT:/settings/v1/quick-setup/completed-steps
     * @secure
     * @response `200` `SettingsV1UpdateCompletedStepsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    quickSetupServiceUpdateCompletedSteps: (
      body: SettingsV1UpdateCompletedStepsRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateCompletedStepsResponse, GoogleRpcStatus>({
        path: `/settings/v1/quick-setup/completed-steps`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings.v1.QuickSetupService
     * @name QuickSetupServiceUpdateQuickSetupDone
     * @request PUT:/settings/v1/quick-setup/done
     * @secure
     * @response `200` `SettingsV1UpdateQuickSetupDoneResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    quickSetupServiceUpdateQuickSetupDone: (
      body: SettingsV1UpdateQuickSetupDoneRequest,
      params: RequestParams = {},
    ) =>
      this.request<SettingsV1UpdateQuickSetupDoneResponse, GoogleRpcStatus>({
        path: `/settings/v1/quick-setup/done`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shopifyV1ShopifyAuthorizationsService = {
    /**
     * No description
     *
     * @tags shopify.v1.ShopifyAuthorizationsService
     * @name ShopifyAuthorizationsServiceGetShopifyAuthorizationUrl
     * @request POST:/shopify-authorizations/v1/url
     * @secure
     * @response `200` `ShopifyV1GetShopifyAuthorizationUrlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyAuthorizationsServiceGetShopifyAuthorizationUrl: (
      body: ShopifyV1GetShopifyAuthorizationUrlRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ShopifyV1GetShopifyAuthorizationUrlResponse,
        GoogleRpcStatus
      >({
        path: `/shopify-authorizations/v1/url`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shopifyV1ShopifyIntegrationsService = {
    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceListShopifyIntegrations
     * @request GET:/shopify-integrations/v1
     * @secure
     * @response `200` `ShopifyV1ListShopifyIntegrationsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceListShopifyIntegrations: (
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1ListShopifyIntegrationsResponse, GoogleRpcStatus>({
        path: `/shopify-integrations/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceCreateShopifyIntegration
     * @request POST:/shopify-integrations/v1
     * @secure
     * @response `200` `ShopifyV1CreateShopifyIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceCreateShopifyIntegration: (
      body: ShopifyV1CreateShopifyIntegrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1CreateShopifyIntegrationResponse, GoogleRpcStatus>({
        path: `/shopify-integrations/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceGetShopifyIntegration
     * @request GET:/shopify-integrations/v1/{id}
     * @secure
     * @response `200` `ShopifyV1GetShopifyIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceGetShopifyIntegration: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1GetShopifyIntegrationResponse, GoogleRpcStatus>({
        path: `/shopify-integrations/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceDeleteShopifyIntegration
     * @request DELETE:/shopify-integrations/v1/{id}
     * @secure
     * @response `200` `ShopifyV1DeleteShopifyIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceDeleteShopifyIntegration: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1DeleteShopifyIntegrationResponse, GoogleRpcStatus>({
        path: `/shopify-integrations/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceActivateShopifyIntegration
     * @request POST:/shopify-integrations/v1/{id}/activate
     * @secure
     * @response `200` `ShopifyV1ActivateShopifyIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceActivateShopifyIntegration: (
      id: string,
      body: ShopifyV1ShopifyIntegrationsServiceActivateShopifyIntegrationBody,
      params: RequestParams = {},
    ) =>
      this.request<
        ShopifyV1ActivateShopifyIntegrationResponse,
        GoogleRpcStatus
      >({
        path: `/shopify-integrations/v1/${id}/activate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceGetShopifyIntegrationAuthorizationUrl
     * @request GET:/shopify-integrations/v1/{id}/authorization-url
     * @secure
     * @response `200` `ShopifyV1GetShopifyIntegrationAuthorizationUrlResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceGetShopifyIntegrationAuthorizationUrl: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ShopifyV1GetShopifyIntegrationAuthorizationUrlResponse,
        GoogleRpcStatus
      >({
        path: `/shopify-integrations/v1/${id}/authorization-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceAuthorizeShopifyIntegration
     * @request POST:/shopify-integrations/v1/{id}/authorize
     * @secure
     * @response `200` `ShopifyV1AuthorizeShopifyIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceAuthorizeShopifyIntegration: (
      id: string,
      body: ShopifyV1ShopifyIntegrationsServiceAuthorizeShopifyIntegrationBody,
      params: RequestParams = {},
    ) =>
      this.request<
        ShopifyV1AuthorizeShopifyIntegrationResponse,
        GoogleRpcStatus
      >({
        path: `/shopify-integrations/v1/${id}/authorize`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyIntegrationsService
     * @name ShopifyIntegrationsServiceDeactivateShopifyIntegration
     * @request POST:/shopify-integrations/v1/{id}/deactivate
     * @secure
     * @response `200` `ShopifyV1DeactivateShopifyIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyIntegrationsServiceDeactivateShopifyIntegration: (
      id: string,
      body: ShopifyV1ShopifyIntegrationsServiceDeactivateShopifyIntegrationBody,
      params: RequestParams = {},
    ) =>
      this.request<
        ShopifyV1DeactivateShopifyIntegrationResponse,
        GoogleRpcStatus
      >({
        path: `/shopify-integrations/v1/${id}/deactivate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shopifyV1ShopifyManagementService = {
    /**
     * No description
     *
     * @tags shopify.v1.ShopifyManagementService
     * @name ShopifyManagementServiceCreateShopifyOrderUpdatedWebhook
     * @request POST:/shopify-management/v1/create-order-updated-webhook
     * @secure
     * @response `200` `ShopifyV1CreateShopifyOrderUpdatedWebhookResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyManagementServiceCreateShopifyOrderUpdatedWebhook: (
      body: ShopifyV1CreateShopifyOrderUpdatedWebhookRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ShopifyV1CreateShopifyOrderUpdatedWebhookResponse,
        GoogleRpcStatus
      >({
        path: `/shopify-management/v1/create-order-updated-webhook`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyManagementService
     * @name ShopifyManagementServiceCreateShopifyWebPixel
     * @request POST:/shopify-management/v1/create-web-pixel
     * @secure
     * @response `200` `ShopifyV1CreateShopifyWebPixelResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyManagementServiceCreateShopifyWebPixel: (
      body: ShopifyV1CreateShopifyWebPixelRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1CreateShopifyWebPixelResponse, GoogleRpcStatus>({
        path: `/shopify-management/v1/create-web-pixel`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyManagementService
     * @name ShopifyManagementServiceDeleteShopifyWebPixel
     * @request POST:/shopify-management/v1/delete-web-pixel
     * @secure
     * @response `200` `ShopifyV1DeleteShopifyWebPixelResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyManagementServiceDeleteShopifyWebPixel: (
      body: ShopifyV1DeleteShopifyWebPixelRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1DeleteShopifyWebPixelResponse, GoogleRpcStatus>({
        path: `/shopify-management/v1/delete-web-pixel`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyManagementService
     * @name ShopifyManagementServiceDeleteShopifyWebhook
     * @request POST:/shopify-management/v1/delete-webhook
     * @secure
     * @response `200` `ShopifyV1DeleteShopifyWebhookResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyManagementServiceDeleteShopifyWebhook: (
      body: ShopifyV1DeleteShopifyWebhookRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1DeleteShopifyWebhookResponse, GoogleRpcStatus>({
        path: `/shopify-management/v1/delete-webhook`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags shopify.v1.ShopifyManagementService
     * @name ShopifyManagementServiceListShopifyWebhooks
     * @request POST:/shopify-management/v1/list-webhooks
     * @secure
     * @response `200` `ShopifyV1ListShopifyWebhooksResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shopifyManagementServiceListShopifyWebhooks: (
      body: ShopifyV1ListShopifyWebhooksRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShopifyV1ListShopifyWebhooksResponse, GoogleRpcStatus>({
        path: `/shopify-management/v1/list-webhooks`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shortLinksV1ShortLinksService = {
    /**
     * No description
     *
     * @tags short_links.v1.ShortLinksService
     * @name ShortLinksServiceListForSourceOffer
     * @request GET:/short-links/v1
     * @secure
     * @response `200` `ShortLinksV1ListForSourceOfferResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shortLinksServiceListForSourceOffer: (
      query: ShortLinksServiceListForSourceOfferParams,
      params: RequestParams = {},
    ) =>
      this.request<ShortLinksV1ListForSourceOfferResponse, GoogleRpcStatus>({
        path: `/short-links/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags short_links.v1.ShortLinksService
     * @name ShortLinksServiceCreateShortLink
     * @request POST:/short-links/v1
     * @secure
     * @response `200` `ShortLinksV1CreateShortLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shortLinksServiceCreateShortLink: (
      body: ShortLinksV1CreateShortLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShortLinksV1CreateShortLinkResponse, GoogleRpcStatus>({
        path: `/short-links/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags short_links.v1.ShortLinksService
     * @name ShortLinksServiceDeleteShortLink
     * @request DELETE:/short-links/v1/{id}
     * @secure
     * @response `200` `ShortLinksV1DeleteShortLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    shortLinksServiceDeleteShortLink: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ShortLinksV1DeleteShortLinkResponse, GoogleRpcStatus>({
        path: `/short-links/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shortLinksV1GetShortLinkService = {
    /**
     * No description
     *
     * @tags short_links.v1.GetShortLinkService
     * @name GetShortLinkServiceGetShortLink
     * @request GET:/short-links/v1/{id}
     * @secure
     * @response `200` `ShortLinksV1GetShortLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    getShortLinkServiceGetShortLink: (id: string, params: RequestParams = {}) =>
      this.request<ShortLinksV1GetShortLinkResponse, GoogleRpcStatus>({
        path: `/short-links/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  smartLinksV1SmartLinksService = {
    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceListSmartLinks
     * @request GET:/smart-links/v1
     * @secure
     * @response `200` `SmartLinksV1ListSmartLinksResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceListSmartLinks: (
      query: SmartLinksServiceListSmartLinksParams,
      params: RequestParams = {},
    ) =>
      this.request<SmartLinksV1ListSmartLinksResponse, GoogleRpcStatus>({
        path: `/smart-links/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceCreateSmartLink
     * @request POST:/smart-links/v1
     * @secure
     * @response `200` `SmartLinksV1CreateSmartLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceCreateSmartLink: (
      body: SmartLinksV1CreateSmartLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<SmartLinksV1CreateSmartLinkResponse, GoogleRpcStatus>({
        path: `/smart-links/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceRemoveRedirectLinkFromSmartLink
     * @request DELETE:/smart-links/v1/smart-link-redirect-links/{id}
     * @secure
     * @response `200` `SmartLinksV1RemoveRedirectLinkFromSmartLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceRemoveRedirectLinkFromSmartLink: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SmartLinksV1RemoveRedirectLinkFromSmartLinkResponse,
        GoogleRpcStatus
      >({
        path: `/smart-links/v1/smart-link-redirect-links/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceSetSmartLinkRedirectLinkWeight
     * @request PUT:/smart-links/v1/smart-link-redirect-links/{id}/weight
     * @secure
     * @response `200` `SmartLinksV1SetSmartLinkRedirectLinkWeightResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceSetSmartLinkRedirectLinkWeight: (
      id: string,
      body: SmartLinksV1SmartLinksServiceSetSmartLinkRedirectLinkWeightBody,
      params: RequestParams = {},
    ) =>
      this.request<
        SmartLinksV1SetSmartLinkRedirectLinkWeightResponse,
        GoogleRpcStatus
      >({
        path: `/smart-links/v1/smart-link-redirect-links/${id}/weight`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceGetSmartLink
     * @request GET:/smart-links/v1/{id}
     * @secure
     * @response `200` `SmartLinksV1GetSmartLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceGetSmartLink: (id: string, params: RequestParams = {}) =>
      this.request<SmartLinksV1GetSmartLinkResponse, GoogleRpcStatus>({
        path: `/smart-links/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceUpdateSmartLink
     * @request PATCH:/smart-links/v1/{id}
     * @secure
     * @response `200` `SmartLinksV1UpdateSmartLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceUpdateSmartLink: (
      id: string,
      body: SmartLinksV1SmartLinksServiceUpdateSmartLinkBody,
      params: RequestParams = {},
    ) =>
      this.request<SmartLinksV1UpdateSmartLinkResponse, GoogleRpcStatus>({
        path: `/smart-links/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceUpdateSmartLinkNoSuitableLpFallback
     * @request PUT:/smart-links/v1/{id}/no-suitable-lp-fallback
     * @secure
     * @response `200` `SmartLinksV1UpdateSmartLinkNoSuitableLpFallbackResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceUpdateSmartLinkNoSuitableLpFallback: (
      id: string,
      body: SmartLinksV1SmartLinksServiceUpdateSmartLinkNoSuitableLpFallbackBody,
      params: RequestParams = {},
    ) =>
      this.request<
        SmartLinksV1UpdateSmartLinkNoSuitableLpFallbackResponse,
        GoogleRpcStatus
      >({
        path: `/smart-links/v1/${id}/no-suitable-lp-fallback`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceAddRedirectLinkToSmartLink
     * @request PUT:/smart-links/v1/{id}/redirect-links/{redirectLinkId}
     * @secure
     * @response `200` `SmartLinksV1AddRedirectLinkToSmartLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceAddRedirectLinkToSmartLink: (
      id: string,
      redirectLinkId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SmartLinksV1AddRedirectLinkToSmartLinkResponse,
        GoogleRpcStatus
      >({
        path: `/smart-links/v1/${id}/redirect-links/${redirectLinkId}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceResetSmartLinkUsageWeights
     * @request GET:/smart-links/v1/{id}/reset-weights
     * @secure
     * @response `200` `SmartLinksV1ResetSmartLinkUsageWeightsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceResetSmartLinkUsageWeights: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SmartLinksV1ResetSmartLinkUsageWeightsResponse,
        GoogleRpcStatus
      >({
        path: `/smart-links/v1/${id}/reset-weights`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags smart_links.v1.SmartLinksService
     * @name SmartLinksServiceUpdateSmartLinkStatus
     * @request PUT:/smart-links/v1/{id}/status
     * @secure
     * @response `200` `SmartLinksV1UpdateSmartLinkStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    smartLinksServiceUpdateSmartLinkStatus: (
      id: string,
      body: SmartLinksV1SmartLinksServiceUpdateSmartLinkStatusBody,
      params: RequestParams = {},
    ) =>
      this.request<SmartLinksV1UpdateSmartLinkStatusResponse, GoogleRpcStatus>({
        path: `/smart-links/v1/${id}/status`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sourcesV1SourcesService = {
    /**
     * No description
     *
     * @tags sources.v1.SourcesService
     * @name SourcesServiceListSources
     * @request GET:/sources/v1
     * @secure
     * @response `200` `SourcesV1ListSourcesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    sourcesServiceListSources: (params: RequestParams = {}) =>
      this.request<SourcesV1ListSourcesResponse, GoogleRpcStatus>({
        path: `/sources/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stripeV1StripeIntegrationsService = {
    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceGetStripeIntegration
     * @request GET:/stripe-integrations/v1/{stripeAccountId}
     * @secure
     * @response `200` `StripeV1GetStripeIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceGetStripeIntegration: (
      stripeAccountId: string,
      params: RequestParams = {},
    ) =>
      this.request<StripeV1GetStripeIntegrationResponse, GoogleRpcStatus>({
        path: `/stripe-integrations/v1/${stripeAccountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceDeleteStripeIntegration
     * @request DELETE:/stripe-integrations/v1/{stripeAccountId}
     * @secure
     * @response `200` `StripeV1DeleteStripeIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceDeleteStripeIntegration: (
      stripeAccountId: string,
      params: RequestParams = {},
    ) =>
      this.request<StripeV1DeleteStripeIntegrationResponse, GoogleRpcStatus>({
        path: `/stripe-integrations/v1/${stripeAccountId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceCreateStripeIntegration
     * @request POST:/stripe-integrations/v1/{stripeAccountId}
     * @secure
     * @response `200` `StripeV1CreateStripeIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceCreateStripeIntegration: (
      stripeAccountId: string,
      params: RequestParams = {},
    ) =>
      this.request<StripeV1CreateStripeIntegrationResponse, GoogleRpcStatus>({
        path: `/stripe-integrations/v1/${stripeAccountId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceGetStripeIntegrationApiVersion
     * @request GET:/stripe-integrations/v1/{stripeAccountId}/api-version
     * @secure
     * @response `200` `StripeV1GetStripeIntegrationApiVersionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceGetStripeIntegrationApiVersion: (
      stripeAccountId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        StripeV1GetStripeIntegrationApiVersionResponse,
        GoogleRpcStatus
      >({
        path: `/stripe-integrations/v1/${stripeAccountId}/api-version`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceGetStripeIntegrationCustomerDetail
     * @request POST:/stripe-integrations/v1/{stripeAccountId}/customer-detail/{stripeCustomerId}
     * @secure
     * @response `200` `StripeV1GetStripeIntegrationCustomerDetailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceGetStripeIntegrationCustomerDetail: (
      stripeAccountId: string,
      stripeCustomerId: string,
      body: StripeV1StripeIntegrationsServiceGetStripeIntegrationCustomerDetailBody,
      params: RequestParams = {},
    ) =>
      this.request<
        StripeV1GetStripeIntegrationCustomerDetailResponse,
        GoogleRpcStatus
      >({
        path: `/stripe-integrations/v1/${stripeAccountId}/customer-detail/${stripeCustomerId}`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceSetStripeIntegrationCouponsTracking
     * @request PUT:/stripe-integrations/v1/{stripeAccountId}/settings/coupons-tracking
     * @secure
     * @response `200` `StripeV1SetStripeIntegrationCouponsTrackingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceSetStripeIntegrationCouponsTracking: (
      stripeAccountId: string,
      body: StripeV1StripeIntegrationsServiceSetStripeIntegrationCouponsTrackingBody,
      params: RequestParams = {},
    ) =>
      this.request<
        StripeV1SetStripeIntegrationCouponsTrackingResponse,
        GoogleRpcStatus
      >({
        path: `/stripe-integrations/v1/${stripeAccountId}/settings/coupons-tracking`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe.v1.StripeIntegrationsService
     * @name StripeIntegrationsServiceSyncStripeIntegration
     * @request POST:/stripe-integrations/v1/{stripeAccountId}/sync
     * @secure
     * @response `200` `StripeV1SyncStripeIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    stripeIntegrationsServiceSyncStripeIntegration: (
      stripeAccountId: string,
      params: RequestParams = {},
    ) =>
      this.request<StripeV1SyncStripeIntegrationResponse, GoogleRpcStatus>({
        path: `/stripe-integrations/v1/${stripeAccountId}/sync`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersV1SuperAdminsService = {
    /**
     * No description
     *
     * @tags users.v1.SuperAdminsService
     * @name SuperAdminsServiceListSuperAdmins
     * @request GET:/super-admins/v1
     * @secure
     * @response `200` `UsersV1ListSuperAdminsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    superAdminsServiceListSuperAdmins: (params: RequestParams = {}) =>
      this.request<UsersV1ListSuperAdminsResponse, GoogleRpcStatus>({
        path: `/super-admins/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users.v1.SuperAdminsService
     * @name SuperAdminsServiceRegisterSuperAdmin
     * @request POST:/super-admins/v1/register
     * @secure
     * @response `200` `UsersV1RegisterSuperAdminResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    superAdminsServiceRegisterSuperAdmin: (
      body: UsersV1RegisterSuperAdminRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1RegisterSuperAdminResponse, GoogleRpcStatus>({
        path: `/super-admins/v1/register`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  currenciesV1SystemCurrenciesService = {
    /**
     * No description
     *
     * @tags currencies.v1.SystemCurrenciesService
     * @name SystemCurrenciesServiceListSystemCurrencies
     * @request GET:/system-currencies/v1
     * @secure
     * @response `200` `CurrenciesV1ListSystemCurrenciesResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    systemCurrenciesServiceListSystemCurrencies: (params: RequestParams = {}) =>
      this.request<CurrenciesV1ListSystemCurrenciesResponse, GoogleRpcStatus>({
        path: `/system-currencies/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  locationsV1LocationsService = {
    /**
     * No description
     *
     * @tags locations.v1.LocationsService
     * @name LocationsServiceListSystemLocations
     * @summary Use for a list of all predefined locations
     * @request GET:/system-locations/v1
     * @secure
     * @response `200` `LocationsV1ListSystemLocationsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    locationsServiceListSystemLocations: (params: RequestParams = {}) =>
      this.request<LocationsV1ListSystemLocationsResponse, GoogleRpcStatus>({
        path: `/system-locations/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagsV1TagsService = {
    /**
     * @description Lists all offer tags in the system.
     *
     * @tags tags.v1.TagsService
     * @name TagsServiceListTags
     * @summary List offer tags
     * @request GET:/tags/v1
     * @secure
     * @response `200` `TagsV1ListTagsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tagsServiceListTags: (params: RequestParams = {}) =>
      this.request<TagsV1ListTagsResponse, GoogleRpcStatus>({
        path: `/tags/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new offer tag in the system.
     *
     * @tags tags.v1.TagsService
     * @name TagsServiceCreateTag
     * @summary Create new offer tag
     * @request POST:/tags/v1
     * @secure
     * @response `200` `TagsV1CreateTagResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tagsServiceCreateTag: (
      body: TagsV1CreateTagRequest,
      params: RequestParams = {},
    ) =>
      this.request<TagsV1CreateTagResponse, GoogleRpcStatus>({
        path: `/tags/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Provides details of existing tag in the system.
     *
     * @tags tags.v1.TagsService
     * @name TagsServiceGetTag
     * @summary Get offer tag details
     * @request GET:/tags/v1/{id}
     * @secure
     * @response `200` `TagsV1GetTagResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tagsServiceGetTag: (id: string, params: RequestParams = {}) =>
      this.request<TagsV1GetTagResponse, GoogleRpcStatus>({
        path: `/tags/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes an offer tag from the system.
     *
     * @tags tags.v1.TagsService
     * @name TagsServiceDeleteTag
     * @summary Delete offer tag
     * @request DELETE:/tags/v1/{id}
     * @secure
     * @response `200` `TagsV1DeleteTagResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tagsServiceDeleteTag: (id: string, params: RequestParams = {}) =>
      this.request<TagsV1DeleteTagResponse, GoogleRpcStatus>({
        path: `/tags/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the details of exsiting tag in the system.
     *
     * @tags tags.v1.TagsService
     * @name TagsServiceUpdateTag
     * @summary Update an existing offer tag
     * @request PATCH:/tags/v1/{id}
     * @secure
     * @response `200` `TagsV1UpdateTagResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tagsServiceUpdateTag: (
      id: string,
      body: TagsV1TagsServiceUpdateTagBody,
      params: RequestParams = {},
    ) =>
      this.request<TagsV1UpdateTagResponse, GoogleRpcStatus>({
        path: `/tags/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tenantStatisticsV1TenantStatisticsService = {
    /**
     * No description
     *
     * @tags tenant_statistics.v1.TenantStatisticsService
     * @name TenantStatisticsServiceListTenantStatistics
     * @request POST:/tenant-statistics/v1
     * @secure
     * @response `200` `TenantStatisticsV1ListTenantStatisticsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantStatisticsServiceListTenantStatistics: (
      body: TenantStatisticsV1ListTenantStatisticsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TenantStatisticsV1ListTenantStatisticsResponse,
        GoogleRpcStatus
      >({
        path: `/tenant-statistics/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenant_statistics.v1.TenantStatisticsService
     * @name TenantStatisticsServiceListInactiveTenants
     * @request GET:/tenants/v1/inactive
     * @secure
     * @response `200` `TenantStatisticsV1ListInactiveTenantsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantStatisticsServiceListInactiveTenants: (
      query: TenantStatisticsServiceListInactiveTenantsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        TenantStatisticsV1ListInactiveTenantsResponse,
        GoogleRpcStatus
      >({
        path: `/tenants/v1/inactive`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tenantsV1TenantsService = {
    /**
     * No description
     *
     * @tags tenants.v1.TenantsService
     * @name TenantsServiceListTenants
     * @request GET:/tenants/v1
     * @secure
     * @response `200` `TenantsV1ListTenantsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantsServiceListTenants: (params: RequestParams = {}) =>
      this.request<TenantsV1ListTenantsResponse, GoogleRpcStatus>({
        path: `/tenants/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tenantsV1TenantModificationService = {
    /**
     * No description
     *
     * @tags tenants.v1.TenantModificationService
     * @name TenantModificationServiceDeleteCurrentTenant
     * @request DELETE:/tenants/v1/current
     * @secure
     * @response `200` `TenantsV1DeleteCurrentTenantResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantModificationServiceDeleteCurrentTenant: (
      params: RequestParams = {},
    ) =>
      this.request<TenantsV1DeleteCurrentTenantResponse, GoogleRpcStatus>({
        path: `/tenants/v1/current`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tenantsV1TenantDeletionService = {
    /**
     * No description
     *
     * @tags tenants.v1.TenantDeletionService
     * @name TenantDeletionServiceDeleteInactiveTenants
     * @request POST:/tenants/v1/delete-inactive
     * @secure
     * @response `200` `TenantsV1DeleteInactiveTenantsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantDeletionServiceDeleteInactiveTenants: (
      body: TenantsV1DeleteInactiveTenantsRequest,
      params: RequestParams = {},
    ) =>
      this.request<TenantsV1DeleteInactiveTenantsResponse, GoogleRpcStatus>({
        path: `/tenants/v1/delete-inactive`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants.v1.TenantDeletionService
     * @name TenantDeletionServiceDeleteTenant
     * @request DELETE:/tenants/v1/{tenantId.value}
     * @secure
     * @response `200` `TenantsV1DeleteTenantResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantDeletionServiceDeleteTenant: (
      { tenantIdValue, ...query }: TenantDeletionServiceDeleteTenantParams,
      params: RequestParams = {},
    ) =>
      this.request<TenantsV1DeleteTenantResponse, GoogleRpcStatus>({
        path: `/tenants/v1/${tenantIdValue}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tenantsV1TenantsRegistrationService = {
    /**
     * No description
     *
     * @tags tenants.v1.TenantsRegistrationService
     * @name TenantsRegistrationServiceRegisterEcommerce
     * @request POST:/tenants/v1/ecommerce
     * @secure
     * @response `200` `TenantsV1RegisterEcommerceResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantsRegistrationServiceRegisterEcommerce: (
      body: TenantsV1RegisterEcommerceRequest,
      params: RequestParams = {},
    ) =>
      this.request<TenantsV1RegisterEcommerceResponse, GoogleRpcStatus>({
        path: `/tenants/v1/ecommerce`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants.v1.TenantsRegistrationService
     * @name TenantsRegistrationServiceIsTenantIdAvailable
     * @request POST:/tenants/v1/is-tenant-id-available
     * @secure
     * @response `200` `TenantsV1IsTenantIdAvailableResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tenantsRegistrationServiceIsTenantIdAvailable: (
      body: TenantsV1IsTenantIdAvailableRequest,
      params: RequestParams = {},
    ) =>
      this.request<TenantsV1IsTenantIdAvailableResponse, GoogleRpcStatus>({
        path: `/tenants/v1/is-tenant-id-available`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tenantsV1UserTenantsService = {
    /**
     * No description
     *
     * @tags tenants.v1.UserTenantsService
     * @name UserTenantsServiceListUserTenants
     * @request GET:/tenants/v1/user
     * @secure
     * @response `200` `TenantsV1ListUserTenantsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    userTenantsServiceListUserTenants: (params: RequestParams = {}) =>
      this.request<TenantsV1ListUserTenantsResponse, GoogleRpcStatus>({
        path: `/tenants/v1/user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tierTransitionAutomationV1TierTransitionAutomationService = {
    /**
     * No description
     *
     * @tags tier_transition_automation.v1.TierTransitionAutomationService
     * @name TierTransitionAutomationServiceGetTierTransitionAutomationSettings
     * @request GET:/tier-transition-automation/v1/settings
     * @secure
     * @response `200` `TierTransitionAutomationV1GetTierTransitionAutomationSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tierTransitionAutomationServiceGetTierTransitionAutomationSettings: (
      params: RequestParams = {},
    ) =>
      this.request<
        TierTransitionAutomationV1GetTierTransitionAutomationSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/tier-transition-automation/v1/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tier_transition_automation.v1.TierTransitionAutomationService
     * @name TierTransitionAutomationServiceSetTierTransitionAutomationSettings
     * @request PUT:/tier-transition-automation/v1/settings
     * @secure
     * @response `200` `TierTransitionAutomationV1SetTierTransitionAutomationSettingsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tierTransitionAutomationServiceSetTierTransitionAutomationSettings: (
      body: TierTransitionAutomationV1SetTierTransitionAutomationSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TierTransitionAutomationV1SetTierTransitionAutomationSettingsResponse,
        GoogleRpcStatus
      >({
        path: `/tier-transition-automation/v1/settings`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tier_transition_automation.v1.TierTransitionAutomationService
     * @name TierTransitionAutomationServiceListTierTransitions
     * @request GET:/tier-transition-automation/v1/transitions
     * @secure
     * @response `200` `TierTransitionAutomationV1ListTierTransitionsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tierTransitionAutomationServiceListTierTransitions: (
      params: RequestParams = {},
    ) =>
      this.request<
        TierTransitionAutomationV1ListTierTransitionsResponse,
        GoogleRpcStatus
      >({
        path: `/tier-transition-automation/v1/transitions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tier_transition_automation.v1.TierTransitionAutomationService
     * @name TierTransitionAutomationServiceCreateTierTransition
     * @request POST:/tier-transition-automation/v1/transitions
     * @secure
     * @response `200` `TierTransitionAutomationV1CreateTierTransitionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tierTransitionAutomationServiceCreateTierTransition: (
      body: TierTransitionAutomationV1CreateTierTransitionRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TierTransitionAutomationV1CreateTierTransitionResponse,
        GoogleRpcStatus
      >({
        path: `/tier-transition-automation/v1/transitions`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tier_transition_automation.v1.TierTransitionAutomationService
     * @name TierTransitionAutomationServiceDeleteTierTransition
     * @request DELETE:/tier-transition-automation/v1/transitions/{id}
     * @secure
     * @response `200` `TierTransitionAutomationV1DeleteTierTransitionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tierTransitionAutomationServiceDeleteTierTransition: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        TierTransitionAutomationV1DeleteTierTransitionResponse,
        GoogleRpcStatus
      >({
        path: `/tier-transition-automation/v1/transitions/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tier_transition_automation.v1.TierTransitionAutomationService
     * @name TierTransitionAutomationServiceUpdateTierTransition
     * @request PATCH:/tier-transition-automation/v1/transitions/{id}
     * @secure
     * @response `200` `TierTransitionAutomationV1UpdateTierTransitionResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tierTransitionAutomationServiceUpdateTierTransition: (
      id: string,
      body: TierTransitionAutomationV1TierTransitionAutomationServiceUpdateTierTransitionBody,
      params: RequestParams = {},
    ) =>
      this.request<
        TierTransitionAutomationV1UpdateTierTransitionResponse,
        GoogleRpcStatus
      >({
        path: `/tier-transition-automation/v1/transitions/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tiersV1TiersService = {
    /**
     * @description Returns a list of active affiliate tiers and their associated payout rates.
     *
     * @tags tiers.v1.TiersService
     * @name TiersServiceListTiers
     * @summary List affiliate tiers
     * @request GET:/tiers/v1
     * @secure
     * @response `200` `TiersV1ListTiersResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tiersServiceListTiers: (params: RequestParams = {}) =>
      this.request<TiersV1ListTiersResponse, GoogleRpcStatus>({
        path: `/tiers/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new affilaite tier in the system.
     *
     * @tags tiers.v1.TiersService
     * @name TiersServiceCreateTier
     * @summary Create affiliate tier
     * @request POST:/tiers/v1
     * @secure
     * @response `200` `TiersV1CreateTierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tiersServiceCreateTier: (
      body: TiersV1CreateTierRequest,
      params: RequestParams = {},
    ) =>
      this.request<TiersV1CreateTierResponse, GoogleRpcStatus>({
        path: `/tiers/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the detail of specific affiliate tier with the payout rates.
     *
     * @tags tiers.v1.TiersService
     * @name TiersServiceGetTier
     * @summary Affiliate tier detail
     * @request GET:/tiers/v1/{id}
     * @secure
     * @response `200` `TiersV1GetTierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tiersServiceGetTier: (id: string, params: RequestParams = {}) =>
      this.request<TiersV1GetTierResponse, GoogleRpcStatus>({
        path: `/tiers/v1/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specific affiliate tier. Affiliates present in the deleted tier will be moved to default tier. Default tier cannot be deleted.
     *
     * @tags tiers.v1.TiersService
     * @name TiersServiceDeleteTier
     * @summary Delete affiliate tier
     * @request DELETE:/tiers/v1/{id}
     * @secure
     * @response `200` `TiersV1DeleteTierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tiersServiceDeleteTier: (id: string, params: RequestParams = {}) =>
      this.request<TiersV1DeleteTierResponse, GoogleRpcStatus>({
        path: `/tiers/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the values of selected affiliate tier.
     *
     * @tags tiers.v1.TiersService
     * @name TiersServiceUpdateTier
     * @summary Update affiliate tier
     * @request PATCH:/tiers/v1/{id}
     * @secure
     * @response `200` `TiersV1UpdateTierResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tiersServiceUpdateTier: (
      id: string,
      body: TiersV1TiersServiceUpdateTierBody,
      params: RequestParams = {},
    ) =>
      this.request<TiersV1UpdateTierResponse, GoogleRpcStatus>({
        path: `/tiers/v1/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tipaltiV1TipaltiIntegrationsService = {
    /**
     * No description
     *
     * @tags tipalti.v1.TipaltiIntegrationsService
     * @name TipaltiIntegrationsServiceGetTipaltiIntegration
     * @request GET:/tipalti-integration/v1
     * @secure
     * @response `200` `TipaltiV1GetTipaltiIntegrationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiIntegrationsServiceGetTipaltiIntegration: (
      params: RequestParams = {},
    ) =>
      this.request<TipaltiV1GetTipaltiIntegrationResponse, GoogleRpcStatus>({
        path: `/tipalti-integration/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tipalti.v1.TipaltiIntegrationsService
     * @name TipaltiIntegrationsServiceSubmitTipaltiAuthorizationCode
     * @request POST:/tipalti-integration/v1/authorization-code
     * @secure
     * @response `200` `TipaltiV1SubmitTipaltiAuthorizationCodeResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiIntegrationsServiceSubmitTipaltiAuthorizationCode: (
      body: TipaltiV1SubmitTipaltiAuthorizationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TipaltiV1SubmitTipaltiAuthorizationCodeResponse,
        GoogleRpcStatus
      >({
        path: `/tipalti-integration/v1/authorization-code`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tipalti.v1.TipaltiIntegrationsService
     * @name TipaltiIntegrationsServiceCreateTipaltiAuthorizationLink
     * @request GET:/tipalti-integration/v1/authorization-link
     * @secure
     * @response `200` `TipaltiV1CreateTipaltiAuthorizationLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiIntegrationsServiceCreateTipaltiAuthorizationLink: (
      params: RequestParams = {},
    ) =>
      this.request<
        TipaltiV1CreateTipaltiAuthorizationLinkResponse,
        GoogleRpcStatus
      >({
        path: `/tipalti-integration/v1/authorization-link`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tipalti.v1.TipaltiIntegrationsService
     * @name TipaltiIntegrationsServiceUpdateTipaltiIFrameAuthorization
     * @request PUT:/tipalti-integration/v1/iframe-authorization
     * @secure
     * @response `200` `TipaltiV1UpdateTipaltiIFrameAuthorizationResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiIntegrationsServiceUpdateTipaltiIFrameAuthorization: (
      body: TipaltiV1UpdateTipaltiIFrameAuthorizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TipaltiV1UpdateTipaltiIFrameAuthorizationResponse,
        GoogleRpcStatus
      >({
        path: `/tipalti-integration/v1/iframe-authorization`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tipaltiV1TipaltiPaymentsService = {
    /**
     * No description
     *
     * @tags tipalti.v1.TipaltiPaymentsService
     * @name TipaltiPaymentsServiceGetPayeeDashboardLink
     * @request GET:/tipalti-payments/v1/payee-dashboard
     * @secure
     * @response `200` `TipaltiV1GetPayeeDashboardLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiPaymentsServiceGetPayeeDashboardLink: (
      query: TipaltiPaymentsServiceGetPayeeDashboardLinkParams,
      params: RequestParams = {},
    ) =>
      this.request<TipaltiV1GetPayeeDashboardLinkResponse, GoogleRpcStatus>({
        path: `/tipalti-payments/v1/payee-dashboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tipalti.v1.TipaltiPaymentsService
     * @name TipaltiPaymentsServiceGetPayeeForAccount
     * @request GET:/tipalti-payments/v1/payee-for-account
     * @secure
     * @response `200` `TipaltiV1GetPayeeForAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiPaymentsServiceGetPayeeForAccount: (
      query: TipaltiPaymentsServiceGetPayeeForAccountParams,
      params: RequestParams = {},
    ) =>
      this.request<TipaltiV1GetPayeeForAccountResponse, GoogleRpcStatus>({
        path: `/tipalti-payments/v1/payee-for-account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve list of payable and unpaid account settlements via Tipalti.
     *
     * @tags tipalti.v1.TipaltiPaymentsService
     * @name TipaltiPaymentsServiceListPayableAccountSettlements
     * @summary List payable account settlements of a settlement
     * @request GET:/tipalti-payments/v1/settlements/{settlementId}/list-payable-account-settlements
     * @secure
     * @response `200` `TipaltiV1ListPayableAccountSettlementsResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiPaymentsServiceListPayableAccountSettlements: (
      settlementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        TipaltiV1ListPayableAccountSettlementsResponse,
        GoogleRpcStatus
      >({
        path: `/tipalti-payments/v1/settlements/${settlementId}/list-payable-account-settlements`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sends new payment batch to Tipalti system for specified settlement. Account settlements of the specified settlement are included in the payment batch only if it has Tipalti payment method, is still unpaid and Tipalti payee corresponding to the account settlement's affiliate is in payable state.
     *
     * @tags tipalti.v1.TipaltiPaymentsService
     * @name TipaltiPaymentsServiceCreatePaymentBatch
     * @summary Create Tipalti payment batch
     * @request POST:/tipalti-payments/v1/settlements/{settlementId}/payment-batch
     * @secure
     * @response `200` `TipaltiV1CreatePaymentBatchResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiPaymentsServiceCreatePaymentBatch: (
      settlementId: string,
      params: RequestParams = {},
    ) =>
      this.request<TipaltiV1CreatePaymentBatchResponse, GoogleRpcStatus>({
        path: `/tipalti-payments/v1/settlements/${settlementId}/payment-batch`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Checks status of a specific Tipalti payment batch of given settlement and refreshes the payment data of the settlement. This should be used only if there is need to manually synchronize payment data with new state in Tipalti system. You can then see the refreshed data in SettlementService.GetSettlement endpoint.
     *
     * @tags tipalti.v1.TipaltiPaymentsService
     * @name TipaltiPaymentsServiceCheckPaymentBatchStatus
     * @summary Check payment batch status
     * @request POST:/tipalti-payments/v1/settlements/{settlementId}/payment-batch/status
     * @secure
     * @response `200` `TipaltiV1CheckPaymentBatchStatusResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    tipaltiPaymentsServiceCheckPaymentBatchStatus: (
      settlementId: string,
      body: TipaltiV1TipaltiPaymentsServiceCheckPaymentBatchStatusBody,
      params: RequestParams = {},
    ) =>
      this.request<TipaltiV1CheckPaymentBatchStatusResponse, GoogleRpcStatus>({
        path: `/tipalti-payments/v1/settlements/${settlementId}/payment-batch/status`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  trackingBlockingV1TrackingBlockingService = {
    /**
     * No description
     *
     * @tags tracking_blocking.v1.TrackingBlockingService
     * @name TrackingBlockingServiceGetTrackingBlocking
     * @request GET:/tracking-blocking/v1
     * @secure
     * @response `200` `TrackingBlockingV1GetTrackingBlockingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    trackingBlockingServiceGetTrackingBlocking: (params: RequestParams = {}) =>
      this.request<
        TrackingBlockingV1GetTrackingBlockingResponse,
        GoogleRpcStatus
      >({
        path: `/tracking-blocking/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tracking_blocking.v1.TrackingBlockingService
     * @name TrackingBlockingServiceSetTrackingBlocking
     * @request PUT:/tracking-blocking/v1
     * @secure
     * @response `200` `TrackingBlockingV1SetTrackingBlockingResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    trackingBlockingServiceSetTrackingBlocking: (
      body: TrackingBlockingV1SetTrackingBlockingRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TrackingBlockingV1SetTrackingBlockingResponse,
        GoogleRpcStatus
      >({
        path: `/tracking-blocking/v1`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  usersV1MfaService = {
    /**
     * No description
     *
     * @tags users.v1.MfaService
     * @name MfaServiceGetAccount
     * @request GET:/users/v1/accounts/{id}
     * @secure
     * @response `200` `UsersV1GetAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    mfaServiceGetAccount: (id: string, params: RequestParams = {}) =>
      this.request<UsersV1GetAccountResponse, GoogleRpcStatus>({
        path: `/users/v1/accounts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users.v1.MfaService
     * @name MfaServiceRemoveMfaFromAccount
     * @request DELETE:/users/v1/accounts/{id}/mfa
     * @secure
     * @response `200` `UsersV1RemoveMfaFromAccountResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    mfaServiceRemoveMfaFromAccount: (id: string, params: RequestParams = {}) =>
      this.request<UsersV1RemoveMfaFromAccountResponse, GoogleRpcStatus>({
        path: `/users/v1/accounts/${id}/mfa`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersV1UserChangeEmailService = {
    /**
     * No description
     *
     * @tags users.v1.UserChangeEmailService
     * @name UserChangeEmailServiceUserChangeEmail
     * @request POST:/users/v1/change-email
     * @secure
     * @response `200` `UsersV1UserChangeEmailResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    userChangeEmailServiceUserChangeEmail: (
      body: UsersV1UserChangeEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1UserChangeEmailResponse, GoogleRpcStatus>({
        path: `/users/v1/change-email`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  usersV1CustomTokensService = {
    /**
     * No description
     *
     * @tags users.v1.CustomTokensService
     * @name CustomTokensServiceGetCustomToken
     * @request GET:/users/v1/custom-token
     * @secure
     * @response `200` `UsersV1GetCustomTokenResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    customTokensServiceGetCustomToken: (params: RequestParams = {}) =>
      this.request<UsersV1GetCustomTokenResponse, GoogleRpcStatus>({
        path: `/users/v1/custom-token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersV1EmailSignInLinkService = {
    /**
     * No description
     *
     * @tags users.v1.EmailSignInLinkService
     * @name EmailSignInLinkServiceGetEmailSignInLink
     * @request POST:/users/v1/get-email-sign-in-link
     * @secure
     * @response `200` `UsersV1GetEmailSignInLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    emailSignInLinkServiceGetEmailSignInLink: (
      body: UsersV1GetEmailSignInLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1GetEmailSignInLinkResponse, GoogleRpcStatus>({
        path: `/users/v1/get-email-sign-in-link`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users.v1.EmailSignInLinkService
     * @name EmailSignInLinkServiceSendEmailSignInLink
     * @request POST:/users/v1/send-email-sign-in-link
     * @secure
     * @response `200` `UsersV1SendEmailSignInLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    emailSignInLinkServiceSendEmailSignInLink: (
      body: UsersV1SendEmailSignInLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1SendEmailSignInLinkResponse, GoogleRpcStatus>({
        path: `/users/v1/send-email-sign-in-link`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users.v1.EmailSignInLinkService
     * @name EmailSignInLinkServiceVerifyEmailSignInLink
     * @request POST:/users/v1/verify-email-sign-in-link
     * @secure
     * @response `200` `UsersV1VerifyEmailSignInLinkResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    emailSignInLinkServiceVerifyEmailSignInLink: (
      body: UsersV1VerifyEmailSignInLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1VerifyEmailSignInLinkResponse, GoogleRpcStatus>({
        path: `/users/v1/verify-email-sign-in-link`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  usersV1InitUserService = {
    /**
     * No description
     *
     * @tags users.v1.InitUserService
     * @name InitUserServiceInitUser
     * @request POST:/users/v1/init
     * @secure
     * @response `200` `UsersV1InitUserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    initUserServiceInitUser: (params: RequestParams = {}) =>
      this.request<UsersV1InitUserResponse, GoogleRpcStatus>({
        path: `/users/v1/init`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersV1UserRegistrationService = {
    /**
     * No description
     *
     * @tags users.v1.UserRegistrationService
     * @name UserRegistrationServiceRegisterUser
     * @request POST:/users/v1/register
     * @secure
     * @response `200` `UsersV1RegisterUserResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    userRegistrationServiceRegisterUser: (
      body: UsersV1RegisterUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1RegisterUserResponse, GoogleRpcStatus>({
        path: `/users/v1/register`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  usersV1SetPasswordService = {
    /**
     * No description
     *
     * @tags users.v1.SetPasswordService
     * @name SetPasswordServiceSetPassword
     * @request POST:/users/v1/set-password
     * @secure
     * @response `200` `UsersV1SetPasswordResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    setPasswordServiceSetPassword: (
      body: UsersV1SetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersV1SetPasswordResponse, GoogleRpcStatus>({
        path: `/users/v1/set-password`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users.v1.SetPasswordService
     * @name SetPasswordServiceIsUserWithoutPassword
     * @request GET:/users/v1/without-password
     * @secure
     * @response `200` `UsersV1IsUserWithoutPasswordResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    setPasswordServiceIsUserWithoutPassword: (params: RequestParams = {}) =>
      this.request<UsersV1IsUserWithoutPasswordResponse, GoogleRpcStatus>({
        path: `/users/v1/without-password`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersV1VerifyEmailOutsideTenantService = {
    /**
     * No description
     *
     * @tags users.v1.VerifyEmailOutsideTenantService
     * @name VerifyEmailOutsideTenantServiceVerifyEmailOutsideTenant
     * @request GET:/users/v1/verify-email
     * @secure
     * @response `200` `UsersV1VerifyEmailOutsideTenantResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    verifyEmailOutsideTenantServiceVerifyEmailOutsideTenant: (
      params: RequestParams = {},
    ) =>
      this.request<UsersV1VerifyEmailOutsideTenantResponse, GoogleRpcStatus>({
        path: `/users/v1/verify-email`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  webhooksV1WebhooksService = {
    /**
     * @description Returns a list of currently active webhooks.
     *
     * @tags webhooks.v1.WebhooksService
     * @name WebhooksServiceListWebhooks
     * @summary List active webhooks
     * @request GET:/webhooks/v1
     * @secure
     * @response `200` `WebhooksV1ListWebhooksResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    webhooksServiceListWebhooks: (params: RequestParams = {}) =>
      this.request<WebhooksV1ListWebhooksResponse, GoogleRpcStatus>({
        path: `/webhooks/v1`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates new webhooks in the system.
     *
     * @tags webhooks.v1.WebhooksService
     * @name WebhooksServiceCreateWebhook
     * @summary Create a new webhook
     * @request POST:/webhooks/v1
     * @secure
     * @response `200` `WebhooksV1CreateWebhookResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    webhooksServiceCreateWebhook: (
      body: WebhooksV1CreateWebhookRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebhooksV1CreateWebhookResponse, GoogleRpcStatus>({
        path: `/webhooks/v1`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Triggers specific webhook to test functionality and sent data.
     *
     * @tags webhooks.v1.WebhooksService
     * @name WebhooksServiceSendWebhook
     * @summary Test webhook response
     * @request POST:/webhooks/v1/test
     * @secure
     * @response `200` `WebhooksV1SendWebhookResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    webhooksServiceSendWebhook: (
      body: WebhooksV1SendWebhookRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebhooksV1SendWebhookResponse, GoogleRpcStatus>({
        path: `/webhooks/v1/test`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specific webhook from the system.
     *
     * @tags webhooks.v1.WebhooksService
     * @name WebhooksServiceDeleteWebhook
     * @summary Delete webhook
     * @request DELETE:/webhooks/v1/{id}
     * @secure
     * @response `200` `WebhooksV1DeleteWebhookResponse` A successful response.
     * @response `default` `GoogleRpcStatus` An unexpected error response.
     */
    webhooksServiceDeleteWebhook: (id: string, params: RequestParams = {}) =>
      this.request<WebhooksV1DeleteWebhookResponse, GoogleRpcStatus>({
        path: `/webhooks/v1/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
